/*! For license information please see termsOfService.9d131d8ecd0c2b1da40c.js.LICENSE.txt */
(() => {
  "use strict";
  var e = {
      175: (e, t) => {
        const n = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/,
          r = /^[\u0021-\u003A\u003C-\u007E]*$/,
          o =
            /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i,
          a = /^[\u0020-\u003A\u003D-\u007E]*$/,
          i = Object.prototype.toString,
          l = (() => {
            const e = function () {};
            return (e.prototype = Object.create(null)), e;
          })();
        function s(e, t, n) {
          do {
            const n = e.charCodeAt(t);
            if (32 !== n && 9 !== n) return t;
          } while (++t < n);
          return n;
        }
        function c(e, t, n) {
          for (; t > n; ) {
            const n = e.charCodeAt(--t);
            if (32 !== n && 9 !== n) return t + 1;
          }
          return n;
        }
        function u(e) {
          if (-1 === e.indexOf("%")) return e;
          try {
            return decodeURIComponent(e);
          } catch (t) {
            return e;
          }
        }
      },
      4: (e, t, n) => {
        var r = n(853),
          o = n(43),
          a = n(950);
        function i(e) {
          var t = "https://react.dev/errors/" + e;
          if (1 < arguments.length) {
            t += "?args[]=" + encodeURIComponent(arguments[1]);
            for (var n = 2; n < arguments.length; n++)
              t += "&args[]=" + encodeURIComponent(arguments[n]);
          }
          return (
            "Minified React error #" +
            e +
            "; visit " +
            t +
            " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
          );
        }
        function l(e) {
          return !(
            !e ||
            (1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType)
          );
        }
        var s = Symbol.for("react.element"),
          c = Symbol.for("react.transitional.element"),
          u = Symbol.for("react.portal"),
          d = Symbol.for("react.fragment"),
          f = Symbol.for("react.strict_mode"),
          p = Symbol.for("react.profiler"),
          h = Symbol.for("react.provider"),
          m = Symbol.for("react.consumer"),
          y = Symbol.for("react.context"),
          v = Symbol.for("react.forward_ref"),
          g = Symbol.for("react.suspense"),
          b = Symbol.for("react.suspense_list"),
          w = Symbol.for("react.memo"),
          S = Symbol.for("react.lazy");
        Symbol.for("react.scope"), Symbol.for("react.debug_trace_mode");
        var k = Symbol.for("react.offscreen");
        Symbol.for("react.legacy_hidden"), Symbol.for("react.tracing_marker");
        var x = Symbol.for("react.memo_cache_sentinel"),
          E = Symbol.iterator;
        function C(e) {
          return null === e || "object" !== typeof e
            ? null
            : "function" === typeof (e = (E && e[E]) || e["@@iterator"])
            ? e
            : null;
        }
        var N = Symbol.for("react.client.reference");
        function T(e) {
          if (null == e) return null;
          if ("function" === typeof e)
            return e.$$typeof === N ? null : e.displayName || e.name || null;
          if ("string" === typeof e) return e;
          switch (e) {
            case d:
              return "Fragment";
            case u:
              return "Portal";
            case p:
              return "Profiler";
            case f:
              return "StrictMode";
            case g:
              return "Suspense";
            case b:
              return "SuspenseList";
          }
          if ("object" === typeof e)
            switch (e.$$typeof) {
              case y:
                return (e.displayName || "Context") + ".Provider";
              case m:
                return (e._context.displayName || "Context") + ".Consumer";
              case v:
                var t = e.render;
                return (
                  (e = e.displayName) ||
                    (e =
                      "" !== (e = t.displayName || t.name || "")
                        ? "ForwardRef(" + e + ")"
                        : "ForwardRef"),
                  e
                );
              case w:
                return null !== (t = e.displayName || null)
                  ? t
                  : T(e.type) || "Memo";
              case S:
                (t = e._payload), (e = e._init);
                try {
                  return T(e(t));
                } catch (n) {}
            }
          return null;
        }
        var P,
          O,
          j = o.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          R = Object.assign;
        function _(e) {
          if (void 0 === P)
            try {
              throw Error();
            } catch (n) {
              var t = n.stack.trim().match(/\n( *(at )?)/);
              (P = (t && t[1]) || ""),
                (O =
                  -1 < n.stack.indexOf("\n    at")
                    ? " (<anonymous>)"
                    : -1 < n.stack.indexOf("@")
                    ? "@unknown:0:0"
                    : "");
            }
          return "\n" + P + e + O;
        }
        var L = !1;
        function z(e, t) {
          if (!e || L) return "";
          L = !0;
          var n = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            var r = {
              DetermineComponentFrameRoot: function () {
                try {
                  if (t) {
                    var n = function () {
                      throw Error();
                    };
                    if (
                      (Object.defineProperty(n.prototype, "props", {
                        set: function () {
                          throw Error();
                        },
                      }),
                      "object" === typeof Reflect && Reflect.construct)
                    ) {
                      try {
                        Reflect.construct(n, []);
                      } catch (o) {
                        var r = o;
                      }
                      Reflect.construct(e, [], n);
                    } else {
                      try {
                        n.call();
                      } catch (a) {
                        r = a;
                      }
                      e.call(n.prototype);
                    }
                  } else {
                    try {
                      throw Error();
                    } catch (i) {
                      r = i;
                    }
                    (n = e()) &&
                      "function" === typeof n.catch &&
                      n.catch(function () {});
                  }
                } catch (l) {
                  if (l && r && "string" === typeof l.stack)
                    return [l.stack, r.stack];
                }
                return [null, null];
              },
            };
            r.DetermineComponentFrameRoot.displayName =
              "DetermineComponentFrameRoot";
            var o = Object.getOwnPropertyDescriptor(
              r.DetermineComponentFrameRoot,
              "name"
            );
            o &&
              o.configurable &&
              Object.defineProperty(r.DetermineComponentFrameRoot, "name", {
                value: "DetermineComponentFrameRoot",
              });
            var a = r.DetermineComponentFrameRoot(),
              i = a[0],
              l = a[1];
            if (i && l) {
              var s = i.split("\n"),
                c = l.split("\n");
              for (
                o = r = 0;
                r < s.length && !s[r].includes("DetermineComponentFrameRoot");

              )
                r++;
              for (
                ;
                o < c.length && !c[o].includes("DetermineComponentFrameRoot");

              )
                o++;
              if (r === s.length || o === c.length)
                for (
                  r = s.length - 1, o = c.length - 1;
                  1 <= r && 0 <= o && s[r] !== c[o];

                )
                  o--;
              for (; 1 <= r && 0 <= o; r--, o--)
                if (s[r] !== c[o]) {
                  if (1 !== r || 1 !== o)
                    do {
                      if ((r--, 0 > --o || s[r] !== c[o])) {
                        var u = "\n" + s[r].replace(" at new ", " at ");
                        return (
                          e.displayName &&
                            u.includes("<anonymous>") &&
                            (u = u.replace("<anonymous>", e.displayName)),
                          u
                        );
                      }
                    } while (1 <= r && 0 <= o);
                  break;
                }
            }
          } finally {
            (L = !1), (Error.prepareStackTrace = n);
          }
          return (n = e ? e.displayName || e.name : "") ? _(n) : "";
        }
        function A(e) {
          switch (e.tag) {
            case 26:
            case 27:
            case 5:
              return _(e.type);
            case 16:
              return _("Lazy");
            case 13:
              return _("Suspense");
            case 19:
              return _("SuspenseList");
            case 0:
            case 15:
              return (e = z(e.type, !1));
            case 11:
              return (e = z(e.type.render, !1));
            case 1:
              return (e = z(e.type, !0));
            default:
              return "";
          }
        }
        function I(e) {
          try {
            var t = "";
            do {
              (t += A(e)), (e = e.return);
            } while (e);
            return t;
          } catch (n) {
            return "\nError generating stack: " + n.message + "\n" + n.stack;
          }
        }
        function M(e) {
          var t = e,
            n = e;
          if (e.alternate) for (; t.return; ) t = t.return;
          else {
            e = t;
            do {
              0 !== (4098 & (t = e).flags) && (n = t.return), (e = t.return);
            } while (e);
          }
          return 3 === t.tag ? n : null;
        }
        function F(e) {
          if (13 === e.tag) {
            var t = e.memoizedState;
            if (
              (null === t &&
                null !== (e = e.alternate) &&
                (t = e.memoizedState),
              null !== t)
            )
              return t.dehydrated;
          }
          return null;
        }
        function D(e) {
          if (M(e) !== e) throw Error(i(188));
        }
        function U(e) {
          var t = e.tag;
          if (5 === t || 26 === t || 27 === t || 6 === t) return e;
          for (e = e.child; null !== e; ) {
            if (null !== (t = U(e))) return t;
            e = e.sibling;
          }
          return null;
        }
        var W = Array.isArray,
          H = a.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          B = { pending: !1, data: null, method: null, action: null },
          V = [],
          $ = -1;
        function q(e) {
          return { current: e };
        }
        function Y(e) {
          0 > $ || ((e.current = V[$]), (V[$] = null), $--);
        }
        function Q(e, t) {
          $++, (V[$] = e.current), (e.current = t);
        }
        var K = q(null),
          G = q(null),
          X = q(null),
          J = q(null);
        function Z(e, t) {
          switch ((Q(X, t), Q(G, e), Q(K, null), (e = t.nodeType))) {
            case 9:
            case 11:
              t = (t = t.documentElement) && (t = t.namespaceURI) ? Gu(t) : 0;
              break;
            default:
              if (
                ((t = (e = 8 === e ? t.parentNode : t).tagName),
                (e = e.namespaceURI))
              )
                t = Xu((e = Gu(e)), t);
              else
                switch (t) {
                  case "svg":
                    t = 1;
                    break;
                  case "math":
                    t = 2;
                    break;
                  default:
                    t = 0;
                }
          }
          Y(K), Q(K, t);
        }
        function ee() {
          Y(K), Y(G), Y(X);
        }
        function te(e) {
          null !== e.memoizedState && Q(J, e);
          var t = K.current,
            n = Xu(t, e.type);
          t !== n && (Q(G, e), Q(K, n));
        }
        function ne(e) {
          G.current === e && (Y(K), Y(G)),
            J.current === e && (Y(J), (Id._currentValue = B));
        }
        var re = Object.prototype.hasOwnProperty,
          oe = r.unstable_scheduleCallback,
          ae = r.unstable_cancelCallback,
          ie = r.unstable_shouldYield,
          le = r.unstable_requestPaint,
          se = r.unstable_now,
          ce = r.unstable_getCurrentPriorityLevel,
          ue = r.unstable_ImmediatePriority,
          de = r.unstable_UserBlockingPriority,
          fe = r.unstable_NormalPriority,
          pe = r.unstable_LowPriority,
          he = r.unstable_IdlePriority,
          me = r.log,
          ye = r.unstable_setDisableYieldValue,
          ve = null,
          ge = null;
        function be(e) {
          if (
            ("function" === typeof me && ye(e),
            ge && "function" === typeof ge.setStrictMode)
          )
            try {
              ge.setStrictMode(ve, e);
            } catch (t) {}
        }
        var we = Math.clz32
            ? Math.clz32
            : function (e) {
                return 0 === (e >>>= 0) ? 32 : (31 - ((Se(e) / ke) | 0)) | 0;
              },
          Se = Math.log,
          ke = Math.LN2;
        var xe = 128,
          Ee = 4194304;
        function Ce(e) {
          var t = 42 & e;
          if (0 !== t) return t;
          switch (e & -e) {
            case 1:
              return 1;
            case 2:
              return 2;
            case 4:
              return 4;
            case 8:
              return 8;
            case 16:
              return 16;
            case 32:
              return 32;
            case 64:
              return 64;
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return 4194176 & e;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              return 62914560 & e;
            case 67108864:
              return 67108864;
            case 134217728:
              return 134217728;
            case 268435456:
              return 268435456;
            case 536870912:
              return 536870912;
            case 1073741824:
              return 0;
            default:
              return e;
          }
        }
        function Ne(e, t) {
          var n = e.pendingLanes;
          if (0 === n) return 0;
          var r = 0,
            o = e.suspendedLanes,
            a = e.pingedLanes,
            i = e.warmLanes;
          e = 0 !== e.finishedLanes;
          var l = 134217727 & n;
          return (
            0 !== l
              ? 0 !== (n = l & ~o)
                ? (r = Ce(n))
                : 0 !== (a &= l)
                ? (r = Ce(a))
                : e || (0 !== (i = l & ~i) && (r = Ce(i)))
              : 0 !== (l = n & ~o)
              ? (r = Ce(l))
              : 0 !== a
              ? (r = Ce(a))
              : e || (0 !== (i = n & ~i) && (r = Ce(i))),
            0 === r
              ? 0
              : 0 !== t &&
                t !== r &&
                0 === (t & o) &&
                ((o = r & -r) >= (i = t & -t) ||
                  (32 === o && 0 !== (4194176 & i)))
              ? t
              : r
          );
        }
        function Te(e, t) {
          return (
            0 === (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t)
          );
        }
        function Pe(e, t) {
          switch (e) {
            case 1:
            case 2:
            case 4:
            case 8:
              return t + 250;
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return t + 5e3;
            default:
              return -1;
          }
        }
        function Oe() {
          var e = xe;
          return 0 === (4194176 & (xe <<= 1)) && (xe = 128), e;
        }
        function je() {
          var e = Ee;
          return 0 === (62914560 & (Ee <<= 1)) && (Ee = 4194304), e;
        }
        function Re(e) {
          for (var t = [], n = 0; 31 > n; n++) t.push(e);
          return t;
        }
        function _e(e, t) {
          (e.pendingLanes |= t),
            268435456 !== t &&
              ((e.suspendedLanes = 0), (e.pingedLanes = 0), (e.warmLanes = 0));
        }
        function Le(e, t, n) {
          (e.pendingLanes |= t), (e.suspendedLanes &= ~t);
          var r = 31 - we(t);
          (e.entangledLanes |= t),
            (e.entanglements[r] =
              1073741824 | e.entanglements[r] | (4194218 & n));
        }
        function ze(e, t) {
          var n = (e.entangledLanes |= t);
          for (e = e.entanglements; n; ) {
            var r = 31 - we(n),
              o = 1 << r;
            (o & t) | (e[r] & t) && (e[r] |= t), (n &= ~o);
          }
        }
        function Ae(e) {
          return 2 < (e &= -e)
            ? 8 < e
              ? 0 !== (134217727 & e)
                ? 32
                : 268435456
              : 8
            : 2;
        }
        function Ie() {
          var e = H.p;
          return 0 !== e ? e : void 0 === (e = window.event) ? 32 : Xd(e.type);
        }
        var Me = Math.random().toString(36).slice(2),
          Fe = "__reactFiber$" + Me,
          De = "__reactProps$" + Me,
          Ue = "__reactContainer$" + Me,
          We = "__reactEvents$" + Me,
          He = "__reactListeners$" + Me,
          Be = "__reactHandles$" + Me,
          Ve = "__reactResources$" + Me,
          $e = "__reactMarker$" + Me;
        function qe(e) {
          delete e[Fe], delete e[De], delete e[We], delete e[He], delete e[Be];
        }
        function Ye(e) {
          var t = e[Fe];
          if (t) return t;
          for (var n = e.parentNode; n; ) {
            if ((t = n[Ue] || n[Fe])) {
              if (
                ((n = t.alternate),
                null !== t.child || (null !== n && null !== n.child))
              )
                for (e = sd(e); null !== e; ) {
                  if ((n = e[Fe])) return n;
                  e = sd(e);
                }
              return t;
            }
            n = (e = n).parentNode;
          }
          return null;
        }
        function Qe(e) {
          if ((e = e[Fe] || e[Ue])) {
            var t = e.tag;
            if (
              5 === t ||
              6 === t ||
              13 === t ||
              26 === t ||
              27 === t ||
              3 === t
            )
              return e;
          }
          return null;
        }
        function Ke(e) {
          var t = e.tag;
          if (5 === t || 26 === t || 27 === t || 6 === t) return e.stateNode;
          throw Error(i(33));
        }
        function Ge(e) {
          var t = e[Ve];
          return (
            t ||
              (t = e[Ve] =
                { hoistableStyles: new Map(), hoistableScripts: new Map() }),
            t
          );
        }
        function Xe(e) {
          e[$e] = !0;
        }
        var Je = new Set(),
          Ze = {};
        function et(e, t) {
          tt(e, t), tt(e + "Capture", t);
        }
        function tt(e, t) {
          for (Ze[e] = t, e = 0; e < t.length; e++) Je.add(t[e]);
        }
        var nt = !(
            "undefined" === typeof window ||
            "undefined" === typeof window.document ||
            "undefined" === typeof window.document.createElement
          ),
          rt = RegExp(
            "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
          ),
          ot = {},
          at = {};
        function it(e, t, n) {
          if (
            ((o = t),
            re.call(at, o) ||
              (!re.call(ot, o) &&
                (rt.test(o) ? (at[o] = !0) : ((ot[o] = !0), 0))))
          )
            if (null === n) e.removeAttribute(t);
            else {
              switch (typeof n) {
                case "undefined":
                case "function":
                case "symbol":
                  return void e.removeAttribute(t);
                case "boolean":
                  var r = t.toLowerCase().slice(0, 5);
                  if ("data-" !== r && "aria-" !== r)
                    return void e.removeAttribute(t);
              }
              e.setAttribute(t, "" + n);
            }
          var o;
        }
        function lt(e, t, n) {
          if (null === n) e.removeAttribute(t);
          else {
            switch (typeof n) {
              case "undefined":
              case "function":
              case "symbol":
              case "boolean":
                return void e.removeAttribute(t);
            }
            e.setAttribute(t, "" + n);
          }
        }
        function st(e, t, n, r) {
          if (null === r) e.removeAttribute(n);
          else {
            switch (typeof r) {
              case "undefined":
              case "function":
              case "symbol":
              case "boolean":
                return void e.removeAttribute(n);
            }
            e.setAttributeNS(t, n, "" + r);
          }
        }
        function ct(e) {
          switch (typeof e) {
            case "bigint":
            case "boolean":
            case "number":
            case "string":
            case "undefined":
            case "object":
              return e;
            default:
              return "";
          }
        }
        function ut(e) {
          var t = e.type;
          return (
            (e = e.nodeName) &&
            "input" === e.toLowerCase() &&
            ("checkbox" === t || "radio" === t)
          );
        }
        function dt(e) {
          e._valueTracker ||
            (e._valueTracker = (function (e) {
              var t = ut(e) ? "checked" : "value",
                n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
                r = "" + e[t];
              if (
                !e.hasOwnProperty(t) &&
                "undefined" !== typeof n &&
                "function" === typeof n.get &&
                "function" === typeof n.set
              ) {
                var o = n.get,
                  a = n.set;
                return (
                  Object.defineProperty(e, t, {
                    configurable: !0,
                    get: function () {
                      return o.call(this);
                    },
                    set: function (e) {
                      (r = "" + e), a.call(this, e);
                    },
                  }),
                  Object.defineProperty(e, t, { enumerable: n.enumerable }),
                  {
                    getValue: function () {
                      return r;
                    },
                    setValue: function (e) {
                      r = "" + e;
                    },
                    stopTracking: function () {
                      (e._valueTracker = null), delete e[t];
                    },
                  }
                );
              }
            })(e));
        }
        function ft(e) {
          if (!e) return !1;
          var t = e._valueTracker;
          if (!t) return !0;
          var n = t.getValue(),
            r = "";
          return (
            e && (r = ut(e) ? (e.checked ? "true" : "false") : e.value),
            (e = r) !== n && (t.setValue(e), !0)
          );
        }
        function pt(e) {
          if (
            "undefined" ===
            typeof (e =
              e || ("undefined" !== typeof document ? document : void 0))
          )
            return null;
          try {
            return e.activeElement || e.body;
          } catch (t) {
            return e.body;
          }
        }
        var ht = /[\n"\\]/g;
        function mt(e) {
          return e.replace(ht, function (e) {
            return "\\" + e.charCodeAt(0).toString(16) + " ";
          });
        }
        function yt(e, t, n, r, o, a, i, l) {
          (e.name = ""),
            null != i &&
            "function" !== typeof i &&
            "symbol" !== typeof i &&
            "boolean" !== typeof i
              ? (e.type = i)
              : e.removeAttribute("type"),
            null != t
              ? "number" === i
                ? ((0 === t && "" === e.value) || e.value != t) &&
                  (e.value = "" + ct(t))
                : e.value !== "" + ct(t) && (e.value = "" + ct(t))
              : ("submit" !== i && "reset" !== i) || e.removeAttribute("value"),
            null != t
              ? gt(e, i, ct(t))
              : null != n
              ? gt(e, i, ct(n))
              : null != r && e.removeAttribute("value"),
            null == o && null != a && (e.defaultChecked = !!a),
            null != o &&
              (e.checked =
                o && "function" !== typeof o && "symbol" !== typeof o),
            null != l &&
            "function" !== typeof l &&
            "symbol" !== typeof l &&
            "boolean" !== typeof l
              ? (e.name = "" + ct(l))
              : e.removeAttribute("name");
        }
        function vt(e, t, n, r, o, a, i, l) {
          if (
            (null != a &&
              "function" !== typeof a &&
              "symbol" !== typeof a &&
              "boolean" !== typeof a &&
              (e.type = a),
            null != t || null != n)
          ) {
            if (
              !(
                ("submit" !== a && "reset" !== a) ||
                (void 0 !== t && null !== t)
              )
            )
              return;
            (n = null != n ? "" + ct(n) : ""),
              (t = null != t ? "" + ct(t) : n),
              l || t === e.value || (e.value = t),
              (e.defaultValue = t);
          }
          (r =
            "function" !== typeof (r = null != r ? r : o) &&
            "symbol" !== typeof r &&
            !!r),
            (e.checked = l ? e.checked : !!r),
            (e.defaultChecked = !!r),
            null != i &&
              "function" !== typeof i &&
              "symbol" !== typeof i &&
              "boolean" !== typeof i &&
              (e.name = i);
        }
        function gt(e, t, n) {
          ("number" === t && pt(e.ownerDocument) === e) ||
            e.defaultValue === "" + n ||
            (e.defaultValue = "" + n);
        }
        function bt(e, t, n, r) {
          if (((e = e.options), t)) {
            t = {};
            for (var o = 0; o < n.length; o++) t["$" + n[o]] = !0;
            for (n = 0; n < e.length; n++)
              (o = t.hasOwnProperty("$" + e[n].value)),
                e[n].selected !== o && (e[n].selected = o),
                o && r && (e[n].defaultSelected = !0);
          } else {
            for (n = "" + ct(n), t = null, o = 0; o < e.length; o++) {
              if (e[o].value === n)
                return (
                  (e[o].selected = !0), void (r && (e[o].defaultSelected = !0))
                );
              null !== t || e[o].disabled || (t = e[o]);
            }
            null !== t && (t.selected = !0);
          }
        }
        function wt(e, t, n) {
          null == t ||
          ((t = "" + ct(t)) !== e.value && (e.value = t), null != n)
            ? (e.defaultValue = null != n ? "" + ct(n) : "")
            : e.defaultValue !== t && (e.defaultValue = t);
        }
        function St(e, t, n, r) {
          if (null == t) {
            if (null != r) {
              if (null != n) throw Error(i(92));
              if (W(r)) {
                if (1 < r.length) throw Error(i(93));
                r = r[0];
              }
              n = r;
            }
            null == n && (n = ""), (t = n);
          }
          (n = ct(t)),
            (e.defaultValue = n),
            (r = e.textContent) === n &&
              "" !== r &&
              null !== r &&
              (e.value = r);
        }
        function kt(e, t) {
          if (t) {
            var n = e.firstChild;
            if (n && n === e.lastChild && 3 === n.nodeType)
              return void (n.nodeValue = t);
          }
          e.textContent = t;
        }
        var xt = new Set(
          "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
            " "
          )
        );
        function Et(e, t, n) {
          var r = 0 === t.indexOf("--");
          null == n || "boolean" === typeof n || "" === n
            ? r
              ? e.setProperty(t, "")
              : "float" === t
              ? (e.cssFloat = "")
              : (e[t] = "")
            : r
            ? e.setProperty(t, n)
            : "number" !== typeof n || 0 === n || xt.has(t)
            ? "float" === t
              ? (e.cssFloat = n)
              : (e[t] = ("" + n).trim())
            : (e[t] = n + "px");
        }
        function Ct(e, t, n) {
          if (null != t && "object" !== typeof t) throw Error(i(62));
          if (((e = e.style), null != n)) {
            for (var r in n)
              !n.hasOwnProperty(r) ||
                (null != t && t.hasOwnProperty(r)) ||
                (0 === r.indexOf("--")
                  ? e.setProperty(r, "")
                  : "float" === r
                  ? (e.cssFloat = "")
                  : (e[r] = ""));
            for (var o in t)
              (r = t[o]), t.hasOwnProperty(o) && n[o] !== r && Et(e, o, r);
          } else for (var a in t) t.hasOwnProperty(a) && Et(e, a, t[a]);
        }
        function Nt(e) {
          if (-1 === e.indexOf("-")) return !1;
          switch (e) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              return !1;
            default:
              return !0;
          }
        }
        var Tt = new Map([
            ["acceptCharset", "accept-charset"],
            ["htmlFor", "for"],
            ["httpEquiv", "http-equiv"],
            ["crossOrigin", "crossorigin"],
            ["accentHeight", "accent-height"],
            ["alignmentBaseline", "alignment-baseline"],
            ["arabicForm", "arabic-form"],
            ["baselineShift", "baseline-shift"],
            ["capHeight", "cap-height"],
            ["clipPath", "clip-path"],
            ["clipRule", "clip-rule"],
            ["colorInterpolation", "color-interpolation"],
            ["colorInterpolationFilters", "color-interpolation-filters"],
            ["colorProfile", "color-profile"],
            ["colorRendering", "color-rendering"],
            ["dominantBaseline", "dominant-baseline"],
            ["enableBackground", "enable-background"],
            ["fillOpacity", "fill-opacity"],
            ["fillRule", "fill-rule"],
            ["floodColor", "flood-color"],
            ["floodOpacity", "flood-opacity"],
            ["fontFamily", "font-family"],
            ["fontSize", "font-size"],
            ["fontSizeAdjust", "font-size-adjust"],
            ["fontStretch", "font-stretch"],
            ["fontStyle", "font-style"],
            ["fontVariant", "font-variant"],
            ["fontWeight", "font-weight"],
            ["glyphName", "glyph-name"],
            ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
            ["glyphOrientationVertical", "glyph-orientation-vertical"],
            ["horizAdvX", "horiz-adv-x"],
            ["horizOriginX", "horiz-origin-x"],
            ["imageRendering", "image-rendering"],
            ["letterSpacing", "letter-spacing"],
            ["lightingColor", "lighting-color"],
            ["markerEnd", "marker-end"],
            ["markerMid", "marker-mid"],
            ["markerStart", "marker-start"],
            ["overlinePosition", "overline-position"],
            ["overlineThickness", "overline-thickness"],
            ["paintOrder", "paint-order"],
            ["panose-1", "panose-1"],
            ["pointerEvents", "pointer-events"],
            ["renderingIntent", "rendering-intent"],
            ["shapeRendering", "shape-rendering"],
            ["stopColor", "stop-color"],
            ["stopOpacity", "stop-opacity"],
            ["strikethroughPosition", "strikethrough-position"],
            ["strikethroughThickness", "strikethrough-thickness"],
            ["strokeDasharray", "stroke-dasharray"],
            ["strokeDashoffset", "stroke-dashoffset"],
            ["strokeLinecap", "stroke-linecap"],
            ["strokeLinejoin", "stroke-linejoin"],
            ["strokeMiterlimit", "stroke-miterlimit"],
            ["strokeOpacity", "stroke-opacity"],
            ["strokeWidth", "stroke-width"],
            ["textAnchor", "text-anchor"],
            ["textDecoration", "text-decoration"],
            ["textRendering", "text-rendering"],
            ["transformOrigin", "transform-origin"],
            ["underlinePosition", "underline-position"],
            ["underlineThickness", "underline-thickness"],
            ["unicodeBidi", "unicode-bidi"],
            ["unicodeRange", "unicode-range"],
            ["unitsPerEm", "units-per-em"],
            ["vAlphabetic", "v-alphabetic"],
            ["vHanging", "v-hanging"],
            ["vIdeographic", "v-ideographic"],
            ["vMathematical", "v-mathematical"],
            ["vectorEffect", "vector-effect"],
            ["vertAdvY", "vert-adv-y"],
            ["vertOriginX", "vert-origin-x"],
            ["vertOriginY", "vert-origin-y"],
            ["wordSpacing", "word-spacing"],
            ["writingMode", "writing-mode"],
            ["xmlnsXlink", "xmlns:xlink"],
            ["xHeight", "x-height"],
          ]),
          Pt =
            /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
        function Ot(e) {
          return Pt.test("" + e)
            ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
            : e;
        }
        var jt = null;
        function Rt(e) {
          return (
            (e = e.target || e.srcElement || window).correspondingUseElement &&
              (e = e.correspondingUseElement),
            3 === e.nodeType ? e.parentNode : e
          );
        }
        var _t = null,
          Lt = null;
        function zt(e) {
          var t = Qe(e);
          if (t && (e = t.stateNode)) {
            var n = e[De] || null;
            e: switch (((e = t.stateNode), t.type)) {
              case "input":
                if (
                  (yt(
                    e,
                    n.value,
                    n.defaultValue,
                    n.defaultValue,
                    n.checked,
                    n.defaultChecked,
                    n.type,
                    n.name
                  ),
                  (t = n.name),
                  "radio" === n.type && null != t)
                ) {
                  for (n = e; n.parentNode; ) n = n.parentNode;
                  for (
                    n = n.querySelectorAll(
                      'input[name="' + mt("" + t) + '"][type="radio"]'
                    ),
                      t = 0;
                    t < n.length;
                    t++
                  ) {
                    var r = n[t];
                    if (r !== e && r.form === e.form) {
                      var o = r[De] || null;
                      if (!o) throw Error(i(90));
                      yt(
                        r,
                        o.value,
                        o.defaultValue,
                        o.defaultValue,
                        o.checked,
                        o.defaultChecked,
                        o.type,
                        o.name
                      );
                    }
                  }
                  for (t = 0; t < n.length; t++)
                    (r = n[t]).form === e.form && ft(r);
                }
                break e;
              case "textarea":
                wt(e, n.value, n.defaultValue);
                break e;
              case "select":
                null != (t = n.value) && bt(e, !!n.multiple, t, !1);
            }
          }
        }
        var At = !1;
        function It(e, t, n) {
          if (At) return e(t, n);
          At = !0;
          try {
            return e(t);
          } finally {
            if (
              ((At = !1),
              (null !== _t || null !== Lt) &&
                (Fc(), _t && ((t = _t), (e = Lt), (Lt = _t = null), zt(t), e)))
            )
              for (t = 0; t < e.length; t++) zt(e[t]);
          }
        }
        function Mt(e, t) {
          var n = e.stateNode;
          if (null === n) return null;
          var r = n[De] || null;
          if (null === r) return null;
          n = r[t];
          e: switch (t) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
              (r = !r.disabled) ||
                (r = !(
                  "button" === (e = e.type) ||
                  "input" === e ||
                  "select" === e ||
                  "textarea" === e
                )),
                (e = !r);
              break e;
            default:
              e = !1;
          }
          if (e) return null;
          if (n && "function" !== typeof n) throw Error(i(231, t, typeof n));
          return n;
        }
        var Ft = !1;
        if (nt)
          try {
            var Dt = {};
            Object.defineProperty(Dt, "passive", {
              get: function () {
                Ft = !0;
              },
            }),
              window.addEventListener("test", Dt, Dt),
              window.removeEventListener("test", Dt, Dt);
          } catch (kf) {
            Ft = !1;
          }
        var Ut = null,
          Wt = null,
          Ht = null;
        function Bt() {
          if (Ht) return Ht;
          var e,
            t,
            n = Wt,
            r = n.length,
            o = "value" in Ut ? Ut.value : Ut.textContent,
            a = o.length;
          for (e = 0; e < r && n[e] === o[e]; e++);
          var i = r - e;
          for (t = 1; t <= i && n[r - t] === o[a - t]; t++);
          return (Ht = o.slice(e, 1 < t ? 1 - t : void 0));
        }
        function Vt(e) {
          var t = e.keyCode;
          return (
            "charCode" in e
              ? 0 === (e = e.charCode) && 13 === t && (e = 13)
              : (e = t),
            10 === e && (e = 13),
            32 <= e || 13 === e ? e : 0
          );
        }
        function $t() {
          return !0;
        }
        function qt() {
          return !1;
        }
        function Yt(e) {
          function t(t, n, r, o, a) {
            for (var i in ((this._reactName = t),
            (this._targetInst = r),
            (this.type = n),
            (this.nativeEvent = o),
            (this.target = a),
            (this.currentTarget = null),
            e))
              e.hasOwnProperty(i) && ((t = e[i]), (this[i] = t ? t(o) : o[i]));
            return (
              (this.isDefaultPrevented = (
                null != o.defaultPrevented
                  ? o.defaultPrevented
                  : !1 === o.returnValue
              )
                ? $t
                : qt),
              (this.isPropagationStopped = qt),
              this
            );
          }
          return (
            R(t.prototype, {
              preventDefault: function () {
                this.defaultPrevented = !0;
                var e = this.nativeEvent;
                e &&
                  (e.preventDefault
                    ? e.preventDefault()
                    : "unknown" !== typeof e.returnValue &&
                      (e.returnValue = !1),
                  (this.isDefaultPrevented = $t));
              },
              stopPropagation: function () {
                var e = this.nativeEvent;
                e &&
                  (e.stopPropagation
                    ? e.stopPropagation()
                    : "unknown" !== typeof e.cancelBubble &&
                      (e.cancelBubble = !0),
                  (this.isPropagationStopped = $t));
              },
              persist: function () {},
              isPersistent: $t,
            }),
            t
          );
        }
        var Qt,
          Kt,
          Gt,
          Xt = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (e) {
              return e.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0,
          },
          Jt = Yt(Xt),
          Zt = R({}, Xt, { view: 0, detail: 0 }),
          en = Yt(Zt),
          tn = R({}, Zt, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: pn,
            button: 0,
            buttons: 0,
            relatedTarget: function (e) {
              return void 0 === e.relatedTarget
                ? e.fromElement === e.srcElement
                  ? e.toElement
                  : e.fromElement
                : e.relatedTarget;
            },
            movementX: function (e) {
              return "movementX" in e
                ? e.movementX
                : (e !== Gt &&
                    (Gt && "mousemove" === e.type
                      ? ((Qt = e.screenX - Gt.screenX),
                        (Kt = e.screenY - Gt.screenY))
                      : (Kt = Qt = 0),
                    (Gt = e)),
                  Qt);
            },
            movementY: function (e) {
              return "movementY" in e ? e.movementY : Kt;
            },
          }),
          nn = Yt(tn),
          rn = Yt(R({}, tn, { dataTransfer: 0 })),
          on = Yt(R({}, Zt, { relatedTarget: 0 })),
          an = Yt(
            R({}, Xt, { animationName: 0, elapsedTime: 0, pseudoElement: 0 })
          ),
          ln = Yt(
            R({}, Xt, {
              clipboardData: function (e) {
                return "clipboardData" in e
                  ? e.clipboardData
                  : window.clipboardData;
              },
            })
          ),
          sn = Yt(R({}, Xt, { data: 0 })),
          cn = {
            Esc: "Escape",
            Spacebar: " ",
            Left: "ArrowLeft",
            Up: "ArrowUp",
            Right: "ArrowRight",
            Down: "ArrowDown",
            Del: "Delete",
            Win: "OS",
            Menu: "ContextMenu",
            Apps: "ContextMenu",
            Scroll: "ScrollLock",
            MozPrintableKey: "Unidentified",
          },
          un = {
            8: "Backspace",
            9: "Tab",
            12: "Clear",
            13: "Enter",
            16: "Shift",
            17: "Control",
            18: "Alt",
            19: "Pause",
            20: "CapsLock",
            27: "Escape",
            32: " ",
            33: "PageUp",
            34: "PageDown",
            35: "End",
            36: "Home",
            37: "ArrowLeft",
            38: "ArrowUp",
            39: "ArrowRight",
            40: "ArrowDown",
            45: "Insert",
            46: "Delete",
            112: "F1",
            113: "F2",
            114: "F3",
            115: "F4",
            116: "F5",
            117: "F6",
            118: "F7",
            119: "F8",
            120: "F9",
            121: "F10",
            122: "F11",
            123: "F12",
            144: "NumLock",
            145: "ScrollLock",
            224: "Meta",
          },
          dn = {
            Alt: "altKey",
            Control: "ctrlKey",
            Meta: "metaKey",
            Shift: "shiftKey",
          };
        function fn(e) {
          var t = this.nativeEvent;
          return t.getModifierState
            ? t.getModifierState(e)
            : !!(e = dn[e]) && !!t[e];
        }
        function pn() {
          return fn;
        }
        var hn = Yt(
            R({}, Zt, {
              key: function (e) {
                if (e.key) {
                  var t = cn[e.key] || e.key;
                  if ("Unidentified" !== t) return t;
                }
                return "keypress" === e.type
                  ? 13 === (e = Vt(e))
                    ? "Enter"
                    : String.fromCharCode(e)
                  : "keydown" === e.type || "keyup" === e.type
                  ? un[e.keyCode] || "Unidentified"
                  : "";
              },
              code: 0,
              location: 0,
              ctrlKey: 0,
              shiftKey: 0,
              altKey: 0,
              metaKey: 0,
              repeat: 0,
              locale: 0,
              getModifierState: pn,
              charCode: function (e) {
                return "keypress" === e.type ? Vt(e) : 0;
              },
              keyCode: function (e) {
                return "keydown" === e.type || "keyup" === e.type
                  ? e.keyCode
                  : 0;
              },
              which: function (e) {
                return "keypress" === e.type
                  ? Vt(e)
                  : "keydown" === e.type || "keyup" === e.type
                  ? e.keyCode
                  : 0;
              },
            })
          ),
          mn = Yt(
            R({}, tn, {
              pointerId: 0,
              width: 0,
              height: 0,
              pressure: 0,
              tangentialPressure: 0,
              tiltX: 0,
              tiltY: 0,
              twist: 0,
              pointerType: 0,
              isPrimary: 0,
            })
          ),
          yn = Yt(
            R({}, Zt, {
              touches: 0,
              targetTouches: 0,
              changedTouches: 0,
              altKey: 0,
              metaKey: 0,
              ctrlKey: 0,
              shiftKey: 0,
              getModifierState: pn,
            })
          ),
          vn = Yt(
            R({}, Xt, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 })
          ),
          gn = Yt(
            R({}, tn, {
              deltaX: function (e) {
                return "deltaX" in e
                  ? e.deltaX
                  : "wheelDeltaX" in e
                  ? -e.wheelDeltaX
                  : 0;
              },
              deltaY: function (e) {
                return "deltaY" in e
                  ? e.deltaY
                  : "wheelDeltaY" in e
                  ? -e.wheelDeltaY
                  : "wheelDelta" in e
                  ? -e.wheelDelta
                  : 0;
              },
              deltaZ: 0,
              deltaMode: 0,
            })
          ),
          bn = Yt(R({}, Xt, { newState: 0, oldState: 0 })),
          wn = [9, 13, 27, 32],
          Sn = nt && "CompositionEvent" in window,
          kn = null;
        nt && "documentMode" in document && (kn = document.documentMode);
        var xn = nt && "TextEvent" in window && !kn,
          En = nt && (!Sn || (kn && 8 < kn && 11 >= kn)),
          Cn = String.fromCharCode(32),
          Nn = !1;
        function Tn(e, t) {
          switch (e) {
            case "keyup":
              return -1 !== wn.indexOf(t.keyCode);
            case "keydown":
              return 229 !== t.keyCode;
            case "keypress":
            case "mousedown":
            case "focusout":
              return !0;
            default:
              return !1;
          }
        }
        function Pn(e) {
          return "object" === typeof (e = e.detail) && "data" in e
            ? e.data
            : null;
        }
        var On = !1;
        var jn = {
          color: !0,
          date: !0,
          datetime: !0,
          "datetime-local": !0,
          email: !0,
          month: !0,
          number: !0,
          password: !0,
          range: !0,
          search: !0,
          tel: !0,
          text: !0,
          time: !0,
          url: !0,
          week: !0,
        };
        function Rn(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return "input" === t ? !!jn[e.type] : "textarea" === t;
        }
        function _n(e, t, n, r) {
          _t ? (Lt ? Lt.push(r) : (Lt = [r])) : (_t = r),
            0 < (t = Iu(t, "onChange")).length &&
              ((n = new Jt("onChange", "change", null, n, r)),
              e.push({ event: n, listeners: t }));
        }
        var Ln = null,
          zn = null;
        function An(e) {
          Pu(e, 0);
        }
        function In(e) {
          if (ft(Ke(e))) return e;
        }
        function Mn(e, t) {
          if ("change" === e) return t;
        }
        var Fn = !1;
        if (nt) {
          var Dn;
          if (nt) {
            var Un = "oninput" in document;
            if (!Un) {
              var Wn = document.createElement("div");
              Wn.setAttribute("oninput", "return;"),
                (Un = "function" === typeof Wn.oninput);
            }
            Dn = Un;
          } else Dn = !1;
          Fn = Dn && (!document.documentMode || 9 < document.documentMode);
        }
        function Hn() {
          Ln && (Ln.detachEvent("onpropertychange", Bn), (zn = Ln = null));
        }
        function Bn(e) {
          if ("value" === e.propertyName && In(zn)) {
            var t = [];
            _n(t, zn, e, Rt(e)), It(An, t);
          }
        }
        function Vn(e, t, n) {
          "focusin" === e
            ? (Hn(), (zn = n), (Ln = t).attachEvent("onpropertychange", Bn))
            : "focusout" === e && Hn();
        }
        function $n(e) {
          if ("selectionchange" === e || "keyup" === e || "keydown" === e)
            return In(zn);
        }
        function qn(e, t) {
          if ("click" === e) return In(t);
        }
        function Yn(e, t) {
          if ("input" === e || "change" === e) return In(t);
        }
        var Qn =
          "function" === typeof Object.is
            ? Object.is
            : function (e, t) {
                return (
                  (e === t && (0 !== e || 1 / e === 1 / t)) ||
                  (e !== e && t !== t)
                );
              };
        function Kn(e, t) {
          if (Qn(e, t)) return !0;
          if (
            "object" !== typeof e ||
            null === e ||
            "object" !== typeof t ||
            null === t
          )
            return !1;
          var n = Object.keys(e),
            r = Object.keys(t);
          if (n.length !== r.length) return !1;
          for (r = 0; r < n.length; r++) {
            var o = n[r];
            if (!re.call(t, o) || !Qn(e[o], t[o])) return !1;
          }
          return !0;
        }
        function Gn(e) {
          for (; e && e.firstChild; ) e = e.firstChild;
          return e;
        }
        function Xn(e, t) {
          var n,
            r = Gn(e);
          for (e = 0; r; ) {
            if (3 === r.nodeType) {
              if (((n = e + r.textContent.length), e <= t && n >= t))
                return { node: r, offset: t - e };
              e = n;
            }
            e: {
              for (; r; ) {
                if (r.nextSibling) {
                  r = r.nextSibling;
                  break e;
                }
                r = r.parentNode;
              }
              r = void 0;
            }
            r = Gn(r);
          }
        }
        function Jn(e, t) {
          return (
            !(!e || !t) &&
            (e === t ||
              ((!e || 3 !== e.nodeType) &&
                (t && 3 === t.nodeType
                  ? Jn(e, t.parentNode)
                  : "contains" in e
                  ? e.contains(t)
                  : !!e.compareDocumentPosition &&
                    !!(16 & e.compareDocumentPosition(t)))))
          );
        }
        function Zn(e) {
          for (
            var t = pt(
              (e =
                null != e &&
                null != e.ownerDocument &&
                null != e.ownerDocument.defaultView
                  ? e.ownerDocument.defaultView
                  : window).document
            );
            t instanceof e.HTMLIFrameElement;

          ) {
            try {
              var n = "string" === typeof t.contentWindow.location.href;
            } catch (r) {
              n = !1;
            }
            if (!n) break;
            t = pt((e = t.contentWindow).document);
          }
          return t;
        }
        function er(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return (
            t &&
            (("input" === t &&
              ("text" === e.type ||
                "search" === e.type ||
                "tel" === e.type ||
                "url" === e.type ||
                "password" === e.type)) ||
              "textarea" === t ||
              "true" === e.contentEditable)
          );
        }
        function tr(e, t) {
          var n = Zn(t);
          t = e.focusedElem;
          var r = e.selectionRange;
          if (
            n !== t &&
            t &&
            t.ownerDocument &&
            Jn(t.ownerDocument.documentElement, t)
          ) {
            if (null !== r && er(t))
              if (
                ((e = r.start),
                void 0 === (n = r.end) && (n = e),
                "selectionStart" in t)
              )
                (t.selectionStart = e),
                  (t.selectionEnd = Math.min(n, t.value.length));
              else if (
                (n =
                  ((e = t.ownerDocument || document) && e.defaultView) ||
                  window).getSelection
              ) {
                n = n.getSelection();
                var o = t.textContent.length,
                  a = Math.min(r.start, o);
                (r = void 0 === r.end ? a : Math.min(r.end, o)),
                  !n.extend && a > r && ((o = r), (r = a), (a = o)),
                  (o = Xn(t, a));
                var i = Xn(t, r);
                o &&
                  i &&
                  (1 !== n.rangeCount ||
                    n.anchorNode !== o.node ||
                    n.anchorOffset !== o.offset ||
                    n.focusNode !== i.node ||
                    n.focusOffset !== i.offset) &&
                  ((e = e.createRange()).setStart(o.node, o.offset),
                  n.removeAllRanges(),
                  a > r
                    ? (n.addRange(e), n.extend(i.node, i.offset))
                    : (e.setEnd(i.node, i.offset), n.addRange(e)));
              }
            for (e = [], n = t; (n = n.parentNode); )
              1 === n.nodeType &&
                e.push({ element: n, left: n.scrollLeft, top: n.scrollTop });
            for (
              "function" === typeof t.focus && t.focus(), t = 0;
              t < e.length;
              t++
            )
              ((n = e[t]).element.scrollLeft = n.left),
                (n.element.scrollTop = n.top);
          }
        }
        var nr =
            nt && "documentMode" in document && 11 >= document.documentMode,
          rr = null,
          or = null,
          ar = null,
          ir = !1;
        function lr(e, t, n) {
          var r =
            n.window === n
              ? n.document
              : 9 === n.nodeType
              ? n
              : n.ownerDocument;
          ir ||
            null == rr ||
            rr !== pt(r) ||
            ("selectionStart" in (r = rr) && er(r)
              ? (r = { start: r.selectionStart, end: r.selectionEnd })
              : (r = {
                  anchorNode: (r = (
                    (r.ownerDocument && r.ownerDocument.defaultView) ||
                    window
                  ).getSelection()).anchorNode,
                  anchorOffset: r.anchorOffset,
                  focusNode: r.focusNode,
                  focusOffset: r.focusOffset,
                }),
            (ar && Kn(ar, r)) ||
              ((ar = r),
              0 < (r = Iu(or, "onSelect")).length &&
                ((t = new Jt("onSelect", "select", null, t, n)),
                e.push({ event: t, listeners: r }),
                (t.target = rr))));
        }
        function sr(e, t) {
          var n = {};
          return (
            (n[e.toLowerCase()] = t.toLowerCase()),
            (n["Webkit" + e] = "webkit" + t),
            (n["Moz" + e] = "moz" + t),
            n
          );
        }
        var cr = {
            animationend: sr("Animation", "AnimationEnd"),
            animationiteration: sr("Animation", "AnimationIteration"),
            animationstart: sr("Animation", "AnimationStart"),
            transitionrun: sr("Transition", "TransitionRun"),
            transitionstart: sr("Transition", "TransitionStart"),
            transitioncancel: sr("Transition", "TransitionCancel"),
            transitionend: sr("Transition", "TransitionEnd"),
          },
          ur = {},
          dr = {};
        function fr(e) {
          if (ur[e]) return ur[e];
          if (!cr[e]) return e;
          var t,
            n = cr[e];
          for (t in n)
            if (n.hasOwnProperty(t) && t in dr) return (ur[e] = n[t]);
          return e;
        }
        nt &&
          ((dr = document.createElement("div").style),
          "AnimationEvent" in window ||
            (delete cr.animationend.animation,
            delete cr.animationiteration.animation,
            delete cr.animationstart.animation),
          "TransitionEvent" in window || delete cr.transitionend.transition);
        var pr = fr("animationend"),
          hr = fr("animationiteration"),
          mr = fr("animationstart"),
          yr = fr("transitionrun"),
          vr = fr("transitionstart"),
          gr = fr("transitioncancel"),
          br = fr("transitionend"),
          wr = new Map(),
          Sr =
            "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(
              " "
            );
        function kr(e, t) {
          wr.set(e, t), et(t, [e]);
        }
        var xr = [],
          Er = 0,
          Cr = 0;
        function Nr() {
          for (var e = Er, t = (Cr = Er = 0); t < e; ) {
            var n = xr[t];
            xr[t++] = null;
            var r = xr[t];
            xr[t++] = null;
            var o = xr[t];
            xr[t++] = null;
            var a = xr[t];
            if (((xr[t++] = null), null !== r && null !== o)) {
              var i = r.pending;
              null === i ? (o.next = o) : ((o.next = i.next), (i.next = o)),
                (r.pending = o);
            }
            0 !== a && jr(n, o, a);
          }
        }
        function Tr(e, t, n, r) {
          (xr[Er++] = e),
            (xr[Er++] = t),
            (xr[Er++] = n),
            (xr[Er++] = r),
            (Cr |= r),
            (e.lanes |= r),
            null !== (e = e.alternate) && (e.lanes |= r);
        }
        function Pr(e, t, n, r) {
          return Tr(e, t, n, r), Rr(e);
        }
        function Or(e, t) {
          return Tr(e, null, null, t), Rr(e);
        }
        function jr(e, t, n) {
          e.lanes |= n;
          var r = e.alternate;
          null !== r && (r.lanes |= n);
          for (var o = !1, a = e.return; null !== a; )
            (a.childLanes |= n),
              null !== (r = a.alternate) && (r.childLanes |= n),
              22 === a.tag &&
                (null === (e = a.stateNode) || 1 & e._visibility || (o = !0)),
              (e = a),
              (a = a.return);
          o &&
            null !== t &&
            3 === e.tag &&
            ((a = e.stateNode),
            (o = 31 - we(n)),
            null === (e = (a = a.hiddenUpdates)[o]) ? (a[o] = [t]) : e.push(t),
            (t.lane = 536870912 | n));
        }
        function Rr(e) {
          if (50 < Pc) throw ((Pc = 0), (Oc = null), Error(i(185)));
          for (var t = e.return; null !== t; ) t = (e = t).return;
          return 3 === e.tag ? e.stateNode : null;
        }
        var _r = {},
          Lr = new WeakMap();
        function zr(e, t) {
          if ("object" === typeof e && null !== e) {
            var n = Lr.get(e);
            return void 0 !== n
              ? n
              : ((t = { value: e, source: t, stack: I(t) }), Lr.set(e, t), t);
          }
          return { value: e, source: t, stack: I(t) };
        }
        var Ar = [],
          Ir = 0,
          Mr = null,
          Fr = 0,
          Dr = [],
          Ur = 0,
          Wr = null,
          Hr = 1,
          Br = "";
        function Vr(e, t) {
          (Ar[Ir++] = Fr), (Ar[Ir++] = Mr), (Mr = e), (Fr = t);
        }
        function $r(e, t, n) {
          (Dr[Ur++] = Hr), (Dr[Ur++] = Br), (Dr[Ur++] = Wr), (Wr = e);
          var r = Hr;
          e = Br;
          var o = 32 - we(r) - 1;
          (r &= ~(1 << o)), (n += 1);
          var a = 32 - we(t) + o;
          if (30 < a) {
            var i = o - (o % 5);
            (a = (r & ((1 << i) - 1)).toString(32)),
              (r >>= i),
              (o -= i),
              (Hr = (1 << (32 - we(t) + o)) | (n << o) | r),
              (Br = a + e);
          } else (Hr = (1 << a) | (n << o) | r), (Br = e);
        }
        function qr(e) {
          null !== e.return && (Vr(e, 1), $r(e, 1, 0));
        }
        function Yr(e) {
          for (; e === Mr; )
            (Mr = Ar[--Ir]), (Ar[Ir] = null), (Fr = Ar[--Ir]), (Ar[Ir] = null);
          for (; e === Wr; )
            (Wr = Dr[--Ur]),
              (Dr[Ur] = null),
              (Br = Dr[--Ur]),
              (Dr[Ur] = null),
              (Hr = Dr[--Ur]),
              (Dr[Ur] = null);
        }
        var Qr = null,
          Kr = null,
          Gr = !1,
          Xr = null,
          Jr = !1,
          Zr = Error(i(519));
        function eo(e) {
          throw (ao(zr(Error(i(418, "")), e)), Zr);
        }
        function to(e) {
          var t = e.stateNode,
            n = e.type,
            r = e.memoizedProps;
          switch (((t[Fe] = e), (t[De] = r), n)) {
            case "dialog":
              Ou("cancel", t), Ou("close", t);
              break;
            case "iframe":
            case "object":
            case "embed":
              Ou("load", t);
              break;
            case "video":
            case "audio":
              for (n = 0; n < Nu.length; n++) Ou(Nu[n], t);
              break;
            case "source":
              Ou("error", t);
              break;
            case "img":
            case "image":
            case "link":
              Ou("error", t), Ou("load", t);
              break;
            case "details":
              Ou("toggle", t);
              break;
            case "input":
              Ou("invalid", t),
                vt(
                  t,
                  r.value,
                  r.defaultValue,
                  r.checked,
                  r.defaultChecked,
                  r.type,
                  r.name,
                  !0
                ),
                dt(t);
              break;
            case "select":
              Ou("invalid", t);
              break;
            case "textarea":
              Ou("invalid", t),
                St(t, r.value, r.defaultValue, r.children),
                dt(t);
          }
          ("string" !== typeof (n = r.children) &&
            "number" !== typeof n &&
            "bigint" !== typeof n) ||
          t.textContent === "" + n ||
          !0 === r.suppressHydrationWarning ||
          Hu(t.textContent, n)
            ? (null != r.popover && (Ou("beforetoggle", t), Ou("toggle", t)),
              null != r.onScroll && Ou("scroll", t),
              null != r.onScrollEnd && Ou("scrollend", t),
              null != r.onClick && (t.onclick = Bu),
              (t = !0))
            : (t = !1),
            t || eo(e);
        }
        function no(e) {
          for (Qr = e.return; Qr; )
            switch (Qr.tag) {
              case 3:
              case 27:
                return void (Jr = !0);
              case 5:
              case 13:
                return void (Jr = !1);
              default:
                Qr = Qr.return;
            }
        }
        function ro(e) {
          if (e !== Qr) return !1;
          if (!Gr) return no(e), (Gr = !0), !1;
          var t,
            n = !1;
          if (
            ((t = 3 !== e.tag && 27 !== e.tag) &&
              ((t = 5 === e.tag) &&
                (t =
                  !("form" !== (t = e.type) && "button" !== t) ||
                  Ju(e.type, e.memoizedProps)),
              (t = !t)),
            t && (n = !0),
            n && Kr && eo(e),
            no(e),
            13 === e.tag)
          ) {
            if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null))
              throw Error(i(317));
            e: {
              for (e = e.nextSibling, n = 0; e; ) {
                if (8 === e.nodeType)
                  if ("/$" === (t = e.data)) {
                    if (0 === n) {
                      Kr = ld(e.nextSibling);
                      break e;
                    }
                    n--;
                  } else ("$" !== t && "$!" !== t && "$?" !== t) || n++;
                e = e.nextSibling;
              }
              Kr = null;
            }
          } else Kr = Qr ? ld(e.stateNode.nextSibling) : null;
          return !0;
        }
        function oo() {
          (Kr = Qr = null), (Gr = !1);
        }
        function ao(e) {
          null === Xr ? (Xr = [e]) : Xr.push(e);
        }
        var io = Error(i(460)),
          lo = Error(i(474)),
          so = { then: function () {} };
        function co(e) {
          return "fulfilled" === (e = e.status) || "rejected" === e;
        }
        function uo() {}
        function fo(e, t, n) {
          switch (
            (void 0 === (n = e[n])
              ? e.push(t)
              : n !== t && (t.then(uo, uo), (t = n)),
            t.status)
          ) {
            case "fulfilled":
              return t.value;
            case "rejected":
              if ((e = t.reason) === io) throw Error(i(483));
              throw e;
            default:
              if ("string" === typeof t.status) t.then(uo, uo);
              else {
                if (null !== (e = tc) && 100 < e.shellSuspendCounter)
                  throw Error(i(482));
                ((e = t).status = "pending"),
                  e.then(
                    function (e) {
                      if ("pending" === t.status) {
                        var n = t;
                        (n.status = "fulfilled"), (n.value = e);
                      }
                    },
                    function (e) {
                      if ("pending" === t.status) {
                        var n = t;
                        (n.status = "rejected"), (n.reason = e);
                      }
                    }
                  );
              }
              switch (t.status) {
                case "fulfilled":
                  return t.value;
                case "rejected":
                  if ((e = t.reason) === io) throw Error(i(483));
                  throw e;
              }
              throw ((po = t), io);
          }
        }
        var po = null;
        function ho() {
          if (null === po) throw Error(i(459));
          var e = po;
          return (po = null), e;
        }
        var mo = null,
          yo = 0;
        function vo(e) {
          var t = yo;
          return (yo += 1), null === mo && (mo = []), fo(mo, e, t);
        }
        function go(e, t) {
          (t = t.props.ref), (e.ref = void 0 !== t ? t : null);
        }
        function bo(e, t) {
          if (t.$$typeof === s) throw Error(i(525));
          throw (
            ((e = Object.prototype.toString.call(t)),
            Error(
              i(
                31,
                "[object Object]" === e
                  ? "object with keys {" + Object.keys(t).join(", ") + "}"
                  : e
              )
            ))
          );
        }
        function wo(e) {
          return (0, e._init)(e._payload);
        }
        function So(e) {
          function t(t, n) {
            if (e) {
              var r = t.deletions;
              null === r ? ((t.deletions = [n]), (t.flags |= 16)) : r.push(n);
            }
          }
          function n(n, r) {
            if (!e) return null;
            for (; null !== r; ) t(n, r), (r = r.sibling);
            return null;
          }
          function r(e) {
            for (var t = new Map(); null !== e; )
              null !== e.key ? t.set(e.key, e) : t.set(e.index, e),
                (e = e.sibling);
            return t;
          }
          function o(e, t) {
            return ((e = Ms(e, t)).index = 0), (e.sibling = null), e;
          }
          function a(t, n, r) {
            return (
              (t.index = r),
              e
                ? null !== (r = t.alternate)
                  ? (r = r.index) < n
                    ? ((t.flags |= 33554434), n)
                    : r
                  : ((t.flags |= 33554434), n)
                : ((t.flags |= 1048576), n)
            );
          }
          function l(t) {
            return e && null === t.alternate && (t.flags |= 33554434), t;
          }
          function s(e, t, n, r) {
            return null === t || 6 !== t.tag
              ? (((t = Hs(n, e.mode, r)).return = e), t)
              : (((t = o(t, n)).return = e), t);
          }
          function f(e, t, n, r) {
            var a = n.type;
            return a === d
              ? h(e, t, n.props.children, r, n.key)
              : null !== t &&
                (t.elementType === a ||
                  ("object" === typeof a &&
                    null !== a &&
                    a.$$typeof === S &&
                    wo(a) === t.type))
              ? (go((t = o(t, n.props)), n), (t.return = e), t)
              : (go((t = Ds(n.type, n.key, n.props, null, e.mode, r)), n),
                (t.return = e),
                t);
          }
          function p(e, t, n, r) {
            return null === t ||
              4 !== t.tag ||
              t.stateNode.containerInfo !== n.containerInfo ||
              t.stateNode.implementation !== n.implementation
              ? (((t = Bs(n, e.mode, r)).return = e), t)
              : (((t = o(t, n.children || [])).return = e), t);
          }
          function h(e, t, n, r, a) {
            return null === t || 7 !== t.tag
              ? (((t = Us(n, e.mode, r, a)).return = e), t)
              : (((t = o(t, n)).return = e), t);
          }
          function m(e, t, n) {
            if (
              ("string" === typeof t && "" !== t) ||
              "number" === typeof t ||
              "bigint" === typeof t
            )
              return ((t = Hs("" + t, e.mode, n)).return = e), t;
            if ("object" === typeof t && null !== t) {
              switch (t.$$typeof) {
                case c:
                  return (
                    go((n = Ds(t.type, t.key, t.props, null, e.mode, n)), t),
                    (n.return = e),
                    n
                  );
                case u:
                  return ((t = Bs(t, e.mode, n)).return = e), t;
                case S:
                  return m(e, (t = (0, t._init)(t._payload)), n);
              }
              if (W(t) || C(t))
                return ((t = Us(t, e.mode, n, null)).return = e), t;
              if ("function" === typeof t.then) return m(e, vo(t), n);
              if (t.$$typeof === y) return m(e, Nl(e, t), n);
              bo(e, t);
            }
            return null;
          }
          function v(e, t, n, r) {
            var o = null !== t ? t.key : null;
            if (
              ("string" === typeof n && "" !== n) ||
              "number" === typeof n ||
              "bigint" === typeof n
            )
              return null !== o ? null : s(e, t, "" + n, r);
            if ("object" === typeof n && null !== n) {
              switch (n.$$typeof) {
                case c:
                  return n.key === o ? f(e, t, n, r) : null;
                case u:
                  return n.key === o ? p(e, t, n, r) : null;
                case S:
                  return v(e, t, (n = (o = n._init)(n._payload)), r);
              }
              if (W(n) || C(n)) return null !== o ? null : h(e, t, n, r, null);
              if ("function" === typeof n.then) return v(e, t, vo(n), r);
              if (n.$$typeof === y) return v(e, t, Nl(e, n), r);
              bo(e, n);
            }
            return null;
          }
          function g(e, t, n, r, o) {
            if (
              ("string" === typeof r && "" !== r) ||
              "number" === typeof r ||
              "bigint" === typeof r
            )
              return s(t, (e = e.get(n) || null), "" + r, o);
            if ("object" === typeof r && null !== r) {
              switch (r.$$typeof) {
                case c:
                  return f(
                    t,
                    (e = e.get(null === r.key ? n : r.key) || null),
                    r,
                    o
                  );
                case u:
                  return p(
                    t,
                    (e = e.get(null === r.key ? n : r.key) || null),
                    r,
                    o
                  );
                case S:
                  return g(e, t, n, (r = (0, r._init)(r._payload)), o);
              }
              if (W(r) || C(r)) return h(t, (e = e.get(n) || null), r, o, null);
              if ("function" === typeof r.then) return g(e, t, n, vo(r), o);
              if (r.$$typeof === y) return g(e, t, n, Nl(t, r), o);
              bo(t, r);
            }
            return null;
          }
          function b(s, f, p, h) {
            if (
              ("object" === typeof p &&
                null !== p &&
                p.type === d &&
                null === p.key &&
                (p = p.props.children),
              "object" === typeof p && null !== p)
            ) {
              switch (p.$$typeof) {
                case c:
                  e: {
                    for (var w = p.key; null !== f; ) {
                      if (f.key === w) {
                        if ((w = p.type) === d) {
                          if (7 === f.tag) {
                            n(s, f.sibling),
                              ((h = o(f, p.props.children)).return = s),
                              (s = h);
                            break e;
                          }
                        } else if (
                          f.elementType === w ||
                          ("object" === typeof w &&
                            null !== w &&
                            w.$$typeof === S &&
                            wo(w) === f.type)
                        ) {
                          n(s, f.sibling),
                            go((h = o(f, p.props)), p),
                            (h.return = s),
                            (s = h);
                          break e;
                        }
                        n(s, f);
                        break;
                      }
                      t(s, f), (f = f.sibling);
                    }
                    p.type === d
                      ? (((h = Us(p.props.children, s.mode, h, p.key)).return =
                          s),
                        (s = h))
                      : (go(
                          (h = Ds(p.type, p.key, p.props, null, s.mode, h)),
                          p
                        ),
                        (h.return = s),
                        (s = h));
                  }
                  return l(s);
                case u:
                  e: {
                    for (w = p.key; null !== f; ) {
                      if (f.key === w) {
                        if (
                          4 === f.tag &&
                          f.stateNode.containerInfo === p.containerInfo &&
                          f.stateNode.implementation === p.implementation
                        ) {
                          n(s, f.sibling),
                            ((h = o(f, p.children || [])).return = s),
                            (s = h);
                          break e;
                        }
                        n(s, f);
                        break;
                      }
                      t(s, f), (f = f.sibling);
                    }
                    ((h = Bs(p, s.mode, h)).return = s), (s = h);
                  }
                  return l(s);
                case S:
                  return b(s, f, (p = (w = p._init)(p._payload)), h);
              }
              if (W(p))
                return (function (o, i, l, s) {
                  for (
                    var c = null, u = null, d = i, f = (i = 0), p = null;
                    null !== d && f < l.length;
                    f++
                  ) {
                    d.index > f ? ((p = d), (d = null)) : (p = d.sibling);
                    var h = v(o, d, l[f], s);
                    if (null === h) {
                      null === d && (d = p);
                      break;
                    }
                    e && d && null === h.alternate && t(o, d),
                      (i = a(h, i, f)),
                      null === u ? (c = h) : (u.sibling = h),
                      (u = h),
                      (d = p);
                  }
                  if (f === l.length) return n(o, d), Gr && Vr(o, f), c;
                  if (null === d) {
                    for (; f < l.length; f++)
                      null !== (d = m(o, l[f], s)) &&
                        ((i = a(d, i, f)),
                        null === u ? (c = d) : (u.sibling = d),
                        (u = d));
                    return Gr && Vr(o, f), c;
                  }
                  for (d = r(d); f < l.length; f++)
                    null !== (p = g(d, o, f, l[f], s)) &&
                      (e &&
                        null !== p.alternate &&
                        d.delete(null === p.key ? f : p.key),
                      (i = a(p, i, f)),
                      null === u ? (c = p) : (u.sibling = p),
                      (u = p));
                  return (
                    e &&
                      d.forEach(function (e) {
                        return t(o, e);
                      }),
                    Gr && Vr(o, f),
                    c
                  );
                })(s, f, p, h);
              if (C(p)) {
                if ("function" !== typeof (w = C(p))) throw Error(i(150));
                return (function (o, l, s, c) {
                  if (null == s) throw Error(i(151));
                  for (
                    var u = null,
                      d = null,
                      f = l,
                      p = (l = 0),
                      h = null,
                      y = s.next();
                    null !== f && !y.done;
                    p++, y = s.next()
                  ) {
                    f.index > p ? ((h = f), (f = null)) : (h = f.sibling);
                    var b = v(o, f, y.value, c);
                    if (null === b) {
                      null === f && (f = h);
                      break;
                    }
                    e && f && null === b.alternate && t(o, f),
                      (l = a(b, l, p)),
                      null === d ? (u = b) : (d.sibling = b),
                      (d = b),
                      (f = h);
                  }
                  if (y.done) return n(o, f), Gr && Vr(o, p), u;
                  if (null === f) {
                    for (; !y.done; p++, y = s.next())
                      null !== (y = m(o, y.value, c)) &&
                        ((l = a(y, l, p)),
                        null === d ? (u = y) : (d.sibling = y),
                        (d = y));
                    return Gr && Vr(o, p), u;
                  }
                  for (f = r(f); !y.done; p++, y = s.next())
                    null !== (y = g(f, o, p, y.value, c)) &&
                      (e &&
                        null !== y.alternate &&
                        f.delete(null === y.key ? p : y.key),
                      (l = a(y, l, p)),
                      null === d ? (u = y) : (d.sibling = y),
                      (d = y));
                  return (
                    e &&
                      f.forEach(function (e) {
                        return t(o, e);
                      }),
                    Gr && Vr(o, p),
                    u
                  );
                })(s, f, (p = w.call(p)), h);
              }
              if ("function" === typeof p.then) return b(s, f, vo(p), h);
              if (p.$$typeof === y) return b(s, f, Nl(s, p), h);
              bo(s, p);
            }
            return ("string" === typeof p && "" !== p) ||
              "number" === typeof p ||
              "bigint" === typeof p
              ? ((p = "" + p),
                null !== f && 6 === f.tag
                  ? (n(s, f.sibling), ((h = o(f, p)).return = s), (s = h))
                  : (n(s, f), ((h = Hs(p, s.mode, h)).return = s), (s = h)),
                l(s))
              : n(s, f);
          }
          return function (e, t, n, r) {
            try {
              yo = 0;
              var o = b(e, t, n, r);
              return (mo = null), o;
            } catch (i) {
              if (i === io) throw i;
              var a = As(29, i, null, e.mode);
              return (a.lanes = r), (a.return = e), a;
            }
          };
        }
        var ko = So(!0),
          xo = So(!1),
          Eo = q(null),
          Co = q(0);
        function No(e, t) {
          Q(Co, (e = cc)), Q(Eo, t), (cc = e | t.baseLanes);
        }
        function To() {
          Q(Co, cc), Q(Eo, Eo.current);
        }
        function Po() {
          (cc = Co.current), Y(Eo), Y(Co);
        }
        var Oo = q(null),
          jo = null;
        function Ro(e) {
          var t = e.alternate;
          Q(Ao, 1 & Ao.current),
            Q(Oo, e),
            null === jo &&
              (null === t || null !== Eo.current || null !== t.memoizedState) &&
              (jo = e);
        }
        function _o(e) {
          if (22 === e.tag) {
            if ((Q(Ao, Ao.current), Q(Oo, e), null === jo)) {
              var t = e.alternate;
              null !== t && null !== t.memoizedState && (jo = e);
            }
          } else Lo();
        }
        function Lo() {
          Q(Ao, Ao.current), Q(Oo, Oo.current);
        }
        function zo(e) {
          Y(Oo), jo === e && (jo = null), Y(Ao);
        }
        var Ao = q(0);
        function Io(e) {
          for (var t = e; null !== t; ) {
            if (13 === t.tag) {
              var n = t.memoizedState;
              if (
                null !== n &&
                (null === (n = n.dehydrated) ||
                  "$?" === n.data ||
                  "$!" === n.data)
              )
                return t;
            } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
              if (0 !== (128 & t.flags)) return t;
            } else if (null !== t.child) {
              (t.child.return = t), (t = t.child);
              continue;
            }
            if (t === e) break;
            for (; null === t.sibling; ) {
              if (null === t.return || t.return === e) return null;
              t = t.return;
            }
            (t.sibling.return = t.return), (t = t.sibling);
          }
          return null;
        }
        var Mo =
            "undefined" !== typeof AbortController
              ? AbortController
              : function () {
                  var e = [],
                    t = (this.signal = {
                      aborted: !1,
                      addEventListener: function (t, n) {
                        e.push(n);
                      },
                    });
                  this.abort = function () {
                    (t.aborted = !0),
                      e.forEach(function (e) {
                        return e();
                      });
                  };
                },
          Fo = r.unstable_scheduleCallback,
          Do = r.unstable_NormalPriority,
          Uo = {
            $$typeof: y,
            Consumer: null,
            Provider: null,
            _currentValue: null,
            _currentValue2: null,
            _threadCount: 0,
          };
        function Wo() {
          return { controller: new Mo(), data: new Map(), refCount: 0 };
        }
        function Ho(e) {
          e.refCount--,
            0 === e.refCount &&
              Fo(Do, function () {
                e.controller.abort();
              });
        }
        var Bo = null,
          Vo = 0,
          $o = 0,
          qo = null;
        function Yo() {
          if (0 === --Vo && null !== Bo) {
            null !== qo && (qo.status = "fulfilled");
            var e = Bo;
            (Bo = null), ($o = 0), (qo = null);
            for (var t = 0; t < e.length; t++) (0, e[t])();
          }
        }
        var Qo = j.S;
        j.S = function (e, t) {
          "object" === typeof t &&
            null !== t &&
            "function" === typeof t.then &&
            (function (e, t) {
              if (null === Bo) {
                var n = (Bo = []);
                (Vo = 0),
                  ($o = Su()),
                  (qo = {
                    status: "pending",
                    value: void 0,
                    then: function (e) {
                      n.push(e);
                    },
                  });
              }
              Vo++, t.then(Yo, Yo);
            })(0, t),
            null !== Qo && Qo(e, t);
        };
        var Ko = q(null);
        function Go() {
          var e = Ko.current;
          return null !== e ? e : tc.pooledCache;
        }
        function Xo(e, t) {
          Q(Ko, null === t ? Ko.current : t.pool);
        }
        function Jo() {
          var e = Go();
          return null === e ? null : { parent: Uo._currentValue, pool: e };
        }
        var Zo = 0,
          ea = null,
          ta = null,
          na = null,
          ra = !1,
          oa = !1,
          aa = !1,
          ia = 0,
          la = 0,
          sa = null,
          ca = 0;
        function ua() {
          throw Error(i(321));
        }
        function da(e, t) {
          if (null === t) return !1;
          for (var n = 0; n < t.length && n < e.length; n++)
            if (!Qn(e[n], t[n])) return !1;
          return !0;
        }
        function fa(e, t, n, r, o, a) {
          return (
            (Zo = a),
            (ea = t),
            (t.memoizedState = null),
            (t.updateQueue = null),
            (t.lanes = 0),
            (j.H = null === e || null === e.memoizedState ? Ni : Ti),
            (aa = !1),
            (a = n(r, o)),
            (aa = !1),
            oa && (a = ha(t, n, r, o)),
            pa(e),
            a
          );
        }
        function pa(e) {
          j.H = Ci;
          var t = null !== ta && null !== ta.next;
          if (
            ((Zo = 0),
            (na = ta = ea = null),
            (ra = !1),
            (la = 0),
            (sa = null),
            t)
          )
            throw Error(i(300));
          null === e ||
            Vi ||
            (null !== (e = e.dependencies) && xl(e) && (Vi = !0));
        }
        function ha(e, t, n, r) {
          ea = e;
          var o = 0;
          do {
            if ((oa && (sa = null), (la = 0), (oa = !1), 25 <= o))
              throw Error(i(301));
            if (((o += 1), (na = ta = null), null != e.updateQueue)) {
              var a = e.updateQueue;
              (a.lastEffect = null),
                (a.events = null),
                (a.stores = null),
                null != a.memoCache && (a.memoCache.index = 0);
            }
            (j.H = Pi), (a = t(n, r));
          } while (oa);
          return a;
        }
        function ma() {
          var e = j.H,
            t = e.useState()[0];
          return (
            (t = "function" === typeof t.then ? Sa(t) : t),
            (e = e.useState()[0]),
            (null !== ta ? ta.memoizedState : null) !== e && (ea.flags |= 1024),
            t
          );
        }
        function ya() {
          var e = 0 !== ia;
          return (ia = 0), e;
        }
        function va(e, t, n) {
          (t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~n);
        }
        function ga(e) {
          if (ra) {
            for (e = e.memoizedState; null !== e; ) {
              var t = e.queue;
              null !== t && (t.pending = null), (e = e.next);
            }
            ra = !1;
          }
          (Zo = 0),
            (na = ta = ea = null),
            (oa = !1),
            (la = ia = 0),
            (sa = null);
        }
        function ba() {
          var e = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null,
          };
          return (
            null === na ? (ea.memoizedState = na = e) : (na = na.next = e), na
          );
        }
        function wa() {
          if (null === ta) {
            var e = ea.alternate;
            e = null !== e ? e.memoizedState : null;
          } else e = ta.next;
          var t = null === na ? ea.memoizedState : na.next;
          if (null !== t) (na = t), (ta = e);
          else {
            if (null === e) {
              if (null === ea.alternate) throw Error(i(467));
              throw Error(i(310));
            }
            (e = {
              memoizedState: (ta = e).memoizedState,
              baseState: ta.baseState,
              baseQueue: ta.baseQueue,
              queue: ta.queue,
              next: null,
            }),
              null === na ? (ea.memoizedState = na = e) : (na = na.next = e);
          }
          return na;
        }
        function Sa(e) {
          var t = la;
          return (
            (la += 1),
            null === sa && (sa = []),
            (e = fo(sa, e, t)),
            (t = ea),
            null === (null === na ? t.memoizedState : na.next) &&
              ((t = t.alternate),
              (j.H = null === t || null === t.memoizedState ? Ni : Ti)),
            e
          );
        }
        function ka(e) {
          if (null !== e && "object" === typeof e) {
            if ("function" === typeof e.then) return Sa(e);
            if (e.$$typeof === y) return Cl(e);
          }
          throw Error(i(438, String(e)));
        }
        function xa(e) {
          var t = null,
            n = ea.updateQueue;
          if ((null !== n && (t = n.memoCache), null == t)) {
            var r = ea.alternate;
            null !== r &&
              null !== (r = r.updateQueue) &&
              null != (r = r.memoCache) &&
              (t = {
                data: r.data.map(function (e) {
                  return e.slice();
                }),
                index: 0,
              });
          }
          if (
            (null == t && (t = { data: [], index: 0 }),
            null === n &&
              ((n = {
                lastEffect: null,
                events: null,
                stores: null,
                memoCache: null,
              }),
              (ea.updateQueue = n)),
            (n.memoCache = t),
            void 0 === (n = t.data[t.index]))
          )
            for (n = t.data[t.index] = Array(e), r = 0; r < e; r++) n[r] = x;
          return t.index++, n;
        }
        function Ea(e, t) {
          return "function" === typeof t ? t(e) : t;
        }
        function Ca(e) {
          return Na(wa(), ta, e);
        }
        function Na(e, t, n) {
          var r = e.queue;
          if (null === r) throw Error(i(311));
          r.lastRenderedReducer = n;
          var o = e.baseQueue,
            a = r.pending;
          if (null !== a) {
            if (null !== o) {
              var l = o.next;
              (o.next = a.next), (a.next = l);
            }
            (t.baseQueue = o = a), (r.pending = null);
          }
          if (((a = e.baseState), null === o)) e.memoizedState = a;
          else {
            var s = (l = null),
              c = null,
              u = (t = o.next),
              d = !1;
            do {
              var f = -536870913 & u.lane;
              if (f !== u.lane ? (rc & f) === f : (Zo & f) === f) {
                var p = u.revertLane;
                if (0 === p)
                  null !== c &&
                    (c = c.next =
                      {
                        lane: 0,
                        revertLane: 0,
                        action: u.action,
                        hasEagerState: u.hasEagerState,
                        eagerState: u.eagerState,
                        next: null,
                      }),
                    f === $o && (d = !0);
                else {
                  if ((Zo & p) === p) {
                    (u = u.next), p === $o && (d = !0);
                    continue;
                  }
                  (f = {
                    lane: 0,
                    revertLane: u.revertLane,
                    action: u.action,
                    hasEagerState: u.hasEagerState,
                    eagerState: u.eagerState,
                    next: null,
                  }),
                    null === c ? ((s = c = f), (l = a)) : (c = c.next = f),
                    (ea.lanes |= p),
                    (dc |= p);
                }
                (f = u.action),
                  aa && n(a, f),
                  (a = u.hasEagerState ? u.eagerState : n(a, f));
              } else
                (p = {
                  lane: f,
                  revertLane: u.revertLane,
                  action: u.action,
                  hasEagerState: u.hasEagerState,
                  eagerState: u.eagerState,
                  next: null,
                }),
                  null === c ? ((s = c = p), (l = a)) : (c = c.next = p),
                  (ea.lanes |= f),
                  (dc |= f);
              u = u.next;
            } while (null !== u && u !== t);
            if (
              (null === c ? (l = a) : (c.next = s),
              !Qn(a, e.memoizedState) && ((Vi = !0), d && null !== (n = qo)))
            )
              throw n;
            (e.memoizedState = a),
              (e.baseState = l),
              (e.baseQueue = c),
              (r.lastRenderedState = a);
          }
          return null === o && (r.lanes = 0), [e.memoizedState, r.dispatch];
        }
        function Ta(e) {
          var t = wa(),
            n = t.queue;
          if (null === n) throw Error(i(311));
          n.lastRenderedReducer = e;
          var r = n.dispatch,
            o = n.pending,
            a = t.memoizedState;
          if (null !== o) {
            n.pending = null;
            var l = (o = o.next);
            do {
              (a = e(a, l.action)), (l = l.next);
            } while (l !== o);
            Qn(a, t.memoizedState) || (Vi = !0),
              (t.memoizedState = a),
              null === t.baseQueue && (t.baseState = a),
              (n.lastRenderedState = a);
          }
          return [a, r];
        }
        function Pa(e, t, n) {
          var r = ea,
            o = wa(),
            a = Gr;
          if (a) {
            if (void 0 === n) throw Error(i(407));
            n = n();
          } else n = t();
          var l = !Qn((ta || o).memoizedState, n);
          if (
            (l && ((o.memoizedState = n), (Vi = !0)),
            (o = o.queue),
            Za(Ra.bind(null, r, o, e), [e]),
            o.getSnapshot !== t ||
              l ||
              (null !== na && 1 & na.memoizedState.tag))
          ) {
            if (
              ((r.flags |= 2048),
              Qa(9, ja.bind(null, r, o, n, t), { destroy: void 0 }, null),
              null === tc)
            )
              throw Error(i(349));
            a || 0 !== (60 & Zo) || Oa(r, t, n);
          }
          return n;
        }
        function Oa(e, t, n) {
          (e.flags |= 16384),
            (e = { getSnapshot: t, value: n }),
            null === (t = ea.updateQueue)
              ? ((t = {
                  lastEffect: null,
                  events: null,
                  stores: null,
                  memoCache: null,
                }),
                (ea.updateQueue = t),
                (t.stores = [e]))
              : null === (n = t.stores)
              ? (t.stores = [e])
              : n.push(e);
        }
        function ja(e, t, n, r) {
          (t.value = n), (t.getSnapshot = r), _a(t) && La(e);
        }
        function Ra(e, t, n) {
          return n(function () {
            _a(t) && La(e);
          });
        }
        function _a(e) {
          var t = e.getSnapshot;
          e = e.value;
          try {
            var n = t();
            return !Qn(e, n);
          } catch (r) {
            return !0;
          }
        }
        function La(e) {
          var t = Or(e, 2);
          null !== t && _c(t, e, 2);
        }
        function za(e) {
          var t = ba();
          if ("function" === typeof e) {
            var n = e;
            if (((e = n()), aa)) {
              be(!0);
              try {
                n();
              } finally {
                be(!1);
              }
            }
          }
          return (
            (t.memoizedState = t.baseState = e),
            (t.queue = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: Ea,
              lastRenderedState: e,
            }),
            t
          );
        }
        function Aa(e, t, n, r) {
          return (e.baseState = n), Na(e, ta, "function" === typeof r ? r : Ea);
        }
        function Ia(e, t, n, r, o) {
          if (ki(e)) throw Error(i(485));
          if (null !== (e = t.action)) {
            var a = {
              payload: o,
              action: e,
              next: null,
              isTransition: !0,
              status: "pending",
              value: null,
              reason: null,
              listeners: [],
              then: function (e) {
                a.listeners.push(e);
              },
            };
            null !== j.T ? n(!0) : (a.isTransition = !1),
              r(a),
              null === (n = t.pending)
                ? ((a.next = t.pending = a), Ma(t, a))
                : ((a.next = n.next), (t.pending = n.next = a));
          }
        }
        function Ma(e, t) {
          var n = t.action,
            r = t.payload,
            o = e.state;
          if (t.isTransition) {
            var a = j.T,
              i = {};
            j.T = i;
            try {
              var l = n(o, r),
                s = j.S;
              null !== s && s(i, l), Fa(e, t, l);
            } catch (c) {
              Ua(e, t, c);
            } finally {
              j.T = a;
            }
          } else
            try {
              Fa(e, t, (a = n(o, r)));
            } catch (u) {
              Ua(e, t, u);
            }
        }
        function Fa(e, t, n) {
          null !== n && "object" === typeof n && "function" === typeof n.then
            ? n.then(
                function (n) {
                  Da(e, t, n);
                },
                function (n) {
                  return Ua(e, t, n);
                }
              )
            : Da(e, t, n);
        }
        function Da(e, t, n) {
          (t.status = "fulfilled"),
            (t.value = n),
            Wa(t),
            (e.state = n),
            null !== (t = e.pending) &&
              ((n = t.next) === t
                ? (e.pending = null)
                : ((n = n.next), (t.next = n), Ma(e, n)));
        }
        function Ua(e, t, n) {
          var r = e.pending;
          if (((e.pending = null), null !== r)) {
            r = r.next;
            do {
              (t.status = "rejected"), (t.reason = n), Wa(t), (t = t.next);
            } while (t !== r);
          }
          e.action = null;
        }
        function Wa(e) {
          e = e.listeners;
          for (var t = 0; t < e.length; t++) (0, e[t])();
        }
        function Ha(e, t) {
          return t;
        }
        function Ba(e, t) {
          if (Gr) {
            var n = tc.formState;
            if (null !== n) {
              e: {
                var r = ea;
                if (Gr) {
                  if (Kr) {
                    t: {
                      for (var o = Kr, a = Jr; 8 !== o.nodeType; ) {
                        if (!a) {
                          o = null;
                          break t;
                        }
                        if (null === (o = ld(o.nextSibling))) {
                          o = null;
                          break t;
                        }
                      }
                      o = "F!" === (a = o.data) || "F" === a ? o : null;
                    }
                    if (o) {
                      (Kr = ld(o.nextSibling)), (r = "F!" === o.data);
                      break e;
                    }
                  }
                  eo(r);
                }
                r = !1;
              }
              r && (t = n[0]);
            }
          }
          return (
            ((n = ba()).memoizedState = n.baseState = t),
            (r = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: Ha,
              lastRenderedState: t,
            }),
            (n.queue = r),
            (n = bi.bind(null, ea, r)),
            (r.dispatch = n),
            (r = za(!1)),
            (a = Si.bind(null, ea, !1, r.queue)),
            (o = { state: t, dispatch: null, action: e, pending: null }),
            ((r = ba()).queue = o),
            (n = Ia.bind(null, ea, o, a, n)),
            (o.dispatch = n),
            (r.memoizedState = e),
            [t, n, !1]
          );
        }
        function Va(e) {
          return $a(wa(), ta, e);
        }
        function $a(e, t, n) {
          (t = Na(e, t, Ha)[0]),
            (e = Ca(Ea)[0]),
            (t =
              "object" === typeof t &&
              null !== t &&
              "function" === typeof t.then
                ? Sa(t)
                : t);
          var r = wa(),
            o = r.queue,
            a = o.dispatch;
          return (
            n !== r.memoizedState &&
              ((ea.flags |= 2048),
              Qa(9, qa.bind(null, o, n), { destroy: void 0 }, null)),
            [t, a, e]
          );
        }
        function qa(e, t) {
          e.action = t;
        }
        function Ya(e) {
          var t = wa(),
            n = ta;
          if (null !== n) return $a(t, n, e);
          wa(), (t = t.memoizedState);
          var r = (n = wa()).queue.dispatch;
          return (n.memoizedState = e), [t, r, !1];
        }
        function Qa(e, t, n, r) {
          return (
            (e = { tag: e, create: t, inst: n, deps: r, next: null }),
            null === (t = ea.updateQueue) &&
              ((t = {
                lastEffect: null,
                events: null,
                stores: null,
                memoCache: null,
              }),
              (ea.updateQueue = t)),
            null === (n = t.lastEffect)
              ? (t.lastEffect = e.next = e)
              : ((r = n.next), (n.next = e), (e.next = r), (t.lastEffect = e)),
            e
          );
        }
        function Ka() {
          return wa().memoizedState;
        }
        function Ga(e, t, n, r) {
          var o = ba();
          (ea.flags |= e),
            (o.memoizedState = Qa(
              1 | t,
              n,
              { destroy: void 0 },
              void 0 === r ? null : r
            ));
        }
        function Xa(e, t, n, r) {
          var o = wa();
          r = void 0 === r ? null : r;
          var a = o.memoizedState.inst;
          null !== ta && null !== r && da(r, ta.memoizedState.deps)
            ? (o.memoizedState = Qa(t, n, a, r))
            : ((ea.flags |= e), (o.memoizedState = Qa(1 | t, n, a, r)));
        }
        function Ja(e, t) {
          Ga(8390656, 8, e, t);
        }
        function Za(e, t) {
          Xa(2048, 8, e, t);
        }
        function ei(e, t) {
          return Xa(4, 2, e, t);
        }
        function ti(e, t) {
          return Xa(4, 4, e, t);
        }
        function ni(e, t) {
          if ("function" === typeof t) {
            e = e();
            var n = t(e);
            return function () {
              "function" === typeof n ? n() : t(null);
            };
          }
          if (null !== t && void 0 !== t)
            return (
              (e = e()),
              (t.current = e),
              function () {
                t.current = null;
              }
            );
        }
        function ri(e, t, n) {
          (n = null !== n && void 0 !== n ? n.concat([e]) : null),
            Xa(4, 4, ni.bind(null, t, e), n);
        }
        function oi() {}
        function ai(e, t) {
          var n = wa();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== t && da(t, r[1])
            ? r[0]
            : ((n.memoizedState = [e, t]), e);
        }
        function ii(e, t) {
          var n = wa();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          if (null !== t && da(t, r[1])) return r[0];
          if (((r = e()), aa)) {
            be(!0);
            try {
              e();
            } finally {
              be(!1);
            }
          }
          return (n.memoizedState = [r, t]), r;
        }
        function li(e, t, n) {
          return void 0 === n || 0 !== (1073741824 & Zo)
            ? (e.memoizedState = t)
            : ((e.memoizedState = n),
              (e = Rc()),
              (ea.lanes |= e),
              (dc |= e),
              n);
        }
        function si(e, t, n, r) {
          return Qn(n, t)
            ? n
            : null !== Eo.current
            ? ((e = li(e, n, r)), Qn(e, t) || (Vi = !0), e)
            : 0 === (42 & Zo)
            ? ((Vi = !0), (e.memoizedState = n))
            : ((e = Rc()), (ea.lanes |= e), (dc |= e), t);
        }
        function ci(e, t, n, r, o) {
          var a = H.p;
          H.p = 0 !== a && 8 > a ? a : 8;
          var i = j.T,
            l = {};
          (j.T = l), Si(e, !1, t, n);
          try {
            var s = o(),
              c = j.S;
            if (
              (null !== c && c(l, s),
              null !== s &&
                "object" === typeof s &&
                "function" === typeof s.then)
            )
              wi(
                e,
                t,
                (function (e, t) {
                  var n = [],
                    r = {
                      status: "pending",
                      value: null,
                      reason: null,
                      then: function (e) {
                        n.push(e);
                      },
                    };
                  return (
                    e.then(
                      function () {
                        (r.status = "fulfilled"), (r.value = t);
                        for (var e = 0; e < n.length; e++) (0, n[e])(t);
                      },
                      function (e) {
                        for (
                          r.status = "rejected", r.reason = e, e = 0;
                          e < n.length;
                          e++
                        )
                          (0, n[e])(void 0);
                      }
                    ),
                    r
                  );
                })(s, r),
                jc()
              );
            else wi(e, t, r, jc());
          } catch (u) {
            wi(
              e,
              t,
              { then: function () {}, status: "rejected", reason: u },
              jc()
            );
          } finally {
            (H.p = a), (j.T = i);
          }
        }
        function ui() {}
        function di(e, t, n, r) {
          if (5 !== e.tag) throw Error(i(476));
          var o = fi(e).queue;
          ci(
            e,
            o,
            t,
            B,
            null === n
              ? ui
              : function () {
                  return pi(e), n(r);
                }
          );
        }
        function fi(e) {
          var t = e.memoizedState;
          if (null !== t) return t;
          var n = {};
          return (
            ((t = {
              memoizedState: B,
              baseState: B,
              baseQueue: null,
              queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: Ea,
                lastRenderedState: B,
              },
              next: null,
            }).next = {
              memoizedState: n,
              baseState: n,
              baseQueue: null,
              queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: Ea,
                lastRenderedState: n,
              },
              next: null,
            }),
            (e.memoizedState = t),
            null !== (e = e.alternate) && (e.memoizedState = t),
            t
          );
        }
        function pi(e) {
          wi(e, fi(e).next.queue, {}, jc());
        }
        function hi() {
          return Cl(Id);
        }
        function mi() {
          return wa().memoizedState;
        }
        function yi() {
          return wa().memoizedState;
        }
        function vi(e) {
          for (var t = e.return; null !== t; ) {
            switch (t.tag) {
              case 24:
              case 3:
                var n = jc(),
                  r = _l(t, (e = Rl(n)), n);
                return (
                  null !== r && (_c(r, t, n), Ll(r, t, n)),
                  (t = { cache: Wo() }),
                  void (e.payload = t)
                );
            }
            t = t.return;
          }
        }
        function gi(e, t, n) {
          var r = jc();
          (n = {
            lane: r,
            revertLane: 0,
            action: n,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          }),
            ki(e)
              ? xi(t, n)
              : null !== (n = Pr(e, t, n, r)) && (_c(n, e, r), Ei(n, t, r));
        }
        function bi(e, t, n) {
          wi(e, t, n, jc());
        }
        function wi(e, t, n, r) {
          var o = {
            lane: r,
            revertLane: 0,
            action: n,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          };
          if (ki(e)) xi(t, o);
          else {
            var a = e.alternate;
            if (
              0 === e.lanes &&
              (null === a || 0 === a.lanes) &&
              null !== (a = t.lastRenderedReducer)
            )
              try {
                var i = t.lastRenderedState,
                  l = a(i, n);
                if (((o.hasEagerState = !0), (o.eagerState = l), Qn(l, i)))
                  return Tr(e, t, o, 0), null === tc && Nr(), !1;
              } catch (s) {}
            if (null !== (n = Pr(e, t, o, r)))
              return _c(n, e, r), Ei(n, t, r), !0;
          }
          return !1;
        }
        function Si(e, t, n, r) {
          if (
            ((r = {
              lane: 2,
              revertLane: Su(),
              action: r,
              hasEagerState: !1,
              eagerState: null,
              next: null,
            }),
            ki(e))
          ) {
            if (t) throw Error(i(479));
          } else null !== (t = Pr(e, n, r, 2)) && _c(t, e, 2);
        }
        function ki(e) {
          var t = e.alternate;
          return e === ea || (null !== t && t === ea);
        }
        function xi(e, t) {
          oa = ra = !0;
          var n = e.pending;
          null === n ? (t.next = t) : ((t.next = n.next), (n.next = t)),
            (e.pending = t);
        }
        function Ei(e, t, n) {
          if (0 !== (4194176 & n)) {
            var r = t.lanes;
            (n |= r &= e.pendingLanes), (t.lanes = n), ze(e, n);
          }
        }
        var Ci = {
          readContext: Cl,
          use: ka,
          useCallback: ua,
          useContext: ua,
          useEffect: ua,
          useImperativeHandle: ua,
          useLayoutEffect: ua,
          useInsertionEffect: ua,
          useMemo: ua,
          useReducer: ua,
          useRef: ua,
          useState: ua,
          useDebugValue: ua,
          useDeferredValue: ua,
          useTransition: ua,
          useSyncExternalStore: ua,
          useId: ua,
        };
        (Ci.useCacheRefresh = ua),
          (Ci.useMemoCache = ua),
          (Ci.useHostTransitionStatus = ua),
          (Ci.useFormState = ua),
          (Ci.useActionState = ua),
          (Ci.useOptimistic = ua);
        var Ni = {
          readContext: Cl,
          use: ka,
          useCallback: function (e, t) {
            return (ba().memoizedState = [e, void 0 === t ? null : t]), e;
          },
          useContext: Cl,
          useEffect: Ja,
          useImperativeHandle: function (e, t, n) {
            (n = null !== n && void 0 !== n ? n.concat([e]) : null),
              Ga(4194308, 4, ni.bind(null, t, e), n);
          },
          useLayoutEffect: function (e, t) {
            return Ga(4194308, 4, e, t);
          },
          useInsertionEffect: function (e, t) {
            Ga(4, 2, e, t);
          },
          useMemo: function (e, t) {
            var n = ba();
            t = void 0 === t ? null : t;
            var r = e();
            if (aa) {
              be(!0);
              try {
                e();
              } finally {
                be(!1);
              }
            }
            return (n.memoizedState = [r, t]), r;
          },
          useReducer: function (e, t, n) {
            var r = ba();
            if (void 0 !== n) {
              var o = n(t);
              if (aa) {
                be(!0);
                try {
                  n(t);
                } finally {
                  be(!1);
                }
              }
            } else o = t;
            return (
              (r.memoizedState = r.baseState = o),
              (e = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: e,
                lastRenderedState: o,
              }),
              (r.queue = e),
              (e = e.dispatch = gi.bind(null, ea, e)),
              [r.memoizedState, e]
            );
          },
          useRef: function (e) {
            return (e = { current: e }), (ba().memoizedState = e);
          },
          useState: function (e) {
            var t = (e = za(e)).queue,
              n = bi.bind(null, ea, t);
            return (t.dispatch = n), [e.memoizedState, n];
          },
          useDebugValue: oi,
          useDeferredValue: function (e, t) {
            return li(ba(), e, t);
          },
          useTransition: function () {
            var e = za(!1);
            return (
              (e = ci.bind(null, ea, e.queue, !0, !1)),
              (ba().memoizedState = e),
              [!1, e]
            );
          },
          useSyncExternalStore: function (e, t, n) {
            var r = ea,
              o = ba();
            if (Gr) {
              if (void 0 === n) throw Error(i(407));
              n = n();
            } else {
              if (((n = t()), null === tc)) throw Error(i(349));
              0 !== (60 & rc) || Oa(r, t, n);
            }
            o.memoizedState = n;
            var a = { value: n, getSnapshot: t };
            return (
              (o.queue = a),
              Ja(Ra.bind(null, r, a, e), [e]),
              (r.flags |= 2048),
              Qa(9, ja.bind(null, r, a, n, t), { destroy: void 0 }, null),
              n
            );
          },
          useId: function () {
            var e = ba(),
              t = tc.identifierPrefix;
            if (Gr) {
              var n = Br;
              (t =
                ":" +
                t +
                "R" +
                (n = (Hr & ~(1 << (32 - we(Hr) - 1))).toString(32) + n)),
                0 < (n = ia++) && (t += "H" + n.toString(32)),
                (t += ":");
            } else t = ":" + t + "r" + (n = ca++).toString(32) + ":";
            return (e.memoizedState = t);
          },
          useCacheRefresh: function () {
            return (ba().memoizedState = vi.bind(null, ea));
          },
        };
        (Ni.useMemoCache = xa),
          (Ni.useHostTransitionStatus = hi),
          (Ni.useFormState = Ba),
          (Ni.useActionState = Ba),
          (Ni.useOptimistic = function (e) {
            var t = ba();
            t.memoizedState = t.baseState = e;
            var n = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: null,
              lastRenderedState: null,
            };
            return (
              (t.queue = n),
              (t = Si.bind(null, ea, !0, n)),
              (n.dispatch = t),
              [e, t]
            );
          });
        var Ti = {
          readContext: Cl,
          use: ka,
          useCallback: ai,
          useContext: Cl,
          useEffect: Za,
          useImperativeHandle: ri,
          useInsertionEffect: ei,
          useLayoutEffect: ti,
          useMemo: ii,
          useReducer: Ca,
          useRef: Ka,
          useState: function () {
            return Ca(Ea);
          },
          useDebugValue: oi,
          useDeferredValue: function (e, t) {
            return si(wa(), ta.memoizedState, e, t);
          },
          useTransition: function () {
            var e = Ca(Ea)[0],
              t = wa().memoizedState;
            return ["boolean" === typeof e ? e : Sa(e), t];
          },
          useSyncExternalStore: Pa,
          useId: mi,
        };
        (Ti.useCacheRefresh = yi),
          (Ti.useMemoCache = xa),
          (Ti.useHostTransitionStatus = hi),
          (Ti.useFormState = Va),
          (Ti.useActionState = Va),
          (Ti.useOptimistic = function (e, t) {
            return Aa(wa(), 0, e, t);
          });
        var Pi = {
          readContext: Cl,
          use: ka,
          useCallback: ai,
          useContext: Cl,
          useEffect: Za,
          useImperativeHandle: ri,
          useInsertionEffect: ei,
          useLayoutEffect: ti,
          useMemo: ii,
          useReducer: Ta,
          useRef: Ka,
          useState: function () {
            return Ta(Ea);
          },
          useDebugValue: oi,
          useDeferredValue: function (e, t) {
            var n = wa();
            return null === ta ? li(n, e, t) : si(n, ta.memoizedState, e, t);
          },
          useTransition: function () {
            var e = Ta(Ea)[0],
              t = wa().memoizedState;
            return ["boolean" === typeof e ? e : Sa(e), t];
          },
          useSyncExternalStore: Pa,
          useId: mi,
        };
        function Oi(e, t, n, r) {
          (n =
            null === (n = n(r, (t = e.memoizedState))) || void 0 === n
              ? t
              : R({}, t, n)),
            (e.memoizedState = n),
            0 === e.lanes && (e.updateQueue.baseState = n);
        }
        (Pi.useCacheRefresh = yi),
          (Pi.useMemoCache = xa),
          (Pi.useHostTransitionStatus = hi),
          (Pi.useFormState = Ya),
          (Pi.useActionState = Ya),
          (Pi.useOptimistic = function (e, t) {
            var n = wa();
            return null !== ta
              ? Aa(n, 0, e, t)
              : ((n.baseState = e), [e, n.queue.dispatch]);
          });
        var ji = {
          isMounted: function (e) {
            return !!(e = e._reactInternals) && M(e) === e;
          },
          enqueueSetState: function (e, t, n) {
            e = e._reactInternals;
            var r = jc(),
              o = Rl(r);
            (o.payload = t),
              void 0 !== n && null !== n && (o.callback = n),
              null !== (t = _l(e, o, r)) && (_c(t, e, r), Ll(t, e, r));
          },
          enqueueReplaceState: function (e, t, n) {
            e = e._reactInternals;
            var r = jc(),
              o = Rl(r);
            (o.tag = 1),
              (o.payload = t),
              void 0 !== n && null !== n && (o.callback = n),
              null !== (t = _l(e, o, r)) && (_c(t, e, r), Ll(t, e, r));
          },
          enqueueForceUpdate: function (e, t) {
            e = e._reactInternals;
            var n = jc(),
              r = Rl(n);
            (r.tag = 2),
              void 0 !== t && null !== t && (r.callback = t),
              null !== (t = _l(e, r, n)) && (_c(t, e, n), Ll(t, e, n));
          },
        };
        function Ri(e, t, n, r, o, a, i) {
          return "function" === typeof (e = e.stateNode).shouldComponentUpdate
            ? e.shouldComponentUpdate(r, a, i)
            : !t.prototype ||
                !t.prototype.isPureReactComponent ||
                !Kn(n, r) ||
                !Kn(o, a);
        }
        function _i(e, t, n, r) {
          (e = t.state),
            "function" === typeof t.componentWillReceiveProps &&
              t.componentWillReceiveProps(n, r),
            "function" === typeof t.UNSAFE_componentWillReceiveProps &&
              t.UNSAFE_componentWillReceiveProps(n, r),
            t.state !== e && ji.enqueueReplaceState(t, t.state, null);
        }
        function Li(e, t) {
          var n = t;
          if ("ref" in t)
            for (var r in ((n = {}), t)) "ref" !== r && (n[r] = t[r]);
          if ((e = e.defaultProps))
            for (var o in (n === t && (n = R({}, n)), e))
              void 0 === n[o] && (n[o] = e[o]);
          return n;
        }
        var zi =
          "function" === typeof reportError
            ? reportError
            : function (e) {
                if (
                  "object" === typeof window &&
                  "function" === typeof window.ErrorEvent
                ) {
                  var t = new window.ErrorEvent("error", {
                    bubbles: !0,
                    cancelable: !0,
                    message:
                      "object" === typeof e &&
                      null !== e &&
                      "string" === typeof e.message
                        ? String(e.message)
                        : String(e),
                    error: e,
                  });
                  if (!window.dispatchEvent(t)) return;
                } else if (
                  "object" === typeof process &&
                  "function" === typeof process.emit
                )
                  return void process.emit("uncaughtException", e);
                console.error(e);
              };
        function Ai(e) {
          zi(e);
        }
        function Ii(e) {
          console.error(e);
        }
        function Mi(e) {
          zi(e);
        }
        function Fi(e, t) {
          try {
            (0, e.onUncaughtError)(t.value, { componentStack: t.stack });
          } catch (n) {
            setTimeout(function () {
              throw n;
            });
          }
        }
        function Di(e, t, n) {
          try {
            (0, e.onCaughtError)(n.value, {
              componentStack: n.stack,
              errorBoundary: 1 === t.tag ? t.stateNode : null,
            });
          } catch (r) {
            setTimeout(function () {
              throw r;
            });
          }
        }
        function Ui(e, t, n) {
          return (
            ((n = Rl(n)).tag = 3),
            (n.payload = { element: null }),
            (n.callback = function () {
              Fi(e, t);
            }),
            n
          );
        }
        function Wi(e) {
          return ((e = Rl(e)).tag = 3), e;
        }
        function Hi(e, t, n, r) {
          var o = n.type.getDerivedStateFromError;
          if ("function" === typeof o) {
            var a = r.value;
            (e.payload = function () {
              return o(a);
            }),
              (e.callback = function () {
                Di(t, n, r);
              });
          }
          var i = n.stateNode;
          null !== i &&
            "function" === typeof i.componentDidCatch &&
            (e.callback = function () {
              Di(t, n, r),
                "function" !== typeof o &&
                  (null === kc ? (kc = new Set([this])) : kc.add(this));
              var e = r.stack;
              this.componentDidCatch(r.value, {
                componentStack: null !== e ? e : "",
              });
            });
        }
        var Bi = Error(i(461)),
          Vi = !1;
        function $i(e, t, n, r) {
          t.child = null === e ? xo(t, null, n, r) : ko(t, e.child, n, r);
        }
        function qi(e, t, n, r, o) {
          n = n.render;
          var a = t.ref;
          if ("ref" in r) {
            var i = {};
            for (var l in r) "ref" !== l && (i[l] = r[l]);
          } else i = r;
          return (
            El(t),
            (r = fa(e, t, n, i, a, o)),
            (l = ya()),
            null === e || Vi
              ? (Gr && l && qr(t), (t.flags |= 1), $i(e, t, r, o), t.child)
              : (va(e, t, o), fl(e, t, o))
          );
        }
        function Yi(e, t, n, r, o) {
          if (null === e) {
            var a = n.type;
            return "function" !== typeof a ||
              Is(a) ||
              void 0 !== a.defaultProps ||
              null !== n.compare
              ? (((e = Ds(n.type, null, r, t, t.mode, o)).ref = t.ref),
                (e.return = t),
                (t.child = e))
              : ((t.tag = 15), (t.type = a), Qi(e, t, a, r, o));
          }
          if (((a = e.child), !pl(e, o))) {
            var i = a.memoizedProps;
            if (
              (n = null !== (n = n.compare) ? n : Kn)(i, r) &&
              e.ref === t.ref
            )
              return fl(e, t, o);
          }
          return (
            (t.flags |= 1),
            ((e = Ms(a, r)).ref = t.ref),
            (e.return = t),
            (t.child = e)
          );
        }
        function Qi(e, t, n, r, o) {
          if (null !== e) {
            var a = e.memoizedProps;
            if (Kn(a, r) && e.ref === t.ref) {
              if (((Vi = !1), (t.pendingProps = r = a), !pl(e, o)))
                return (t.lanes = e.lanes), fl(e, t, o);
              0 !== (131072 & e.flags) && (Vi = !0);
            }
          }
          return Ji(e, t, n, r, o);
        }
        function Ki(e, t, n) {
          var r = t.pendingProps,
            o = r.children,
            a = 0 !== (2 & t.stateNode._pendingVisibility),
            i = null !== e ? e.memoizedState : null;
          if ((Xi(e, t), "hidden" === r.mode || a)) {
            if (0 !== (128 & t.flags)) {
              if (((r = null !== i ? i.baseLanes | n : n), null !== e)) {
                for (o = t.child = e.child, a = 0; null !== o; )
                  (a = a | o.lanes | o.childLanes), (o = o.sibling);
                t.childLanes = a & ~r;
              } else (t.childLanes = 0), (t.child = null);
              return Gi(e, t, r, n);
            }
            if (0 === (536870912 & n))
              return (
                (t.lanes = t.childLanes = 536870912),
                Gi(e, t, null !== i ? i.baseLanes | n : n, n)
              );
            (t.memoizedState = { baseLanes: 0, cachePool: null }),
              null !== e && Xo(0, null !== i ? i.cachePool : null),
              null !== i ? No(t, i) : To(),
              _o(t);
          } else
            null !== i
              ? (Xo(0, i.cachePool), No(t, i), Lo(), (t.memoizedState = null))
              : (null !== e && Xo(0, null), To(), Lo());
          return $i(e, t, o, n), t.child;
        }
        function Gi(e, t, n, r) {
          var o = Go();
          return (
            (o = null === o ? null : { parent: Uo._currentValue, pool: o }),
            (t.memoizedState = { baseLanes: n, cachePool: o }),
            null !== e && Xo(0, null),
            To(),
            _o(t),
            null !== e && kl(e, t, r, !0),
            null
          );
        }
        function Xi(e, t) {
          var n = t.ref;
          if (null === n) null !== e && null !== e.ref && (t.flags |= 2097664);
          else {
            if ("function" !== typeof n && "object" !== typeof n)
              throw Error(i(284));
            (null !== e && e.ref === n) || (t.flags |= 2097664);
          }
        }
        function Ji(e, t, n, r, o) {
          return (
            El(t),
            (n = fa(e, t, n, r, void 0, o)),
            (r = ya()),
            null === e || Vi
              ? (Gr && r && qr(t), (t.flags |= 1), $i(e, t, n, o), t.child)
              : (va(e, t, o), fl(e, t, o))
          );
        }
        function Zi(e, t, n, r, o, a) {
          return (
            El(t),
            (t.updateQueue = null),
            (n = ha(t, r, n, o)),
            pa(e),
            (r = ya()),
            null === e || Vi
              ? (Gr && r && qr(t), (t.flags |= 1), $i(e, t, n, a), t.child)
              : (va(e, t, a), fl(e, t, a))
          );
        }
        function el(e, t, n, r, o) {
          if ((El(t), null === t.stateNode)) {
            var a = _r,
              i = n.contextType;
            "object" === typeof i && null !== i && (a = Cl(i)),
              (a = new n(r, a)),
              (t.memoizedState =
                null !== a.state && void 0 !== a.state ? a.state : null),
              (a.updater = ji),
              (t.stateNode = a),
              (a._reactInternals = t),
              ((a = t.stateNode).props = r),
              (a.state = t.memoizedState),
              (a.refs = {}),
              Ol(t),
              (i = n.contextType),
              (a.context = "object" === typeof i && null !== i ? Cl(i) : _r),
              (a.state = t.memoizedState),
              "function" === typeof (i = n.getDerivedStateFromProps) &&
                (Oi(t, n, i, r), (a.state = t.memoizedState)),
              "function" === typeof n.getDerivedStateFromProps ||
                "function" === typeof a.getSnapshotBeforeUpdate ||
                ("function" !== typeof a.UNSAFE_componentWillMount &&
                  "function" !== typeof a.componentWillMount) ||
                ((i = a.state),
                "function" === typeof a.componentWillMount &&
                  a.componentWillMount(),
                "function" === typeof a.UNSAFE_componentWillMount &&
                  a.UNSAFE_componentWillMount(),
                i !== a.state && ji.enqueueReplaceState(a, a.state, null),
                Ml(t, r, a, o),
                Il(),
                (a.state = t.memoizedState)),
              "function" === typeof a.componentDidMount && (t.flags |= 4194308),
              (r = !0);
          } else if (null === e) {
            a = t.stateNode;
            var l = t.memoizedProps,
              s = Li(n, l);
            a.props = s;
            var c = a.context,
              u = n.contextType;
            (i = _r), "object" === typeof u && null !== u && (i = Cl(u));
            var d = n.getDerivedStateFromProps;
            (u =
              "function" === typeof d ||
              "function" === typeof a.getSnapshotBeforeUpdate),
              (l = t.pendingProps !== l),
              u ||
                ("function" !== typeof a.UNSAFE_componentWillReceiveProps &&
                  "function" !== typeof a.componentWillReceiveProps) ||
                ((l || c !== i) && _i(t, a, r, i)),
              (Pl = !1);
            var f = t.memoizedState;
            (a.state = f),
              Ml(t, r, a, o),
              Il(),
              (c = t.memoizedState),
              l || f !== c || Pl
                ? ("function" === typeof d &&
                    (Oi(t, n, d, r), (c = t.memoizedState)),
                  (s = Pl || Ri(t, n, s, r, f, c, i))
                    ? (u ||
                        ("function" !== typeof a.UNSAFE_componentWillMount &&
                          "function" !== typeof a.componentWillMount) ||
                        ("function" === typeof a.componentWillMount &&
                          a.componentWillMount(),
                        "function" === typeof a.UNSAFE_componentWillMount &&
                          a.UNSAFE_componentWillMount()),
                      "function" === typeof a.componentDidMount &&
                        (t.flags |= 4194308))
                    : ("function" === typeof a.componentDidMount &&
                        (t.flags |= 4194308),
                      (t.memoizedProps = r),
                      (t.memoizedState = c)),
                  (a.props = r),
                  (a.state = c),
                  (a.context = i),
                  (r = s))
                : ("function" === typeof a.componentDidMount &&
                    (t.flags |= 4194308),
                  (r = !1));
          } else {
            (a = t.stateNode),
              jl(e, t),
              (u = Li(n, (i = t.memoizedProps))),
              (a.props = u),
              (d = t.pendingProps),
              (f = a.context),
              (c = n.contextType),
              (s = _r),
              "object" === typeof c && null !== c && (s = Cl(c)),
              (c =
                "function" === typeof (l = n.getDerivedStateFromProps) ||
                "function" === typeof a.getSnapshotBeforeUpdate) ||
                ("function" !== typeof a.UNSAFE_componentWillReceiveProps &&
                  "function" !== typeof a.componentWillReceiveProps) ||
                ((i !== d || f !== s) && _i(t, a, r, s)),
              (Pl = !1),
              (f = t.memoizedState),
              (a.state = f),
              Ml(t, r, a, o),
              Il();
            var p = t.memoizedState;
            i !== d ||
            f !== p ||
            Pl ||
            (null !== e && null !== e.dependencies && xl(e.dependencies))
              ? ("function" === typeof l &&
                  (Oi(t, n, l, r), (p = t.memoizedState)),
                (u =
                  Pl ||
                  Ri(t, n, u, r, f, p, s) ||
                  (null !== e && null !== e.dependencies && xl(e.dependencies)))
                  ? (c ||
                      ("function" !== typeof a.UNSAFE_componentWillUpdate &&
                        "function" !== typeof a.componentWillUpdate) ||
                      ("function" === typeof a.componentWillUpdate &&
                        a.componentWillUpdate(r, p, s),
                      "function" === typeof a.UNSAFE_componentWillUpdate &&
                        a.UNSAFE_componentWillUpdate(r, p, s)),
                    "function" === typeof a.componentDidUpdate &&
                      (t.flags |= 4),
                    "function" === typeof a.getSnapshotBeforeUpdate &&
                      (t.flags |= 1024))
                  : ("function" !== typeof a.componentDidUpdate ||
                      (i === e.memoizedProps && f === e.memoizedState) ||
                      (t.flags |= 4),
                    "function" !== typeof a.getSnapshotBeforeUpdate ||
                      (i === e.memoizedProps && f === e.memoizedState) ||
                      (t.flags |= 1024),
                    (t.memoizedProps = r),
                    (t.memoizedState = p)),
                (a.props = r),
                (a.state = p),
                (a.context = s),
                (r = u))
              : ("function" !== typeof a.componentDidUpdate ||
                  (i === e.memoizedProps && f === e.memoizedState) ||
                  (t.flags |= 4),
                "function" !== typeof a.getSnapshotBeforeUpdate ||
                  (i === e.memoizedProps && f === e.memoizedState) ||
                  (t.flags |= 1024),
                (r = !1));
          }
          return (
            (a = r),
            Xi(e, t),
            (r = 0 !== (128 & t.flags)),
            a || r
              ? ((a = t.stateNode),
                (n =
                  r && "function" !== typeof n.getDerivedStateFromError
                    ? null
                    : a.render()),
                (t.flags |= 1),
                null !== e && r
                  ? ((t.child = ko(t, e.child, null, o)),
                    (t.child = ko(t, null, n, o)))
                  : $i(e, t, n, o),
                (t.memoizedState = a.state),
                (e = t.child))
              : (e = fl(e, t, o)),
            e
          );
        }
        function tl(e, t, n, r) {
          return oo(), (t.flags |= 256), $i(e, t, n, r), t.child;
        }
        var nl = { dehydrated: null, treeContext: null, retryLane: 0 };
        function rl(e) {
          return { baseLanes: e, cachePool: Jo() };
        }
        function ol(e, t, n) {
          return (e = null !== e ? e.childLanes & ~n : 0), t && (e |= hc), e;
        }
        function al(e, t, n) {
          var r,
            o = t.pendingProps,
            a = !1,
            l = 0 !== (128 & t.flags);
          if (
            ((r = l) ||
              (r =
                (null === e || null !== e.memoizedState) &&
                0 !== (2 & Ao.current)),
            r && ((a = !0), (t.flags &= -129)),
            (r = 0 !== (32 & t.flags)),
            (t.flags &= -33),
            null === e)
          ) {
            if (Gr) {
              if ((a ? Ro(t) : Lo(), Gr)) {
                var s,
                  c = Kr;
                if ((s = c)) {
                  e: {
                    for (s = c, c = Jr; 8 !== s.nodeType; ) {
                      if (!c) {
                        c = null;
                        break e;
                      }
                      if (null === (s = ld(s.nextSibling))) {
                        c = null;
                        break e;
                      }
                    }
                    c = s;
                  }
                  null !== c
                    ? ((t.memoizedState = {
                        dehydrated: c,
                        treeContext:
                          null !== Wr ? { id: Hr, overflow: Br } : null,
                        retryLane: 536870912,
                      }),
                      ((s = As(18, null, null, 0)).stateNode = c),
                      (s.return = t),
                      (t.child = s),
                      (Qr = t),
                      (Kr = null),
                      (s = !0))
                    : (s = !1);
                }
                s || eo(t);
              }
              if (null !== (c = t.memoizedState) && null !== (c = c.dehydrated))
                return (
                  "$!" === c.data ? (t.lanes = 16) : (t.lanes = 536870912), null
                );
              zo(t);
            }
            return (
              (c = o.children),
              (o = o.fallback),
              a
                ? (Lo(),
                  (c = ll({ mode: "hidden", children: c }, (a = t.mode))),
                  (o = Us(o, a, n, null)),
                  (c.return = t),
                  (o.return = t),
                  (c.sibling = o),
                  (t.child = c),
                  ((a = t.child).memoizedState = rl(n)),
                  (a.childLanes = ol(e, r, n)),
                  (t.memoizedState = nl),
                  o)
                : (Ro(t), il(t, c))
            );
          }
          if (null !== (s = e.memoizedState) && null !== (c = s.dehydrated)) {
            if (l)
              256 & t.flags
                ? (Ro(t), (t.flags &= -257), (t = sl(e, t, n)))
                : null !== t.memoizedState
                ? (Lo(), (t.child = e.child), (t.flags |= 128), (t = null))
                : (Lo(),
                  (a = o.fallback),
                  (c = t.mode),
                  (o = ll({ mode: "visible", children: o.children }, c)),
                  ((a = Us(a, c, n, null)).flags |= 2),
                  (o.return = t),
                  (a.return = t),
                  (o.sibling = a),
                  (t.child = o),
                  ko(t, e.child, null, n),
                  ((o = t.child).memoizedState = rl(n)),
                  (o.childLanes = ol(e, r, n)),
                  (t.memoizedState = nl),
                  (t = a));
            else if ((Ro(t), "$!" === c.data)) {
              if ((r = c.nextSibling && c.nextSibling.dataset)) var u = r.dgst;
              (r = u),
                ((o = Error(i(419))).stack = ""),
                (o.digest = r),
                ao({ value: o, source: null, stack: null }),
                (t = sl(e, t, n));
            } else if (
              (Vi || kl(e, t, n, !1), (r = 0 !== (n & e.childLanes)), Vi || r)
            ) {
              if (null !== (r = tc)) {
                if (0 !== (42 & (o = n & -n))) o = 1;
                else
                  switch (o) {
                    case 2:
                      o = 1;
                      break;
                    case 8:
                      o = 4;
                      break;
                    case 32:
                      o = 16;
                      break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                      o = 64;
                      break;
                    case 268435456:
                      o = 134217728;
                      break;
                    default:
                      o = 0;
                  }
                if (
                  0 !== (o = 0 !== (o & (r.suspendedLanes | n)) ? 0 : o) &&
                  o !== s.retryLane
                )
                  throw ((s.retryLane = o), Or(e, o), _c(r, e, o), Bi);
              }
              "$?" === c.data || Vc(), (t = sl(e, t, n));
            } else
              "$?" === c.data
                ? ((t.flags |= 128),
                  (t.child = e.child),
                  (t = lu.bind(null, e)),
                  (c._reactRetry = t),
                  (t = null))
                : ((e = s.treeContext),
                  (Kr = ld(c.nextSibling)),
                  (Qr = t),
                  (Gr = !0),
                  (Xr = null),
                  (Jr = !1),
                  null !== e &&
                    ((Dr[Ur++] = Hr),
                    (Dr[Ur++] = Br),
                    (Dr[Ur++] = Wr),
                    (Hr = e.id),
                    (Br = e.overflow),
                    (Wr = t)),
                  ((t = il(t, o.children)).flags |= 4096));
            return t;
          }
          return a
            ? (Lo(),
              (a = o.fallback),
              (c = t.mode),
              (u = (s = e.child).sibling),
              ((o = Ms(s, {
                mode: "hidden",
                children: o.children,
              })).subtreeFlags = 31457280 & s.subtreeFlags),
              null !== u
                ? (a = Ms(u, a))
                : ((a = Us(a, c, n, null)).flags |= 2),
              (a.return = t),
              (o.return = t),
              (o.sibling = a),
              (t.child = o),
              (o = a),
              (a = t.child),
              null === (c = e.child.memoizedState)
                ? (c = rl(n))
                : (null !== (s = c.cachePool)
                    ? ((u = Uo._currentValue),
                      (s = s.parent !== u ? { parent: u, pool: u } : s))
                    : (s = Jo()),
                  (c = { baseLanes: c.baseLanes | n, cachePool: s })),
              (a.memoizedState = c),
              (a.childLanes = ol(e, r, n)),
              (t.memoizedState = nl),
              o)
            : (Ro(t),
              (e = (n = e.child).sibling),
              ((n = Ms(n, { mode: "visible", children: o.children })).return =
                t),
              (n.sibling = null),
              null !== e &&
                (null === (r = t.deletions)
                  ? ((t.deletions = [e]), (t.flags |= 16))
                  : r.push(e)),
              (t.child = n),
              (t.memoizedState = null),
              n);
        }
        function il(e, t) {
          return (
            ((t = ll({ mode: "visible", children: t }, e.mode)).return = e),
            (e.child = t)
          );
        }
        function ll(e, t) {
          return Ws(e, t, 0, null);
        }
        function sl(e, t, n) {
          return (
            ko(t, e.child, null, n),
            ((e = il(t, t.pendingProps.children)).flags |= 2),
            (t.memoizedState = null),
            e
          );
        }
        function cl(e, t, n) {
          e.lanes |= t;
          var r = e.alternate;
          null !== r && (r.lanes |= t), wl(e.return, t, n);
        }
        function ul(e, t, n, r, o) {
          var a = e.memoizedState;
          null === a
            ? (e.memoizedState = {
                isBackwards: t,
                rendering: null,
                renderingStartTime: 0,
                last: r,
                tail: n,
                tailMode: o,
              })
            : ((a.isBackwards = t),
              (a.rendering = null),
              (a.renderingStartTime = 0),
              (a.last = r),
              (a.tail = n),
              (a.tailMode = o));
        }
        function dl(e, t, n) {
          var r = t.pendingProps,
            o = r.revealOrder,
            a = r.tail;
          if (($i(e, t, r.children, n), 0 !== (2 & (r = Ao.current))))
            (r = (1 & r) | 2), (t.flags |= 128);
          else {
            if (null !== e && 0 !== (128 & e.flags))
              e: for (e = t.child; null !== e; ) {
                if (13 === e.tag) null !== e.memoizedState && cl(e, n, t);
                else if (19 === e.tag) cl(e, n, t);
                else if (null !== e.child) {
                  (e.child.return = e), (e = e.child);
                  continue;
                }
                if (e === t) break e;
                for (; null === e.sibling; ) {
                  if (null === e.return || e.return === t) break e;
                  e = e.return;
                }
                (e.sibling.return = e.return), (e = e.sibling);
              }
            r &= 1;
          }
          switch ((Q(Ao, r), o)) {
            case "forwards":
              for (n = t.child, o = null; null !== n; )
                null !== (e = n.alternate) && null === Io(e) && (o = n),
                  (n = n.sibling);
              null === (n = o)
                ? ((o = t.child), (t.child = null))
                : ((o = n.sibling), (n.sibling = null)),
                ul(t, !1, o, n, a);
              break;
            case "backwards":
              for (n = null, o = t.child, t.child = null; null !== o; ) {
                if (null !== (e = o.alternate) && null === Io(e)) {
                  t.child = o;
                  break;
                }
                (e = o.sibling), (o.sibling = n), (n = o), (o = e);
              }
              ul(t, !0, n, null, a);
              break;
            case "together":
              ul(t, !1, null, null, void 0);
              break;
            default:
              t.memoizedState = null;
          }
          return t.child;
        }
        function fl(e, t, n) {
          if (
            (null !== e && (t.dependencies = e.dependencies),
            (dc |= t.lanes),
            0 === (n & t.childLanes))
          ) {
            if (null === e) return null;
            if ((kl(e, t, n, !1), 0 === (n & t.childLanes))) return null;
          }
          if (null !== e && t.child !== e.child) throw Error(i(153));
          if (null !== t.child) {
            for (
              n = Ms((e = t.child), e.pendingProps), t.child = n, n.return = t;
              null !== e.sibling;

            )
              (e = e.sibling),
                ((n = n.sibling = Ms(e, e.pendingProps)).return = t);
            n.sibling = null;
          }
          return t.child;
        }
        function pl(e, t) {
          return (
            0 !== (e.lanes & t) || !(null === (e = e.dependencies) || !xl(e))
          );
        }
        function hl(e, t, n) {
          if (null !== e)
            if (e.memoizedProps !== t.pendingProps) Vi = !0;
            else {
              if (!pl(e, n) && 0 === (128 & t.flags))
                return (
                  (Vi = !1),
                  (function (e, t, n) {
                    switch (t.tag) {
                      case 3:
                        Z(t, t.stateNode.containerInfo),
                          gl(t, Uo, e.memoizedState.cache),
                          oo();
                        break;
                      case 27:
                      case 5:
                        te(t);
                        break;
                      case 4:
                        Z(t, t.stateNode.containerInfo);
                        break;
                      case 10:
                        gl(t, t.type, t.memoizedProps.value);
                        break;
                      case 13:
                        var r = t.memoizedState;
                        if (null !== r)
                          return null !== r.dehydrated
                            ? (Ro(t), (t.flags |= 128), null)
                            : 0 !== (n & t.child.childLanes)
                            ? al(e, t, n)
                            : (Ro(t),
                              null !== (e = fl(e, t, n)) ? e.sibling : null);
                        Ro(t);
                        break;
                      case 19:
                        var o = 0 !== (128 & e.flags);
                        if (
                          ((r = 0 !== (n & t.childLanes)) ||
                            (kl(e, t, n, !1), (r = 0 !== (n & t.childLanes))),
                          o)
                        ) {
                          if (r) return dl(e, t, n);
                          t.flags |= 128;
                        }
                        if (
                          (null !== (o = t.memoizedState) &&
                            ((o.rendering = null),
                            (o.tail = null),
                            (o.lastEffect = null)),
                          Q(Ao, Ao.current),
                          r)
                        )
                          break;
                        return null;
                      case 22:
                      case 23:
                        return (t.lanes = 0), Ki(e, t, n);
                      case 24:
                        gl(t, Uo, e.memoizedState.cache);
                    }
                    return fl(e, t, n);
                  })(e, t, n)
                );
              Vi = 0 !== (131072 & e.flags);
            }
          else (Vi = !1), Gr && 0 !== (1048576 & t.flags) && $r(t, Fr, t.index);
          switch (((t.lanes = 0), t.tag)) {
            case 16:
              e: {
                e = t.pendingProps;
                var r = t.elementType,
                  o = r._init;
                if (
                  ((r = o(r._payload)), (t.type = r), "function" !== typeof r)
                ) {
                  if (void 0 !== r && null !== r) {
                    if ((o = r.$$typeof) === v) {
                      (t.tag = 11), (t = qi(null, t, r, e, n));
                      break e;
                    }
                    if (o === w) {
                      (t.tag = 14), (t = Yi(null, t, r, e, n));
                      break e;
                    }
                  }
                  throw ((t = T(r) || r), Error(i(306, t, "")));
                }
                Is(r)
                  ? ((e = Li(r, e)), (t.tag = 1), (t = el(null, t, r, e, n)))
                  : ((t.tag = 0), (t = Ji(null, t, r, e, n)));
              }
              return t;
            case 0:
              return Ji(e, t, t.type, t.pendingProps, n);
            case 1:
              return el(e, t, (r = t.type), (o = Li(r, t.pendingProps)), n);
            case 3:
              e: {
                if ((Z(t, t.stateNode.containerInfo), null === e))
                  throw Error(i(387));
                var a = t.pendingProps;
                (r = (o = t.memoizedState).element),
                  jl(e, t),
                  Ml(t, a, null, n);
                var l = t.memoizedState;
                if (
                  ((a = l.cache),
                  gl(t, Uo, a),
                  a !== o.cache && Sl(t, [Uo], n, !0),
                  Il(),
                  (a = l.element),
                  o.isDehydrated)
                ) {
                  if (
                    ((o = { element: a, isDehydrated: !1, cache: l.cache }),
                    (t.updateQueue.baseState = o),
                    (t.memoizedState = o),
                    256 & t.flags)
                  ) {
                    t = tl(e, t, a, n);
                    break e;
                  }
                  if (a !== r) {
                    ao((r = zr(Error(i(424)), t))), (t = tl(e, t, a, n));
                    break e;
                  }
                  for (
                    Kr = ld(t.stateNode.containerInfo.firstChild),
                      Qr = t,
                      Gr = !0,
                      Xr = null,
                      Jr = !0,
                      n = xo(t, null, a, n),
                      t.child = n;
                    n;

                  )
                    (n.flags = (-3 & n.flags) | 4096), (n = n.sibling);
                } else {
                  if ((oo(), a === r)) {
                    t = fl(e, t, n);
                    break e;
                  }
                  $i(e, t, a, n);
                }
                t = t.child;
              }
              return t;
            case 26:
              return (
                Xi(e, t),
                null === e
                  ? (n = yd(t.type, null, t.pendingProps, null))
                    ? (t.memoizedState = n)
                    : Gr ||
                      ((n = t.type),
                      (e = t.pendingProps),
                      ((r = Ku(X.current).createElement(n))[Fe] = t),
                      (r[De] = e),
                      qu(r, n, e),
                      Xe(r),
                      (t.stateNode = r))
                  : (t.memoizedState = yd(
                      t.type,
                      e.memoizedProps,
                      t.pendingProps,
                      e.memoizedState
                    )),
                null
              );
            case 27:
              return (
                te(t),
                null === e &&
                  Gr &&
                  ((r = t.stateNode = cd(t.type, t.pendingProps, X.current)),
                  (Qr = t),
                  (Jr = !0),
                  (Kr = ld(r.firstChild))),
                (r = t.pendingProps.children),
                null !== e || Gr
                  ? $i(e, t, r, n)
                  : (t.child = ko(t, null, r, n)),
                Xi(e, t),
                t.child
              );
            case 5:
              return (
                null === e &&
                  Gr &&
                  ((o = r = Kr) &&
                    (null !==
                    (r = (function (e, t, n, r) {
                      for (; 1 === e.nodeType; ) {
                        var o = n;
                        if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
                          if (
                            !r &&
                            ("INPUT" !== e.nodeName || "hidden" !== e.type)
                          )
                            break;
                        } else if (r) {
                          if (!e[$e])
                            switch (t) {
                              case "meta":
                                if (!e.hasAttribute("itemprop")) break;
                                return e;
                              case "link":
                                if (
                                  "stylesheet" ===
                                    (a = e.getAttribute("rel")) &&
                                  e.hasAttribute("data-precedence")
                                )
                                  break;
                                if (
                                  a !== o.rel ||
                                  e.getAttribute("href") !==
                                    (null == o.href ? null : o.href) ||
                                  e.getAttribute("crossorigin") !==
                                    (null == o.crossOrigin
                                      ? null
                                      : o.crossOrigin) ||
                                  e.getAttribute("title") !==
                                    (null == o.title ? null : o.title)
                                )
                                  break;
                                return e;
                              case "style":
                                if (e.hasAttribute("data-precedence")) break;
                                return e;
                              case "script":
                                if (
                                  ((a = e.getAttribute("src")) !==
                                    (null == o.src ? null : o.src) ||
                                    e.getAttribute("type") !==
                                      (null == o.type ? null : o.type) ||
                                    e.getAttribute("crossorigin") !==
                                      (null == o.crossOrigin
                                        ? null
                                        : o.crossOrigin)) &&
                                  a &&
                                  e.hasAttribute("async") &&
                                  !e.hasAttribute("itemprop")
                                )
                                  break;
                                return e;
                              default:
                                return e;
                            }
                        } else {
                          if ("input" !== t || "hidden" !== e.type) return e;
                          var a = null == o.name ? null : "" + o.name;
                          if (
                            "hidden" === o.type &&
                            e.getAttribute("name") === a
                          )
                            return e;
                        }
                        if (null === (e = ld(e.nextSibling))) break;
                      }
                      return null;
                    })(r, t.type, t.pendingProps, Jr))
                      ? ((t.stateNode = r),
                        (Qr = t),
                        (Kr = ld(r.firstChild)),
                        (Jr = !1),
                        (o = !0))
                      : (o = !1)),
                  o || eo(t)),
                te(t),
                (o = t.type),
                (a = t.pendingProps),
                (l = null !== e ? e.memoizedProps : null),
                (r = a.children),
                Ju(o, a)
                  ? (r = null)
                  : null !== l && Ju(o, l) && (t.flags |= 32),
                null !== t.memoizedState &&
                  ((o = fa(e, t, ma, null, null, n)), (Id._currentValue = o)),
                Xi(e, t),
                $i(e, t, r, n),
                t.child
              );
            case 6:
              return (
                null === e &&
                  Gr &&
                  ((e = n = Kr) &&
                    (null !==
                    (n = (function (e, t, n) {
                      if ("" === t) return null;
                      for (; 3 !== e.nodeType; ) {
                        if (
                          (1 !== e.nodeType ||
                            "INPUT" !== e.nodeName ||
                            "hidden" !== e.type) &&
                          !n
                        )
                          return null;
                        if (null === (e = ld(e.nextSibling))) return null;
                      }
                      return e;
                    })(n, t.pendingProps, Jr))
                      ? ((t.stateNode = n), (Qr = t), (Kr = null), (e = !0))
                      : (e = !1)),
                  e || eo(t)),
                null
              );
            case 13:
              return al(e, t, n);
            case 4:
              return (
                Z(t, t.stateNode.containerInfo),
                (r = t.pendingProps),
                null === e ? (t.child = ko(t, null, r, n)) : $i(e, t, r, n),
                t.child
              );
            case 11:
              return qi(e, t, t.type, t.pendingProps, n);
            case 7:
              return $i(e, t, t.pendingProps, n), t.child;
            case 8:
            case 12:
              return $i(e, t, t.pendingProps.children, n), t.child;
            case 10:
              return (
                (r = t.pendingProps),
                gl(t, t.type, r.value),
                $i(e, t, r.children, n),
                t.child
              );
            case 9:
              return (
                (o = t.type._context),
                (r = t.pendingProps.children),
                El(t),
                (r = r((o = Cl(o)))),
                (t.flags |= 1),
                $i(e, t, r, n),
                t.child
              );
            case 14:
              return Yi(e, t, t.type, t.pendingProps, n);
            case 15:
              return Qi(e, t, t.type, t.pendingProps, n);
            case 19:
              return dl(e, t, n);
            case 22:
              return Ki(e, t, n);
            case 24:
              return (
                El(t),
                (r = Cl(Uo)),
                null === e
                  ? (null === (o = Go()) &&
                      ((o = tc),
                      (a = Wo()),
                      (o.pooledCache = a),
                      a.refCount++,
                      null !== a && (o.pooledCacheLanes |= n),
                      (o = a)),
                    (t.memoizedState = { parent: r, cache: o }),
                    Ol(t),
                    gl(t, Uo, o))
                  : (0 !== (e.lanes & n) &&
                      (jl(e, t), Ml(t, null, null, n), Il()),
                    (o = e.memoizedState),
                    (a = t.memoizedState),
                    o.parent !== r
                      ? ((o = { parent: r, cache: r }),
                        (t.memoizedState = o),
                        0 === t.lanes &&
                          (t.memoizedState = t.updateQueue.baseState = o),
                        gl(t, Uo, r))
                      : ((r = a.cache),
                        gl(t, Uo, r),
                        r !== o.cache && Sl(t, [Uo], n, !0))),
                $i(e, t, t.pendingProps.children, n),
                t.child
              );
            case 29:
              throw t.pendingProps;
          }
          throw Error(i(156, t.tag));
        }
        var ml = q(null),
          yl = null,
          vl = null;
        function gl(e, t, n) {
          Q(ml, t._currentValue), (t._currentValue = n);
        }
        function bl(e) {
          (e._currentValue = ml.current), Y(ml);
        }
        function wl(e, t, n) {
          for (; null !== e; ) {
            var r = e.alternate;
            if (
              ((e.childLanes & t) !== t
                ? ((e.childLanes |= t), null !== r && (r.childLanes |= t))
                : null !== r && (r.childLanes & t) !== t && (r.childLanes |= t),
              e === n)
            )
              break;
            e = e.return;
          }
        }
        function Sl(e, t, n, r) {
          var o = e.child;
          for (null !== o && (o.return = e); null !== o; ) {
            var a = o.dependencies;
            if (null !== a) {
              var l = o.child;
              a = a.firstContext;
              e: for (; null !== a; ) {
                var s = a;
                a = o;
                for (var c = 0; c < t.length; c++)
                  if (s.context === t[c]) {
                    (a.lanes |= n),
                      null !== (s = a.alternate) && (s.lanes |= n),
                      wl(a.return, n, e),
                      r || (l = null);
                    break e;
                  }
                a = s.next;
              }
            } else if (18 === o.tag) {
              if (null === (l = o.return)) throw Error(i(341));
              (l.lanes |= n),
                null !== (a = l.alternate) && (a.lanes |= n),
                wl(l, n, e),
                (l = null);
            } else l = o.child;
            if (null !== l) l.return = o;
            else
              for (l = o; null !== l; ) {
                if (l === e) {
                  l = null;
                  break;
                }
                if (null !== (o = l.sibling)) {
                  (o.return = l.return), (l = o);
                  break;
                }
                l = l.return;
              }
            o = l;
          }
        }
        function kl(e, t, n, r) {
          e = null;
          for (var o = t, a = !1; null !== o; ) {
            if (!a)
              if (0 !== (524288 & o.flags)) a = !0;
              else if (0 !== (262144 & o.flags)) break;
            if (10 === o.tag) {
              var l = o.alternate;
              if (null === l) throw Error(i(387));
              if (null !== (l = l.memoizedProps)) {
                var s = o.type;
                Qn(o.pendingProps.value, l.value) ||
                  (null !== e ? e.push(s) : (e = [s]));
              }
            } else if (o === J.current) {
              if (null === (l = o.alternate)) throw Error(i(387));
              l.memoizedState.memoizedState !== o.memoizedState.memoizedState &&
                (null !== e ? e.push(Id) : (e = [Id]));
            }
            o = o.return;
          }
          null !== e && Sl(t, e, n, r), (t.flags |= 262144);
        }
        function xl(e) {
          for (e = e.firstContext; null !== e; ) {
            if (!Qn(e.context._currentValue, e.memoizedValue)) return !0;
            e = e.next;
          }
          return !1;
        }
        function El(e) {
          (yl = e),
            (vl = null),
            null !== (e = e.dependencies) && (e.firstContext = null);
        }
        function Cl(e) {
          return Tl(yl, e);
        }
        function Nl(e, t) {
          return null === yl && El(e), Tl(e, t);
        }
        function Tl(e, t) {
          var n = t._currentValue;
          if (
            ((t = { context: t, memoizedValue: n, next: null }), null === vl)
          ) {
            if (null === e) throw Error(i(308));
            (vl = t),
              (e.dependencies = { lanes: 0, firstContext: t }),
              (e.flags |= 524288);
          } else vl = vl.next = t;
          return n;
        }
        var Pl = !1;
        function Ol(e) {
          e.updateQueue = {
            baseState: e.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null, lanes: 0, hiddenCallbacks: null },
            callbacks: null,
          };
        }
        function jl(e, t) {
          (e = e.updateQueue),
            t.updateQueue === e &&
              (t.updateQueue = {
                baseState: e.baseState,
                firstBaseUpdate: e.firstBaseUpdate,
                lastBaseUpdate: e.lastBaseUpdate,
                shared: e.shared,
                callbacks: null,
              });
        }
        function Rl(e) {
          return { lane: e, tag: 0, payload: null, callback: null, next: null };
        }
        function _l(e, t, n) {
          var r = e.updateQueue;
          if (null === r) return null;
          if (((r = r.shared), 0 !== (2 & ec))) {
            var o = r.pending;
            return (
              null === o ? (t.next = t) : ((t.next = o.next), (o.next = t)),
              (r.pending = t),
              (t = Rr(e)),
              jr(e, null, n),
              t
            );
          }
          return Tr(e, r, t, n), Rr(e);
        }
        function Ll(e, t, n) {
          if (
            null !== (t = t.updateQueue) &&
            ((t = t.shared), 0 !== (4194176 & n))
          ) {
            var r = t.lanes;
            (n |= r &= e.pendingLanes), (t.lanes = n), ze(e, n);
          }
        }
        function zl(e, t) {
          var n = e.updateQueue,
            r = e.alternate;
          if (null !== r && n === (r = r.updateQueue)) {
            var o = null,
              a = null;
            if (null !== (n = n.firstBaseUpdate)) {
              do {
                var i = {
                  lane: n.lane,
                  tag: n.tag,
                  payload: n.payload,
                  callback: null,
                  next: null,
                };
                null === a ? (o = a = i) : (a = a.next = i), (n = n.next);
              } while (null !== n);
              null === a ? (o = a = t) : (a = a.next = t);
            } else o = a = t;
            return (
              (n = {
                baseState: r.baseState,
                firstBaseUpdate: o,
                lastBaseUpdate: a,
                shared: r.shared,
                callbacks: r.callbacks,
              }),
              void (e.updateQueue = n)
            );
          }
          null === (e = n.lastBaseUpdate)
            ? (n.firstBaseUpdate = t)
            : (e.next = t),
            (n.lastBaseUpdate = t);
        }
        var Al = !1;
        function Il() {
          if (Al) {
            if (null !== qo) throw qo;
          }
        }
        function Ml(e, t, n, r) {
          Al = !1;
          var o = e.updateQueue;
          Pl = !1;
          var a = o.firstBaseUpdate,
            i = o.lastBaseUpdate,
            l = o.shared.pending;
          if (null !== l) {
            o.shared.pending = null;
            var s = l,
              c = s.next;
            (s.next = null), null === i ? (a = c) : (i.next = c), (i = s);
            var u = e.alternate;
            null !== u &&
              (l = (u = u.updateQueue).lastBaseUpdate) !== i &&
              (null === l ? (u.firstBaseUpdate = c) : (l.next = c),
              (u.lastBaseUpdate = s));
          }
          if (null !== a) {
            var d = o.baseState;
            for (i = 0, u = c = s = null, l = a; ; ) {
              var f = -536870913 & l.lane,
                p = f !== l.lane;
              if (p ? (rc & f) === f : (r & f) === f) {
                0 !== f && f === $o && (Al = !0),
                  null !== u &&
                    (u = u.next =
                      {
                        lane: 0,
                        tag: l.tag,
                        payload: l.payload,
                        callback: null,
                        next: null,
                      });
                e: {
                  var h = e,
                    m = l;
                  f = t;
                  var y = n;
                  switch (m.tag) {
                    case 1:
                      if ("function" === typeof (h = m.payload)) {
                        d = h.call(y, d, f);
                        break e;
                      }
                      d = h;
                      break e;
                    case 3:
                      h.flags = (-65537 & h.flags) | 128;
                    case 0:
                      if (
                        null ===
                          (f =
                            "function" === typeof (h = m.payload)
                              ? h.call(y, d, f)
                              : h) ||
                        void 0 === f
                      )
                        break e;
                      d = R({}, d, f);
                      break e;
                    case 2:
                      Pl = !0;
                  }
                }
                null !== (f = l.callback) &&
                  ((e.flags |= 64),
                  p && (e.flags |= 8192),
                  null === (p = o.callbacks) ? (o.callbacks = [f]) : p.push(f));
              } else
                (p = {
                  lane: f,
                  tag: l.tag,
                  payload: l.payload,
                  callback: l.callback,
                  next: null,
                }),
                  null === u ? ((c = u = p), (s = d)) : (u = u.next = p),
                  (i |= f);
              if (null === (l = l.next)) {
                if (null === (l = o.shared.pending)) break;
                (l = (p = l).next),
                  (p.next = null),
                  (o.lastBaseUpdate = p),
                  (o.shared.pending = null);
              }
            }
            null === u && (s = d),
              (o.baseState = s),
              (o.firstBaseUpdate = c),
              (o.lastBaseUpdate = u),
              null === a && (o.shared.lanes = 0),
              (dc |= i),
              (e.lanes = i),
              (e.memoizedState = d);
          }
        }
        function Fl(e, t) {
          if ("function" !== typeof e) throw Error(i(191, e));
          e.call(t);
        }
        function Dl(e, t) {
          var n = e.callbacks;
          if (null !== n)
            for (e.callbacks = null, e = 0; e < n.length; e++) Fl(n[e], t);
        }
        function Ul(e, t) {
          try {
            var n = t.updateQueue,
              r = null !== n ? n.lastEffect : null;
            if (null !== r) {
              var o = r.next;
              n = o;
              do {
                if ((n.tag & e) === e) {
                  r = void 0;
                  var a = n.create,
                    i = n.inst;
                  (r = a()), (i.destroy = r);
                }
                n = n.next;
              } while (n !== o);
            }
          } catch (l) {
            ru(t, t.return, l);
          }
        }
        function Wl(e, t, n) {
          try {
            var r = t.updateQueue,
              o = null !== r ? r.lastEffect : null;
            if (null !== o) {
              var a = o.next;
              r = a;
              do {
                if ((r.tag & e) === e) {
                  var i = r.inst,
                    l = i.destroy;
                  if (void 0 !== l) {
                    (i.destroy = void 0), (o = t);
                    var s = n;
                    try {
                      l();
                    } catch (c) {
                      ru(o, s, c);
                    }
                  }
                }
                r = r.next;
              } while (r !== a);
            }
          } catch (c) {
            ru(t, t.return, c);
          }
        }
        function Hl(e) {
          var t = e.updateQueue;
          if (null !== t) {
            var n = e.stateNode;
            try {
              Dl(t, n);
            } catch (r) {
              ru(e, e.return, r);
            }
          }
        }
        function Bl(e, t, n) {
          (n.props = Li(e.type, e.memoizedProps)), (n.state = e.memoizedState);
          try {
            n.componentWillUnmount();
          } catch (r) {
            ru(e, t, r);
          }
        }
        function Vl(e, t) {
          try {
            var n = e.ref;
            if (null !== n) {
              var r = e.stateNode;
              switch (e.tag) {
                case 26:
                case 27:
                case 5:
                  var o = r;
                  break;
                default:
                  o = r;
              }
              "function" === typeof n ? (e.refCleanup = n(o)) : (n.current = o);
            }
          } catch (a) {
            ru(e, t, a);
          }
        }
        function $l(e, t) {
          var n = e.ref,
            r = e.refCleanup;
          if (null !== n)
            if ("function" === typeof r)
              try {
                r();
              } catch (o) {
                ru(e, t, o);
              } finally {
                (e.refCleanup = null),
                  null != (e = e.alternate) && (e.refCleanup = null);
              }
            else if ("function" === typeof n)
              try {
                n(null);
              } catch (a) {
                ru(e, t, a);
              }
            else n.current = null;
        }
        function ql(e) {
          var t = e.type,
            n = e.memoizedProps,
            r = e.stateNode;
          try {
            e: switch (t) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                n.autoFocus && r.focus();
                break e;
              case "img":
                n.src ? (r.src = n.src) : n.srcSet && (r.srcset = n.srcSet);
            }
          } catch (o) {
            ru(e, e.return, o);
          }
        }
        function Yl(e, t, n) {
          try {
            var r = e.stateNode;
            !(function (e, t, n, r) {
              switch (t) {
                case "div":
                case "span":
                case "svg":
                case "path":
                case "a":
                case "g":
                case "p":
                case "li":
                  break;
                case "input":
                  var o = null,
                    a = null,
                    l = null,
                    s = null,
                    c = null,
                    u = null,
                    d = null;
                  for (h in n) {
                    var f = n[h];
                    if (n.hasOwnProperty(h) && null != f)
                      switch (h) {
                        case "checked":
                        case "value":
                          break;
                        case "defaultValue":
                          c = f;
                        default:
                          r.hasOwnProperty(h) || Vu(e, t, h, null, r, f);
                      }
                  }
                  for (var p in r) {
                    var h = r[p];
                    if (
                      ((f = n[p]),
                      r.hasOwnProperty(p) && (null != h || null != f))
                    )
                      switch (p) {
                        case "type":
                          a = h;
                          break;
                        case "name":
                          o = h;
                          break;
                        case "checked":
                          u = h;
                          break;
                        case "defaultChecked":
                          d = h;
                          break;
                        case "value":
                          l = h;
                          break;
                        case "defaultValue":
                          s = h;
                          break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                          if (null != h) throw Error(i(137, t));
                          break;
                        default:
                          h !== f && Vu(e, t, p, h, r, f);
                      }
                  }
                  return void yt(e, l, s, c, u, d, a, o);
                case "select":
                  for (a in ((h = l = s = p = null), n))
                    if (((c = n[a]), n.hasOwnProperty(a) && null != c))
                      switch (a) {
                        case "value":
                          break;
                        case "multiple":
                          h = c;
                        default:
                          r.hasOwnProperty(a) || Vu(e, t, a, null, r, c);
                      }
                  for (o in r)
                    if (
                      ((a = r[o]),
                      (c = n[o]),
                      r.hasOwnProperty(o) && (null != a || null != c))
                    )
                      switch (o) {
                        case "value":
                          p = a;
                          break;
                        case "defaultValue":
                          s = a;
                          break;
                        case "multiple":
                          l = a;
                        default:
                          a !== c && Vu(e, t, o, a, r, c);
                      }
                  return (
                    (t = s),
                    (n = l),
                    (r = h),
                    void (null != p
                      ? bt(e, !!n, p, !1)
                      : !!r !== !!n &&
                        (null != t
                          ? bt(e, !!n, t, !0)
                          : bt(e, !!n, n ? [] : "", !1)))
                  );
                case "textarea":
                  for (s in ((h = p = null), n))
                    if (
                      ((o = n[s]),
                      n.hasOwnProperty(s) && null != o && !r.hasOwnProperty(s))
                    )
                      switch (s) {
                        case "value":
                        case "children":
                          break;
                        default:
                          Vu(e, t, s, null, r, o);
                      }
                  for (l in r)
                    if (
                      ((o = r[l]),
                      (a = n[l]),
                      r.hasOwnProperty(l) && (null != o || null != a))
                    )
                      switch (l) {
                        case "value":
                          p = o;
                          break;
                        case "defaultValue":
                          h = o;
                          break;
                        case "children":
                          break;
                        case "dangerouslySetInnerHTML":
                          if (null != o) throw Error(i(91));
                          break;
                        default:
                          o !== a && Vu(e, t, l, o, r, a);
                      }
                  return void wt(e, p, h);
                case "option":
                  for (var m in n)
                    if (
                      ((p = n[m]),
                      n.hasOwnProperty(m) && null != p && !r.hasOwnProperty(m))
                    )
                      if ("selected" === m) e.selected = !1;
                      else Vu(e, t, m, null, r, p);
                  for (c in r)
                    if (
                      ((p = r[c]),
                      (h = n[c]),
                      r.hasOwnProperty(c) &&
                        p !== h &&
                        (null != p || null != h))
                    )
                      if ("selected" === c)
                        e.selected =
                          p && "function" !== typeof p && "symbol" !== typeof p;
                      else Vu(e, t, c, p, r, h);
                  return;
                case "img":
                case "link":
                case "area":
                case "base":
                case "br":
                case "col":
                case "embed":
                case "hr":
                case "keygen":
                case "meta":
                case "param":
                case "source":
                case "track":
                case "wbr":
                case "menuitem":
                  for (var y in n)
                    (p = n[y]),
                      n.hasOwnProperty(y) &&
                        null != p &&
                        !r.hasOwnProperty(y) &&
                        Vu(e, t, y, null, r, p);
                  for (u in r)
                    if (
                      ((p = r[u]),
                      (h = n[u]),
                      r.hasOwnProperty(u) &&
                        p !== h &&
                        (null != p || null != h))
                    )
                      switch (u) {
                        case "children":
                        case "dangerouslySetInnerHTML":
                          if (null != p) throw Error(i(137, t));
                          break;
                        default:
                          Vu(e, t, u, p, r, h);
                      }
                  return;
                default:
                  if (Nt(t)) {
                    for (var v in n)
                      (p = n[v]),
                        n.hasOwnProperty(v) &&
                          void 0 !== p &&
                          !r.hasOwnProperty(v) &&
                          $u(e, t, v, void 0, r, p);
                    for (d in r)
                      (p = r[d]),
                        (h = n[d]),
                        !r.hasOwnProperty(d) ||
                          p === h ||
                          (void 0 === p && void 0 === h) ||
                          $u(e, t, d, p, r, h);
                    return;
                  }
              }
              for (var g in n)
                (p = n[g]),
                  n.hasOwnProperty(g) &&
                    null != p &&
                    !r.hasOwnProperty(g) &&
                    Vu(e, t, g, null, r, p);
              for (f in r)
                (p = r[f]),
                  (h = n[f]),
                  !r.hasOwnProperty(f) ||
                    p === h ||
                    (null == p && null == h) ||
                    Vu(e, t, f, p, r, h);
            })(r, e.type, n, t),
              (r[De] = t);
          } catch (o) {
            ru(e, e.return, o);
          }
        }
        function Ql(e) {
          return (
            5 === e.tag ||
            3 === e.tag ||
            26 === e.tag ||
            27 === e.tag ||
            4 === e.tag
          );
        }
        function Kl(e) {
          e: for (;;) {
            for (; null === e.sibling; ) {
              if (null === e.return || Ql(e.return)) return null;
              e = e.return;
            }
            for (
              e.sibling.return = e.return, e = e.sibling;
              5 !== e.tag && 6 !== e.tag && 27 !== e.tag && 18 !== e.tag;

            ) {
              if (2 & e.flags) continue e;
              if (null === e.child || 4 === e.tag) continue e;
              (e.child.return = e), (e = e.child);
            }
            if (!(2 & e.flags)) return e.stateNode;
          }
        }
        function Gl(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r)
            (e = e.stateNode),
              t
                ? 8 === n.nodeType
                  ? n.parentNode.insertBefore(e, t)
                  : n.insertBefore(e, t)
                : (8 === n.nodeType
                    ? (t = n.parentNode).insertBefore(e, n)
                    : (t = n).appendChild(e),
                  (null !== (n = n._reactRootContainer) && void 0 !== n) ||
                    null !== t.onclick ||
                    (t.onclick = Bu));
          else if (4 !== r && 27 !== r && null !== (e = e.child))
            for (Gl(e, t, n), e = e.sibling; null !== e; )
              Gl(e, t, n), (e = e.sibling);
        }
        function Xl(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r)
            (e = e.stateNode), t ? n.insertBefore(e, t) : n.appendChild(e);
          else if (4 !== r && 27 !== r && null !== (e = e.child))
            for (Xl(e, t, n), e = e.sibling; null !== e; )
              Xl(e, t, n), (e = e.sibling);
        }
        var Jl = !1,
          Zl = !1,
          es = !1,
          ts = "function" === typeof WeakSet ? WeakSet : Set,
          ns = null,
          rs = !1;
        function os(e, t, n) {
          var r = n.flags;
          switch (n.tag) {
            case 0:
            case 11:
            case 15:
              vs(e, n), 4 & r && Ul(5, n);
              break;
            case 1:
              if ((vs(e, n), 4 & r))
                if (((e = n.stateNode), null === t))
                  try {
                    e.componentDidMount();
                  } catch (l) {
                    ru(n, n.return, l);
                  }
                else {
                  var o = Li(n.type, t.memoizedProps);
                  t = t.memoizedState;
                  try {
                    e.componentDidUpdate(
                      o,
                      t,
                      e.__reactInternalSnapshotBeforeUpdate
                    );
                  } catch (s) {
                    ru(n, n.return, s);
                  }
                }
              64 & r && Hl(n), 512 & r && Vl(n, n.return);
              break;
            case 3:
              if ((vs(e, n), 64 & r && null !== (r = n.updateQueue))) {
                if (((e = null), null !== n.child))
                  switch (n.child.tag) {
                    case 27:
                    case 5:
                    case 1:
                      e = n.child.stateNode;
                  }
                try {
                  Dl(r, e);
                } catch (l) {
                  ru(n, n.return, l);
                }
              }
              break;
            case 26:
              vs(e, n), 512 & r && Vl(n, n.return);
              break;
            case 27:
            case 5:
              vs(e, n),
                null === t && 4 & r && ql(n),
                512 & r && Vl(n, n.return);
              break;
            case 12:
            default:
              vs(e, n);
              break;
            case 13:
              vs(e, n), 4 & r && us(e, n);
              break;
            case 22:
              if (!(o = null !== n.memoizedState || Jl)) {
                t = (null !== t && null !== t.memoizedState) || Zl;
                var a = Jl,
                  i = Zl;
                (Jl = o),
                  (Zl = t) && !i
                    ? bs(e, n, 0 !== (8772 & n.subtreeFlags))
                    : vs(e, n),
                  (Jl = a),
                  (Zl = i);
              }
              512 & r &&
                ("manual" === n.memoizedProps.mode
                  ? Vl(n, n.return)
                  : $l(n, n.return));
          }
        }
        function as(e) {
          var t = e.alternate;
          null !== t && ((e.alternate = null), as(t)),
            (e.child = null),
            (e.deletions = null),
            (e.sibling = null),
            5 === e.tag && null !== (t = e.stateNode) && qe(t),
            (e.stateNode = null),
            (e.return = null),
            (e.dependencies = null),
            (e.memoizedProps = null),
            (e.memoizedState = null),
            (e.pendingProps = null),
            (e.stateNode = null),
            (e.updateQueue = null);
        }
        var is = null,
          ls = !1;
        function ss(e, t, n) {
          for (n = n.child; null !== n; ) cs(e, t, n), (n = n.sibling);
        }
        function cs(e, t, n) {
          if (ge && "function" === typeof ge.onCommitFiberUnmount)
            try {
              ge.onCommitFiberUnmount(ve, n);
            } catch (i) {}
          switch (n.tag) {
            case 26:
              Zl || $l(n, t),
                ss(e, t, n),
                n.memoizedState
                  ? n.memoizedState.count--
                  : n.stateNode && (n = n.stateNode).parentNode.removeChild(n);
              break;
            case 27:
              Zl || $l(n, t);
              var r = is,
                o = ls;
              for (
                is = n.stateNode, ss(e, t, n), t = (n = n.stateNode).attributes;
                t.length;

              )
                n.removeAttributeNode(t[0]);
              qe(n), (is = r), (ls = o);
              break;
            case 5:
              Zl || $l(n, t);
            case 6:
              o = is;
              var a = ls;
              if (((is = null), ss(e, t, n), (ls = a), null !== (is = o)))
                if (ls)
                  try {
                    (e = is),
                      (r = n.stateNode),
                      8 === e.nodeType
                        ? e.parentNode.removeChild(r)
                        : e.removeChild(r);
                  } catch (l) {
                    ru(n, t, l);
                  }
                else
                  try {
                    is.removeChild(n.stateNode);
                  } catch (l) {
                    ru(n, t, l);
                  }
              break;
            case 18:
              null !== is &&
                (ls
                  ? ((t = is),
                    (n = n.stateNode),
                    8 === t.nodeType
                      ? ad(t.parentNode, n)
                      : 1 === t.nodeType && ad(t, n),
                    yf(t))
                  : ad(is, n.stateNode));
              break;
            case 4:
              (r = is),
                (o = ls),
                (is = n.stateNode.containerInfo),
                (ls = !0),
                ss(e, t, n),
                (is = r),
                (ls = o);
              break;
            case 0:
            case 11:
            case 14:
            case 15:
              Zl || Wl(2, n, t), Zl || Wl(4, n, t), ss(e, t, n);
              break;
            case 1:
              Zl ||
                ($l(n, t),
                "function" === typeof (r = n.stateNode).componentWillUnmount &&
                  Bl(n, t, r)),
                ss(e, t, n);
              break;
            case 21:
              ss(e, t, n);
              break;
            case 22:
              Zl || $l(n, t),
                (Zl = (r = Zl) || null !== n.memoizedState),
                ss(e, t, n),
                (Zl = r);
              break;
            default:
              ss(e, t, n);
          }
        }
        function us(e, t) {
          if (
            null === t.memoizedState &&
            null !== (e = t.alternate) &&
            null !== (e = e.memoizedState) &&
            null !== (e = e.dehydrated)
          )
            try {
              yf(e);
            } catch (n) {
              ru(t, t.return, n);
            }
        }
        function ds(e, t) {
          var n = (function (e) {
            switch (e.tag) {
              case 13:
              case 19:
                var t = e.stateNode;
                return null === t && (t = e.stateNode = new ts()), t;
              case 22:
                return (
                  null === (t = (e = e.stateNode)._retryCache) &&
                    (t = e._retryCache = new ts()),
                  t
                );
              default:
                throw Error(i(435, e.tag));
            }
          })(e);
          t.forEach(function (t) {
            var r = su.bind(null, e, t);
            n.has(t) || (n.add(t), t.then(r, r));
          });
        }
        function fs(e, t) {
          var n = t.deletions;
          if (null !== n)
            for (var r = 0; r < n.length; r++) {
              var o = n[r],
                a = e,
                l = t,
                s = l;
              e: for (; null !== s; ) {
                switch (s.tag) {
                  case 27:
                  case 5:
                    (is = s.stateNode), (ls = !1);
                    break e;
                  case 3:
                  case 4:
                    (is = s.stateNode.containerInfo), (ls = !0);
                    break e;
                }
                s = s.return;
              }
              if (null === is) throw Error(i(160));
              cs(a, l, o),
                (is = null),
                (ls = !1),
                null !== (a = o.alternate) && (a.return = null),
                (o.return = null);
            }
          if (13878 & t.subtreeFlags)
            for (t = t.child; null !== t; ) hs(t, e), (t = t.sibling);
        }
        var ps = null;
        function hs(e, t) {
          var n = e.alternate,
            r = e.flags;
          switch (e.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              fs(t, e),
                ms(e),
                4 & r && (Wl(3, e, e.return), Ul(3, e), Wl(5, e, e.return));
              break;
            case 1:
              fs(t, e),
                ms(e),
                512 & r && (Zl || null === n || $l(n, n.return)),
                64 & r &&
                  Jl &&
                  null !== (e = e.updateQueue) &&
                  null !== (r = e.callbacks) &&
                  ((n = e.shared.hiddenCallbacks),
                  (e.shared.hiddenCallbacks = null === n ? r : n.concat(r)));
              break;
            case 26:
              var o = ps;
              if (
                (fs(t, e),
                ms(e),
                512 & r && (Zl || null === n || $l(n, n.return)),
                4 & r)
              ) {
                var a = null !== n ? n.memoizedState : null;
                if (((r = e.memoizedState), null === n))
                  if (null === r)
                    if (null === e.stateNode) {
                      e: {
                        (r = e.type),
                          (n = e.memoizedProps),
                          (o = o.ownerDocument || o);
                        t: switch (r) {
                          case "title":
                            (!(a = o.getElementsByTagName("title")[0]) ||
                              a[$e] ||
                              a[Fe] ||
                              "http://www.w3.org/2000/svg" === a.namespaceURI ||
                              a.hasAttribute("itemprop")) &&
                              ((a = o.createElement(r)),
                              o.head.insertBefore(
                                a,
                                o.querySelector("head > title")
                              )),
                              qu(a, r, n),
                              (a[Fe] = e),
                              Xe(a),
                              (r = a);
                            break e;
                          case "link":
                            var l = Td("link", "href", o).get(
                              r + (n.href || "")
                            );
                            if (l)
                              for (var s = 0; s < l.length; s++)
                                if (
                                  (a = l[s]).getAttribute("href") ===
                                    (null == n.href ? null : n.href) &&
                                  a.getAttribute("rel") ===
                                    (null == n.rel ? null : n.rel) &&
                                  a.getAttribute("title") ===
                                    (null == n.title ? null : n.title) &&
                                  a.getAttribute("crossorigin") ===
                                    (null == n.crossOrigin
                                      ? null
                                      : n.crossOrigin)
                                ) {
                                  l.splice(s, 1);
                                  break t;
                                }
                            qu((a = o.createElement(r)), r, n),
                              o.head.appendChild(a);
                            break;
                          case "meta":
                            if (
                              (l = Td("meta", "content", o).get(
                                r + (n.content || "")
                              ))
                            )
                              for (s = 0; s < l.length; s++)
                                if (
                                  (a = l[s]).getAttribute("content") ===
                                    (null == n.content
                                      ? null
                                      : "" + n.content) &&
                                  a.getAttribute("name") ===
                                    (null == n.name ? null : n.name) &&
                                  a.getAttribute("property") ===
                                    (null == n.property ? null : n.property) &&
                                  a.getAttribute("http-equiv") ===
                                    (null == n.httpEquiv
                                      ? null
                                      : n.httpEquiv) &&
                                  a.getAttribute("charset") ===
                                    (null == n.charSet ? null : n.charSet)
                                ) {
                                  l.splice(s, 1);
                                  break t;
                                }
                            qu((a = o.createElement(r)), r, n),
                              o.head.appendChild(a);
                            break;
                          default:
                            throw Error(i(468, r));
                        }
                        (a[Fe] = e), Xe(a), (r = a);
                      }
                      e.stateNode = r;
                    } else Pd(o, e.type, e.stateNode);
                  else e.stateNode = kd(o, r, e.memoizedProps);
                else
                  a !== r
                    ? (null === a
                        ? null !== n.stateNode &&
                          (n = n.stateNode).parentNode.removeChild(n)
                        : a.count--,
                      null === r
                        ? Pd(o, e.type, e.stateNode)
                        : kd(o, r, e.memoizedProps))
                    : null === r &&
                      null !== e.stateNode &&
                      Yl(e, e.memoizedProps, n.memoizedProps);
              }
              break;
            case 27:
              if (4 & r && null === e.alternate) {
                (o = e.stateNode), (a = e.memoizedProps);
                try {
                  for (var c = o.firstChild; c; ) {
                    var u = c.nextSibling,
                      d = c.nodeName;
                    c[$e] ||
                      "HEAD" === d ||
                      "BODY" === d ||
                      "SCRIPT" === d ||
                      "STYLE" === d ||
                      ("LINK" === d && "stylesheet" === c.rel.toLowerCase()) ||
                      o.removeChild(c),
                      (c = u);
                  }
                  for (var f = e.type, p = o.attributes; p.length; )
                    o.removeAttributeNode(p[0]);
                  qu(o, f, a), (o[Fe] = e), (o[De] = a);
                } catch (m) {
                  ru(e, e.return, m);
                }
              }
            case 5:
              if (
                (fs(t, e),
                ms(e),
                512 & r && (Zl || null === n || $l(n, n.return)),
                32 & e.flags)
              ) {
                o = e.stateNode;
                try {
                  kt(o, "");
                } catch (m) {
                  ru(e, e.return, m);
                }
              }
              4 & r &&
                null != e.stateNode &&
                Yl(e, (o = e.memoizedProps), null !== n ? n.memoizedProps : o),
                1024 & r && (es = !0);
              break;
            case 6:
              if ((fs(t, e), ms(e), 4 & r)) {
                if (null === e.stateNode) throw Error(i(162));
                (r = e.memoizedProps), (n = e.stateNode);
                try {
                  n.nodeValue = r;
                } catch (m) {
                  ru(e, e.return, m);
                }
              }
              break;
            case 3:
              if (
                ((Nd = null),
                (o = ps),
                (ps = fd(t.containerInfo)),
                fs(t, e),
                (ps = o),
                ms(e),
                4 & r && null !== n && n.memoizedState.isDehydrated)
              )
                try {
                  yf(t.containerInfo);
                } catch (m) {
                  ru(e, e.return, m);
                }
              es && ((es = !1), ys(e));
              break;
            case 4:
              (r = ps),
                (ps = fd(e.stateNode.containerInfo)),
                fs(t, e),
                ms(e),
                (ps = r);
              break;
            case 12:
              fs(t, e), ms(e);
              break;
            case 13:
              fs(t, e),
                ms(e),
                8192 & e.child.flags &&
                  (null !== e.memoizedState) !==
                    (null !== n && null !== n.memoizedState) &&
                  (bc = se()),
                4 & r &&
                  null !== (r = e.updateQueue) &&
                  ((e.updateQueue = null), ds(e, r));
              break;
            case 22:
              if (
                (512 & r && (Zl || null === n || $l(n, n.return)),
                (c = null !== e.memoizedState),
                (u = null !== n && null !== n.memoizedState),
                (Jl = (d = Jl) || c),
                (Zl = (f = Zl) || u),
                fs(t, e),
                (Zl = f),
                (Jl = d),
                ms(e),
                ((t = e.stateNode)._current = e),
                (t._visibility &= -3),
                (t._visibility |= 2 & t._pendingVisibility),
                8192 & r &&
                  ((t._visibility = c ? -2 & t._visibility : 1 | t._visibility),
                  c && ((t = Jl || Zl), null === n || u || t || gs(e)),
                  null === e.memoizedProps ||
                    "manual" !== e.memoizedProps.mode))
              )
                e: for (n = null, t = e; ; ) {
                  if (5 === t.tag || 26 === t.tag || 27 === t.tag) {
                    if (null === n) {
                      u = n = t;
                      try {
                        if (((o = u.stateNode), c))
                          "function" === typeof (a = o.style).setProperty
                            ? a.setProperty("display", "none", "important")
                            : (a.display = "none");
                        else {
                          l = u.stateNode;
                          var h =
                            void 0 !== (s = u.memoizedProps.style) &&
                            null !== s &&
                            s.hasOwnProperty("display")
                              ? s.display
                              : null;
                          l.style.display =
                            null == h || "boolean" === typeof h
                              ? ""
                              : ("" + h).trim();
                        }
                      } catch (m) {
                        ru(u, u.return, m);
                      }
                    }
                  } else if (6 === t.tag) {
                    if (null === n) {
                      u = t;
                      try {
                        u.stateNode.nodeValue = c ? "" : u.memoizedProps;
                      } catch (m) {
                        ru(u, u.return, m);
                      }
                    }
                  } else if (
                    ((22 !== t.tag && 23 !== t.tag) ||
                      null === t.memoizedState ||
                      t === e) &&
                    null !== t.child
                  ) {
                    (t.child.return = t), (t = t.child);
                    continue;
                  }
                  if (t === e) break e;
                  for (; null === t.sibling; ) {
                    if (null === t.return || t.return === e) break e;
                    n === t && (n = null), (t = t.return);
                  }
                  n === t && (n = null),
                    (t.sibling.return = t.return),
                    (t = t.sibling);
                }
              4 & r &&
                null !== (r = e.updateQueue) &&
                null !== (n = r.retryQueue) &&
                ((r.retryQueue = null), ds(e, n));
              break;
            case 19:
              fs(t, e),
                ms(e),
                4 & r &&
                  null !== (r = e.updateQueue) &&
                  ((e.updateQueue = null), ds(e, r));
              break;
            case 21:
              break;
            default:
              fs(t, e), ms(e);
          }
        }
        function ms(e) {
          var t = e.flags;
          if (2 & t) {
            try {
              if (27 !== e.tag) {
                e: {
                  for (var n = e.return; null !== n; ) {
                    if (Ql(n)) {
                      var r = n;
                      break e;
                    }
                    n = n.return;
                  }
                  throw Error(i(160));
                }
                switch (r.tag) {
                  case 27:
                    var o = r.stateNode;
                    Xl(e, Kl(e), o);
                    break;
                  case 5:
                    var a = r.stateNode;
                    32 & r.flags && (kt(a, ""), (r.flags &= -33)),
                      Xl(e, Kl(e), a);
                    break;
                  case 3:
                  case 4:
                    var l = r.stateNode.containerInfo;
                    Gl(e, Kl(e), l);
                    break;
                  default:
                    throw Error(i(161));
                }
              }
            } catch (s) {
              ru(e, e.return, s);
            }
            e.flags &= -3;
          }
          4096 & t && (e.flags &= -4097);
        }
        function ys(e) {
          if (1024 & e.subtreeFlags)
            for (e = e.child; null !== e; ) {
              var t = e;
              ys(t),
                5 === t.tag && 1024 & t.flags && t.stateNode.reset(),
                (e = e.sibling);
            }
        }
        function vs(e, t) {
          if (8772 & t.subtreeFlags)
            for (t = t.child; null !== t; )
              os(e, t.alternate, t), (t = t.sibling);
        }
        function gs(e) {
          for (e = e.child; null !== e; ) {
            var t = e;
            switch (t.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                Wl(4, t, t.return), gs(t);
                break;
              case 1:
                $l(t, t.return);
                var n = t.stateNode;
                "function" === typeof n.componentWillUnmount &&
                  Bl(t, t.return, n),
                  gs(t);
                break;
              case 26:
              case 27:
              case 5:
                $l(t, t.return), gs(t);
                break;
              case 22:
                $l(t, t.return), null === t.memoizedState && gs(t);
                break;
              default:
                gs(t);
            }
            e = e.sibling;
          }
        }
        function bs(e, t, n) {
          for (
            n = n && 0 !== (8772 & t.subtreeFlags), t = t.child;
            null !== t;

          ) {
            var r = t.alternate,
              o = e,
              a = t,
              i = a.flags;
            switch (a.tag) {
              case 0:
              case 11:
              case 15:
                bs(o, a, n), Ul(4, a);
                break;
              case 1:
                if (
                  (bs(o, a, n),
                  "function" ===
                    typeof (o = (r = a).stateNode).componentDidMount)
                )
                  try {
                    o.componentDidMount();
                  } catch (c) {
                    ru(r, r.return, c);
                  }
                if (null !== (o = (r = a).updateQueue)) {
                  var l = r.stateNode;
                  try {
                    var s = o.shared.hiddenCallbacks;
                    if (null !== s)
                      for (
                        o.shared.hiddenCallbacks = null, o = 0;
                        o < s.length;
                        o++
                      )
                        Fl(s[o], l);
                  } catch (c) {
                    ru(r, r.return, c);
                  }
                }
                n && 64 & i && Hl(a), Vl(a, a.return);
                break;
              case 26:
              case 27:
              case 5:
                bs(o, a, n), n && null === r && 4 & i && ql(a), Vl(a, a.return);
                break;
              case 12:
              default:
                bs(o, a, n);
                break;
              case 13:
                bs(o, a, n), n && 4 & i && us(o, a);
                break;
              case 22:
                null === a.memoizedState && bs(o, a, n), Vl(a, a.return);
            }
            t = t.sibling;
          }
        }
        function ws(e, t) {
          var n = null;
          null !== e &&
            null !== e.memoizedState &&
            null !== e.memoizedState.cachePool &&
            (n = e.memoizedState.cachePool.pool),
            (e = null),
            null !== t.memoizedState &&
              null !== t.memoizedState.cachePool &&
              (e = t.memoizedState.cachePool.pool),
            e !== n && (null != e && e.refCount++, null != n && Ho(n));
        }
        function Ss(e, t) {
          (e = null),
            null !== t.alternate && (e = t.alternate.memoizedState.cache),
            (t = t.memoizedState.cache) !== e &&
              (t.refCount++, null != e && Ho(e));
        }
        function ks(e, t, n, r) {
          if (10256 & t.subtreeFlags)
            for (t = t.child; null !== t; ) xs(e, t, n, r), (t = t.sibling);
        }
        function xs(e, t, n, r) {
          var o = t.flags;
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              ks(e, t, n, r), 2048 & o && Ul(9, t);
              break;
            case 3:
              ks(e, t, n, r),
                2048 & o &&
                  ((e = null),
                  null !== t.alternate && (e = t.alternate.memoizedState.cache),
                  (t = t.memoizedState.cache) !== e &&
                    (t.refCount++, null != e && Ho(e)));
              break;
            case 12:
              if (2048 & o) {
                ks(e, t, n, r), (e = t.stateNode);
                try {
                  var a = t.memoizedProps,
                    i = a.id,
                    l = a.onPostCommit;
                  "function" === typeof l &&
                    l(
                      i,
                      null === t.alternate ? "mount" : "update",
                      e.passiveEffectDuration,
                      -0
                    );
                } catch (s) {
                  ru(t, t.return, s);
                }
              } else ks(e, t, n, r);
              break;
            case 23:
              break;
            case 22:
              (a = t.stateNode),
                null !== t.memoizedState
                  ? 4 & a._visibility
                    ? ks(e, t, n, r)
                    : Cs(e, t)
                  : 4 & a._visibility
                  ? ks(e, t, n, r)
                  : ((a._visibility |= 4),
                    Es(e, t, n, r, 0 !== (10256 & t.subtreeFlags))),
                2048 & o && ws(t.alternate, t);
              break;
            case 24:
              ks(e, t, n, r), 2048 & o && Ss(t.alternate, t);
              break;
            default:
              ks(e, t, n, r);
          }
        }
        function Es(e, t, n, r, o) {
          for (
            o = o && 0 !== (10256 & t.subtreeFlags), t = t.child;
            null !== t;

          ) {
            var a = e,
              i = t,
              l = n,
              s = r,
              c = i.flags;
            switch (i.tag) {
              case 0:
              case 11:
              case 15:
                Es(a, i, l, s, o), Ul(8, i);
                break;
              case 23:
                break;
              case 22:
                var u = i.stateNode;
                null !== i.memoizedState
                  ? 4 & u._visibility
                    ? Es(a, i, l, s, o)
                    : Cs(a, i)
                  : ((u._visibility |= 4), Es(a, i, l, s, o)),
                  o && 2048 & c && ws(i.alternate, i);
                break;
              case 24:
                Es(a, i, l, s, o), o && 2048 & c && Ss(i.alternate, i);
                break;
              default:
                Es(a, i, l, s, o);
            }
            t = t.sibling;
          }
        }
        function Cs(e, t) {
          if (10256 & t.subtreeFlags)
            for (t = t.child; null !== t; ) {
              var n = e,
                r = t,
                o = r.flags;
              switch (r.tag) {
                case 22:
                  Cs(n, r), 2048 & o && ws(r.alternate, r);
                  break;
                case 24:
                  Cs(n, r), 2048 & o && Ss(r.alternate, r);
                  break;
                default:
                  Cs(n, r);
              }
              t = t.sibling;
            }
        }
        var Ns = 8192;
        function Ts(e) {
          if (e.subtreeFlags & Ns)
            for (e = e.child; null !== e; ) Ps(e), (e = e.sibling);
        }
        function Ps(e) {
          switch (e.tag) {
            case 26:
              Ts(e),
                e.flags & Ns &&
                  null !== e.memoizedState &&
                  (function (e, t, n) {
                    if (null === jd) throw Error(i(475));
                    var r = jd;
                    if (
                      "stylesheet" === t.type &&
                      ("string" !== typeof n.media ||
                        !1 !== matchMedia(n.media).matches) &&
                      0 === (4 & t.state.loading)
                    ) {
                      if (null === t.instance) {
                        var o = vd(n.href),
                          a = e.querySelector(gd(o));
                        if (a)
                          return (
                            null !== (e = a._p) &&
                              "object" === typeof e &&
                              "function" === typeof e.then &&
                              (r.count++, (r = _d.bind(r)), e.then(r, r)),
                            (t.state.loading |= 4),
                            (t.instance = a),
                            void Xe(a)
                          );
                        (a = e.ownerDocument || e),
                          (n = bd(n)),
                          (o = ud.get(o)) && Ed(n, o),
                          Xe((a = a.createElement("link")));
                        var l = a;
                        (l._p = new Promise(function (e, t) {
                          (l.onload = e), (l.onerror = t);
                        })),
                          qu(a, "link", n),
                          (t.instance = a);
                      }
                      null === r.stylesheets && (r.stylesheets = new Map()),
                        r.stylesheets.set(t, e),
                        (e = t.state.preload) &&
                          0 === (3 & t.state.loading) &&
                          (r.count++,
                          (t = _d.bind(r)),
                          e.addEventListener("load", t),
                          e.addEventListener("error", t));
                    }
                  })(ps, e.memoizedState, e.memoizedProps);
              break;
            case 5:
            default:
              Ts(e);
              break;
            case 3:
            case 4:
              var t = ps;
              (ps = fd(e.stateNode.containerInfo)), Ts(e), (ps = t);
              break;
            case 22:
              null === e.memoizedState &&
                (null !== (t = e.alternate) && null !== t.memoizedState
                  ? ((t = Ns), (Ns = 16777216), Ts(e), (Ns = t))
                  : Ts(e));
          }
        }
        function Os(e) {
          var t = e.alternate;
          if (null !== t && null !== (e = t.child)) {
            t.child = null;
            do {
              (t = e.sibling), (e.sibling = null), (e = t);
            } while (null !== e);
          }
        }
        function js(e) {
          var t = e.deletions;
          if (0 !== (16 & e.flags)) {
            if (null !== t)
              for (var n = 0; n < t.length; n++) {
                var r = t[n];
                (ns = r), Ls(r, e);
              }
            Os(e);
          }
          if (10256 & e.subtreeFlags)
            for (e = e.child; null !== e; ) Rs(e), (e = e.sibling);
        }
        function Rs(e) {
          switch (e.tag) {
            case 0:
            case 11:
            case 15:
              js(e), 2048 & e.flags && Wl(9, e, e.return);
              break;
            case 3:
            case 12:
            default:
              js(e);
              break;
            case 22:
              var t = e.stateNode;
              null !== e.memoizedState &&
              4 & t._visibility &&
              (null === e.return || 13 !== e.return.tag)
                ? ((t._visibility &= -5), _s(e))
                : js(e);
          }
        }
        function _s(e) {
          var t = e.deletions;
          if (0 !== (16 & e.flags)) {
            if (null !== t)
              for (var n = 0; n < t.length; n++) {
                var r = t[n];
                (ns = r), Ls(r, e);
              }
            Os(e);
          }
          for (e = e.child; null !== e; ) {
            switch ((t = e).tag) {
              case 0:
              case 11:
              case 15:
                Wl(8, t, t.return), _s(t);
                break;
              case 22:
                4 & (n = t.stateNode)._visibility &&
                  ((n._visibility &= -5), _s(t));
                break;
              default:
                _s(t);
            }
            e = e.sibling;
          }
        }
        function Ls(e, t) {
          for (; null !== ns; ) {
            var n = ns;
            switch (n.tag) {
              case 0:
              case 11:
              case 15:
                Wl(8, n, t);
                break;
              case 23:
              case 22:
                if (
                  null !== n.memoizedState &&
                  null !== n.memoizedState.cachePool
                ) {
                  var r = n.memoizedState.cachePool.pool;
                  null != r && r.refCount++;
                }
                break;
              case 24:
                Ho(n.memoizedState.cache);
            }
            if (null !== (r = n.child)) (r.return = n), (ns = r);
            else
              e: for (n = e; null !== ns; ) {
                var o = (r = ns).sibling,
                  a = r.return;
                if ((as(r), r === n)) {
                  ns = null;
                  break e;
                }
                if (null !== o) {
                  (o.return = a), (ns = o);
                  break e;
                }
                ns = a;
              }
          }
        }
        function zs(e, t, n, r) {
          (this.tag = e),
            (this.key = n),
            (this.sibling =
              this.child =
              this.return =
              this.stateNode =
              this.type =
              this.elementType =
                null),
            (this.index = 0),
            (this.refCleanup = this.ref = null),
            (this.pendingProps = t),
            (this.dependencies =
              this.memoizedState =
              this.updateQueue =
              this.memoizedProps =
                null),
            (this.mode = r),
            (this.subtreeFlags = this.flags = 0),
            (this.deletions = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null);
        }
        function As(e, t, n, r) {
          return new zs(e, t, n, r);
        }
        function Is(e) {
          return !(!(e = e.prototype) || !e.isReactComponent);
        }
        function Ms(e, t) {
          var n = e.alternate;
          return (
            null === n
              ? (((n = As(e.tag, t, e.key, e.mode)).elementType =
                  e.elementType),
                (n.type = e.type),
                (n.stateNode = e.stateNode),
                (n.alternate = e),
                (e.alternate = n))
              : ((n.pendingProps = t),
                (n.type = e.type),
                (n.flags = 0),
                (n.subtreeFlags = 0),
                (n.deletions = null)),
            (n.flags = 31457280 & e.flags),
            (n.childLanes = e.childLanes),
            (n.lanes = e.lanes),
            (n.child = e.child),
            (n.memoizedProps = e.memoizedProps),
            (n.memoizedState = e.memoizedState),
            (n.updateQueue = e.updateQueue),
            (t = e.dependencies),
            (n.dependencies =
              null === t
                ? null
                : { lanes: t.lanes, firstContext: t.firstContext }),
            (n.sibling = e.sibling),
            (n.index = e.index),
            (n.ref = e.ref),
            (n.refCleanup = e.refCleanup),
            n
          );
        }
        function Fs(e, t) {
          e.flags &= 31457282;
          var n = e.alternate;
          return (
            null === n
              ? ((e.childLanes = 0),
                (e.lanes = t),
                (e.child = null),
                (e.subtreeFlags = 0),
                (e.memoizedProps = null),
                (e.memoizedState = null),
                (e.updateQueue = null),
                (e.dependencies = null),
                (e.stateNode = null))
              : ((e.childLanes = n.childLanes),
                (e.lanes = n.lanes),
                (e.child = n.child),
                (e.subtreeFlags = 0),
                (e.deletions = null),
                (e.memoizedProps = n.memoizedProps),
                (e.memoizedState = n.memoizedState),
                (e.updateQueue = n.updateQueue),
                (e.type = n.type),
                (t = n.dependencies),
                (e.dependencies =
                  null === t
                    ? null
                    : { lanes: t.lanes, firstContext: t.firstContext })),
            e
          );
        }
        function Ds(e, t, n, r, o, a) {
          var l = 0;
          if (((r = e), "function" === typeof e)) Is(e) && (l = 1);
          else if ("string" === typeof e)
            l = (function (e, t, n) {
              if (1 === n || null != t.itemProp) return !1;
              switch (e) {
                case "meta":
                case "title":
                  return !0;
                case "style":
                  if (
                    "string" !== typeof t.precedence ||
                    "string" !== typeof t.href ||
                    "" === t.href
                  )
                    break;
                  return !0;
                case "link":
                  if (
                    "string" !== typeof t.rel ||
                    "string" !== typeof t.href ||
                    "" === t.href ||
                    t.onLoad ||
                    t.onError
                  )
                    break;
                  return (
                    "stylesheet" !== t.rel ||
                    ((e = t.disabled),
                    "string" === typeof t.precedence && null == e)
                  );
                case "script":
                  if (
                    t.async &&
                    "function" !== typeof t.async &&
                    "symbol" !== typeof t.async &&
                    !t.onLoad &&
                    !t.onError &&
                    t.src &&
                    "string" === typeof t.src
                  )
                    return !0;
              }
              return !1;
            })(e, n, K.current)
              ? 26
              : "html" === e || "head" === e || "body" === e
              ? 27
              : 5;
          else
            e: switch (e) {
              case d:
                return Us(n.children, o, a, t);
              case f:
                (l = 8), (o |= 24);
                break;
              case p:
                return (
                  ((e = As(12, n, t, 2 | o)).elementType = p), (e.lanes = a), e
                );
              case g:
                return (
                  ((e = As(13, n, t, o)).elementType = g), (e.lanes = a), e
                );
              case b:
                return (
                  ((e = As(19, n, t, o)).elementType = b), (e.lanes = a), e
                );
              case k:
                return Ws(n, o, a, t);
              default:
                if ("object" === typeof e && null !== e)
                  switch (e.$$typeof) {
                    case h:
                    case y:
                      l = 10;
                      break e;
                    case m:
                      l = 9;
                      break e;
                    case v:
                      l = 11;
                      break e;
                    case w:
                      l = 14;
                      break e;
                    case S:
                      (l = 16), (r = null);
                      break e;
                  }
                (l = 29),
                  (n = Error(i(130, null === e ? "null" : typeof e, ""))),
                  (r = null);
            }
          return (
            ((t = As(l, n, t, o)).elementType = e),
            (t.type = r),
            (t.lanes = a),
            t
          );
        }
        function Us(e, t, n, r) {
          return ((e = As(7, e, r, t)).lanes = n), e;
        }
        function Ws(e, t, n, r) {
          ((e = As(22, e, r, t)).elementType = k), (e.lanes = n);
          var o = {
            _visibility: 1,
            _pendingVisibility: 1,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null,
            _current: null,
            detach: function () {
              var e = o._current;
              if (null === e) throw Error(i(456));
              if (0 === (2 & o._pendingVisibility)) {
                var t = Or(e, 2);
                null !== t && ((o._pendingVisibility |= 2), _c(t, e, 2));
              }
            },
            attach: function () {
              var e = o._current;
              if (null === e) throw Error(i(456));
              if (0 !== (2 & o._pendingVisibility)) {
                var t = Or(e, 2);
                null !== t && ((o._pendingVisibility &= -3), _c(t, e, 2));
              }
            },
          };
          return (e.stateNode = o), e;
        }
        function Hs(e, t, n) {
          return ((e = As(6, e, null, t)).lanes = n), e;
        }
        function Bs(e, t, n) {
          return (
            ((t = As(
              4,
              null !== e.children ? e.children : [],
              e.key,
              t
            )).lanes = n),
            (t.stateNode = {
              containerInfo: e.containerInfo,
              pendingChildren: null,
              implementation: e.implementation,
            }),
            t
          );
        }
        function Vs(e) {
          e.flags |= 4;
        }
        function $s(e, t) {
          if ("stylesheet" !== t.type || 0 !== (4 & t.state.loading))
            e.flags &= -16777217;
          else if (((e.flags |= 16777216), !Od(t))) {
            if (
              null !== (t = Oo.current) &&
              ((4194176 & rc) === rc
                ? null !== jo
                : ((62914560 & rc) !== rc && 0 === (536870912 & rc)) ||
                  t !== jo)
            )
              throw ((po = so), lo);
            e.flags |= 8192;
          }
        }
        function qs(e, t) {
          null !== t && (e.flags |= 4),
            16384 & e.flags &&
              ((t = 22 !== e.tag ? je() : 536870912),
              (e.lanes |= t),
              (mc |= t));
        }
        function Ys(e, t) {
          if (!Gr)
            switch (e.tailMode) {
              case "hidden":
                t = e.tail;
                for (var n = null; null !== t; )
                  null !== t.alternate && (n = t), (t = t.sibling);
                null === n ? (e.tail = null) : (n.sibling = null);
                break;
              case "collapsed":
                n = e.tail;
                for (var r = null; null !== n; )
                  null !== n.alternate && (r = n), (n = n.sibling);
                null === r
                  ? t || null === e.tail
                    ? (e.tail = null)
                    : (e.tail.sibling = null)
                  : (r.sibling = null);
            }
        }
        function Qs(e) {
          var t = null !== e.alternate && e.alternate.child === e.child,
            n = 0,
            r = 0;
          if (t)
            for (var o = e.child; null !== o; )
              (n |= o.lanes | o.childLanes),
                (r |= 31457280 & o.subtreeFlags),
                (r |= 31457280 & o.flags),
                (o.return = e),
                (o = o.sibling);
          else
            for (o = e.child; null !== o; )
              (n |= o.lanes | o.childLanes),
                (r |= o.subtreeFlags),
                (r |= o.flags),
                (o.return = e),
                (o = o.sibling);
          return (e.subtreeFlags |= r), (e.childLanes = n), t;
        }
        function Ks(e, t, n) {
          var r = t.pendingProps;
          switch ((Yr(t), t.tag)) {
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
            case 1:
              return Qs(t), null;
            case 3:
              return (
                (n = t.stateNode),
                (r = null),
                null !== e && (r = e.memoizedState.cache),
                t.memoizedState.cache !== r && (t.flags |= 2048),
                bl(Uo),
                ee(),
                n.pendingContext &&
                  ((n.context = n.pendingContext), (n.pendingContext = null)),
                (null !== e && null !== e.child) ||
                  (ro(t)
                    ? Vs(t)
                    : null === e ||
                      (e.memoizedState.isDehydrated && 0 === (256 & t.flags)) ||
                      ((t.flags |= 1024),
                      null !== Xr && (zc(Xr), (Xr = null)))),
                Qs(t),
                null
              );
            case 26:
              return (
                (n = t.memoizedState),
                null === e
                  ? (Vs(t),
                    null !== n
                      ? (Qs(t), $s(t, n))
                      : (Qs(t), (t.flags &= -16777217)))
                  : n
                  ? n !== e.memoizedState
                    ? (Vs(t), Qs(t), $s(t, n))
                    : (Qs(t), (t.flags &= -16777217))
                  : (e.memoizedProps !== r && Vs(t),
                    Qs(t),
                    (t.flags &= -16777217)),
                null
              );
            case 27:
              ne(t), (n = X.current);
              var o = t.type;
              if (null !== e && null != t.stateNode)
                e.memoizedProps !== r && Vs(t);
              else {
                if (!r) {
                  if (null === t.stateNode) throw Error(i(166));
                  return Qs(t), null;
                }
                (e = K.current),
                  ro(t) ? to(t) : ((e = cd(o, r, n)), (t.stateNode = e), Vs(t));
              }
              return Qs(t), null;
            case 5:
              if ((ne(t), (n = t.type), null !== e && null != t.stateNode))
                e.memoizedProps !== r && Vs(t);
              else {
                if (!r) {
                  if (null === t.stateNode) throw Error(i(166));
                  return Qs(t), null;
                }
                if (((e = K.current), ro(t))) to(t);
                else {
                  switch (((o = Ku(X.current)), e)) {
                    case 1:
                      e = o.createElementNS("http://www.w3.org/2000/svg", n);
                      break;
                    case 2:
                      e = o.createElementNS(
                        "http://www.w3.org/1998/Math/MathML",
                        n
                      );
                      break;
                    default:
                      switch (n) {
                        case "svg":
                          e = o.createElementNS(
                            "http://www.w3.org/2000/svg",
                            n
                          );
                          break;
                        case "math":
                          e = o.createElementNS(
                            "http://www.w3.org/1998/Math/MathML",
                            n
                          );
                          break;
                        case "script":
                          ((e = o.createElement("div")).innerHTML =
                            "<script></script>"),
                            (e = e.removeChild(e.firstChild));
                          break;
                        case "select":
                          (e =
                            "string" === typeof r.is
                              ? o.createElement("select", { is: r.is })
                              : o.createElement("select")),
                            r.multiple
                              ? (e.multiple = !0)
                              : r.size && (e.size = r.size);
                          break;
                        default:
                          e =
                            "string" === typeof r.is
                              ? o.createElement(n, { is: r.is })
                              : o.createElement(n);
                      }
                  }
                  (e[Fe] = t), (e[De] = r);
                  e: for (o = t.child; null !== o; ) {
                    if (5 === o.tag || 6 === o.tag) e.appendChild(o.stateNode);
                    else if (4 !== o.tag && 27 !== o.tag && null !== o.child) {
                      (o.child.return = o), (o = o.child);
                      continue;
                    }
                    if (o === t) break e;
                    for (; null === o.sibling; ) {
                      if (null === o.return || o.return === t) break e;
                      o = o.return;
                    }
                    (o.sibling.return = o.return), (o = o.sibling);
                  }
                  t.stateNode = e;
                  e: switch ((qu(e, n, r), n)) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      e = !!r.autoFocus;
                      break e;
                    case "img":
                      e = !0;
                      break e;
                    default:
                      e = !1;
                  }
                  e && Vs(t);
                }
              }
              return Qs(t), (t.flags &= -16777217), null;
            case 6:
              if (e && null != t.stateNode) e.memoizedProps !== r && Vs(t);
              else {
                if ("string" !== typeof r && null === t.stateNode)
                  throw Error(i(166));
                if (((e = X.current), ro(t))) {
                  if (
                    ((e = t.stateNode),
                    (n = t.memoizedProps),
                    (r = null),
                    null !== (o = Qr))
                  )
                    switch (o.tag) {
                      case 27:
                      case 5:
                        r = o.memoizedProps;
                    }
                  (e[Fe] = t),
                    (e = !!(
                      e.nodeValue === n ||
                      (null !== r && !0 === r.suppressHydrationWarning) ||
                      Hu(e.nodeValue, n)
                    )) || eo(t);
                } else
                  ((e = Ku(e).createTextNode(r))[Fe] = t), (t.stateNode = e);
              }
              return Qs(t), null;
            case 13:
              if (
                ((r = t.memoizedState),
                null === e ||
                  (null !== e.memoizedState &&
                    null !== e.memoizedState.dehydrated))
              ) {
                if (((o = ro(t)), null !== r && null !== r.dehydrated)) {
                  if (null === e) {
                    if (!o) throw Error(i(318));
                    if (
                      !(o =
                        null !== (o = t.memoizedState) ? o.dehydrated : null)
                    )
                      throw Error(i(317));
                    o[Fe] = t;
                  } else
                    oo(),
                      0 === (128 & t.flags) && (t.memoizedState = null),
                      (t.flags |= 4);
                  Qs(t), (o = !1);
                } else null !== Xr && (zc(Xr), (Xr = null)), (o = !0);
                if (!o) return 256 & t.flags ? (zo(t), t) : (zo(t), null);
              }
              if ((zo(t), 0 !== (128 & t.flags))) return (t.lanes = n), t;
              if (
                ((n = null !== r),
                (e = null !== e && null !== e.memoizedState),
                n)
              ) {
                (o = null),
                  null !== (r = t.child).alternate &&
                    null !== r.alternate.memoizedState &&
                    null !== r.alternate.memoizedState.cachePool &&
                    (o = r.alternate.memoizedState.cachePool.pool);
                var a = null;
                null !== r.memoizedState &&
                  null !== r.memoizedState.cachePool &&
                  (a = r.memoizedState.cachePool.pool),
                  a !== o && (r.flags |= 2048);
              }
              return (
                n !== e && n && (t.child.flags |= 8192),
                qs(t, t.updateQueue),
                Qs(t),
                null
              );
            case 4:
              return (
                ee(), null === e && _u(t.stateNode.containerInfo), Qs(t), null
              );
            case 10:
              return bl(t.type), Qs(t), null;
            case 19:
              if ((Y(Ao), null === (o = t.memoizedState))) return Qs(t), null;
              if (((r = 0 !== (128 & t.flags)), null === (a = o.rendering)))
                if (r) Ys(o, !1);
                else {
                  if (0 !== uc || (null !== e && 0 !== (128 & e.flags)))
                    for (e = t.child; null !== e; ) {
                      if (null !== (a = Io(e))) {
                        for (
                          t.flags |= 128,
                            Ys(o, !1),
                            e = a.updateQueue,
                            t.updateQueue = e,
                            qs(t, e),
                            t.subtreeFlags = 0,
                            e = n,
                            n = t.child;
                          null !== n;

                        )
                          Fs(n, e), (n = n.sibling);
                        return Q(Ao, (1 & Ao.current) | 2), t.child;
                      }
                      e = e.sibling;
                    }
                  null !== o.tail &&
                    se() > wc &&
                    ((t.flags |= 128),
                    (r = !0),
                    Ys(o, !1),
                    (t.lanes = 4194304));
                }
              else {
                if (!r)
                  if (null !== (e = Io(a))) {
                    if (
                      ((t.flags |= 128),
                      (r = !0),
                      (e = e.updateQueue),
                      (t.updateQueue = e),
                      qs(t, e),
                      Ys(o, !0),
                      null === o.tail &&
                        "hidden" === o.tailMode &&
                        !a.alternate &&
                        !Gr)
                    )
                      return Qs(t), null;
                  } else
                    2 * se() - o.renderingStartTime > wc &&
                      536870912 !== n &&
                      ((t.flags |= 128),
                      (r = !0),
                      Ys(o, !1),
                      (t.lanes = 4194304));
                o.isBackwards
                  ? ((a.sibling = t.child), (t.child = a))
                  : (null !== (e = o.last) ? (e.sibling = a) : (t.child = a),
                    (o.last = a));
              }
              return null !== o.tail
                ? ((t = o.tail),
                  (o.rendering = t),
                  (o.tail = t.sibling),
                  (o.renderingStartTime = se()),
                  (t.sibling = null),
                  (e = Ao.current),
                  Q(Ao, r ? (1 & e) | 2 : 1 & e),
                  t)
                : (Qs(t), null);
            case 22:
            case 23:
              return (
                zo(t),
                Po(),
                (r = null !== t.memoizedState),
                null !== e
                  ? (null !== e.memoizedState) !== r && (t.flags |= 8192)
                  : r && (t.flags |= 8192),
                r
                  ? 0 !== (536870912 & n) &&
                    0 === (128 & t.flags) &&
                    (Qs(t), 6 & t.subtreeFlags && (t.flags |= 8192))
                  : Qs(t),
                null !== (n = t.updateQueue) && qs(t, n.retryQueue),
                (n = null),
                null !== e &&
                  null !== e.memoizedState &&
                  null !== e.memoizedState.cachePool &&
                  (n = e.memoizedState.cachePool.pool),
                (r = null),
                null !== t.memoizedState &&
                  null !== t.memoizedState.cachePool &&
                  (r = t.memoizedState.cachePool.pool),
                r !== n && (t.flags |= 2048),
                null !== e && Y(Ko),
                null
              );
            case 24:
              return (
                (n = null),
                null !== e && (n = e.memoizedState.cache),
                t.memoizedState.cache !== n && (t.flags |= 2048),
                bl(Uo),
                Qs(t),
                null
              );
            case 25:
              return null;
          }
          throw Error(i(156, t.tag));
        }
        function Gs(e, t) {
          switch ((Yr(t), t.tag)) {
            case 1:
              return 65536 & (e = t.flags)
                ? ((t.flags = (-65537 & e) | 128), t)
                : null;
            case 3:
              return (
                bl(Uo),
                ee(),
                0 !== (65536 & (e = t.flags)) && 0 === (128 & e)
                  ? ((t.flags = (-65537 & e) | 128), t)
                  : null
              );
            case 26:
            case 27:
            case 5:
              return ne(t), null;
            case 13:
              if (
                (zo(t), null !== (e = t.memoizedState) && null !== e.dehydrated)
              ) {
                if (null === t.alternate) throw Error(i(340));
                oo();
              }
              return 65536 & (e = t.flags)
                ? ((t.flags = (-65537 & e) | 128), t)
                : null;
            case 19:
              return Y(Ao), null;
            case 4:
              return ee(), null;
            case 10:
              return bl(t.type), null;
            case 22:
            case 23:
              return (
                zo(t),
                Po(),
                null !== e && Y(Ko),
                65536 & (e = t.flags)
                  ? ((t.flags = (-65537 & e) | 128), t)
                  : null
              );
            case 24:
              return bl(Uo), null;
            default:
              return null;
          }
        }
        function Xs(e, t) {
          switch ((Yr(t), t.tag)) {
            case 3:
              bl(Uo), ee();
              break;
            case 26:
            case 27:
            case 5:
              ne(t);
              break;
            case 4:
              ee();
              break;
            case 13:
              zo(t);
              break;
            case 19:
              Y(Ao);
              break;
            case 10:
              bl(t.type);
              break;
            case 22:
            case 23:
              zo(t), Po(), null !== e && Y(Ko);
              break;
            case 24:
              bl(Uo);
          }
        }
        var Js = {
            getCacheForType: function (e) {
              var t = Cl(Uo),
                n = t.data.get(e);
              return void 0 === n && ((n = e()), t.data.set(e, n)), n;
            },
          },
          Zs = "function" === typeof WeakMap ? WeakMap : Map,
          ec = 0,
          tc = null,
          nc = null,
          rc = 0,
          oc = 0,
          ac = null,
          ic = !1,
          lc = !1,
          sc = !1,
          cc = 0,
          uc = 0,
          dc = 0,
          fc = 0,
          pc = 0,
          hc = 0,
          mc = 0,
          yc = null,
          vc = null,
          gc = !1,
          bc = 0,
          wc = 1 / 0,
          Sc = null,
          kc = null,
          xc = !1,
          Ec = null,
          Cc = 0,
          Nc = 0,
          Tc = null,
          Pc = 0,
          Oc = null;
        function jc() {
          if (0 !== (2 & ec) && 0 !== rc) return rc & -rc;
          if (null !== j.T) {
            return 0 !== $o ? $o : Su();
          }
          return Ie();
        }
        function Rc() {
          0 === hc && (hc = 0 === (536870912 & rc) || Gr ? Oe() : 536870912);
          var e = Oo.current;
          return null !== e && (e.flags |= 32), hc;
        }
        function _c(e, t, n) {
          ((e === tc && 2 === oc) || null !== e.cancelPendingCommit) &&
            (Uc(e, 0), Mc(e, rc, hc, !1)),
            _e(e, n),
            (0 !== (2 & ec) && e === tc) ||
              (e === tc &&
                (0 === (2 & ec) && (fc |= n), 4 === uc && Mc(e, rc, hc, !1)),
              mu(e));
        }
        function Lc(e, t, n) {
          if (0 !== (6 & ec)) throw Error(i(327));
          for (
            var r =
                (!n && 0 === (60 & t) && 0 === (t & e.expiredLanes)) ||
                Te(e, t),
              o = r
                ? (function (e, t) {
                    var n = ec;
                    ec |= 2;
                    var r = Hc(),
                      o = Bc();
                    tc !== e || rc !== t
                      ? ((Sc = null), (wc = se() + 500), Uc(e, t))
                      : (lc = Te(e, t));
                    e: for (;;)
                      try {
                        if (0 !== oc && null !== nc) {
                          t = nc;
                          var a = ac;
                          t: switch (oc) {
                            case 1:
                              (oc = 0), (ac = null), Gc(e, t, a, 1);
                              break;
                            case 2:
                              if (co(a)) {
                                (oc = 0), (ac = null), Kc(t);
                                break;
                              }
                              (t = function () {
                                2 === oc && tc === e && (oc = 7), mu(e);
                              }),
                                a.then(t, t);
                              break e;
                            case 3:
                              oc = 7;
                              break e;
                            case 4:
                              oc = 5;
                              break e;
                            case 7:
                              co(a)
                                ? ((oc = 0), (ac = null), Kc(t))
                                : ((oc = 0), (ac = null), Gc(e, t, a, 7));
                              break;
                            case 5:
                              var l = null;
                              switch (nc.tag) {
                                case 26:
                                  l = nc.memoizedState;
                                case 5:
                                case 27:
                                  var s = nc;
                                  if (!l || Od(l)) {
                                    (oc = 0), (ac = null);
                                    var c = s.sibling;
                                    if (null !== c) nc = c;
                                    else {
                                      var u = s.return;
                                      null !== u
                                        ? ((nc = u), Xc(u))
                                        : (nc = null);
                                    }
                                    break t;
                                  }
                              }
                              (oc = 0), (ac = null), Gc(e, t, a, 5);
                              break;
                            case 6:
                              (oc = 0), (ac = null), Gc(e, t, a, 6);
                              break;
                            case 8:
                              Dc(), (uc = 6);
                              break e;
                            default:
                              throw Error(i(462));
                          }
                        }
                        Yc();
                        break;
                      } catch (d) {
                        Wc(e, d);
                      }
                    return (
                      (vl = yl = null),
                      (j.H = r),
                      (j.A = o),
                      (ec = n),
                      null !== nc ? 0 : ((tc = null), (rc = 0), Nr(), uc)
                    );
                  })(e, t)
                : $c(e, t, !0),
              a = r;
            ;

          ) {
            if (0 === o) {
              lc && !r && Mc(e, t, 0, !1);
              break;
            }
            if (6 === o) Mc(e, t, 0, !ic);
            else {
              if (((n = e.current.alternate), a && !Ic(n))) {
                (o = $c(e, t, !1)), (a = !1);
                continue;
              }
              if (2 === o) {
                if (((a = t), e.errorRecoveryDisabledLanes & a)) var l = 0;
                else
                  l =
                    0 !== (l = -536870913 & e.pendingLanes)
                      ? l
                      : 536870912 & l
                      ? 536870912
                      : 0;
                if (0 !== l) {
                  t = l;
                  e: {
                    var s = e;
                    o = yc;
                    var c = s.current.memoizedState.isDehydrated;
                    if (
                      (c && (Uc(s, l).flags |= 256), 2 !== (l = $c(s, l, !1)))
                    ) {
                      if (sc && !c) {
                        (s.errorRecoveryDisabledLanes |= a), (fc |= a), (o = 4);
                        break e;
                      }
                      (a = vc), (vc = o), null !== a && zc(a);
                    }
                    o = l;
                  }
                  if (((a = !1), 2 !== o)) continue;
                }
              }
              if (1 === o) {
                Uc(e, 0), Mc(e, t, 0, !0);
                break;
              }
              e: {
                switch (((r = e), o)) {
                  case 0:
                  case 1:
                    throw Error(i(345));
                  case 4:
                    if ((4194176 & t) === t) {
                      Mc(r, t, hc, !ic);
                      break e;
                    }
                    break;
                  case 2:
                    vc = null;
                    break;
                  case 3:
                  case 5:
                    break;
                  default:
                    throw Error(i(329));
                }
                if (
                  ((r.finishedWork = n),
                  (r.finishedLanes = t),
                  (62914560 & t) === t && 10 < (a = bc + 300 - se()))
                ) {
                  if ((Mc(r, t, hc, !ic), 0 !== Ne(r, 0))) break e;
                  r.timeoutHandle = ed(
                    Ac.bind(
                      null,
                      r,
                      n,
                      vc,
                      Sc,
                      gc,
                      t,
                      hc,
                      fc,
                      mc,
                      ic,
                      2,
                      -0,
                      0
                    ),
                    a
                  );
                } else Ac(r, n, vc, Sc, gc, t, hc, fc, mc, ic, 0, -0, 0);
              }
            }
            break;
          }
          mu(e);
        }
        function zc(e) {
          null === vc ? (vc = e) : vc.push.apply(vc, e);
        }
        function Ac(e, t, n, r, o, a, l, s, c, u, d, f, p) {
          var h = t.subtreeFlags;
          if (
            (8192 & h || 16785408 === (16785408 & h)) &&
            ((jd = { stylesheets: null, count: 0, unsuspend: Rd }),
            Ps(t),
            null !==
              (t = (function () {
                if (null === jd) throw Error(i(475));
                var e = jd;
                return (
                  e.stylesheets && 0 === e.count && zd(e, e.stylesheets),
                  0 < e.count
                    ? function (t) {
                        var n = setTimeout(function () {
                          if (
                            (e.stylesheets && zd(e, e.stylesheets), e.unsuspend)
                          ) {
                            var t = e.unsuspend;
                            (e.unsuspend = null), t();
                          }
                        }, 6e4);
                        return (
                          (e.unsuspend = t),
                          function () {
                            (e.unsuspend = null), clearTimeout(n);
                          }
                        );
                      }
                    : null
                );
              })()))
          )
            return (
              (e.cancelPendingCommit = t(
                Zc.bind(null, e, n, r, o, l, s, c, 1, f, p)
              )),
              void Mc(e, a, l, !u)
            );
          Zc(e, n, r, o, l, s, c, d, f, p);
        }
        function Ic(e) {
          for (var t = e; ; ) {
            var n = t.tag;
            if (
              (0 === n || 11 === n || 15 === n) &&
              16384 & t.flags &&
              null !== (n = t.updateQueue) &&
              null !== (n = n.stores)
            )
              for (var r = 0; r < n.length; r++) {
                var o = n[r],
                  a = o.getSnapshot;
                o = o.value;
                try {
                  if (!Qn(a(), o)) return !1;
                } catch (i) {
                  return !1;
                }
              }
            if (((n = t.child), 16384 & t.subtreeFlags && null !== n))
              (n.return = t), (t = n);
            else {
              if (t === e) break;
              for (; null === t.sibling; ) {
                if (null === t.return || t.return === e) return !0;
                t = t.return;
              }
              (t.sibling.return = t.return), (t = t.sibling);
            }
          }
          return !0;
        }
        function Mc(e, t, n, r) {
          (t &= ~pc),
            (t &= ~fc),
            (e.suspendedLanes |= t),
            (e.pingedLanes &= ~t),
            r && (e.warmLanes |= t),
            (r = e.expirationTimes);
          for (var o = t; 0 < o; ) {
            var a = 31 - we(o),
              i = 1 << a;
            (r[a] = -1), (o &= ~i);
          }
          0 !== n && Le(e, n, t);
        }
        function Fc() {
          return 0 !== (6 & ec) || (yu(0, !1), !1);
        }
        function Dc() {
          if (null !== nc) {
            if (0 === oc) var e = nc.return;
            else
              (vl = yl = null), ga((e = nc)), (mo = null), (yo = 0), (e = nc);
            for (; null !== e; ) Xs(e.alternate, e), (e = e.return);
            nc = null;
          }
        }
        function Uc(e, t) {
          (e.finishedWork = null), (e.finishedLanes = 0);
          var n = e.timeoutHandle;
          -1 !== n && ((e.timeoutHandle = -1), td(n)),
            null !== (n = e.cancelPendingCommit) &&
              ((e.cancelPendingCommit = null), n()),
            Dc(),
            (tc = e),
            (nc = n = Ms(e.current, null)),
            (rc = t),
            (oc = 0),
            (ac = null),
            (ic = !1),
            (lc = Te(e, t)),
            (sc = !1),
            (mc = hc = pc = fc = dc = uc = 0),
            (vc = yc = null),
            (gc = !1),
            0 !== (8 & t) && (t |= 32 & t);
          var r = e.entangledLanes;
          if (0 !== r)
            for (e = e.entanglements, r &= t; 0 < r; ) {
              var o = 31 - we(r),
                a = 1 << o;
              (t |= e[o]), (r &= ~a);
            }
          return (cc = t), Nr(), n;
        }
        function Wc(e, t) {
          (ea = null),
            (j.H = Ci),
            t === io
              ? ((t = ho()), (oc = 3))
              : t === lo
              ? ((t = ho()), (oc = 4))
              : (oc =
                  t === Bi
                    ? 8
                    : null !== t &&
                      "object" === typeof t &&
                      "function" === typeof t.then
                    ? 6
                    : 1),
            (ac = t),
            null === nc && ((uc = 1), Fi(e, zr(t, e.current)));
        }
        function Hc() {
          var e = j.H;
          return (j.H = Ci), null === e ? Ci : e;
        }
        function Bc() {
          var e = j.A;
          return (j.A = Js), e;
        }
        function Vc() {
          (uc = 4),
            ic || ((4194176 & rc) !== rc && null !== Oo.current) || (lc = !0),
            (0 === (134217727 & dc) && 0 === (134217727 & fc)) ||
              null === tc ||
              Mc(tc, rc, hc, !1);
        }
        function $c(e, t, n) {
          var r = ec;
          ec |= 2;
          var o = Hc(),
            a = Bc();
          (tc === e && rc === t) || ((Sc = null), Uc(e, t)), (t = !1);
          var i = uc;
          e: for (;;)
            try {
              if (0 !== oc && null !== nc) {
                var l = nc,
                  s = ac;
                switch (oc) {
                  case 8:
                    Dc(), (i = 6);
                    break e;
                  case 3:
                  case 2:
                  case 6:
                    null === Oo.current && (t = !0);
                    var c = oc;
                    if (((oc = 0), (ac = null), Gc(e, l, s, c), n && lc)) {
                      i = 0;
                      break e;
                    }
                    break;
                  default:
                    (c = oc), (oc = 0), (ac = null), Gc(e, l, s, c);
                }
              }
              qc(), (i = uc);
              break;
            } catch (u) {
              Wc(e, u);
            }
          return (
            t && e.shellSuspendCounter++,
            (vl = yl = null),
            (ec = r),
            (j.H = o),
            (j.A = a),
            null === nc && ((tc = null), (rc = 0), Nr()),
            i
          );
        }
        function qc() {
          for (; null !== nc; ) Qc(nc);
        }
        function Yc() {
          for (; null !== nc && !ie(); ) Qc(nc);
        }
        function Qc(e) {
          var t = hl(e.alternate, e, cc);
          (e.memoizedProps = e.pendingProps), null === t ? Xc(e) : (nc = t);
        }
        function Kc(e) {
          var t = e,
            n = t.alternate;
          switch (t.tag) {
            case 15:
            case 0:
              t = Zi(n, t, t.pendingProps, t.type, void 0, rc);
              break;
            case 11:
              t = Zi(n, t, t.pendingProps, t.type.render, t.ref, rc);
              break;
            case 5:
              ga(t);
            default:
              Xs(n, t), (t = hl(n, (t = nc = Fs(t, cc)), cc));
          }
          (e.memoizedProps = e.pendingProps), null === t ? Xc(e) : (nc = t);
        }
        function Gc(e, t, n, r) {
          (vl = yl = null), ga(t), (mo = null), (yo = 0);
          var o = t.return;
          try {
            if (
              (function (e, t, n, r, o) {
                if (
                  ((n.flags |= 32768),
                  null !== r &&
                    "object" === typeof r &&
                    "function" === typeof r.then)
                ) {
                  if (
                    (null !== (t = n.alternate) && kl(t, n, o, !0),
                    null !== (n = Oo.current))
                  ) {
                    switch (n.tag) {
                      case 13:
                        return (
                          null === jo
                            ? Vc()
                            : null === n.alternate && 0 === uc && (uc = 3),
                          (n.flags &= -257),
                          (n.flags |= 65536),
                          (n.lanes = o),
                          r === so
                            ? (n.flags |= 16384)
                            : (null === (t = n.updateQueue)
                                ? (n.updateQueue = new Set([r]))
                                : t.add(r),
                              ou(e, r, o)),
                          !1
                        );
                      case 22:
                        return (
                          (n.flags |= 65536),
                          r === so
                            ? (n.flags |= 16384)
                            : (null === (t = n.updateQueue)
                                ? ((t = {
                                    transitions: null,
                                    markerInstances: null,
                                    retryQueue: new Set([r]),
                                  }),
                                  (n.updateQueue = t))
                                : null === (n = t.retryQueue)
                                ? (t.retryQueue = new Set([r]))
                                : n.add(r),
                              ou(e, r, o)),
                          !1
                        );
                    }
                    throw Error(i(435, n.tag));
                  }
                  return ou(e, r, o), Vc(), !1;
                }
                if (Gr)
                  return (
                    null !== (t = Oo.current)
                      ? (0 === (65536 & t.flags) && (t.flags |= 256),
                        (t.flags |= 65536),
                        (t.lanes = o),
                        r !== Zr &&
                          ao(zr((e = Error(i(422), { cause: r })), n)))
                      : (r !== Zr &&
                          ao(zr((t = Error(i(423), { cause: r })), n)),
                        ((e = e.current.alternate).flags |= 65536),
                        (o &= -o),
                        (e.lanes |= o),
                        (r = zr(r, n)),
                        zl(e, (o = Ui(e.stateNode, r, o))),
                        4 !== uc && (uc = 2)),
                    !1
                  );
                var a = Error(i(520), { cause: r });
                if (
                  ((a = zr(a, n)),
                  null === yc ? (yc = [a]) : yc.push(a),
                  4 !== uc && (uc = 2),
                  null === t)
                )
                  return !0;
                (r = zr(r, n)), (n = t);
                do {
                  switch (n.tag) {
                    case 3:
                      return (
                        (n.flags |= 65536),
                        (e = o & -o),
                        (n.lanes |= e),
                        zl(n, (e = Ui(n.stateNode, r, e))),
                        !1
                      );
                    case 1:
                      if (
                        ((t = n.type),
                        (a = n.stateNode),
                        0 === (128 & n.flags) &&
                          ("function" === typeof t.getDerivedStateFromError ||
                            (null !== a &&
                              "function" === typeof a.componentDidCatch &&
                              (null === kc || !kc.has(a)))))
                      )
                        return (
                          (n.flags |= 65536),
                          (o &= -o),
                          (n.lanes |= o),
                          Hi((o = Wi(o)), e, n, r),
                          zl(n, o),
                          !1
                        );
                  }
                  n = n.return;
                } while (null !== n);
                return !1;
              })(e, o, t, n, rc)
            )
              return (uc = 1), Fi(e, zr(n, e.current)), void (nc = null);
          } catch (a) {
            if (null !== o) throw ((nc = o), a);
            return (uc = 1), Fi(e, zr(n, e.current)), void (nc = null);
          }
          32768 & t.flags
            ? (Gr || 1 === r
                ? (e = !0)
                : lc || 0 !== (536870912 & rc)
                ? (e = !1)
                : ((ic = e = !0),
                  (2 === r || 3 === r || 6 === r) &&
                    null !== (r = Oo.current) &&
                    13 === r.tag &&
                    (r.flags |= 16384)),
              Jc(t, e))
            : Xc(t);
        }
        function Xc(e) {
          var t = e;
          do {
            if (0 !== (32768 & t.flags)) return void Jc(t, ic);
            e = t.return;
            var n = Ks(t.alternate, t, cc);
            if (null !== n) return void (nc = n);
            if (null !== (t = t.sibling)) return void (nc = t);
            nc = t = e;
          } while (null !== t);
          0 === uc && (uc = 5);
        }
        function Jc(e, t) {
          do {
            var n = Gs(e.alternate, e);
            if (null !== n) return (n.flags &= 32767), void (nc = n);
            if (
              (null !== (n = e.return) &&
                ((n.flags |= 32768),
                (n.subtreeFlags = 0),
                (n.deletions = null)),
              !t && null !== (e = e.sibling))
            )
              return void (nc = e);
            nc = e = n;
          } while (null !== e);
          (uc = 6), (nc = null);
        }
        function Zc(e, t, n, r, o, a, l, s, c, u) {
          var d = j.T,
            f = H.p;
          try {
            (H.p = 2),
              (j.T = null),
              (function (e, t, n, r, o, a, l, s) {
                do {
                  tu();
                } while (null !== Ec);
                if (0 !== (6 & ec)) throw Error(i(327));
                var c = e.finishedWork;
                if (((r = e.finishedLanes), null === c)) return null;
                if (
                  ((e.finishedWork = null),
                  (e.finishedLanes = 0),
                  c === e.current)
                )
                  throw Error(i(177));
                (e.callbackNode = null),
                  (e.callbackPriority = 0),
                  (e.cancelPendingCommit = null);
                var u = c.lanes | c.childLanes;
                if (
                  ((function (e, t, n, r, o, a) {
                    var i = e.pendingLanes;
                    (e.pendingLanes = n),
                      (e.suspendedLanes = 0),
                      (e.pingedLanes = 0),
                      (e.warmLanes = 0),
                      (e.expiredLanes &= n),
                      (e.entangledLanes &= n),
                      (e.errorRecoveryDisabledLanes &= n),
                      (e.shellSuspendCounter = 0);
                    var l = e.entanglements,
                      s = e.expirationTimes,
                      c = e.hiddenUpdates;
                    for (n = i & ~n; 0 < n; ) {
                      var u = 31 - we(n),
                        d = 1 << u;
                      (l[u] = 0), (s[u] = -1);
                      var f = c[u];
                      if (null !== f)
                        for (c[u] = null, u = 0; u < f.length; u++) {
                          var p = f[u];
                          null !== p && (p.lane &= -536870913);
                        }
                      n &= ~d;
                    }
                    0 !== r && Le(e, r, 0),
                      0 !== a &&
                        0 === o &&
                        0 !== e.tag &&
                        (e.suspendedLanes |= a & ~(i & ~t));
                  })(e, r, (u |= Cr), a, l, s),
                  e === tc && ((nc = tc = null), (rc = 0)),
                  (0 === (10256 & c.subtreeFlags) && 0 === (10256 & c.flags)) ||
                    xc ||
                    ((xc = !0),
                    (Nc = u),
                    (Tc = n),
                    (function (e, t) {
                      oe(e, t);
                    })(fe, function () {
                      return tu(), null;
                    })),
                  (n = 0 !== (15990 & c.flags)),
                  0 !== (15990 & c.subtreeFlags) || n
                    ? ((n = j.T),
                      (j.T = null),
                      (a = H.p),
                      (H.p = 2),
                      (l = ec),
                      (ec |= 4),
                      (function (e, t) {
                        if (
                          ((e = e.containerInfo), (Yu = Vd), er((e = Zn(e))))
                        ) {
                          if ("selectionStart" in e)
                            var n = {
                              start: e.selectionStart,
                              end: e.selectionEnd,
                            };
                          else
                            e: {
                              var r =
                                (n =
                                  ((n = e.ownerDocument) && n.defaultView) ||
                                  window).getSelection && n.getSelection();
                              if (r && 0 !== r.rangeCount) {
                                n = r.anchorNode;
                                var o = r.anchorOffset,
                                  a = r.focusNode;
                                r = r.focusOffset;
                                try {
                                  n.nodeType, a.nodeType;
                                } catch (y) {
                                  n = null;
                                  break e;
                                }
                                var l = 0,
                                  s = -1,
                                  c = -1,
                                  u = 0,
                                  d = 0,
                                  f = e,
                                  p = null;
                                t: for (;;) {
                                  for (
                                    var h;
                                    f !== n ||
                                      (0 !== o && 3 !== f.nodeType) ||
                                      (s = l + o),
                                      f !== a ||
                                        (0 !== r && 3 !== f.nodeType) ||
                                        (c = l + r),
                                      3 === f.nodeType &&
                                        (l += f.nodeValue.length),
                                      null !== (h = f.firstChild);

                                  )
                                    (p = f), (f = h);
                                  for (;;) {
                                    if (f === e) break t;
                                    if (
                                      (p === n && ++u === o && (s = l),
                                      p === a && ++d === r && (c = l),
                                      null !== (h = f.nextSibling))
                                    )
                                      break;
                                    p = (f = p).parentNode;
                                  }
                                  f = h;
                                }
                                n =
                                  -1 === s || -1 === c
                                    ? null
                                    : { start: s, end: c };
                              } else n = null;
                            }
                          n = n || { start: 0, end: 0 };
                        } else n = null;
                        for (
                          Qu = { focusedElem: e, selectionRange: n },
                            Vd = !1,
                            ns = t;
                          null !== ns;

                        )
                          if (
                            ((e = (t = ns).child),
                            0 !== (1028 & t.subtreeFlags) && null !== e)
                          )
                            (e.return = t), (ns = e);
                          else
                            for (; null !== ns; ) {
                              switch (
                                ((a = (t = ns).alternate), (e = t.flags), t.tag)
                              ) {
                                case 0:
                                case 11:
                                case 15:
                                case 5:
                                case 26:
                                case 27:
                                case 6:
                                case 4:
                                case 17:
                                  break;
                                case 1:
                                  if (0 !== (1024 & e) && null !== a) {
                                    (e = void 0),
                                      (n = t),
                                      (o = a.memoizedProps),
                                      (a = a.memoizedState),
                                      (r = n.stateNode);
                                    try {
                                      var m = Li(
                                        n.type,
                                        o,
                                        (n.elementType, n.type)
                                      );
                                      (e = r.getSnapshotBeforeUpdate(m, a)),
                                        (r.__reactInternalSnapshotBeforeUpdate =
                                          e);
                                    } catch (v) {
                                      ru(n, n.return, v);
                                    }
                                  }
                                  break;
                                case 3:
                                  if (0 !== (1024 & e))
                                    if (
                                      9 ===
                                      (n = (e = t.stateNode.containerInfo)
                                        .nodeType)
                                    )
                                      id(e);
                                    else if (1 === n)
                                      switch (e.nodeName) {
                                        case "HEAD":
                                        case "HTML":
                                        case "BODY":
                                          id(e);
                                          break;
                                        default:
                                          e.textContent = "";
                                      }
                                  break;
                                default:
                                  if (0 !== (1024 & e)) throw Error(i(163));
                              }
                              if (null !== (e = t.sibling)) {
                                (e.return = t.return), (ns = e);
                                break;
                              }
                              ns = t.return;
                            }
                        (m = rs), (rs = !1);
                      })(e, c),
                      hs(c, e),
                      tr(Qu, e.containerInfo),
                      (Vd = !!Yu),
                      (Qu = Yu = null),
                      (e.current = c),
                      os(e, c.alternate, c),
                      le(),
                      (ec = l),
                      (H.p = a),
                      (j.T = n))
                    : (e.current = c),
                  xc ? ((xc = !1), (Ec = e), (Cc = r)) : eu(e, u),
                  (u = e.pendingLanes),
                  0 === u && (kc = null),
                  (function (e) {
                    if (ge && "function" === typeof ge.onCommitFiberRoot)
                      try {
                        ge.onCommitFiberRoot(
                          ve,
                          e,
                          void 0,
                          128 === (128 & e.current.flags)
                        );
                      } catch (t) {}
                  })(c.stateNode),
                  mu(e),
                  null !== t)
                )
                  for (o = e.onRecoverableError, c = 0; c < t.length; c++)
                    (u = t[c]), o(u.value, { componentStack: u.stack });
                0 !== (3 & Cc) && tu(),
                  (u = e.pendingLanes),
                  0 !== (4194218 & r) && 0 !== (42 & u)
                    ? e === Oc
                      ? Pc++
                      : ((Pc = 0), (Oc = e))
                    : (Pc = 0),
                  yu(0, !1);
              })(e, t, n, r, f, o, a, l);
          } finally {
            (j.T = d), (H.p = f);
          }
        }
        function eu(e, t) {
          0 === (e.pooledCacheLanes &= t) &&
            null != (t = e.pooledCache) &&
            ((e.pooledCache = null), Ho(t));
        }
        function tu() {
          if (null !== Ec) {
            var e = Ec,
              t = Nc;
            Nc = 0;
            var n = Ae(Cc),
              r = j.T,
              o = H.p;
            try {
              if (((H.p = 32 > n ? 32 : n), (j.T = null), null === Ec))
                var a = !1;
              else {
                (n = Tc), (Tc = null);
                var l = Ec,
                  s = Cc;
                if (((Ec = null), (Cc = 0), 0 !== (6 & ec)))
                  throw Error(i(331));
                var c = ec;
                if (
                  ((ec |= 4),
                  Rs(l.current),
                  xs(l, l.current, s, n),
                  (ec = c),
                  yu(0, !1),
                  ge && "function" === typeof ge.onPostCommitFiberRoot)
                )
                  try {
                    ge.onPostCommitFiberRoot(ve, l);
                  } catch (u) {}
                a = !0;
              }
              return a;
            } finally {
              (H.p = o), (j.T = r), eu(e, t);
            }
          }
          return !1;
        }
        function nu(e, t, n) {
          (t = zr(n, t)),
            null !== (e = _l(e, (t = Ui(e.stateNode, t, 2)), 2)) &&
              (_e(e, 2), mu(e));
        }
        function ru(e, t, n) {
          if (3 === e.tag) nu(e, e, n);
          else
            for (; null !== t; ) {
              if (3 === t.tag) {
                nu(t, e, n);
                break;
              }
              if (1 === t.tag) {
                var r = t.stateNode;
                if (
                  "function" === typeof t.type.getDerivedStateFromError ||
                  ("function" === typeof r.componentDidCatch &&
                    (null === kc || !kc.has(r)))
                ) {
                  (e = zr(n, e)),
                    null !== (r = _l(t, (n = Wi(2)), 2)) &&
                      (Hi(n, r, t, e), _e(r, 2), mu(r));
                  break;
                }
              }
              t = t.return;
            }
        }
        function ou(e, t, n) {
          var r = e.pingCache;
          if (null === r) {
            r = e.pingCache = new Zs();
            var o = new Set();
            r.set(t, o);
          } else void 0 === (o = r.get(t)) && ((o = new Set()), r.set(t, o));
          o.has(n) ||
            ((sc = !0), o.add(n), (e = au.bind(null, e, t, n)), t.then(e, e));
        }
        function au(e, t, n) {
          var r = e.pingCache;
          null !== r && r.delete(t),
            (e.pingedLanes |= e.suspendedLanes & n),
            (e.warmLanes &= ~n),
            tc === e &&
              (rc & n) === n &&
              (4 === uc ||
              (3 === uc && (62914560 & rc) === rc && 300 > se() - bc)
                ? 0 === (2 & ec) && Uc(e, 0)
                : (pc |= n),
              mc === rc && (mc = 0)),
            mu(e);
        }
        function iu(e, t) {
          0 === t && (t = je()), null !== (e = Or(e, t)) && (_e(e, t), mu(e));
        }
        function lu(e) {
          var t = e.memoizedState,
            n = 0;
          null !== t && (n = t.retryLane), iu(e, n);
        }
        function su(e, t) {
          var n = 0;
          switch (e.tag) {
            case 13:
              var r = e.stateNode,
                o = e.memoizedState;
              null !== o && (n = o.retryLane);
              break;
            case 19:
              r = e.stateNode;
              break;
            case 22:
              r = e.stateNode._retryCache;
              break;
            default:
              throw Error(i(314));
          }
          null !== r && r.delete(t), iu(e, n);
        }
        var cu = null,
          uu = null,
          du = !1,
          fu = !1,
          pu = !1,
          hu = 0;
        function mu(e) {
          var t;
          e !== uu &&
            null === e.next &&
            (null === uu ? (cu = uu = e) : (uu = uu.next = e)),
            (fu = !0),
            du ||
              ((du = !0),
              (t = vu),
              rd(function () {
                0 !== (6 & ec) ? oe(ue, t) : t();
              }));
        }
        function yu(e, t) {
          if (!pu && fu) {
            pu = !0;
            do {
              for (var n = !1, r = cu; null !== r; ) {
                if (!t)
                  if (0 !== e) {
                    var o = r.pendingLanes;
                    if (0 === o) var a = 0;
                    else {
                      var i = r.suspendedLanes,
                        l = r.pingedLanes;
                      (a = (1 << (31 - we(42 | e) + 1)) - 1),
                        (a =
                          201326677 & (a &= o & ~(i & ~l))
                            ? (201326677 & a) | 1
                            : a
                            ? 2 | a
                            : 0);
                    }
                    0 !== a && ((n = !0), wu(r, a));
                  } else
                    (a = rc),
                      0 === (3 & (a = Ne(r, r === tc ? a : 0))) ||
                        Te(r, a) ||
                        ((n = !0), wu(r, a));
                r = r.next;
              }
            } while (n);
            pu = !1;
          }
        }
        function vu() {
          fu = du = !1;
          var e = 0;
          0 !== hu &&
            ((function () {
              var e = window.event;
              if (e && "popstate" === e.type) return e !== Zu && ((Zu = e), !0);
              return (Zu = null), !1;
            })() && (e = hu),
            (hu = 0));
          for (var t = se(), n = null, r = cu; null !== r; ) {
            var o = r.next,
              a = gu(r, t);
            0 === a
              ? ((r.next = null),
                null === n ? (cu = o) : (n.next = o),
                null === o && (uu = n))
              : ((n = r), (0 !== e || 0 !== (3 & a)) && (fu = !0)),
              (r = o);
          }
          yu(e, !1);
        }
        function gu(e, t) {
          for (
            var n = e.suspendedLanes,
              r = e.pingedLanes,
              o = e.expirationTimes,
              a = -62914561 & e.pendingLanes;
            0 < a;

          ) {
            var i = 31 - we(a),
              l = 1 << i,
              s = o[i];
            -1 === s
              ? (0 !== (l & n) && 0 === (l & r)) || (o[i] = Pe(l, t))
              : s <= t && (e.expiredLanes |= l),
              (a &= ~l);
          }
          if (
            ((n = rc),
            (n = Ne(e, e === (t = tc) ? n : 0)),
            (r = e.callbackNode),
            0 === n || (e === t && 2 === oc) || null !== e.cancelPendingCommit)
          )
            return (
              null !== r && null !== r && ae(r),
              (e.callbackNode = null),
              (e.callbackPriority = 0)
            );
          if (0 === (3 & n) || Te(e, n)) {
            if ((t = n & -n) === e.callbackPriority) return t;
            switch ((null !== r && ae(r), Ae(n))) {
              case 2:
              case 8:
                n = de;
                break;
              case 32:
              default:
                n = fe;
                break;
              case 268435456:
                n = he;
            }
            return (
              (r = bu.bind(null, e)),
              (n = oe(n, r)),
              (e.callbackPriority = t),
              (e.callbackNode = n),
              t
            );
          }
          return (
            null !== r && null !== r && ae(r),
            (e.callbackPriority = 2),
            (e.callbackNode = null),
            2
          );
        }
        function bu(e, t) {
          var n = e.callbackNode;
          if (tu() && e.callbackNode !== n) return null;
          var r = rc;
          return 0 === (r = Ne(e, e === tc ? r : 0))
            ? null
            : (Lc(e, r, t),
              gu(e, se()),
              null != e.callbackNode && e.callbackNode === n
                ? bu.bind(null, e)
                : null);
        }
        function wu(e, t) {
          if (tu()) return null;
          Lc(e, t, !0);
        }
        function Su() {
          return 0 === hu && (hu = Oe()), hu;
        }
        function ku(e) {
          return null == e || "symbol" === typeof e || "boolean" === typeof e
            ? null
            : "function" === typeof e
            ? e
            : Ot("" + e);
        }
        function xu(e, t) {
          var n = t.ownerDocument.createElement("input");
          return (
            (n.name = t.name),
            (n.value = t.value),
            e.id && n.setAttribute("form", e.id),
            t.parentNode.insertBefore(n, t),
            (e = new FormData(e)),
            n.parentNode.removeChild(n),
            e
          );
        }
        for (var Eu = 0; Eu < Sr.length; Eu++) {
          var Cu = Sr[Eu];
          kr(Cu.toLowerCase(), "on" + (Cu[0].toUpperCase() + Cu.slice(1)));
        }
        kr(pr, "onAnimationEnd"),
          kr(hr, "onAnimationIteration"),
          kr(mr, "onAnimationStart"),
          kr("dblclick", "onDoubleClick"),
          kr("focusin", "onFocus"),
          kr("focusout", "onBlur"),
          kr(yr, "onTransitionRun"),
          kr(vr, "onTransitionStart"),
          kr(gr, "onTransitionCancel"),
          kr(br, "onTransitionEnd"),
          tt("onMouseEnter", ["mouseout", "mouseover"]),
          tt("onMouseLeave", ["mouseout", "mouseover"]),
          tt("onPointerEnter", ["pointerout", "pointerover"]),
          tt("onPointerLeave", ["pointerout", "pointerover"]),
          et(
            "onChange",
            "change click focusin focusout input keydown keyup selectionchange".split(
              " "
            )
          ),
          et(
            "onSelect",
            "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
              " "
            )
          ),
          et("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste",
          ]),
          et(
            "onCompositionEnd",
            "compositionend focusout keydown keypress keyup mousedown".split(
              " "
            )
          ),
          et(
            "onCompositionStart",
            "compositionstart focusout keydown keypress keyup mousedown".split(
              " "
            )
          ),
          et(
            "onCompositionUpdate",
            "compositionupdate focusout keydown keypress keyup mousedown".split(
              " "
            )
          );
        var Nu =
            "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
              " "
            ),
          Tu = new Set(
            "beforetoggle cancel close invalid load scroll scrollend toggle"
              .split(" ")
              .concat(Nu)
          );
        function Pu(e, t) {
          t = 0 !== (4 & t);
          for (var n = 0; n < e.length; n++) {
            var r = e[n],
              o = r.event;
            r = r.listeners;
            e: {
              var a = void 0;
              if (t)
                for (var i = r.length - 1; 0 <= i; i--) {
                  var l = r[i],
                    s = l.instance,
                    c = l.currentTarget;
                  if (((l = l.listener), s !== a && o.isPropagationStopped()))
                    break e;
                  (a = l), (o.currentTarget = c);
                  try {
                    a(o);
                  } catch (u) {
                    zi(u);
                  }
                  (o.currentTarget = null), (a = s);
                }
              else
                for (i = 0; i < r.length; i++) {
                  if (
                    ((s = (l = r[i]).instance),
                    (c = l.currentTarget),
                    (l = l.listener),
                    s !== a && o.isPropagationStopped())
                  )
                    break e;
                  (a = l), (o.currentTarget = c);
                  try {
                    a(o);
                  } catch (u) {
                    zi(u);
                  }
                  (o.currentTarget = null), (a = s);
                }
            }
          }
        }
        function Ou(e, t) {
          var n = t[We];
          void 0 === n && (n = t[We] = new Set());
          var r = e + "__bubble";
          n.has(r) || (Lu(t, e, 2, !1), n.add(r));
        }
        function ju(e, t, n) {
          var r = 0;
          t && (r |= 4), Lu(n, e, r, t);
        }
        var Ru = "_reactListening" + Math.random().toString(36).slice(2);
        function _u(e) {
          if (!e[Ru]) {
            (e[Ru] = !0),
              Je.forEach(function (t) {
                "selectionchange" !== t &&
                  (Tu.has(t) || ju(t, !1, e), ju(t, !0, e));
              });
            var t = 9 === e.nodeType ? e : e.ownerDocument;
            null === t || t[Ru] || ((t[Ru] = !0), ju("selectionchange", !1, t));
          }
        }
        function Lu(e, t, n, r) {
          switch (Xd(t)) {
            case 2:
              var o = $d;
              break;
            case 8:
              o = qd;
              break;
            default:
              o = Yd;
          }
          (n = o.bind(null, t, n, e)),
            (o = void 0),
            !Ft ||
              ("touchstart" !== t && "touchmove" !== t && "wheel" !== t) ||
              (o = !0),
            r
              ? void 0 !== o
                ? e.addEventListener(t, n, { capture: !0, passive: o })
                : e.addEventListener(t, n, !0)
              : void 0 !== o
              ? e.addEventListener(t, n, { passive: o })
              : e.addEventListener(t, n, !1);
        }
        function zu(e, t, n, r, o) {
          var a = r;
          if (0 === (1 & t) && 0 === (2 & t) && null !== r)
            e: for (;;) {
              if (null === r) return;
              var i = r.tag;
              if (3 === i || 4 === i) {
                var l = r.stateNode.containerInfo;
                if (l === o || (8 === l.nodeType && l.parentNode === o)) break;
                if (4 === i)
                  for (i = r.return; null !== i; ) {
                    var s = i.tag;
                    if (
                      (3 === s || 4 === s) &&
                      ((s = i.stateNode.containerInfo) === o ||
                        (8 === s.nodeType && s.parentNode === o))
                    )
                      return;
                    i = i.return;
                  }
                for (; null !== l; ) {
                  if (null === (i = Ye(l))) return;
                  if (5 === (s = i.tag) || 6 === s || 26 === s || 27 === s) {
                    r = a = i;
                    continue e;
                  }
                  l = l.parentNode;
                }
              }
              r = r.return;
            }
          It(function () {
            var r = a,
              o = Rt(n),
              i = [];
            e: {
              var l = wr.get(e);
              if (void 0 !== l) {
                var s = Jt,
                  c = e;
                switch (e) {
                  case "keypress":
                    if (0 === Vt(n)) break e;
                  case "keydown":
                  case "keyup":
                    s = hn;
                    break;
                  case "focusin":
                    (c = "focus"), (s = on);
                    break;
                  case "focusout":
                    (c = "blur"), (s = on);
                    break;
                  case "beforeblur":
                  case "afterblur":
                    s = on;
                    break;
                  case "click":
                    if (2 === n.button) break e;
                  case "auxclick":
                  case "dblclick":
                  case "mousedown":
                  case "mousemove":
                  case "mouseup":
                  case "mouseout":
                  case "mouseover":
                  case "contextmenu":
                    s = nn;
                    break;
                  case "drag":
                  case "dragend":
                  case "dragenter":
                  case "dragexit":
                  case "dragleave":
                  case "dragover":
                  case "dragstart":
                  case "drop":
                    s = rn;
                    break;
                  case "touchcancel":
                  case "touchend":
                  case "touchmove":
                  case "touchstart":
                    s = yn;
                    break;
                  case pr:
                  case hr:
                  case mr:
                    s = an;
                    break;
                  case br:
                    s = vn;
                    break;
                  case "scroll":
                  case "scrollend":
                    s = en;
                    break;
                  case "wheel":
                    s = gn;
                    break;
                  case "copy":
                  case "cut":
                  case "paste":
                    s = ln;
                    break;
                  case "gotpointercapture":
                  case "lostpointercapture":
                  case "pointercancel":
                  case "pointerdown":
                  case "pointermove":
                  case "pointerout":
                  case "pointerover":
                  case "pointerup":
                    s = mn;
                    break;
                  case "toggle":
                  case "beforetoggle":
                    s = bn;
                }
                var u = 0 !== (4 & t),
                  d = !u && ("scroll" === e || "scrollend" === e),
                  f = u ? (null !== l ? l + "Capture" : null) : l;
                u = [];
                for (var p, h = r; null !== h; ) {
                  var m = h;
                  if (
                    ((p = m.stateNode),
                    (5 !== (m = m.tag) && 26 !== m && 27 !== m) ||
                      null === p ||
                      null === f ||
                      (null != (m = Mt(h, f)) && u.push(Au(h, m, p))),
                    d)
                  )
                    break;
                  h = h.return;
                }
                0 < u.length &&
                  ((l = new s(l, c, null, n, o)),
                  i.push({ event: l, listeners: u }));
              }
            }
            if (0 === (7 & t)) {
              if (
                ((s = "mouseout" === e || "pointerout" === e),
                (!(l = "mouseover" === e || "pointerover" === e) ||
                  n === jt ||
                  !(c = n.relatedTarget || n.fromElement) ||
                  (!Ye(c) && !c[Ue])) &&
                  (s || l) &&
                  ((l =
                    o.window === o
                      ? o
                      : (l = o.ownerDocument)
                      ? l.defaultView || l.parentWindow
                      : window),
                  s
                    ? ((s = r),
                      null !==
                        (c = (c = n.relatedTarget || n.toElement)
                          ? Ye(c)
                          : null) &&
                        ((d = M(c)),
                        (u = c.tag),
                        c !== d || (5 !== u && 27 !== u && 6 !== u)) &&
                        (c = null))
                    : ((s = null), (c = r)),
                  s !== c))
              ) {
                if (
                  ((u = nn),
                  (m = "onMouseLeave"),
                  (f = "onMouseEnter"),
                  (h = "mouse"),
                  ("pointerout" !== e && "pointerover" !== e) ||
                    ((u = mn),
                    (m = "onPointerLeave"),
                    (f = "onPointerEnter"),
                    (h = "pointer")),
                  (d = null == s ? l : Ke(s)),
                  (p = null == c ? l : Ke(c)),
                  ((l = new u(m, h + "leave", s, n, o)).target = d),
                  (l.relatedTarget = p),
                  (m = null),
                  Ye(o) === r &&
                    (((u = new u(f, h + "enter", c, n, o)).target = p),
                    (u.relatedTarget = d),
                    (m = u)),
                  (d = m),
                  s && c)
                )
                  e: {
                    for (f = c, h = 0, p = u = s; p; p = Mu(p)) h++;
                    for (p = 0, m = f; m; m = Mu(m)) p++;
                    for (; 0 < h - p; ) (u = Mu(u)), h--;
                    for (; 0 < p - h; ) (f = Mu(f)), p--;
                    for (; h--; ) {
                      if (u === f || (null !== f && u === f.alternate)) break e;
                      (u = Mu(u)), (f = Mu(f));
                    }
                    u = null;
                  }
                else u = null;
                null !== s && Fu(i, l, s, u, !1),
                  null !== c && null !== d && Fu(i, d, c, u, !0);
              }
              if (
                "select" ===
                  (s =
                    (l = r ? Ke(r) : window).nodeName &&
                    l.nodeName.toLowerCase()) ||
                ("input" === s && "file" === l.type)
              )
                var y = Mn;
              else if (Rn(l))
                if (Fn) y = Yn;
                else {
                  y = $n;
                  var v = Vn;
                }
              else
                !(s = l.nodeName) ||
                "input" !== s.toLowerCase() ||
                ("checkbox" !== l.type && "radio" !== l.type)
                  ? r && Nt(r.elementType) && (y = Mn)
                  : (y = qn);
              switch (
                (y && (y = y(e, r))
                  ? _n(i, y, n, o)
                  : (v && v(e, l, r),
                    "focusout" === e &&
                      r &&
                      "number" === l.type &&
                      null != r.memoizedProps.value &&
                      gt(l, "number", l.value)),
                (v = r ? Ke(r) : window),
                e)
              ) {
                case "focusin":
                  (Rn(v) || "true" === v.contentEditable) &&
                    ((rr = v), (or = r), (ar = null));
                  break;
                case "focusout":
                  ar = or = rr = null;
                  break;
                case "mousedown":
                  ir = !0;
                  break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                  (ir = !1), lr(i, n, o);
                  break;
                case "selectionchange":
                  if (nr) break;
                case "keydown":
                case "keyup":
                  lr(i, n, o);
              }
              var g;
              if (Sn)
                e: {
                  switch (e) {
                    case "compositionstart":
                      var b = "onCompositionStart";
                      break e;
                    case "compositionend":
                      b = "onCompositionEnd";
                      break e;
                    case "compositionupdate":
                      b = "onCompositionUpdate";
                      break e;
                  }
                  b = void 0;
                }
              else
                On
                  ? Tn(e, n) && (b = "onCompositionEnd")
                  : "keydown" === e &&
                    229 === n.keyCode &&
                    (b = "onCompositionStart");
              b &&
                (En &&
                  "ko" !== n.locale &&
                  (On || "onCompositionStart" !== b
                    ? "onCompositionEnd" === b && On && (g = Bt())
                    : ((Wt = "value" in (Ut = o) ? Ut.value : Ut.textContent),
                      (On = !0))),
                0 < (v = Iu(r, b)).length &&
                  ((b = new sn(b, e, null, n, o)),
                  i.push({ event: b, listeners: v }),
                  g ? (b.data = g) : null !== (g = Pn(n)) && (b.data = g))),
                (g = xn
                  ? (function (e, t) {
                      switch (e) {
                        case "compositionend":
                          return Pn(t);
                        case "keypress":
                          return 32 !== t.which ? null : ((Nn = !0), Cn);
                        case "textInput":
                          return (e = t.data) === Cn && Nn ? null : e;
                        default:
                          return null;
                      }
                    })(e, n)
                  : (function (e, t) {
                      if (On)
                        return "compositionend" === e || (!Sn && Tn(e, t))
                          ? ((e = Bt()), (Ht = Wt = Ut = null), (On = !1), e)
                          : null;
                      switch (e) {
                        case "paste":
                        default:
                          return null;
                        case "keypress":
                          if (
                            !(t.ctrlKey || t.altKey || t.metaKey) ||
                            (t.ctrlKey && t.altKey)
                          ) {
                            if (t.char && 1 < t.char.length) return t.char;
                            if (t.which) return String.fromCharCode(t.which);
                          }
                          return null;
                        case "compositionend":
                          return En && "ko" !== t.locale ? null : t.data;
                      }
                    })(e, n)) &&
                  0 < (b = Iu(r, "onBeforeInput")).length &&
                  ((v = new sn("onBeforeInput", "beforeinput", null, n, o)),
                  i.push({ event: v, listeners: b }),
                  (v.data = g)),
                (function (e, t, n, r, o) {
                  if ("submit" === t && n && n.stateNode === o) {
                    var a = ku((o[De] || null).action),
                      i = r.submitter;
                    i &&
                      null !==
                        (t = (t = i[De] || null)
                          ? ku(t.formAction)
                          : i.getAttribute("formAction")) &&
                      ((a = t), (i = null));
                    var l = new Jt("action", "action", null, r, o);
                    e.push({
                      event: l,
                      listeners: [
                        {
                          instance: null,
                          listener: function () {
                            if (r.defaultPrevented) {
                              if (0 !== hu) {
                                var e = i ? xu(o, i) : new FormData(o);
                                di(
                                  n,
                                  {
                                    pending: !0,
                                    data: e,
                                    method: o.method,
                                    action: a,
                                  },
                                  null,
                                  e
                                );
                              }
                            } else
                              "function" === typeof a &&
                                (l.preventDefault(),
                                (e = i ? xu(o, i) : new FormData(o)),
                                di(
                                  n,
                                  {
                                    pending: !0,
                                    data: e,
                                    method: o.method,
                                    action: a,
                                  },
                                  a,
                                  e
                                ));
                          },
                          currentTarget: o,
                        },
                      ],
                    });
                  }
                })(i, e, r, n, o);
            }
            Pu(i, t);
          });
        }
        function Au(e, t, n) {
          return { instance: e, listener: t, currentTarget: n };
        }
        function Iu(e, t) {
          for (var n = t + "Capture", r = []; null !== e; ) {
            var o = e,
              a = o.stateNode;
            (5 !== (o = o.tag) && 26 !== o && 27 !== o) ||
              null === a ||
              (null != (o = Mt(e, n)) && r.unshift(Au(e, o, a)),
              null != (o = Mt(e, t)) && r.push(Au(e, o, a))),
              (e = e.return);
          }
          return r;
        }
        function Mu(e) {
          if (null === e) return null;
          do {
            e = e.return;
          } while (e && 5 !== e.tag && 27 !== e.tag);
          return e || null;
        }
        function Fu(e, t, n, r, o) {
          for (var a = t._reactName, i = []; null !== n && n !== r; ) {
            var l = n,
              s = l.alternate,
              c = l.stateNode;
            if (((l = l.tag), null !== s && s === r)) break;
            (5 !== l && 26 !== l && 27 !== l) ||
              null === c ||
              ((s = c),
              o
                ? null != (c = Mt(n, a)) && i.unshift(Au(n, c, s))
                : o || (null != (c = Mt(n, a)) && i.push(Au(n, c, s)))),
              (n = n.return);
          }
          0 !== i.length && e.push({ event: t, listeners: i });
        }
        var Du = /\r\n?/g,
          Uu = /\u0000|\uFFFD/g;
        function Wu(e) {
          return ("string" === typeof e ? e : "" + e)
            .replace(Du, "\n")
            .replace(Uu, "");
        }
        function Hu(e, t) {
          return (t = Wu(t)), Wu(e) === t;
        }
        function Bu() {}
        function Vu(e, t, n, r, o, a) {
          switch (n) {
            case "children":
              "string" === typeof r
                ? "body" === t || ("textarea" === t && "" === r) || kt(e, r)
                : ("number" === typeof r || "bigint" === typeof r) &&
                  "body" !== t &&
                  kt(e, "" + r);
              break;
            case "className":
              lt(e, "class", r);
              break;
            case "tabIndex":
              lt(e, "tabindex", r);
              break;
            case "dir":
            case "role":
            case "viewBox":
            case "width":
            case "height":
              lt(e, n, r);
              break;
            case "style":
              Ct(e, r, a);
              break;
            case "data":
              if ("object" !== t) {
                lt(e, "data", r);
                break;
              }
            case "src":
            case "href":
              if ("" === r && ("a" !== t || "href" !== n)) {
                e.removeAttribute(n);
                break;
              }
              if (
                null == r ||
                "function" === typeof r ||
                "symbol" === typeof r ||
                "boolean" === typeof r
              ) {
                e.removeAttribute(n);
                break;
              }
              (r = Ot("" + r)), e.setAttribute(n, r);
              break;
            case "action":
            case "formAction":
              if ("function" === typeof r) {
                e.setAttribute(
                  n,
                  "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
                );
                break;
              }
              if (
                ("function" === typeof a &&
                  ("formAction" === n
                    ? ("input" !== t && Vu(e, t, "name", o.name, o, null),
                      Vu(e, t, "formEncType", o.formEncType, o, null),
                      Vu(e, t, "formMethod", o.formMethod, o, null),
                      Vu(e, t, "formTarget", o.formTarget, o, null))
                    : (Vu(e, t, "encType", o.encType, o, null),
                      Vu(e, t, "method", o.method, o, null),
                      Vu(e, t, "target", o.target, o, null))),
                null == r || "symbol" === typeof r || "boolean" === typeof r)
              ) {
                e.removeAttribute(n);
                break;
              }
              (r = Ot("" + r)), e.setAttribute(n, r);
              break;
            case "onClick":
              null != r && (e.onclick = Bu);
              break;
            case "onScroll":
              null != r && Ou("scroll", e);
              break;
            case "onScrollEnd":
              null != r && Ou("scrollend", e);
              break;
            case "dangerouslySetInnerHTML":
              if (null != r) {
                if ("object" !== typeof r || !("__html" in r))
                  throw Error(i(61));
                if (null != (n = r.__html)) {
                  if (null != o.children) throw Error(i(60));
                  e.innerHTML = n;
                }
              }
              break;
            case "multiple":
              e.multiple =
                r && "function" !== typeof r && "symbol" !== typeof r;
              break;
            case "muted":
              e.muted = r && "function" !== typeof r && "symbol" !== typeof r;
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "ref":
            case "autoFocus":
              break;
            case "xlinkHref":
              if (
                null == r ||
                "function" === typeof r ||
                "boolean" === typeof r ||
                "symbol" === typeof r
              ) {
                e.removeAttribute("xlink:href");
                break;
              }
              (n = Ot("" + r)),
                e.setAttributeNS(
                  "http://www.w3.org/1999/xlink",
                  "xlink:href",
                  n
                );
              break;
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
              null != r && "function" !== typeof r && "symbol" !== typeof r
                ? e.setAttribute(n, "" + r)
                : e.removeAttribute(n);
              break;
            case "inert":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
              r && "function" !== typeof r && "symbol" !== typeof r
                ? e.setAttribute(n, "")
                : e.removeAttribute(n);
              break;
            case "capture":
            case "download":
              !0 === r
                ? e.setAttribute(n, "")
                : !1 !== r &&
                  null != r &&
                  "function" !== typeof r &&
                  "symbol" !== typeof r
                ? e.setAttribute(n, r)
                : e.removeAttribute(n);
              break;
            case "cols":
            case "rows":
            case "size":
            case "span":
              null != r &&
              "function" !== typeof r &&
              "symbol" !== typeof r &&
              !isNaN(r) &&
              1 <= r
                ? e.setAttribute(n, r)
                : e.removeAttribute(n);
              break;
            case "rowSpan":
            case "start":
              null == r ||
              "function" === typeof r ||
              "symbol" === typeof r ||
              isNaN(r)
                ? e.removeAttribute(n)
                : e.setAttribute(n, r);
              break;
            case "popover":
              Ou("beforetoggle", e), Ou("toggle", e), it(e, "popover", r);
              break;
            case "xlinkActuate":
              st(e, "http://www.w3.org/1999/xlink", "xlink:actuate", r);
              break;
            case "xlinkArcrole":
              st(e, "http://www.w3.org/1999/xlink", "xlink:arcrole", r);
              break;
            case "xlinkRole":
              st(e, "http://www.w3.org/1999/xlink", "xlink:role", r);
              break;
            case "xlinkShow":
              st(e, "http://www.w3.org/1999/xlink", "xlink:show", r);
              break;
            case "xlinkTitle":
              st(e, "http://www.w3.org/1999/xlink", "xlink:title", r);
              break;
            case "xlinkType":
              st(e, "http://www.w3.org/1999/xlink", "xlink:type", r);
              break;
            case "xmlBase":
              st(e, "http://www.w3.org/XML/1998/namespace", "xml:base", r);
              break;
            case "xmlLang":
              st(e, "http://www.w3.org/XML/1998/namespace", "xml:lang", r);
              break;
            case "xmlSpace":
              st(e, "http://www.w3.org/XML/1998/namespace", "xml:space", r);
              break;
            case "is":
              it(e, "is", r);
              break;
            case "innerText":
            case "textContent":
              break;
            default:
              (!(2 < n.length) ||
                ("o" !== n[0] && "O" !== n[0]) ||
                ("n" !== n[1] && "N" !== n[1])) &&
                it(e, (n = Tt.get(n) || n), r);
          }
        }
        function $u(e, t, n, r, o, a) {
          switch (n) {
            case "style":
              Ct(e, r, a);
              break;
            case "dangerouslySetInnerHTML":
              if (null != r) {
                if ("object" !== typeof r || !("__html" in r))
                  throw Error(i(61));
                if (null != (n = r.__html)) {
                  if (null != o.children) throw Error(i(60));
                  e.innerHTML = n;
                }
              }
              break;
            case "children":
              "string" === typeof r
                ? kt(e, r)
                : ("number" === typeof r || "bigint" === typeof r) &&
                  kt(e, "" + r);
              break;
            case "onScroll":
              null != r && Ou("scroll", e);
              break;
            case "onScrollEnd":
              null != r && Ou("scrollend", e);
              break;
            case "onClick":
              null != r && (e.onclick = Bu);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "innerHTML":
            case "ref":
            case "innerText":
            case "textContent":
              break;
            default:
              Ze.hasOwnProperty(n) ||
                ("o" !== n[0] ||
                "n" !== n[1] ||
                ((o = n.endsWith("Capture")),
                (t = n.slice(2, o ? n.length - 7 : void 0)),
                "function" ===
                  typeof (a = null != (a = e[De] || null) ? a[n] : null) &&
                  e.removeEventListener(t, a, o),
                "function" !== typeof r)
                  ? n in e
                    ? (e[n] = r)
                    : !0 === r
                    ? e.setAttribute(n, "")
                    : it(e, n, r)
                  : ("function" !== typeof a &&
                      null !== a &&
                      (n in e
                        ? (e[n] = null)
                        : e.hasAttribute(n) && e.removeAttribute(n)),
                    e.addEventListener(t, r, o)));
          }
        }
        function qu(e, t, n) {
          switch (t) {
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
              break;
            case "img":
              Ou("error", e), Ou("load", e);
              var r,
                o = !1,
                a = !1;
              for (r in n)
                if (n.hasOwnProperty(r)) {
                  var l = n[r];
                  if (null != l)
                    switch (r) {
                      case "src":
                        o = !0;
                        break;
                      case "srcSet":
                        a = !0;
                        break;
                      case "children":
                      case "dangerouslySetInnerHTML":
                        throw Error(i(137, t));
                      default:
                        Vu(e, t, r, l, n, null);
                    }
                }
              return (
                a && Vu(e, t, "srcSet", n.srcSet, n, null),
                void (o && Vu(e, t, "src", n.src, n, null))
              );
            case "input":
              Ou("invalid", e);
              var s = (r = l = a = null),
                c = null,
                u = null;
              for (o in n)
                if (n.hasOwnProperty(o)) {
                  var d = n[o];
                  if (null != d)
                    switch (o) {
                      case "name":
                        a = d;
                        break;
                      case "type":
                        l = d;
                        break;
                      case "checked":
                        c = d;
                        break;
                      case "defaultChecked":
                        u = d;
                        break;
                      case "value":
                        r = d;
                        break;
                      case "defaultValue":
                        s = d;
                        break;
                      case "children":
                      case "dangerouslySetInnerHTML":
                        if (null != d) throw Error(i(137, t));
                        break;
                      default:
                        Vu(e, t, o, d, n, null);
                    }
                }
              return vt(e, r, s, c, u, l, a, !1), void dt(e);
            case "select":
              for (a in (Ou("invalid", e), (o = l = r = null), n))
                if (n.hasOwnProperty(a) && null != (s = n[a]))
                  switch (a) {
                    case "value":
                      r = s;
                      break;
                    case "defaultValue":
                      l = s;
                      break;
                    case "multiple":
                      o = s;
                    default:
                      Vu(e, t, a, s, n, null);
                  }
              return (
                (t = r),
                (n = l),
                (e.multiple = !!o),
                void (null != t
                  ? bt(e, !!o, t, !1)
                  : null != n && bt(e, !!o, n, !0))
              );
            case "textarea":
              for (l in (Ou("invalid", e), (r = a = o = null), n))
                if (n.hasOwnProperty(l) && null != (s = n[l]))
                  switch (l) {
                    case "value":
                      o = s;
                      break;
                    case "defaultValue":
                      a = s;
                      break;
                    case "children":
                      r = s;
                      break;
                    case "dangerouslySetInnerHTML":
                      if (null != s) throw Error(i(91));
                      break;
                    default:
                      Vu(e, t, l, s, n, null);
                  }
              return St(e, o, a, r), void dt(e);
            case "option":
              for (c in n)
                if (n.hasOwnProperty(c) && null != (o = n[c]))
                  if ("selected" === c)
                    e.selected =
                      o && "function" !== typeof o && "symbol" !== typeof o;
                  else Vu(e, t, c, o, n, null);
              return;
            case "dialog":
              Ou("cancel", e), Ou("close", e);
              break;
            case "iframe":
            case "object":
              Ou("load", e);
              break;
            case "video":
            case "audio":
              for (o = 0; o < Nu.length; o++) Ou(Nu[o], e);
              break;
            case "image":
              Ou("error", e), Ou("load", e);
              break;
            case "details":
              Ou("toggle", e);
              break;
            case "embed":
            case "source":
            case "link":
              Ou("error", e), Ou("load", e);
            case "area":
            case "base":
            case "br":
            case "col":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "track":
            case "wbr":
            case "menuitem":
              for (u in n)
                if (n.hasOwnProperty(u) && null != (o = n[u]))
                  switch (u) {
                    case "children":
                    case "dangerouslySetInnerHTML":
                      throw Error(i(137, t));
                    default:
                      Vu(e, t, u, o, n, null);
                  }
              return;
            default:
              if (Nt(t)) {
                for (d in n)
                  n.hasOwnProperty(d) &&
                    void 0 !== (o = n[d]) &&
                    $u(e, t, d, o, n, void 0);
                return;
              }
          }
          for (s in n)
            n.hasOwnProperty(s) &&
              null != (o = n[s]) &&
              Vu(e, t, s, o, n, null);
        }
        var Yu = null,
          Qu = null;
        function Ku(e) {
          return 9 === e.nodeType ? e : e.ownerDocument;
        }
        function Gu(e) {
          switch (e) {
            case "http://www.w3.org/2000/svg":
              return 1;
            case "http://www.w3.org/1998/Math/MathML":
              return 2;
            default:
              return 0;
          }
        }
        function Xu(e, t) {
          if (0 === e)
            switch (t) {
              case "svg":
                return 1;
              case "math":
                return 2;
              default:
                return 0;
            }
          return 1 === e && "foreignObject" === t ? 0 : e;
        }
        function Ju(e, t) {
          return (
            "textarea" === e ||
            "noscript" === e ||
            "string" === typeof t.children ||
            "number" === typeof t.children ||
            "bigint" === typeof t.children ||
            ("object" === typeof t.dangerouslySetInnerHTML &&
              null !== t.dangerouslySetInnerHTML &&
              null != t.dangerouslySetInnerHTML.__html)
          );
        }
        var Zu = null;
        var ed = "function" === typeof setTimeout ? setTimeout : void 0,
          td = "function" === typeof clearTimeout ? clearTimeout : void 0,
          nd = "function" === typeof Promise ? Promise : void 0,
          rd =
            "function" === typeof queueMicrotask
              ? queueMicrotask
              : "undefined" !== typeof nd
              ? function (e) {
                  return nd.resolve(null).then(e).catch(od);
                }
              : ed;
        function od(e) {
          setTimeout(function () {
            throw e;
          });
        }
        function ad(e, t) {
          var n = t,
            r = 0;
          do {
            var o = n.nextSibling;
            if ((e.removeChild(n), o && 8 === o.nodeType))
              if ("/$" === (n = o.data)) {
                if (0 === r) return e.removeChild(o), void yf(t);
                r--;
              } else ("$" !== n && "$?" !== n && "$!" !== n) || r++;
            n = o;
          } while (n);
          yf(t);
        }
        function id(e) {
          var t = e.firstChild;
          for (t && 10 === t.nodeType && (t = t.nextSibling); t; ) {
            var n = t;
            switch (((t = t.nextSibling), n.nodeName)) {
              case "HTML":
              case "HEAD":
              case "BODY":
                id(n), qe(n);
                continue;
              case "SCRIPT":
              case "STYLE":
                continue;
              case "LINK":
                if ("stylesheet" === n.rel.toLowerCase()) continue;
            }
            e.removeChild(n);
          }
        }
        function ld(e) {
          for (; null != e; e = e.nextSibling) {
            var t = e.nodeType;
            if (1 === t || 3 === t) break;
            if (8 === t) {
              if (
                "$" === (t = e.data) ||
                "$!" === t ||
                "$?" === t ||
                "F!" === t ||
                "F" === t
              )
                break;
              if ("/$" === t) return null;
            }
          }
          return e;
        }
        function sd(e) {
          e = e.previousSibling;
          for (var t = 0; e; ) {
            if (8 === e.nodeType) {
              var n = e.data;
              if ("$" === n || "$!" === n || "$?" === n) {
                if (0 === t) return e;
                t--;
              } else "/$" === n && t++;
            }
            e = e.previousSibling;
          }
          return null;
        }
        function cd(e, t, n) {
          switch (((t = Ku(n)), e)) {
            case "html":
              if (!(e = t.documentElement)) throw Error(i(452));
              return e;
            case "head":
              if (!(e = t.head)) throw Error(i(453));
              return e;
            case "body":
              if (!(e = t.body)) throw Error(i(454));
              return e;
            default:
              throw Error(i(451));
          }
        }
        var ud = new Map(),
          dd = new Set();
        function fd(e) {
          return "function" === typeof e.getRootNode
            ? e.getRootNode()
            : e.ownerDocument;
        }
        var pd = H.d;
        H.d = {
          f: function () {
            var e = pd.f(),
              t = Fc();
            return e || t;
          },
          r: function (e) {
            var t = Qe(e);
            null !== t && 5 === t.tag && "form" === t.type ? pi(t) : pd.r(e);
          },
          D: function (e) {
            pd.D(e), md("dns-prefetch", e, null);
          },
          C: function (e, t) {
            pd.C(e, t), md("preconnect", e, t);
          },
          L: function (e, t, n) {
            pd.L(e, t, n);
            var r = hd;
            if (r && e && t) {
              var o = 'link[rel="preload"][as="' + mt(t) + '"]';
              "image" === t && n && n.imageSrcSet
                ? ((o += '[imagesrcset="' + mt(n.imageSrcSet) + '"]'),
                  "string" === typeof n.imageSizes &&
                    (o += '[imagesizes="' + mt(n.imageSizes) + '"]'))
                : (o += '[href="' + mt(e) + '"]');
              var a = o;
              switch (t) {
                case "style":
                  a = vd(e);
                  break;
                case "script":
                  a = wd(e);
              }
              ud.has(a) ||
                ((e = R(
                  {
                    rel: "preload",
                    href: "image" === t && n && n.imageSrcSet ? void 0 : e,
                    as: t,
                  },
                  n
                )),
                ud.set(a, e),
                null !== r.querySelector(o) ||
                  ("style" === t && r.querySelector(gd(a))) ||
                  ("script" === t && r.querySelector(Sd(a))) ||
                  (qu((t = r.createElement("link")), "link", e),
                  Xe(t),
                  r.head.appendChild(t)));
            }
          },
          m: function (e, t) {
            pd.m(e, t);
            var n = hd;
            if (n && e) {
              var r = t && "string" === typeof t.as ? t.as : "script",
                o =
                  'link[rel="modulepreload"][as="' +
                  mt(r) +
                  '"][href="' +
                  mt(e) +
                  '"]',
                a = o;
              switch (r) {
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                  a = wd(e);
              }
              if (
                !ud.has(a) &&
                ((e = R({ rel: "modulepreload", href: e }, t)),
                ud.set(a, e),
                null === n.querySelector(o))
              ) {
                switch (r) {
                  case "audioworklet":
                  case "paintworklet":
                  case "serviceworker":
                  case "sharedworker":
                  case "worker":
                  case "script":
                    if (n.querySelector(Sd(a))) return;
                }
                qu((r = n.createElement("link")), "link", e),
                  Xe(r),
                  n.head.appendChild(r);
              }
            }
          },
          X: function (e, t) {
            pd.X(e, t);
            var n = hd;
            if (n && e) {
              var r = Ge(n).hoistableScripts,
                o = wd(e),
                a = r.get(o);
              a ||
                ((a = n.querySelector(Sd(o))) ||
                  ((e = R({ src: e, async: !0 }, t)),
                  (t = ud.get(o)) && Cd(e, t),
                  Xe((a = n.createElement("script"))),
                  qu(a, "link", e),
                  n.head.appendChild(a)),
                (a = { type: "script", instance: a, count: 1, state: null }),
                r.set(o, a));
            }
          },
          S: function (e, t, n) {
            pd.S(e, t, n);
            var r = hd;
            if (r && e) {
              var o = Ge(r).hoistableStyles,
                a = vd(e);
              t = t || "default";
              var i = o.get(a);
              if (!i) {
                var l = { loading: 0, preload: null };
                if ((i = r.querySelector(gd(a)))) l.loading = 5;
                else {
                  (e = R(
                    { rel: "stylesheet", href: e, "data-precedence": t },
                    n
                  )),
                    (n = ud.get(a)) && Ed(e, n);
                  var s = (i = r.createElement("link"));
                  Xe(s),
                    qu(s, "link", e),
                    (s._p = new Promise(function (e, t) {
                      (s.onload = e), (s.onerror = t);
                    })),
                    s.addEventListener("load", function () {
                      l.loading |= 1;
                    }),
                    s.addEventListener("error", function () {
                      l.loading |= 2;
                    }),
                    (l.loading |= 4),
                    xd(i, t, r);
                }
                (i = { type: "stylesheet", instance: i, count: 1, state: l }),
                  o.set(a, i);
              }
            }
          },
          M: function (e, t) {
            pd.M(e, t);
            var n = hd;
            if (n && e) {
              var r = Ge(n).hoistableScripts,
                o = wd(e),
                a = r.get(o);
              a ||
                ((a = n.querySelector(Sd(o))) ||
                  ((e = R({ src: e, async: !0, type: "module" }, t)),
                  (t = ud.get(o)) && Cd(e, t),
                  Xe((a = n.createElement("script"))),
                  qu(a, "link", e),
                  n.head.appendChild(a)),
                (a = { type: "script", instance: a, count: 1, state: null }),
                r.set(o, a));
            }
          },
        };
        var hd = "undefined" === typeof document ? null : document;
        function md(e, t, n) {
          var r = hd;
          if (r && "string" === typeof t && t) {
            var o = mt(t);
            (o = 'link[rel="' + e + '"][href="' + o + '"]'),
              "string" === typeof n && (o += '[crossorigin="' + n + '"]'),
              dd.has(o) ||
                (dd.add(o),
                (e = { rel: e, crossOrigin: n, href: t }),
                null === r.querySelector(o) &&
                  (qu((t = r.createElement("link")), "link", e),
                  Xe(t),
                  r.head.appendChild(t)));
          }
        }
        function yd(e, t, n, r) {
          var o,
            a,
            l,
            s,
            c = (c = X.current) ? fd(c) : null;
          if (!c) throw Error(i(446));
          switch (e) {
            case "meta":
            case "title":
              return null;
            case "style":
              return "string" === typeof n.precedence &&
                "string" === typeof n.href
                ? ((t = vd(n.href)),
                  (r = (n = Ge(c).hoistableStyles).get(t)) ||
                    ((r = {
                      type: "style",
                      instance: null,
                      count: 0,
                      state: null,
                    }),
                    n.set(t, r)),
                  r)
                : { type: "void", instance: null, count: 0, state: null };
            case "link":
              if (
                "stylesheet" === n.rel &&
                "string" === typeof n.href &&
                "string" === typeof n.precedence
              ) {
                e = vd(n.href);
                var u = Ge(c).hoistableStyles,
                  d = u.get(e);
                if (
                  (d ||
                    ((c = c.ownerDocument || c),
                    (d = {
                      type: "stylesheet",
                      instance: null,
                      count: 0,
                      state: { loading: 0, preload: null },
                    }),
                    u.set(e, d),
                    (u = c.querySelector(gd(e))) &&
                      !u._p &&
                      ((d.instance = u), (d.state.loading = 5)),
                    ud.has(e) ||
                      ((n = {
                        rel: "preload",
                        as: "style",
                        href: n.href,
                        crossOrigin: n.crossOrigin,
                        integrity: n.integrity,
                        media: n.media,
                        hrefLang: n.hrefLang,
                        referrerPolicy: n.referrerPolicy,
                      }),
                      ud.set(e, n),
                      u ||
                        ((o = c),
                        (a = e),
                        (l = n),
                        (s = d.state),
                        o.querySelector(
                          'link[rel="preload"][as="style"][' + a + "]"
                        )
                          ? (s.loading = 1)
                          : ((a = o.createElement("link")),
                            (s.preload = a),
                            a.addEventListener("load", function () {
                              return (s.loading |= 1);
                            }),
                            a.addEventListener("error", function () {
                              return (s.loading |= 2);
                            }),
                            qu(a, "link", l),
                            Xe(a),
                            o.head.appendChild(a))))),
                  t && null === r)
                )
                  throw Error(i(528, ""));
                return d;
              }
              if (t && null !== r) throw Error(i(529, ""));
              return null;
            case "script":
              return (
                (t = n.async),
                "string" === typeof (n = n.src) &&
                t &&
                "function" !== typeof t &&
                "symbol" !== typeof t
                  ? ((t = wd(n)),
                    (r = (n = Ge(c).hoistableScripts).get(t)) ||
                      ((r = {
                        type: "script",
                        instance: null,
                        count: 0,
                        state: null,
                      }),
                      n.set(t, r)),
                    r)
                  : { type: "void", instance: null, count: 0, state: null }
              );
            default:
              throw Error(i(444, e));
          }
        }
        function vd(e) {
          return 'href="' + mt(e) + '"';
        }
        function gd(e) {
          return 'link[rel="stylesheet"][' + e + "]";
        }
        function bd(e) {
          return R({}, e, {
            "data-precedence": e.precedence,
            precedence: null,
          });
        }
        function wd(e) {
          return '[src="' + mt(e) + '"]';
        }
        function Sd(e) {
          return "script[async]" + e;
        }
        function kd(e, t, n) {
          if ((t.count++, null === t.instance))
            switch (t.type) {
              case "style":
                var r = e.querySelector(
                  'style[data-href~="' + mt(n.href) + '"]'
                );
                if (r) return (t.instance = r), Xe(r), r;
                var o = R({}, n, {
                  "data-href": n.href,
                  "data-precedence": n.precedence,
                  href: null,
                  precedence: null,
                });
                return (
                  Xe((r = (e.ownerDocument || e).createElement("style"))),
                  qu(r, "style", o),
                  xd(r, n.precedence, e),
                  (t.instance = r)
                );
              case "stylesheet":
                o = vd(n.href);
                var a = e.querySelector(gd(o));
                if (a)
                  return (t.state.loading |= 4), (t.instance = a), Xe(a), a;
                (r = bd(n)),
                  (o = ud.get(o)) && Ed(r, o),
                  Xe((a = (e.ownerDocument || e).createElement("link")));
                var l = a;
                return (
                  (l._p = new Promise(function (e, t) {
                    (l.onload = e), (l.onerror = t);
                  })),
                  qu(a, "link", r),
                  (t.state.loading |= 4),
                  xd(a, n.precedence, e),
                  (t.instance = a)
                );
              case "script":
                return (
                  (a = wd(n.src)),
                  (o = e.querySelector(Sd(a)))
                    ? ((t.instance = o), Xe(o), o)
                    : ((r = n),
                      (o = ud.get(a)) && Cd((r = R({}, n)), o),
                      Xe(
                        (o = (e = e.ownerDocument || e).createElement("script"))
                      ),
                      qu(o, "link", r),
                      e.head.appendChild(o),
                      (t.instance = o))
                );
              case "void":
                return null;
              default:
                throw Error(i(443, t.type));
            }
          else
            "stylesheet" === t.type &&
              0 === (4 & t.state.loading) &&
              ((r = t.instance),
              (t.state.loading |= 4),
              xd(r, n.precedence, e));
          return t.instance;
        }
        function xd(e, t, n) {
          for (
            var r = n.querySelectorAll(
                'link[rel="stylesheet"][data-precedence],style[data-precedence]'
              ),
              o = r.length ? r[r.length - 1] : null,
              a = o,
              i = 0;
            i < r.length;
            i++
          ) {
            var l = r[i];
            if (l.dataset.precedence === t) a = l;
            else if (a !== o) break;
          }
          a
            ? a.parentNode.insertBefore(e, a.nextSibling)
            : (t = 9 === n.nodeType ? n.head : n).insertBefore(e, t.firstChild);
        }
        function Ed(e, t) {
          null == e.crossOrigin && (e.crossOrigin = t.crossOrigin),
            null == e.referrerPolicy && (e.referrerPolicy = t.referrerPolicy),
            null == e.title && (e.title = t.title);
        }
        function Cd(e, t) {
          null == e.crossOrigin && (e.crossOrigin = t.crossOrigin),
            null == e.referrerPolicy && (e.referrerPolicy = t.referrerPolicy),
            null == e.integrity && (e.integrity = t.integrity);
        }
        var Nd = null;
        function Td(e, t, n) {
          if (null === Nd) {
            var r = new Map(),
              o = (Nd = new Map());
            o.set(n, r);
          } else (r = (o = Nd).get(n)) || ((r = new Map()), o.set(n, r));
          if (r.has(e)) return r;
          for (
            r.set(e, null), n = n.getElementsByTagName(e), o = 0;
            o < n.length;
            o++
          ) {
            var a = n[o];
            if (
              !(
                a[$e] ||
                a[Fe] ||
                ("link" === e && "stylesheet" === a.getAttribute("rel"))
              ) &&
              "http://www.w3.org/2000/svg" !== a.namespaceURI
            ) {
              var i = a.getAttribute(t) || "";
              i = e + i;
              var l = r.get(i);
              l ? l.push(a) : r.set(i, [a]);
            }
          }
          return r;
        }
        function Pd(e, t, n) {
          (e = e.ownerDocument || e).head.insertBefore(
            n,
            "title" === t ? e.querySelector("head > title") : null
          );
        }
        function Od(e) {
          return "stylesheet" !== e.type || 0 !== (3 & e.state.loading);
        }
        var jd = null;
        function Rd() {}
        function _d() {
          if ((this.count--, 0 === this.count))
            if (this.stylesheets) zd(this, this.stylesheets);
            else if (this.unsuspend) {
              var e = this.unsuspend;
              (this.unsuspend = null), e();
            }
        }
        var Ld = null;
        function zd(e, t) {
          (e.stylesheets = null),
            null !== e.unsuspend &&
              (e.count++,
              (Ld = new Map()),
              t.forEach(Ad, e),
              (Ld = null),
              _d.call(e));
        }
        function Ad(e, t) {
          if (!(4 & t.state.loading)) {
            var n = Ld.get(e);
            if (n) var r = n.get(null);
            else {
              (n = new Map()), Ld.set(e, n);
              for (
                var o = e.querySelectorAll(
                    "link[data-precedence],style[data-precedence]"
                  ),
                  a = 0;
                a < o.length;
                a++
              ) {
                var i = o[a];
                ("LINK" !== i.nodeName &&
                  "not all" === i.getAttribute("media")) ||
                  (n.set(i.dataset.precedence, i), (r = i));
              }
              r && n.set(null, r);
            }
            (i = (o = t.instance).getAttribute("data-precedence")),
              (a = n.get(i) || r) === r && n.set(null, o),
              n.set(i, o),
              this.count++,
              (r = _d.bind(this)),
              o.addEventListener("load", r),
              o.addEventListener("error", r),
              a
                ? a.parentNode.insertBefore(o, a.nextSibling)
                : (e = 9 === e.nodeType ? e.head : e).insertBefore(
                    o,
                    e.firstChild
                  ),
              (t.state.loading |= 4);
          }
        }
        var Id = {
          $$typeof: y,
          Provider: null,
          Consumer: null,
          _currentValue: B,
          _currentValue2: B,
          _threadCount: 0,
        };
        function Md(e, t, n, r, o, a, i, l) {
          (this.tag = 1),
            (this.containerInfo = e),
            (this.finishedWork =
              this.pingCache =
              this.current =
              this.pendingChildren =
                null),
            (this.timeoutHandle = -1),
            (this.callbackNode =
              this.next =
              this.pendingContext =
              this.context =
              this.cancelPendingCommit =
                null),
            (this.callbackPriority = 0),
            (this.expirationTimes = Re(-1)),
            (this.entangledLanes =
              this.shellSuspendCounter =
              this.errorRecoveryDisabledLanes =
              this.finishedLanes =
              this.expiredLanes =
              this.warmLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = Re(0)),
            (this.hiddenUpdates = Re(null)),
            (this.identifierPrefix = r),
            (this.onUncaughtError = o),
            (this.onCaughtError = a),
            (this.onRecoverableError = i),
            (this.pooledCache = null),
            (this.pooledCacheLanes = 0),
            (this.formState = l),
            (this.incompleteTransitions = new Map());
        }
        function Fd(e, t, n, r, o, a, i, l, s, c, u, d) {
          return (
            (e = new Md(e, t, n, i, l, s, c, d)),
            (t = 1),
            !0 === a && (t |= 24),
            (a = As(3, null, null, t)),
            (e.current = a),
            (a.stateNode = e),
            (t = Wo()).refCount++,
            (e.pooledCache = t),
            t.refCount++,
            (a.memoizedState = { element: r, isDehydrated: n, cache: t }),
            Ol(a),
            e
          );
        }
        function Dd(e) {
          return e ? (e = _r) : _r;
        }
        function Ud(e, t, n, r, o, a) {
          (o = Dd(o)),
            null === r.context ? (r.context = o) : (r.pendingContext = o),
            ((r = Rl(t)).payload = { element: n }),
            null !== (a = void 0 === a ? null : a) && (r.callback = a),
            null !== (n = _l(e, r, t)) && (_c(n, 0, t), Ll(n, e, t));
        }
        function Wd(e, t) {
          if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
            var n = e.retryLane;
            e.retryLane = 0 !== n && n < t ? n : t;
          }
        }
        function Hd(e, t) {
          Wd(e, t), (e = e.alternate) && Wd(e, t);
        }
        function Bd(e) {
          if (13 === e.tag) {
            var t = Or(e, 67108864);
            null !== t && _c(t, 0, 67108864), Hd(e, 67108864);
          }
        }
        var Vd = !0;
        function $d(e, t, n, r) {
          var o = j.T;
          j.T = null;
          var a = H.p;
          try {
            (H.p = 2), Yd(e, t, n, r);
          } finally {
            (H.p = a), (j.T = o);
          }
        }
        function qd(e, t, n, r) {
          var o = j.T;
          j.T = null;
          var a = H.p;
          try {
            (H.p = 8), Yd(e, t, n, r);
          } finally {
            (H.p = a), (j.T = o);
          }
        }
        function Yd(e, t, n, r) {
          if (Vd) {
            var o = Qd(r);
            if (null === o) zu(e, t, r, Kd, n), lf(e, r);
            else if (
              (function (e, t, n, r, o) {
                switch (t) {
                  case "focusin":
                    return (Zd = sf(Zd, e, t, n, r, o)), !0;
                  case "dragenter":
                    return (ef = sf(ef, e, t, n, r, o)), !0;
                  case "mouseover":
                    return (tf = sf(tf, e, t, n, r, o)), !0;
                  case "pointerover":
                    var a = o.pointerId;
                    return nf.set(a, sf(nf.get(a) || null, e, t, n, r, o)), !0;
                  case "gotpointercapture":
                    return (
                      (a = o.pointerId),
                      rf.set(a, sf(rf.get(a) || null, e, t, n, r, o)),
                      !0
                    );
                }
                return !1;
              })(o, e, t, n, r)
            )
              r.stopPropagation();
            else if ((lf(e, r), 4 & t && -1 < af.indexOf(e))) {
              for (; null !== o; ) {
                var a = Qe(o);
                if (null !== a)
                  switch (a.tag) {
                    case 3:
                      if (
                        (a = a.stateNode).current.memoizedState.isDehydrated
                      ) {
                        var i = Ce(a.pendingLanes);
                        if (0 !== i) {
                          var l = a;
                          for (
                            l.pendingLanes |= 2, l.entangledLanes |= 2;
                            i;

                          ) {
                            var s = 1 << (31 - we(i));
                            (l.entanglements[1] |= s), (i &= ~s);
                          }
                          mu(a),
                            0 === (6 & ec) && ((wc = se() + 500), yu(0, !1));
                        }
                      }
                      break;
                    case 13:
                      null !== (l = Or(a, 2)) && _c(l, 0, 2), Fc(), Hd(a, 2);
                  }
                if ((null === (a = Qd(r)) && zu(e, t, r, Kd, n), a === o))
                  break;
                o = a;
              }
              null !== o && r.stopPropagation();
            } else zu(e, t, r, null, n);
          }
        }
        function Qd(e) {
          return Gd((e = Rt(e)));
        }
        var Kd = null;
        function Gd(e) {
          if (((Kd = null), null !== (e = Ye(e)))) {
            var t = M(e);
            if (null === t) e = null;
            else {
              var n = t.tag;
              if (13 === n) {
                if (null !== (e = F(t))) return e;
                e = null;
              } else if (3 === n) {
                if (t.stateNode.current.memoizedState.isDehydrated)
                  return 3 === t.tag ? t.stateNode.containerInfo : null;
                e = null;
              } else t !== e && (e = null);
            }
          }
          return (Kd = e), null;
        }
        function Xd(e) {
          switch (e) {
            case "beforetoggle":
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "toggle":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
              return 2;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
              return 8;
            case "message":
              switch (ce()) {
                case ue:
                  return 2;
                case de:
                  return 8;
                case fe:
                case pe:
                  return 32;
                case he:
                  return 268435456;
                default:
                  return 32;
              }
            default:
              return 32;
          }
        }
        var Jd = !1,
          Zd = null,
          ef = null,
          tf = null,
          nf = new Map(),
          rf = new Map(),
          of = [],
          af =
            "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
              " "
            );
        function lf(e, t) {
          switch (e) {
            case "focusin":
            case "focusout":
              Zd = null;
              break;
            case "dragenter":
            case "dragleave":
              ef = null;
              break;
            case "mouseover":
            case "mouseout":
              tf = null;
              break;
            case "pointerover":
            case "pointerout":
              nf.delete(t.pointerId);
              break;
            case "gotpointercapture":
            case "lostpointercapture":
              rf.delete(t.pointerId);
          }
        }
        function sf(e, t, n, r, o, a) {
          return null === e || e.nativeEvent !== a
            ? ((e = {
                blockedOn: t,
                domEventName: n,
                eventSystemFlags: r,
                nativeEvent: a,
                targetContainers: [o],
              }),
              null !== t && null !== (t = Qe(t)) && Bd(t),
              e)
            : ((e.eventSystemFlags |= r),
              (t = e.targetContainers),
              null !== o && -1 === t.indexOf(o) && t.push(o),
              e);
        }
        function cf(e) {
          var t = Ye(e.target);
          if (null !== t) {
            var n = M(t);
            if (null !== n)
              if (13 === (t = n.tag)) {
                if (null !== (t = F(n)))
                  return (
                    (e.blockedOn = t),
                    void (function (e, t) {
                      var n = H.p;
                      try {
                        return (H.p = e), t();
                      } finally {
                        H.p = n;
                      }
                    })(e.priority, function () {
                      if (13 === n.tag) {
                        var e = jc(),
                          t = Or(n, e);
                        null !== t && _c(t, 0, e), Hd(n, e);
                      }
                    })
                  );
              } else if (
                3 === t &&
                n.stateNode.current.memoizedState.isDehydrated
              )
                return void (e.blockedOn =
                  3 === n.tag ? n.stateNode.containerInfo : null);
          }
          e.blockedOn = null;
        }
        function uf(e) {
          if (null !== e.blockedOn) return !1;
          for (var t = e.targetContainers; 0 < t.length; ) {
            var n = Qd(e.nativeEvent);
            if (null !== n)
              return null !== (t = Qe(n)) && Bd(t), (e.blockedOn = n), !1;
            var r = new (n = e.nativeEvent).constructor(n.type, n);
            (jt = r), n.target.dispatchEvent(r), (jt = null), t.shift();
          }
          return !0;
        }
        function df(e, t, n) {
          uf(e) && n.delete(t);
        }
        function ff() {
          (Jd = !1),
            null !== Zd && uf(Zd) && (Zd = null),
            null !== ef && uf(ef) && (ef = null),
            null !== tf && uf(tf) && (tf = null),
            nf.forEach(df),
            rf.forEach(df);
        }
        function pf(e, t) {
          e.blockedOn === t &&
            ((e.blockedOn = null),
            Jd ||
              ((Jd = !0),
              r.unstable_scheduleCallback(r.unstable_NormalPriority, ff)));
        }
        var hf = null;
        function mf(e) {
          hf !== e &&
            ((hf = e),
            r.unstable_scheduleCallback(r.unstable_NormalPriority, function () {
              hf === e && (hf = null);
              for (var t = 0; t < e.length; t += 3) {
                var n = e[t],
                  r = e[t + 1],
                  o = e[t + 2];
                if ("function" !== typeof r) {
                  if (null === Gd(r || n)) continue;
                  break;
                }
                var a = Qe(n);
                null !== a &&
                  (e.splice(t, 3),
                  (t -= 3),
                  di(
                    a,
                    { pending: !0, data: o, method: n.method, action: r },
                    r,
                    o
                  ));
              }
            }));
        }
        function yf(e) {
          function t(t) {
            return pf(t, e);
          }
          null !== Zd && pf(Zd, e),
            null !== ef && pf(ef, e),
            null !== tf && pf(tf, e),
            nf.forEach(t),
            rf.forEach(t);
          for (var n = 0; n < of.length; n++) {
            var r = of[n];
            r.blockedOn === e && (r.blockedOn = null);
          }
          for (; 0 < of.length && null === (n = of[0]).blockedOn; )
            cf(n), null === n.blockedOn && of.shift();
          if (null != (n = (e.ownerDocument || e).$$reactFormReplay))
            for (r = 0; r < n.length; r += 3) {
              var o = n[r],
                a = n[r + 1],
                i = o[De] || null;
              if ("function" === typeof a) i || mf(n);
              else if (i) {
                var l = null;
                if (a && a.hasAttribute("formAction")) {
                  if (((o = a), (i = a[De] || null))) l = i.formAction;
                  else if (null !== Gd(o)) continue;
                } else l = i.action;
                "function" === typeof l
                  ? (n[r + 1] = l)
                  : (n.splice(r, 3), (r -= 3)),
                  mf(n);
              }
            }
        }
        function vf(e) {
          this._internalRoot = e;
        }
        function gf(e) {
          this._internalRoot = e;
        }
        (gf.prototype.render = vf.prototype.render =
          function (e) {
            var t = this._internalRoot;
            if (null === t) throw Error(i(409));
            Ud(t.current, jc(), e, t, null, null);
          }),
          (gf.prototype.unmount = vf.prototype.unmount =
            function () {
              var e = this._internalRoot;
              if (null !== e) {
                this._internalRoot = null;
                var t = e.containerInfo;
                0 === e.tag && tu(),
                  Ud(e.current, 2, null, e, null, null),
                  Fc(),
                  (t[Ue] = null);
              }
            }),
          (gf.prototype.unstable_scheduleHydration = function (e) {
            if (e) {
              var t = Ie();
              e = { blockedOn: null, target: e, priority: t };
              for (
                var n = 0;
                n < of.length && 0 !== t && t < of[n].priority;
                n++
              );
              of.splice(n, 0, e), 0 === n && cf(e);
            }
          });
        var bf = o.version;
        if ("19.0.0" !== bf) throw Error(i(527, bf, "19.0.0"));
        H.findDOMNode = function (e) {
          var t = e._reactInternals;
          if (void 0 === t) {
            if ("function" === typeof e.render) throw Error(i(188));
            throw ((e = Object.keys(e).join(",")), Error(i(268, e)));
          }
          return (
            (e = (function (e) {
              var t = e.alternate;
              if (!t) {
                if (null === (t = M(e))) throw Error(i(188));
                return t !== e ? null : e;
              }
              for (var n = e, r = t; ; ) {
                var o = n.return;
                if (null === o) break;
                var a = o.alternate;
                if (null === a) {
                  if (null !== (r = o.return)) {
                    n = r;
                    continue;
                  }
                  break;
                }
                if (o.child === a.child) {
                  for (a = o.child; a; ) {
                    if (a === n) return D(o), e;
                    if (a === r) return D(o), t;
                    a = a.sibling;
                  }
                  throw Error(i(188));
                }
                if (n.return !== r.return) (n = o), (r = a);
                else {
                  for (var l = !1, s = o.child; s; ) {
                    if (s === n) {
                      (l = !0), (n = o), (r = a);
                      break;
                    }
                    if (s === r) {
                      (l = !0), (r = o), (n = a);
                      break;
                    }
                    s = s.sibling;
                  }
                  if (!l) {
                    for (s = a.child; s; ) {
                      if (s === n) {
                        (l = !0), (n = a), (r = o);
                        break;
                      }
                      if (s === r) {
                        (l = !0), (r = a), (n = o);
                        break;
                      }
                      s = s.sibling;
                    }
                    if (!l) throw Error(i(189));
                  }
                }
                if (n.alternate !== r) throw Error(i(190));
              }
              if (3 !== n.tag) throw Error(i(188));
              return n.stateNode.current === n ? e : t;
            })(t)),
            (e = null === (e = null !== e ? U(e) : null) ? null : e.stateNode)
          );
        };
        var wf = {
          bundleType: 0,
          version: "19.0.0",
          rendererPackageName: "react-dom",
          currentDispatcherRef: j,
          findFiberByHostInstance: Ye,
          reconcilerVersion: "19.0.0",
        };
        if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
          var Sf = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (!Sf.isDisabled && Sf.supportsFiber)
            try {
              (ve = Sf.inject(wf)), (ge = Sf);
            } catch (xf) {}
        }
        (t.createRoot = function (e, t) {
          if (!l(e)) throw Error(i(299));
          var n = !1,
            r = "",
            o = Ai,
            a = Ii,
            s = Mi;
          return (
            null !== t &&
              void 0 !== t &&
              (!0 === t.unstable_strictMode && (n = !0),
              void 0 !== t.identifierPrefix && (r = t.identifierPrefix),
              void 0 !== t.onUncaughtError && (o = t.onUncaughtError),
              void 0 !== t.onCaughtError && (a = t.onCaughtError),
              void 0 !== t.onRecoverableError && (s = t.onRecoverableError),
              void 0 !== t.unstable_transitionCallbacks &&
                t.unstable_transitionCallbacks),
            (t = Fd(e, 1, !1, null, 0, n, r, o, a, s, 0, null)),
            (e[Ue] = t.current),
            _u(8 === e.nodeType ? e.parentNode : e),
            new vf(t)
          );
        }),
          (t.hydrateRoot = function (e, t, n) {
            if (!l(e)) throw Error(i(299));
            var r = !1,
              o = "",
              a = Ai,
              s = Ii,
              c = Mi,
              u = null;
            return (
              null !== n &&
                void 0 !== n &&
                (!0 === n.unstable_strictMode && (r = !0),
                void 0 !== n.identifierPrefix && (o = n.identifierPrefix),
                void 0 !== n.onUncaughtError && (a = n.onUncaughtError),
                void 0 !== n.onCaughtError && (s = n.onCaughtError),
                void 0 !== n.onRecoverableError && (c = n.onRecoverableError),
                void 0 !== n.unstable_transitionCallbacks &&
                  n.unstable_transitionCallbacks,
                void 0 !== n.formState && (u = n.formState)),
              ((t = Fd(e, 1, !0, t, 0, r, o, a, s, c, 0, u)).context =
                Dd(null)),
              (n = t.current),
              ((o = Rl((r = jc()))).callback = null),
              _l(n, o, r),
              (t.current.lanes = r),
              _e(t, r),
              mu(t),
              (e[Ue] = t.current),
              _u(e),
              new gf(t)
            );
          }),
          (t.version = "19.0.0");
      },
      672: (e, t, n) => {
        var r = n(43);
        function o(e) {
          var t = "https://react.dev/errors/" + e;
          if (1 < arguments.length) {
            t += "?args[]=" + encodeURIComponent(arguments[1]);
            for (var n = 2; n < arguments.length; n++)
              t += "&args[]=" + encodeURIComponent(arguments[n]);
          }
          return (
            "Minified React error #" +
            e +
            "; visit " +
            t +
            " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
          );
        }
        function a() {}
        var i = {
            d: {
              f: a,
              r: function () {
                throw Error(o(522));
              },
              D: a,
              C: a,
              L: a,
              m: a,
              X: a,
              S: a,
              M: a,
            },
            p: 0,
            findDOMNode: null,
          },
          l = Symbol.for("react.portal");
        var s =
          r.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
        function c(e, t) {
          return "font" === e
            ? ""
            : "string" === typeof t
            ? "use-credentials" === t
              ? t
              : ""
            : void 0;
        }
        (t.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = i),
          (t.createPortal = function (e, t) {
            var n =
              2 < arguments.length && void 0 !== arguments[2]
                ? arguments[2]
                : null;
            if (
              !t ||
              (1 !== t.nodeType && 9 !== t.nodeType && 11 !== t.nodeType)
            )
              throw Error(o(299));
            return (function (e, t, n) {
              var r =
                3 < arguments.length && void 0 !== arguments[3]
                  ? arguments[3]
                  : null;
              return {
                $$typeof: l,
                key: null == r ? null : "" + r,
                children: e,
                containerInfo: t,
                implementation: n,
              };
            })(e, t, null, n);
          }),
          (t.flushSync = function (e) {
            var t = s.T,
              n = i.p;
            try {
              if (((s.T = null), (i.p = 2), e)) return e();
            } finally {
              (s.T = t), (i.p = n), i.d.f();
            }
          }),
          (t.preconnect = function (e, t) {
            "string" === typeof e &&
              (t
                ? (t =
                    "string" === typeof (t = t.crossOrigin)
                      ? "use-credentials" === t
                        ? t
                        : ""
                      : void 0)
                : (t = null),
              i.d.C(e, t));
          }),
          (t.prefetchDNS = function (e) {
            "string" === typeof e && i.d.D(e);
          }),
          (t.preinit = function (e, t) {
            if ("string" === typeof e && t && "string" === typeof t.as) {
              var n = t.as,
                r = c(n, t.crossOrigin),
                o = "string" === typeof t.integrity ? t.integrity : void 0,
                a =
                  "string" === typeof t.fetchPriority
                    ? t.fetchPriority
                    : void 0;
              "style" === n
                ? i.d.S(
                    e,
                    "string" === typeof t.precedence ? t.precedence : void 0,
                    { crossOrigin: r, integrity: o, fetchPriority: a }
                  )
                : "script" === n &&
                  i.d.X(e, {
                    crossOrigin: r,
                    integrity: o,
                    fetchPriority: a,
                    nonce: "string" === typeof t.nonce ? t.nonce : void 0,
                  });
            }
          }),
          (t.preinitModule = function (e, t) {
            if ("string" === typeof e)
              if ("object" === typeof t && null !== t) {
                if (null == t.as || "script" === t.as) {
                  var n = c(t.as, t.crossOrigin);
                  i.d.M(e, {
                    crossOrigin: n,
                    integrity:
                      "string" === typeof t.integrity ? t.integrity : void 0,
                    nonce: "string" === typeof t.nonce ? t.nonce : void 0,
                  });
                }
              } else null == t && i.d.M(e);
          }),
          (t.preload = function (e, t) {
            if (
              "string" === typeof e &&
              "object" === typeof t &&
              null !== t &&
              "string" === typeof t.as
            ) {
              var n = t.as,
                r = c(n, t.crossOrigin);
              i.d.L(e, n, {
                crossOrigin: r,
                integrity:
                  "string" === typeof t.integrity ? t.integrity : void 0,
                nonce: "string" === typeof t.nonce ? t.nonce : void 0,
                type: "string" === typeof t.type ? t.type : void 0,
                fetchPriority:
                  "string" === typeof t.fetchPriority
                    ? t.fetchPriority
                    : void 0,
                referrerPolicy:
                  "string" === typeof t.referrerPolicy
                    ? t.referrerPolicy
                    : void 0,
                imageSrcSet:
                  "string" === typeof t.imageSrcSet ? t.imageSrcSet : void 0,
                imageSizes:
                  "string" === typeof t.imageSizes ? t.imageSizes : void 0,
                media: "string" === typeof t.media ? t.media : void 0,
              });
            }
          }),
          (t.preloadModule = function (e, t) {
            if ("string" === typeof e)
              if (t) {
                var n = c(t.as, t.crossOrigin);
                i.d.m(e, {
                  as:
                    "string" === typeof t.as && "script" !== t.as
                      ? t.as
                      : void 0,
                  crossOrigin: n,
                  integrity:
                    "string" === typeof t.integrity ? t.integrity : void 0,
                });
              } else i.d.m(e);
          }),
          (t.requestFormReset = function (e) {
            i.d.r(e);
          }),
          (t.unstable_batchedUpdates = function (e, t) {
            return e(t);
          }),
          (t.useFormState = function (e, t, n) {
            return s.H.useFormState(e, t, n);
          }),
          (t.useFormStatus = function () {
            return s.H.useHostTransitionStatus();
          }),
          (t.version = "19.0.0");
      },
      391: (e, t, n) => {
        !(function e() {
          if (
            "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
            "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
            } catch (t) {
              console.error(t);
            }
        })(),
          (e.exports = n(4));
      },
      950: (e, t, n) => {
        !(function e() {
          if (
            "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
            "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
            } catch (t) {
              console.error(t);
            }
        })(),
          (e.exports = n(672));
      },
      799: (e, t) => {
        var n = Symbol.for("react.transitional.element"),
          r = Symbol.for("react.fragment");
        function o(e, t, r) {
          var o = null;
          if (
            (void 0 !== r && (o = "" + r),
            void 0 !== t.key && (o = "" + t.key),
            "key" in t)
          )
            for (var a in ((r = {}), t)) "key" !== a && (r[a] = t[a]);
          else r = t;
          return (
            (t = r.ref),
            {
              $$typeof: n,
              type: e,
              key: o,
              ref: void 0 !== t ? t : null,
              props: r,
            }
          );
        }
        (t.Fragment = r), (t.jsx = o), (t.jsxs = o);
      },
      288: (e, t) => {
        var n = Symbol.for("react.transitional.element"),
          r = Symbol.for("react.portal"),
          o = Symbol.for("react.fragment"),
          a = Symbol.for("react.strict_mode"),
          i = Symbol.for("react.profiler"),
          l = Symbol.for("react.consumer"),
          s = Symbol.for("react.context"),
          c = Symbol.for("react.forward_ref"),
          u = Symbol.for("react.suspense"),
          d = Symbol.for("react.memo"),
          f = Symbol.for("react.lazy"),
          p = Symbol.iterator;
        var h = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {},
          },
          m = Object.assign,
          y = {};
        function v(e, t, n) {
          (this.props = e),
            (this.context = t),
            (this.refs = y),
            (this.updater = n || h);
        }
        function g() {}
        function b(e, t, n) {
          (this.props = e),
            (this.context = t),
            (this.refs = y),
            (this.updater = n || h);
        }
        (v.prototype.isReactComponent = {}),
          (v.prototype.setState = function (e, t) {
            if ("object" !== typeof e && "function" !== typeof e && null != e)
              throw Error(
                "takes an object of state variables to update or a function which returns an object of state variables."
              );
            this.updater.enqueueSetState(this, e, t, "setState");
          }),
          (v.prototype.forceUpdate = function (e) {
            this.updater.enqueueForceUpdate(this, e, "forceUpdate");
          }),
          (g.prototype = v.prototype);
        var w = (b.prototype = new g());
        (w.constructor = b), m(w, v.prototype), (w.isPureReactComponent = !0);
        var S = Array.isArray,
          k = { H: null, A: null, T: null, S: null },
          x = Object.prototype.hasOwnProperty;
        function E(e, t, r, o, a, i) {
          return (
            (r = i.ref),
            {
              $$typeof: n,
              type: e,
              key: t,
              ref: void 0 !== r ? r : null,
              props: i,
            }
          );
        }
        function C(e) {
          return "object" === typeof e && null !== e && e.$$typeof === n;
        }
        var N = /\/+/g;
        function T(e, t) {
          return "object" === typeof e && null !== e && null != e.key
            ? (function (e) {
                var t = { "=": "=0", ":": "=2" };
                return (
                  "$" +
                  e.replace(/[=:]/g, function (e) {
                    return t[e];
                  })
                );
              })("" + e.key)
            : t.toString(36);
        }
        function P() {}
        function O(e, t, o, a, i) {
          var l = typeof e;
          ("undefined" !== l && "boolean" !== l) || (e = null);
          var s,
            c,
            u = !1;
          if (null === e) u = !0;
          else
            switch (l) {
              case "bigint":
              case "string":
              case "number":
                u = !0;
                break;
              case "object":
                switch (e.$$typeof) {
                  case n:
                  case r:
                    u = !0;
                    break;
                  case f:
                    return O((u = e._init)(e._payload), t, o, a, i);
                }
            }
          if (u)
            return (
              (i = i(e)),
              (u = "" === a ? "." + T(e, 0) : a),
              S(i)
                ? ((o = ""),
                  null != u && (o = u.replace(N, "$&/") + "/"),
                  O(i, t, o, "", function (e) {
                    return e;
                  }))
                : null != i &&
                  (C(i) &&
                    ((s = i),
                    (c =
                      o +
                      (null == i.key || (e && e.key === i.key)
                        ? ""
                        : ("" + i.key).replace(N, "$&/") + "/") +
                      u),
                    (i = E(s.type, c, void 0, 0, 0, s.props))),
                  t.push(i)),
              1
            );
          u = 0;
          var d,
            h = "" === a ? "." : a + ":";
          if (S(e))
            for (var m = 0; m < e.length; m++)
              u += O((a = e[m]), t, o, (l = h + T(a, m)), i);
          else if (
            "function" ===
            typeof (m =
              null === (d = e) || "object" !== typeof d
                ? null
                : "function" === typeof (d = (p && d[p]) || d["@@iterator"])
                ? d
                : null)
          )
            for (e = m.call(e), m = 0; !(a = e.next()).done; )
              u += O((a = a.value), t, o, (l = h + T(a, m++)), i);
          else if ("object" === l) {
            if ("function" === typeof e.then)
              return O(
                (function (e) {
                  switch (e.status) {
                    case "fulfilled":
                      return e.value;
                    case "rejected":
                      throw e.reason;
                    default:
                      switch (
                        ("string" === typeof e.status
                          ? e.then(P, P)
                          : ((e.status = "pending"),
                            e.then(
                              function (t) {
                                "pending" === e.status &&
                                  ((e.status = "fulfilled"), (e.value = t));
                              },
                              function (t) {
                                "pending" === e.status &&
                                  ((e.status = "rejected"), (e.reason = t));
                              }
                            )),
                        e.status)
                      ) {
                        case "fulfilled":
                          return e.value;
                        case "rejected":
                          throw e.reason;
                      }
                  }
                  throw e;
                })(e),
                t,
                o,
                a,
                i
              );
            throw (
              ((t = String(e)),
              Error(
                "Objects are not valid as a React child (found: " +
                  ("[object Object]" === t
                    ? "object with keys {" + Object.keys(e).join(", ") + "}"
                    : t) +
                  "). If you meant to render a collection of children, use an array instead."
              ))
            );
          }
          return u;
        }
        function j(e, t, n) {
          if (null == e) return e;
          var r = [],
            o = 0;
          return (
            O(e, r, "", "", function (e) {
              return t.call(n, e, o++);
            }),
            r
          );
        }
        function R(e) {
          if (-1 === e._status) {
            var t = e._result;
            (t = t()).then(
              function (t) {
                (0 !== e._status && -1 !== e._status) ||
                  ((e._status = 1), (e._result = t));
              },
              function (t) {
                (0 !== e._status && -1 !== e._status) ||
                  ((e._status = 2), (e._result = t));
              }
            ),
              -1 === e._status && ((e._status = 0), (e._result = t));
          }
          if (1 === e._status) return e._result.default;
          throw e._result;
        }
        var _ =
          "function" === typeof reportError
            ? reportError
            : function (e) {
                if (
                  "object" === typeof window &&
                  "function" === typeof window.ErrorEvent
                ) {
                  var t = new window.ErrorEvent("error", {
                    bubbles: !0,
                    cancelable: !0,
                    message:
                      "object" === typeof e &&
                      null !== e &&
                      "string" === typeof e.message
                        ? String(e.message)
                        : String(e),
                    error: e,
                  });
                  if (!window.dispatchEvent(t)) return;
                } else if (
                  "object" === typeof process &&
                  "function" === typeof process.emit
                )
                  return void process.emit("uncaughtException", e);
                console.error(e);
              };
        function L() {}
        (t.Children = {
          map: j,
          forEach: function (e, t, n) {
            j(
              e,
              function () {
                t.apply(this, arguments);
              },
              n
            );
          },
          count: function (e) {
            var t = 0;
            return (
              j(e, function () {
                t++;
              }),
              t
            );
          },
          toArray: function (e) {
            return (
              j(e, function (e) {
                return e;
              }) || []
            );
          },
          only: function (e) {
            if (!C(e))
              throw Error(
                "React.Children.only expected to receive a single React element child."
              );
            return e;
          },
        }),
          (t.Component = v),
          (t.Fragment = o),
          (t.Profiler = i),
          (t.PureComponent = b),
          (t.StrictMode = a),
          (t.Suspense = u),
          (t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE =
            k),
          (t.act = function () {
            throw Error(
              "act(...) is not supported in production builds of React."
            );
          }),
          (t.cache = function (e) {
            return function () {
              return e.apply(null, arguments);
            };
          }),
          (t.cloneElement = function (e, t, n) {
            if (null === e || void 0 === e)
              throw Error(
                "The argument must be a React element, but you passed " +
                  e +
                  "."
              );
            var r = m({}, e.props),
              o = e.key;
            if (null != t)
              for (a in (void 0 !== t.ref && void 0,
              void 0 !== t.key && (o = "" + t.key),
              t))
                !x.call(t, a) ||
                  "key" === a ||
                  "__self" === a ||
                  "__source" === a ||
                  ("ref" === a && void 0 === t.ref) ||
                  (r[a] = t[a]);
            var a = arguments.length - 2;
            if (1 === a) r.children = n;
            else if (1 < a) {
              for (var i = Array(a), l = 0; l < a; l++) i[l] = arguments[l + 2];
              r.children = i;
            }
            return E(e.type, o, void 0, 0, 0, r);
          }),
          (t.createContext = function (e) {
            return (
              ((e = {
                $$typeof: s,
                _currentValue: e,
                _currentValue2: e,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
              }).Provider = e),
              (e.Consumer = { $$typeof: l, _context: e }),
              e
            );
          }),
          (t.createElement = function (e, t, n) {
            var r,
              o = {},
              a = null;
            if (null != t)
              for (r in (void 0 !== t.key && (a = "" + t.key), t))
                x.call(t, r) &&
                  "key" !== r &&
                  "__self" !== r &&
                  "__source" !== r &&
                  (o[r] = t[r]);
            var i = arguments.length - 2;
            if (1 === i) o.children = n;
            else if (1 < i) {
              for (var l = Array(i), s = 0; s < i; s++) l[s] = arguments[s + 2];
              o.children = l;
            }
            if (e && e.defaultProps)
              for (r in (i = e.defaultProps)) void 0 === o[r] && (o[r] = i[r]);
            return E(e, a, void 0, 0, 0, o);
          }),
          (t.createRef = function () {
            return { current: null };
          }),
          (t.forwardRef = function (e) {
            return { $$typeof: c, render: e };
          }),
          (t.isValidElement = C),
          (t.lazy = function (e) {
            return {
              $$typeof: f,
              _payload: { _status: -1, _result: e },
              _init: R,
            };
          }),
          (t.memo = function (e, t) {
            return { $$typeof: d, type: e, compare: void 0 === t ? null : t };
          }),
          (t.startTransition = function (e) {
            var t = k.T,
              n = {};
            k.T = n;
            try {
              var r = e(),
                o = k.S;
              null !== o && o(n, r),
                "object" === typeof r &&
                  null !== r &&
                  "function" === typeof r.then &&
                  r.then(L, _);
            } catch (a) {
              _(a);
            } finally {
              k.T = t;
            }
          }),
          (t.unstable_useCacheRefresh = function () {
            return k.H.useCacheRefresh();
          }),
          (t.use = function (e) {
            return k.H.use(e);
          }),
          (t.useActionState = function (e, t, n) {
            return k.H.useActionState(e, t, n);
          }),
          (t.useCallback = function (e, t) {
            return k.H.useCallback(e, t);
          }),
          (t.useContext = function (e) {
            return k.H.useContext(e);
          }),
          (t.useDebugValue = function () {}),
          (t.useDeferredValue = function (e, t) {
            return k.H.useDeferredValue(e, t);
          }),
          (t.useEffect = function (e, t) {
            return k.H.useEffect(e, t);
          }),
          (t.useId = function () {
            return k.H.useId();
          }),
          (t.useImperativeHandle = function (e, t, n) {
            return k.H.useImperativeHandle(e, t, n);
          }),
          (t.useInsertionEffect = function (e, t) {
            return k.H.useInsertionEffect(e, t);
          }),
          (t.useLayoutEffect = function (e, t) {
            return k.H.useLayoutEffect(e, t);
          }),
          (t.useMemo = function (e, t) {
            return k.H.useMemo(e, t);
          }),
          (t.useOptimistic = function (e, t) {
            return k.H.useOptimistic(e, t);
          }),
          (t.useReducer = function (e, t, n) {
            return k.H.useReducer(e, t, n);
          }),
          (t.useRef = function (e) {
            return k.H.useRef(e);
          }),
          (t.useState = function (e) {
            return k.H.useState(e);
          }),
          (t.useSyncExternalStore = function (e, t, n) {
            return k.H.useSyncExternalStore(e, t, n);
          }),
          (t.useTransition = function () {
            return k.H.useTransition();
          }),
          (t.version = "19.0.0");
      },
      43: (e, t, n) => {
        e.exports = n(288);
      },
      579: (e, t, n) => {
        e.exports = n(799);
      },
      896: (e, t) => {
        function n(e, t) {
          var n = e.length;
          e.push(t);
          e: for (; 0 < n; ) {
            var r = (n - 1) >>> 1,
              o = e[r];
            if (!(0 < a(o, t))) break e;
            (e[r] = t), (e[n] = o), (n = r);
          }
        }
        function r(e) {
          return 0 === e.length ? null : e[0];
        }
        function o(e) {
          if (0 === e.length) return null;
          var t = e[0],
            n = e.pop();
          if (n !== t) {
            e[0] = n;
            e: for (var r = 0, o = e.length, i = o >>> 1; r < i; ) {
              var l = 2 * (r + 1) - 1,
                s = e[l],
                c = l + 1,
                u = e[c];
              if (0 > a(s, n))
                c < o && 0 > a(u, s)
                  ? ((e[r] = u), (e[c] = n), (r = c))
                  : ((e[r] = s), (e[l] = n), (r = l));
              else {
                if (!(c < o && 0 > a(u, n))) break e;
                (e[r] = u), (e[c] = n), (r = c);
              }
            }
          }
          return t;
        }
        function a(e, t) {
          var n = e.sortIndex - t.sortIndex;
          return 0 !== n ? n : e.id - t.id;
        }
        if (
          ((t.unstable_now = void 0),
          "object" === typeof performance &&
            "function" === typeof performance.now)
        ) {
          var i = performance;
          t.unstable_now = function () {
            return i.now();
          };
        } else {
          var l = Date,
            s = l.now();
          t.unstable_now = function () {
            return l.now() - s;
          };
        }
        var c = [],
          u = [],
          d = 1,
          f = null,
          p = 3,
          h = !1,
          m = !1,
          y = !1,
          v = "function" === typeof setTimeout ? setTimeout : null,
          g = "function" === typeof clearTimeout ? clearTimeout : null,
          b = "undefined" !== typeof setImmediate ? setImmediate : null;
        function w(e) {
          for (var t = r(u); null !== t; ) {
            if (null === t.callback) o(u);
            else {
              if (!(t.startTime <= e)) break;
              o(u), (t.sortIndex = t.expirationTime), n(c, t);
            }
            t = r(u);
          }
        }
        function S(e) {
          if (((y = !1), w(e), !m))
            if (null !== r(c)) (m = !0), R();
            else {
              var t = r(u);
              null !== t && _(S, t.startTime - e);
            }
        }
        var k,
          x = !1,
          E = -1,
          C = 5,
          N = -1;
        function T() {
          return !(t.unstable_now() - N < C);
        }
        function P() {
          if (x) {
            var e = t.unstable_now();
            N = e;
            var n = !0;
            try {
              e: {
                (m = !1), y && ((y = !1), g(E), (E = -1)), (h = !0);
                var a = p;
                try {
                  t: {
                    for (
                      w(e), f = r(c);
                      null !== f && !(f.expirationTime > e && T());

                    ) {
                      var i = f.callback;
                      if ("function" === typeof i) {
                        (f.callback = null), (p = f.priorityLevel);
                        var l = i(f.expirationTime <= e);
                        if (((e = t.unstable_now()), "function" === typeof l)) {
                          (f.callback = l), w(e), (n = !0);
                          break t;
                        }
                        f === r(c) && o(c), w(e);
                      } else o(c);
                      f = r(c);
                    }
                    if (null !== f) n = !0;
                    else {
                      var s = r(u);
                      null !== s && _(S, s.startTime - e), (n = !1);
                    }
                  }
                  break e;
                } finally {
                  (f = null), (p = a), (h = !1);
                }
                n = void 0;
              }
            } finally {
              n ? k() : (x = !1);
            }
          }
        }
        if ("function" === typeof b)
          k = function () {
            b(P);
          };
        else if ("undefined" !== typeof MessageChannel) {
          var O = new MessageChannel(),
            j = O.port2;
          (O.port1.onmessage = P),
            (k = function () {
              j.postMessage(null);
            });
        } else
          k = function () {
            v(P, 0);
          };
        function R() {
          x || ((x = !0), k());
        }
        function _(e, n) {
          E = v(function () {
            e(t.unstable_now());
          }, n);
        }
        (t.unstable_IdlePriority = 5),
          (t.unstable_ImmediatePriority = 1),
          (t.unstable_LowPriority = 4),
          (t.unstable_NormalPriority = 3),
          (t.unstable_Profiling = null),
          (t.unstable_UserBlockingPriority = 2),
          (t.unstable_cancelCallback = function (e) {
            e.callback = null;
          }),
          (t.unstable_continueExecution = function () {
            m || h || ((m = !0), R());
          }),
          (t.unstable_forceFrameRate = function (e) {
            0 > e || 125 < e
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
                )
              : (C = 0 < e ? Math.floor(1e3 / e) : 5);
          }),
          (t.unstable_getCurrentPriorityLevel = function () {
            return p;
          }),
          (t.unstable_getFirstCallbackNode = function () {
            return r(c);
          }),
          (t.unstable_next = function (e) {
            switch (p) {
              case 1:
              case 2:
              case 3:
                var t = 3;
                break;
              default:
                t = p;
            }
            var n = p;
            p = t;
            try {
              return e();
            } finally {
              p = n;
            }
          }),
          (t.unstable_pauseExecution = function () {}),
          (t.unstable_requestPaint = function () {}),
          (t.unstable_runWithPriority = function (e, t) {
            switch (e) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
              default:
                e = 3;
            }
            var n = p;
            p = e;
            try {
              return t();
            } finally {
              p = n;
            }
          }),
          (t.unstable_scheduleCallback = function (e, o, a) {
            var i = t.unstable_now();
            switch (
              ("object" === typeof a && null !== a
                ? (a = "number" === typeof (a = a.delay) && 0 < a ? i + a : i)
                : (a = i),
              e)
            ) {
              case 1:
                var l = -1;
                break;
              case 2:
                l = 250;
                break;
              case 5:
                l = 1073741823;
                break;
              case 4:
                l = 1e4;
                break;
              default:
                l = 5e3;
            }
            return (
              (e = {
                id: d++,
                callback: o,
                priorityLevel: e,
                startTime: a,
                expirationTime: (l = a + l),
                sortIndex: -1,
              }),
              a > i
                ? ((e.sortIndex = a),
                  n(u, e),
                  null === r(c) &&
                    e === r(u) &&
                    (y ? (g(E), (E = -1)) : (y = !0), _(S, a - i)))
                : ((e.sortIndex = l), n(c, e), m || h || ((m = !0), R())),
              e
            );
          }),
          (t.unstable_shouldYield = T),
          (t.unstable_wrapCallback = function (e) {
            var t = p;
            return function () {
              var n = p;
              p = t;
              try {
                return e.apply(this, arguments);
              } finally {
                p = n;
              }
            };
          });
      },
      853: (e, t, n) => {
        e.exports = n(896);
      },
    },
    t = {};
  function n(r) {
    var o = t[r];
    if (void 0 !== o) return o.exports;
    var a = (t[r] = { exports: {} });
    return e[r](a, a.exports, n), a.exports;
  }
  n.nc = void 0;
  var r = n(43),
    o = n(391);
  function a(e, t) {
    if (null == e) return {};
    var n = {};
    for (var r in e)
      if ({}.hasOwnProperty.call(e, r)) {
        if (t.includes(r)) continue;
        n[r] = e[r];
      }
    return n;
  }
  function i(e, t) {
    if (null == e) return {};
    var n,
      r,
      o = a(e, t);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);
      for (r = 0; r < i.length; r++)
        (n = i[r]),
          t.includes(n) ||
            ({}.propertyIsEnumerable.call(e, n) && (o[n] = e[n]));
    }
    return o;
  }
  function l(e) {
    return (
      (l =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            }),
      l(e)
    );
  }
  function s(e) {
    var t = (function (e, t) {
      if ("object" != l(e) || !e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var r = n.call(e, t || "default");
        if ("object" != l(r)) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    })(e, "string");
    return "symbol" == l(t) ? t : t + "";
  }
  function c(e, t, n) {
    return (
      (t = s(t)) in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function u(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t &&
        (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })),
        n.push.apply(n, r);
    }
    return n;
  }
  function d(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2
        ? u(Object(n), !0).forEach(function (t) {
            c(e, t, n[t]);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : u(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
    }
    return e;
  }
  n(175);
  const f = ["page"],
    p = ["page", "matches"],
    h = [
      "onClick",
      "discover",
      "prefetch",
      "relative",
      "reloadDocument",
      "replace",
      "state",
      "target",
      "to",
      "preventScrollReset",
      "viewTransition",
    ],
    m = [
      "aria-current",
      "caseSensitive",
      "className",
      "end",
      "style",
      "to",
      "viewTransition",
      "children",
    ],
    y = [
      "discover",
      "fetcherKey",
      "navigate",
      "reloadDocument",
      "replace",
      "state",
      "method",
      "action",
      "onSubmit",
      "relative",
      "preventScrollReset",
      "viewTransition",
    ];
  var v = "popstate";
  function g() {
    return C(
      function (e, t) {
        let { pathname: n, search: r, hash: o } = e.location;
        return k(
          "",
          { pathname: n, search: r, hash: o },
          (t.state && t.state.usr) || null,
          (t.state && t.state.key) || "default"
        );
      },
      function (e, t) {
        return "string" === typeof t ? t : x(t);
      },
      null,
      arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
    );
  }
  function b(e, t) {
    if (!1 === e || null === e || "undefined" === typeof e) throw new Error(t);
  }
  function w(e, t) {
    if (!e) {
      "undefined" !== typeof console && console.warn(t);
      try {
        throw new Error(t);
      } catch (n) {}
    }
  }
  function S(e, t) {
    return { usr: e.state, key: e.key, idx: t };
  }
  function k(e, t) {
    let n =
        arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
      r = arguments.length > 3 ? arguments[3] : void 0;
    return d(
      d(
        {
          pathname: "string" === typeof e ? e : e.pathname,
          search: "",
          hash: "",
        },
        "string" === typeof t ? E(t) : t
      ),
      {},
      {
        state: n,
        key: (t && t.key) || r || Math.random().toString(36).substring(2, 10),
      }
    );
  }
  function x(e) {
    let { pathname: t = "/", search: n = "", hash: r = "" } = e;
    return (
      n && "?" !== n && (t += "?" === n.charAt(0) ? n : "?" + n),
      r && "#" !== r && (t += "#" === r.charAt(0) ? r : "#" + r),
      t
    );
  }
  function E(e) {
    let t = {};
    if (e) {
      let n = e.indexOf("#");
      n >= 0 && ((t.hash = e.substring(n)), (e = e.substring(0, n)));
      let r = e.indexOf("?");
      r >= 0 && ((t.search = e.substring(r)), (e = e.substring(0, r))),
        e && (t.pathname = e);
    }
    return t;
  }
  function C(e, t, n) {
    let r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
      { window: o = document.defaultView, v5Compat: a = !1 } = r,
      i = o.history,
      l = "POP",
      s = null,
      c = u();
    function u() {
      return (i.state || { idx: null }).idx;
    }
    function f() {
      l = "POP";
      let e = u(),
        t = null == e ? null : e - c;
      (c = e), s && s({ action: l, location: h.location, delta: t });
    }
    function p(e) {
      let t =
          "null" !== o.location.origin ? o.location.origin : o.location.href,
        n = "string" === typeof e ? e : x(e);
      return (
        (n = n.replace(/ $/, "%20")),
        b(
          t,
          "No window.location.(origin|href) available to create URL for href: ".concat(
            n
          )
        ),
        new URL(n, t)
      );
    }
    null == c &&
      ((c = 0), i.replaceState(d(d({}, i.state), {}, { idx: c }), ""));
    let h = {
      get action() {
        return l;
      },
      get location() {
        return e(o, i);
      },
      listen(e) {
        if (s) throw new Error("A history only accepts one active listener");
        return (
          o.addEventListener(v, f),
          (s = e),
          () => {
            o.removeEventListener(v, f), (s = null);
          }
        );
      },
      createHref: (e) => t(o, e),
      createURL: p,
      encodeLocation(e) {
        let t = p(e);
        return { pathname: t.pathname, search: t.search, hash: t.hash };
      },
      push: function (e, t) {
        l = "PUSH";
        let r = k(h.location, e, t);
        n && n(r, e), (c = u() + 1);
        let d = S(r, c),
          f = h.createHref(r);
        try {
          i.pushState(d, "", f);
        } catch (p) {
          if (p instanceof DOMException && "DataCloneError" === p.name) throw p;
          o.location.assign(f);
        }
        a && s && s({ action: l, location: h.location, delta: 1 });
      },
      replace: function (e, t) {
        l = "REPLACE";
        let r = k(h.location, e, t);
        n && n(r, e), (c = u());
        let o = S(r, c),
          d = h.createHref(r);
        i.replaceState(o, "", d),
          a && s && s({ action: l, location: h.location, delta: 0 });
      },
      go: (e) => i.go(e),
    };
    return h;
  }
  function N(e, t) {
    return T(
      e,
      t,
      arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "/",
      !1
    );
  }
  function T(e, t, n, r) {
    let o = W(("string" === typeof t ? E(t) : t).pathname || "/", n);
    if (null == o) return null;
    let a = P(e);
    !(function (e) {
      e.sort((e, t) =>
        e.score !== t.score
          ? t.score - e.score
          : (function (e, t) {
              let n =
                e.length === t.length &&
                e.slice(0, -1).every((e, n) => e === t[n]);
              return n ? e[e.length - 1] - t[t.length - 1] : 0;
            })(
              e.routesMeta.map((e) => e.childrenIndex),
              t.routesMeta.map((e) => e.childrenIndex)
            )
      );
    })(a);
    let i = null;
    for (let l = 0; null == i && l < a.length; ++l) {
      let e = U(o);
      i = F(a[l], e, r);
    }
    return i;
  }
  function P(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
      r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "",
      o = (e, o, a) => {
        let i = {
          relativePath: void 0 === a ? e.path || "" : a,
          caseSensitive: !0 === e.caseSensitive,
          childrenIndex: o,
          route: e,
        };
        i.relativePath.startsWith("/") &&
          (b(
            i.relativePath.startsWith(r),
            'Absolute route path "'
              .concat(i.relativePath, '" nested under path "')
              .concat(
                r,
                '" is not valid. An absolute child route path must start with the combined path of all its parent routes.'
              )
          ),
          (i.relativePath = i.relativePath.slice(r.length)));
        let l = q([r, i.relativePath]),
          s = n.concat(i);
        e.children &&
          e.children.length > 0 &&
          (b(
            !0 !== e.index,
            'Index routes must not have child routes. Please remove all child routes from route path "'.concat(
              l,
              '".'
            )
          ),
          P(e.children, t, s, l)),
          (null != e.path || e.index) &&
            t.push({ path: l, score: M(l, e.index), routesMeta: s });
      };
    return (
      e.forEach((e, t) => {
        var n;
        if (
          "" !== e.path &&
          null !== (n = e.path) &&
          void 0 !== n &&
          n.includes("?")
        )
          for (let r of O(e.path)) o(e, t, r);
        else o(e, t);
      }),
      t
    );
  }
  function O(e) {
    let t = e.split("/");
    if (0 === t.length) return [];
    let [n, ...r] = t,
      o = n.endsWith("?"),
      a = n.replace(/\?$/, "");
    if (0 === r.length) return o ? [a, ""] : [a];
    let i = O(r.join("/")),
      l = [];
    return (
      l.push(...i.map((e) => ("" === e ? a : [a, e].join("/")))),
      o && l.push(...i),
      l.map((t) => (e.startsWith("/") && "" === t ? "/" : t))
    );
  }
  var j = /^:[\w-]+$/,
    R = 3,
    _ = 2,
    L = 1,
    z = 10,
    A = -2,
    I = (e) => "*" === e;
  function M(e, t) {
    let n = e.split("/"),
      r = n.length;
    return (
      n.some(I) && (r += A),
      t && (r += _),
      n
        .filter((e) => !I(e))
        .reduce((e, t) => e + (j.test(t) ? R : "" === t ? L : z), r)
    );
  }
  function F(e, t) {
    let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
      { routesMeta: r } = e,
      o = {},
      a = "/",
      i = [];
    for (let l = 0; l < r.length; ++l) {
      let e = r[l],
        s = l === r.length - 1,
        c = "/" === a ? t : t.slice(a.length) || "/",
        u = D(
          { path: e.relativePath, caseSensitive: e.caseSensitive, end: s },
          c
        ),
        d = e.route;
      if (
        (!u &&
          s &&
          n &&
          !r[r.length - 1].route.index &&
          (u = D(
            { path: e.relativePath, caseSensitive: e.caseSensitive, end: !1 },
            c
          )),
        !u)
      )
        return null;
      Object.assign(o, u.params),
        i.push({
          params: o,
          pathname: q([a, u.pathname]),
          pathnameBase: Y(q([a, u.pathnameBase])),
          route: d,
        }),
        "/" !== u.pathnameBase && (a = q([a, u.pathnameBase]));
    }
    return i;
  }
  function D(e, t) {
    "string" === typeof e && (e = { path: e, caseSensitive: !1, end: !0 });
    let [n, r] = (function (e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          n =
            !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
        w(
          "*" === e || !e.endsWith("*") || e.endsWith("/*"),
          'Route path "'
            .concat(e, '" will be treated as if it were "')
            .concat(
              e.replace(/\*$/, "/*"),
              '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "'
            )
            .concat(e.replace(/\*$/, "/*"), '".')
        );
        let r = [],
          o =
            "^" +
            e
              .replace(/\/*\*?$/, "")
              .replace(/^\/*/, "/")
              .replace(/[\\.*+^${}|()[\]]/g, "\\$&")
              .replace(
                /\/:([\w-]+)(\?)?/g,
                (e, t, n) => (
                  r.push({ paramName: t, isOptional: null != n }),
                  n ? "/?([^\\/]+)?" : "/([^\\/]+)"
                )
              );
        e.endsWith("*")
          ? (r.push({ paramName: "*" }),
            (o += "*" === e || "/*" === e ? "(.*)$" : "(?:\\/(.+)|\\/*)$"))
          : n
          ? (o += "\\/*$")
          : "" !== e && "/" !== e && (o += "(?:(?=\\/|$))");
        let a = new RegExp(o, t ? void 0 : "i");
        return [a, r];
      })(e.path, e.caseSensitive, e.end),
      o = t.match(n);
    if (!o) return null;
    let a = o[0],
      i = a.replace(/(.)\/+$/, "$1"),
      l = o.slice(1);
    return {
      params: r.reduce((e, t, n) => {
        let { paramName: r, isOptional: o } = t;
        if ("*" === r) {
          let e = l[n] || "";
          i = a.slice(0, a.length - e.length).replace(/(.)\/+$/, "$1");
        }
        const s = l[n];
        return (e[r] = o && !s ? void 0 : (s || "").replace(/%2F/g, "/")), e;
      }, {}),
      pathname: a,
      pathnameBase: i,
      pattern: e,
    };
  }
  function U(e) {
    try {
      return e
        .split("/")
        .map((e) => decodeURIComponent(e).replace(/\//g, "%2F"))
        .join("/");
    } catch (t) {
      return (
        w(
          !1,
          'The URL path "'
            .concat(
              e,
              '" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent encoding ('
            )
            .concat(t, ").")
        ),
        e
      );
    }
  }
  function W(e, t) {
    if ("/" === t) return e;
    if (!e.toLowerCase().startsWith(t.toLowerCase())) return null;
    let n = t.endsWith("/") ? t.length - 1 : t.length,
      r = e.charAt(n);
    return r && "/" !== r ? null : e.slice(n) || "/";
  }
  function H(e, t, n, r) {
    return "Cannot include a '"
      .concat(e, "' character in a manually specified `to.")
      .concat(t, "` field [")
      .concat(JSON.stringify(r), "].  Please separate it out to the `to.")
      .concat(
        n,
        '` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.'
      );
  }
  function B(e) {
    return e.filter(
      (e, t) => 0 === t || (e.route.path && e.route.path.length > 0)
    );
  }
  function V(e) {
    let t = B(e);
    return t.map((e, n) => (n === t.length - 1 ? e.pathname : e.pathnameBase));
  }
  function $(e, t, n) {
    let r,
      o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    "string" === typeof e
      ? (r = E(e))
      : ((r = d({}, e)),
        b(
          !r.pathname || !r.pathname.includes("?"),
          H("?", "pathname", "search", r)
        ),
        b(
          !r.pathname || !r.pathname.includes("#"),
          H("#", "pathname", "hash", r)
        ),
        b(!r.search || !r.search.includes("#"), H("#", "search", "hash", r)));
    let a,
      i = "" === e || "" === r.pathname,
      l = i ? "/" : r.pathname;
    if (null == l) a = n;
    else {
      let e = t.length - 1;
      if (!o && l.startsWith("..")) {
        let t = l.split("/");
        for (; ".." === t[0]; ) t.shift(), (e -= 1);
        r.pathname = t.join("/");
      }
      a = e >= 0 ? t[e] : "/";
    }
    let s = (function (e) {
        let t =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : "/",
          {
            pathname: n,
            search: r = "",
            hash: o = "",
          } = "string" === typeof e ? E(e) : e,
          a = n
            ? n.startsWith("/")
              ? n
              : (function (e, t) {
                  let n = t.replace(/\/+$/, "").split("/");
                  return (
                    e.split("/").forEach((e) => {
                      ".." === e
                        ? n.length > 1 && n.pop()
                        : "." !== e && n.push(e);
                    }),
                    n.length > 1 ? n.join("/") : "/"
                  );
                })(n, t)
            : t;
        return { pathname: a, search: Q(r), hash: K(o) };
      })(r, a),
      c = l && "/" !== l && l.endsWith("/"),
      u = (i || "." === l) && n.endsWith("/");
    return s.pathname.endsWith("/") || (!c && !u) || (s.pathname += "/"), s;
  }
  var q = (e) => e.join("/").replace(/\/\/+/g, "/"),
    Y = (e) => e.replace(/\/+$/, "").replace(/^\/*/, "/"),
    Q = (e) => (e && "?" !== e ? (e.startsWith("?") ? e : "?" + e) : ""),
    K = (e) => (e && "#" !== e ? (e.startsWith("#") ? e : "#" + e) : "");
  function G(e) {
    return (
      null != e &&
      "number" === typeof e.status &&
      "string" === typeof e.statusText &&
      "boolean" === typeof e.internal &&
      "data" in e
    );
  }
  var X = ["POST", "PUT", "PATCH", "DELETE"],
    J = (new Set(X), ["GET", ...X]);
  new Set(J), Symbol("ResetLoaderData");
  var Z = r.createContext(null);
  Z.displayName = "DataRouter";
  var ee = r.createContext(null);
  ee.displayName = "DataRouterState";
  var te = r.createContext({ isTransitioning: !1 });
  te.displayName = "ViewTransition";
  var ne = r.createContext(new Map());
  ne.displayName = "Fetchers";
  var re = r.createContext(null);
  re.displayName = "Await";
  var oe = r.createContext(null);
  oe.displayName = "Navigation";
  var ae = r.createContext(null);
  ae.displayName = "Location";
  var ie = r.createContext({ outlet: null, matches: [], isDataRoute: !1 });
  ie.displayName = "Route";
  var le = r.createContext(null);
  le.displayName = "RouteError";
  function se() {
    return null != r.useContext(ae);
  }
  function ce() {
    return (
      b(
        se(),
        "useLocation() may be used only in the context of a <Router> component."
      ),
      r.useContext(ae).location
    );
  }
  var ue =
    "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
  function de(e) {
    r.useContext(oe).static || r.useLayoutEffect(e);
  }
  function fe() {
    let { isDataRoute: e } = r.useContext(ie);
    return e
      ? (function () {
          let { router: e } = Se("useNavigate"),
            t = xe("useNavigate"),
            n = r.useRef(!1);
          de(() => {
            n.current = !0;
          });
          let o = r.useCallback(
            async function (r) {
              let o =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
              w(n.current, ue),
                n.current &&
                  ("number" === typeof r
                    ? e.navigate(r)
                    : await e.navigate(r, d({ fromRouteId: t }, o)));
            },
            [e, t]
          );
          return o;
        })()
      : (function () {
          b(
            se(),
            "useNavigate() may be used only in the context of a <Router> component."
          );
          let e = r.useContext(Z),
            { basename: t, navigator: n } = r.useContext(oe),
            { matches: o } = r.useContext(ie),
            { pathname: a } = ce(),
            i = JSON.stringify(V(o)),
            l = r.useRef(!1);
          de(() => {
            l.current = !0;
          });
          let s = r.useCallback(
            function (r) {
              let o =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
              if ((w(l.current, ue), !l.current)) return;
              if ("number" === typeof r) return void n.go(r);
              let s = $(r, JSON.parse(i), a, "path" === o.relative);
              null == e &&
                "/" !== t &&
                (s.pathname = "/" === s.pathname ? t : q([t, s.pathname])),
                (o.replace ? n.replace : n.push)(s, o.state, o);
            },
            [t, n, i, a, e]
          );
          return s;
        })();
  }
  r.createContext(null);
  function pe(e) {
    let { relative: t } =
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      { matches: n } = r.useContext(ie),
      { pathname: o } = ce(),
      a = JSON.stringify(V(n));
    return r.useMemo(() => $(e, JSON.parse(a), o, "path" === t), [e, a, o, t]);
  }
  function he(e, t, n, o) {
    b(
      se(),
      "useRoutes() may be used only in the context of a <Router> component."
    );
    let { navigator: a } = r.useContext(oe),
      { matches: i } = r.useContext(ie),
      l = i[i.length - 1],
      s = l ? l.params : {},
      c = l ? l.pathname : "/",
      u = l ? l.pathnameBase : "/",
      f = l && l.route;
    {
      let e = (f && f.path) || "";
      Ne(
        c,
        !f || e.endsWith("*") || e.endsWith("*?"),
        'You rendered descendant <Routes> (or called `useRoutes()`) at "'
          .concat(c, '" (under <Route path="')
          .concat(
            e,
            '">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won\'t match anymore and therefore the child routes will never render.\n\nPlease change the parent <Route path="'
          )
          .concat(e, '"> to <Route path="')
          .concat("/" === e ? "*" : "".concat(e, "/*"), '">.')
      );
    }
    let p,
      h = ce();
    if (t) {
      var m;
      let e = "string" === typeof t ? E(t) : t;
      b(
        "/" === u ||
          (null === (m = e.pathname) || void 0 === m
            ? void 0
            : m.startsWith(u)),
        'When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "'
          .concat(u, '" but pathname "')
          .concat(e.pathname, '" was given in the `location` prop.')
      ),
        (p = e);
    } else p = h;
    let y = p.pathname || "/",
      v = y;
    if ("/" !== u) {
      let e = u.replace(/^\//, "").split("/");
      v = "/" + y.replace(/^\//, "").split("/").slice(e.length).join("/");
    }
    let g = N(e, { pathname: v });
    w(
      f || null != g,
      'No routes matched location "'
        .concat(p.pathname)
        .concat(p.search)
        .concat(p.hash, '" ')
    ),
      w(
        null == g ||
          void 0 !== g[g.length - 1].route.element ||
          void 0 !== g[g.length - 1].route.Component ||
          void 0 !== g[g.length - 1].route.lazy,
        'Matched leaf route at location "'
          .concat(p.pathname)
          .concat(p.search)
          .concat(
            p.hash,
            '" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.'
          )
      );
    let S = be(
      g &&
        g.map((e) =>
          Object.assign({}, e, {
            params: Object.assign({}, s, e.params),
            pathname: q([
              u,
              a.encodeLocation
                ? a.encodeLocation(e.pathname).pathname
                : e.pathname,
            ]),
            pathnameBase:
              "/" === e.pathnameBase
                ? u
                : q([
                    u,
                    a.encodeLocation
                      ? a.encodeLocation(e.pathnameBase).pathname
                      : e.pathnameBase,
                  ]),
          })
        ),
      i,
      n,
      o
    );
    return t && S
      ? r.createElement(
          ae.Provider,
          {
            value: {
              location: d(
                {
                  pathname: "/",
                  search: "",
                  hash: "",
                  state: null,
                  key: "default",
                },
                p
              ),
              navigationType: "POP",
            },
          },
          S
        )
      : S;
  }
  function me() {
    let e = Ee(),
      t = G(e)
        ? "".concat(e.status, " ").concat(e.statusText)
        : e instanceof Error
        ? e.message
        : JSON.stringify(e),
      n = e instanceof Error ? e.stack : null,
      o = "rgba(200,200,200, 0.5)",
      a = { padding: "0.5rem", backgroundColor: o },
      i = { padding: "2px 4px", backgroundColor: o },
      l = null;
    return (
      console.error("Error handled by React Router default ErrorBoundary:", e),
      (l = r.createElement(
        r.Fragment,
        null,
        r.createElement("p", null, "\ud83d\udcbf Hey developer \ud83d\udc4b"),
        r.createElement(
          "p",
          null,
          "You can provide a way better UX than this when your app throws errors by providing your own ",
          r.createElement("code", { style: i }, "ErrorBoundary"),
          " or",
          " ",
          r.createElement("code", { style: i }, "errorElement"),
          " prop on your route."
        )
      )),
      r.createElement(
        r.Fragment,
        null,
        r.createElement("h2", null, "Unexpected Application Error!"),
        r.createElement("h3", { style: { fontStyle: "italic" } }, t),
        n ? r.createElement("pre", { style: a }, n) : null,
        l
      )
    );
  }
  var ye = r.createElement(me, null),
    ve = class extends r.Component {
      constructor(e) {
        super(e),
          (this.state = {
            location: e.location,
            revalidation: e.revalidation,
            error: e.error,
          });
      }
      static getDerivedStateFromError(e) {
        return { error: e };
      }
      static getDerivedStateFromProps(e, t) {
        return t.location !== e.location ||
          ("idle" !== t.revalidation && "idle" === e.revalidation)
          ? {
              error: e.error,
              location: e.location,
              revalidation: e.revalidation,
            }
          : {
              error: void 0 !== e.error ? e.error : t.error,
              location: t.location,
              revalidation: e.revalidation || t.revalidation,
            };
      }
      componentDidCatch(e, t) {
        console.error(
          "React Router caught the following error during render",
          e,
          t
        );
      }
      render() {
        return void 0 !== this.state.error
          ? r.createElement(
              ie.Provider,
              { value: this.props.routeContext },
              r.createElement(le.Provider, {
                value: this.state.error,
                children: this.props.component,
              })
            )
          : this.props.children;
      }
    };
  function ge(e) {
    let { routeContext: t, match: n, children: o } = e,
      a = r.useContext(Z);
    return (
      a &&
        a.static &&
        a.staticContext &&
        (n.route.errorElement || n.route.ErrorBoundary) &&
        (a.staticContext._deepestRenderedBoundaryId = n.route.id),
      r.createElement(ie.Provider, { value: t }, o)
    );
  }
  function be(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
    if (null == e) {
      if (!n) return null;
      if (n.errors) e = n.matches;
      else {
        if (0 !== t.length || n.initialized || !(n.matches.length > 0))
          return null;
        e = n.matches;
      }
    }
    let o = e,
      a = null === n || void 0 === n ? void 0 : n.errors;
    if (null != a) {
      let e = o.findIndex(
        (e) =>
          e.route.id &&
          void 0 !== (null === a || void 0 === a ? void 0 : a[e.route.id])
      );
      b(
        e >= 0,
        "Could not find a matching route for errors on route IDs: ".concat(
          Object.keys(a).join(",")
        )
      ),
        (o = o.slice(0, Math.min(o.length, e + 1)));
    }
    let i = !1,
      l = -1;
    if (n)
      for (let r = 0; r < o.length; r++) {
        let e = o[r];
        if (
          ((e.route.HydrateFallback || e.route.hydrateFallbackElement) &&
            (l = r),
          e.route.id)
        ) {
          let { loaderData: t, errors: r } = n,
            a =
              e.route.loader &&
              !t.hasOwnProperty(e.route.id) &&
              (!r || void 0 === r[e.route.id]);
          if (e.route.lazy || a) {
            (i = !0), (o = l >= 0 ? o.slice(0, l + 1) : [o[0]]);
            break;
          }
        }
      }
    return o.reduceRight((e, s, c) => {
      let u,
        d = !1,
        f = null,
        p = null;
      n &&
        ((u = a && s.route.id ? a[s.route.id] : void 0),
        (f = s.route.errorElement || ye),
        i &&
          (l < 0 && 0 === c
            ? (Ne(
                "route-fallback",
                !1,
                "No `HydrateFallback` element provided to render during initial hydration"
              ),
              (d = !0),
              (p = null))
            : l === c &&
              ((d = !0), (p = s.route.hydrateFallbackElement || null))));
      let h = t.concat(o.slice(0, c + 1)),
        m = () => {
          let t;
          return (
            (t = u
              ? f
              : d
              ? p
              : s.route.Component
              ? r.createElement(s.route.Component, null)
              : s.route.element
              ? s.route.element
              : e),
            r.createElement(ge, {
              match: s,
              routeContext: { outlet: e, matches: h, isDataRoute: null != n },
              children: t,
            })
          );
        };
      return n && (s.route.ErrorBoundary || s.route.errorElement || 0 === c)
        ? r.createElement(ve, {
            location: n.location,
            revalidation: n.revalidation,
            component: f,
            error: u,
            children: m(),
            routeContext: { outlet: null, matches: h, isDataRoute: !0 },
          })
        : m();
    }, null);
  }
  function we(e) {
    return "".concat(
      e,
      " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router."
    );
  }
  function Se(e) {
    let t = r.useContext(Z);
    return b(t, we(e)), t;
  }
  function ke(e) {
    let t = r.useContext(ee);
    return b(t, we(e)), t;
  }
  function xe(e) {
    let t = (function (e) {
        let t = r.useContext(ie);
        return b(t, we(e)), t;
      })(e),
      n = t.matches[t.matches.length - 1];
    return (
      b(
        n.route.id,
        "".concat(e, ' can only be used on routes that contain a unique "id"')
      ),
      n.route.id
    );
  }
  function Ee() {
    var e;
    let t = r.useContext(le),
      n = ke("useRouteError"),
      o = xe("useRouteError");
    return void 0 !== t
      ? t
      : null === (e = n.errors) || void 0 === e
      ? void 0
      : e[o];
  }
  var Ce = {};
  function Ne(e, t, n) {
    t || Ce[e] || ((Ce[e] = !0), w(!1, n));
  }
  r.memo(function (e) {
    let { routes: t, future: n, state: r } = e;
    return he(t, void 0, r, n);
  });
  function Te(e) {
    let {
      basename: t = "/",
      children: n = null,
      location: o,
      navigationType: a = "POP",
      navigator: i,
      static: l = !1,
    } = e;
    b(
      !se(),
      "You cannot render a <Router> inside another <Router>. You should never have more than one in your app."
    );
    let s = t.replace(/^\/*/, "/"),
      c = r.useMemo(
        () => ({ basename: s, navigator: i, static: l, future: {} }),
        [s, i, l]
      );
    "string" === typeof o && (o = E(o));
    let {
        pathname: u = "/",
        search: d = "",
        hash: f = "",
        state: p = null,
        key: h = "default",
      } = o,
      m = r.useMemo(() => {
        let e = W(u, s);
        return null == e
          ? null
          : {
              location: { pathname: e, search: d, hash: f, state: p, key: h },
              navigationType: a,
            };
      }, [s, u, d, f, p, h, a]);
    return (
      w(
        null != m,
        '<Router basename="'
          .concat(s, '"> is not able to match the URL "')
          .concat(u)
          .concat(d)
          .concat(
            f,
            "\" because it does not start with the basename, so the <Router> won't render anything."
          )
      ),
      null == m
        ? null
        : r.createElement(
            oe.Provider,
            { value: c },
            r.createElement(ae.Provider, { children: n, value: m })
          )
    );
  }
  r.Component;
  var Pe = "get",
    Oe = "application/x-www-form-urlencoded";
  function je(e) {
    return null != e && "string" === typeof e.tagName;
  }
  var Re = null;
  var _e = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain",
  ]);
  function Le(e) {
    return null == e || _e.has(e)
      ? e
      : (w(
          !1,
          '"'
            .concat(
              e,
              '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` and will default to "'
            )
            .concat(Oe, '"')
        ),
        null);
  }
  function ze(e, t) {
    let n, r, o, a, i;
    if (je((l = e)) && "form" === l.tagName.toLowerCase()) {
      let i = e.getAttribute("action");
      (r = i ? W(i, t) : null),
        (n = e.getAttribute("method") || Pe),
        (o = Le(e.getAttribute("enctype")) || Oe),
        (a = new FormData(e));
    } else if (
      (function (e) {
        return je(e) && "button" === e.tagName.toLowerCase();
      })(e) ||
      ((function (e) {
        return je(e) && "input" === e.tagName.toLowerCase();
      })(e) &&
        ("submit" === e.type || "image" === e.type))
    ) {
      let i = e.form;
      if (null == i)
        throw new Error(
          'Cannot submit a <button> or <input type="submit"> without a <form>'
        );
      let l = e.getAttribute("formaction") || i.getAttribute("action");
      if (
        ((r = l ? W(l, t) : null),
        (n = e.getAttribute("formmethod") || i.getAttribute("method") || Pe),
        (o =
          Le(e.getAttribute("formenctype")) ||
          Le(i.getAttribute("enctype")) ||
          Oe),
        (a = new FormData(i, e)),
        !(function () {
          if (null === Re)
            try {
              new FormData(document.createElement("form"), 0), (Re = !1);
            } catch (e) {
              Re = !0;
            }
          return Re;
        })())
      ) {
        let { name: t, type: n, value: r } = e;
        if ("image" === n) {
          let e = t ? "".concat(t, ".") : "";
          a.append("".concat(e, "x"), "0"), a.append("".concat(e, "y"), "0");
        } else t && a.append(t, r);
      }
    } else {
      if (je(e))
        throw new Error(
          'Cannot submit element that is not <form>, <button>, or <input type="submit|image">'
        );
      (n = Pe), (r = null), (o = Oe), (i = e);
    }
    var l;
    return (
      a && "text/plain" === o && ((i = a), (a = void 0)),
      { action: r, method: n.toLowerCase(), encType: o, formData: a, body: i }
    );
  }
  function Ae(e, t) {
    if (!1 === e || null === e || "undefined" === typeof e) throw new Error(t);
  }
  async function Ie(e, t) {
    if (e.id in t) return t[e.id];
    try {
      let n = await import(e.module);
      return (t[e.id] = n), n;
    } catch (n) {
      return (
        console.error(
          "Error loading route module `".concat(
            e.module,
            "`, reloading page..."
          )
        ),
        console.error(n),
        window.__reactRouterContext && window.__reactRouterContext.isSpaMode,
        window.location.reload(),
        new Promise(() => {})
      );
    }
  }
  function Me(e) {
    return null != e && "string" === typeof e.page;
  }
  function Fe(e) {
    return (
      null != e &&
      (null == e.href
        ? "preload" === e.rel &&
          "string" === typeof e.imageSrcSet &&
          "string" === typeof e.imageSizes
        : "string" === typeof e.rel && "string" === typeof e.href)
    );
  }
  function De(e, t, n, r, o, a) {
    let i = (e, t) => !n[t] || e.route.id !== n[t].route.id,
      l = (e, t) => {
        var r;
        return (
          n[t].pathname !== e.pathname ||
          ((null === (r = n[t].route.path) || void 0 === r
            ? void 0
            : r.endsWith("*")) &&
            n[t].params["*"] !== e.params["*"])
        );
      };
    return "assets" === a
      ? t.filter((e, t) => i(e, t) || l(e, t))
      : "data" === a
      ? t.filter((t, a) => {
          let s = r.routes[t.route.id];
          if (!s || !s.hasLoader) return !1;
          if (i(t, a) || l(t, a)) return !0;
          if (t.route.shouldRevalidate) {
            var c;
            let r = t.route.shouldRevalidate({
              currentUrl: new URL(
                o.pathname + o.search + o.hash,
                window.origin
              ),
              currentParams:
                (null === (c = n[0]) || void 0 === c ? void 0 : c.params) || {},
              nextUrl: new URL(e, window.origin),
              nextParams: t.params,
              defaultShouldRevalidate: !0,
            });
            if ("boolean" === typeof r) return r;
          }
          return !0;
        })
      : [];
  }
  function Ue(e) {
    return [...new Set(e)];
  }
  function We(e, t) {
    let n = new Set(),
      r = new Set(t);
    return e.reduce((e, o) => {
      if (t && !Me(o) && "script" === o.as && o.href && r.has(o.href)) return e;
      let a = JSON.stringify(
        (function (e) {
          let t = {},
            n = Object.keys(e).sort();
          for (let r of n) t[r] = e[r];
          return t;
        })(o)
      );
      return n.has(a) || (n.add(a), e.push({ key: a, link: o })), e;
    }, []);
  }
  function He(e) {
    return { __html: e };
  }
  Symbol("SingleFetchRedirect");
  function Be(e) {
    let t =
      "string" === typeof e
        ? new URL(
            e,
            "undefined" === typeof window
              ? "server://singlefetch/"
              : window.location.origin
          )
        : e;
    return (
      "/" === t.pathname
        ? (t.pathname = "_root.data")
        : (t.pathname = "".concat(t.pathname.replace(/\/$/, ""), ".data")),
      t
    );
  }
  r.Component;
  function Ve(e) {
    let { error: t, isOutsideRemixApp: n } = e;
    console.error(t);
    let o,
      a = r.createElement("script", {
        dangerouslySetInnerHTML: {
          __html:
            '\n        console.log(\n          "\ud83d\udcbf Hey developer \ud83d\udc4b. You can provide a way better UX than this when your app throws errors. Check out https://remix.run/guides/errors for more information."\n        );\n      ',
        },
      });
    if (G(t))
      return r.createElement(
        $e,
        { title: "Unhandled Thrown Response!" },
        r.createElement(
          "h1",
          { style: { fontSize: "24px" } },
          t.status,
          " ",
          t.statusText
        ),
        a
      );
    if (t instanceof Error) o = t;
    else {
      let e =
        null == t
          ? "Unknown Error"
          : "object" === typeof t && "toString" in t
          ? t.toString()
          : JSON.stringify(t);
      o = new Error(e);
    }
    return r.createElement(
      $e,
      { title: "Application Error!", isOutsideRemixApp: n },
      r.createElement(
        "h1",
        { style: { fontSize: "24px" } },
        "Application Error"
      ),
      r.createElement(
        "pre",
        {
          style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto",
          },
        },
        o.stack
      ),
      a
    );
  }
  function $e(e) {
    var t;
    let { title: n, renderScripts: o, isOutsideRemixApp: a, children: i } = e,
      { routeModules: l } = Ge();
    return null !== (t = l.root) && void 0 !== t && t.Layout && !a
      ? i
      : r.createElement(
          "html",
          { lang: "en" },
          r.createElement(
            "head",
            null,
            r.createElement("meta", { charSet: "utf-8" }),
            r.createElement("meta", {
              name: "viewport",
              content: "width=device-width,initial-scale=1,viewport-fit=cover",
            }),
            r.createElement("title", null, n)
          ),
          r.createElement(
            "body",
            null,
            r.createElement(
              "main",
              {
                style: { fontFamily: "system-ui, sans-serif", padding: "2rem" },
              },
              i,
              o ? r.createElement(rt, null) : null
            )
          )
        );
  }
  function qe(e) {
    return !e;
  }
  function Ye() {
    let e = r.useContext(Z);
    return (
      Ae(
        e,
        "You must render this element inside a <DataRouterContext.Provider> element"
      ),
      e
    );
  }
  function Qe() {
    let e = r.useContext(ee);
    return (
      Ae(
        e,
        "You must render this element inside a <DataRouterStateContext.Provider> element"
      ),
      e
    );
  }
  var Ke = r.createContext(void 0);
  function Ge() {
    let e = r.useContext(Ke);
    return (
      Ae(e, "You must render this element inside a <HydratedRouter> element"), e
    );
  }
  function Xe(e, t) {
    return (n) => {
      e && e(n), n.defaultPrevented || t(n);
    };
  }
  function Je(e, t, n) {
    if (n && !nt) return [e[0]];
    if (t) {
      let n = e.findIndex((e) => void 0 !== t[e.route.id]);
      return e.slice(0, n + 1);
    }
    return e;
  }
  function Ze(e) {
    let { page: t } = e,
      n = i(e, f),
      { router: o } = Ye(),
      a = r.useMemo(
        () => N(o.routes, t, o.basename),
        [o.routes, t, o.basename]
      );
    return a ? r.createElement(tt, d({ page: t, matches: a }, n)) : null;
  }
  function et(e) {
    let { manifest: t, routeModules: n } = Ge(),
      [o, a] = r.useState([]);
    return (
      r.useEffect(() => {
        let r = !1;
        return (
          (async function (e, t, n) {
            return We(
              (
                await Promise.all(
                  e.map(async (e) => {
                    let r = t.routes[e.route.id];
                    if (r) {
                      let e = await Ie(r, n);
                      return e.links ? e.links() : [];
                    }
                    return [];
                  })
                )
              )
                .flat(1)
                .filter(Fe)
                .filter((e) => "stylesheet" === e.rel || "preload" === e.rel)
                .map((e) =>
                  "stylesheet" === e.rel
                    ? d(d({}, e), {}, { rel: "prefetch", as: "style" })
                    : d(d({}, e), {}, { rel: "prefetch" })
                )
            );
          })(e, t, n).then((e) => {
            r || a(e);
          }),
          () => {
            r = !0;
          }
        );
      }, [e, t, n]),
      o
    );
  }
  function tt(e) {
    let { page: t, matches: n } = e,
      o = i(e, p),
      a = ce(),
      { manifest: l, routeModules: s } = Ge(),
      { loaderData: c, matches: u } = Qe(),
      f = r.useMemo(() => De(t, n, u, l, a, "data"), [t, n, u, l, a]),
      h = r.useMemo(() => De(t, n, u, l, a, "assets"), [t, n, u, l, a]),
      m = r.useMemo(() => {
        if (t === a.pathname + a.search + a.hash) return [];
        let e = new Set(),
          r = !1;
        if (
          (n.forEach((t) => {
            var n;
            let o = l.routes[t.route.id];
            o &&
              o.hasLoader &&
              ((!f.some((e) => e.route.id === t.route.id) &&
                t.route.id in c &&
                null !== (n = s[t.route.id]) &&
                void 0 !== n &&
                n.shouldRevalidate) ||
              o.hasClientLoader
                ? (r = !0)
                : e.add(t.route.id));
          }),
          0 === e.size)
        )
          return [];
        let o = Be(t);
        return (
          r &&
            e.size > 0 &&
            o.searchParams.set(
              "_routes",
              n
                .filter((t) => e.has(t.route.id))
                .map((e) => e.route.id)
                .join(",")
            ),
          [o.pathname + o.search]
        );
      }, [c, a, l, f, n, t, s]),
      y = r.useMemo(
        () =>
          (function (e, t) {
            return Ue(
              e
                .map((e) => {
                  let n = t.routes[e.route.id];
                  if (!n) return [];
                  let r = [n.module];
                  return n.imports && (r = r.concat(n.imports)), r;
                })
                .flat(1)
            );
          })(h, l),
        [h, l]
      ),
      v = et(h);
    return r.createElement(
      r.Fragment,
      null,
      m.map((e) =>
        r.createElement(
          "link",
          d({ key: e, rel: "prefetch", as: "fetch", href: e }, o)
        )
      ),
      y.map((e) =>
        r.createElement("link", d({ key: e, rel: "modulepreload", href: e }, o))
      ),
      v.map((e) => {
        let { key: t, link: n } = e;
        return r.createElement("link", d({ key: t }, n));
      })
    );
  }
  Ke.displayName = "FrameworkContext";
  var nt = !1;
  function rt(e) {
    let {
        manifest: t,
        serverHandoffString: n,
        isSpaMode: o,
        renderMeta: a,
      } = Ge(),
      { router: i, static: l, staticContext: s } = Ye(),
      { matches: c } = Qe(),
      u = qe(o);
    a && (a.didRenderScripts = !0);
    let f = Je(c, null, o);
    r.useEffect(() => {
      nt = !0;
    }, []);
    let p = r.useMemo(() => {
        var o;
        let a = s
            ? "window.__reactRouterContext = "
                .concat(n, ";")
                .concat(
                  "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());"
                )
            : " ",
          c = l
            ? ""
                .concat(
                  null !== (o = t.hmr) && void 0 !== o && o.runtime
                    ? "import ".concat(JSON.stringify(t.hmr.runtime), ";")
                    : ""
                )
                .concat(u ? "" : "import ".concat(JSON.stringify(t.url)), ";\n")
                .concat(
                  f
                    .map((e, n) =>
                      "import * as route"
                        .concat(n, " from ")
                        .concat(
                          JSON.stringify(t.routes[e.route.id].module),
                          ";"
                        )
                    )
                    .join("\n"),
                  "\n  "
                )
                .concat(
                  u
                    ? "window.__reactRouterManifest = ".concat(
                        JSON.stringify(
                          (function (e, t) {
                            let n = new Set(
                                t.state.matches.map((e) => e.route.id)
                              ),
                              r = t.state.location.pathname
                                .split("/")
                                .filter(Boolean),
                              o = ["/"];
                            for (r.pop(); r.length > 0; )
                              o.push("/".concat(r.join("/"))), r.pop();
                            o.forEach((e) => {
                              let r = N(t.routes, e, t.basename);
                              r && r.forEach((e) => n.add(e.route.id));
                            });
                            let a = [...n].reduce(
                              (t, n) => Object.assign(t, { [n]: e.routes[n] }),
                              {}
                            );
                            return d(d({}, e), {}, { routes: a });
                          })(t, i),
                          null,
                          2
                        ),
                        ";"
                      )
                    : "",
                  "\n  window.__reactRouterRouteModules = {"
                )
                .concat(
                  f
                    .map((e, t) =>
                      "".concat(JSON.stringify(e.route.id), ":route").concat(t)
                    )
                    .join(","),
                  "};\n\nimport("
                )
                .concat(JSON.stringify(t.entry.module), ");")
            : " ";
        return r.createElement(
          r.Fragment,
          null,
          r.createElement(
            "script",
            d(
              d({}, e),
              {},
              {
                suppressHydrationWarning: !0,
                dangerouslySetInnerHTML: He(a),
                type: void 0,
              }
            )
          ),
          r.createElement(
            "script",
            d(
              d({}, e),
              {},
              {
                suppressHydrationWarning: !0,
                dangerouslySetInnerHTML: He(c),
                type: "module",
                async: !0,
              }
            )
          )
        );
      }, []),
      h = f
        .map((e) => {
          let n = t.routes[e.route.id];
          return n ? (n.imports || []).concat([n.module]) : [];
        })
        .flat(1),
      m = nt ? [] : t.entry.imports.concat(h);
    return nt
      ? null
      : r.createElement(
          r.Fragment,
          null,
          u
            ? null
            : r.createElement("link", {
                rel: "modulepreload",
                href: t.url,
                crossOrigin: e.crossOrigin,
              }),
          r.createElement("link", {
            rel: "modulepreload",
            href: t.entry.module,
            crossOrigin: e.crossOrigin,
          }),
          ((y = m), [...new Set(y)]).map((t) =>
            r.createElement("link", {
              key: t,
              rel: "modulepreload",
              href: t,
              crossOrigin: e.crossOrigin,
            })
          ),
          p
        );
    var y;
  }
  function ot() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return (e) => {
      t.forEach((t) => {
        "function" === typeof t ? t(e) : null != t && (t.current = e);
      });
    };
  }
  var at =
    "undefined" !== typeof window &&
    "undefined" !== typeof window.document &&
    "undefined" !== typeof window.document.createElement;
  try {
    at && (window.__reactRouterVersion = "7.1.1");
  } catch (ga) {}
  function it(e) {
    let { basename: t, children: n, window: o } = e,
      a = r.useRef();
    null == a.current && (a.current = g({ window: o, v5Compat: !0 }));
    let i = a.current,
      [l, s] = r.useState({ action: i.action, location: i.location }),
      c = r.useCallback(
        (e) => {
          r.startTransition(() => s(e));
        },
        [s]
      );
    return (
      r.useLayoutEffect(() => i.listen(c), [i, c]),
      r.createElement(Te, {
        basename: t,
        children: n,
        location: l.location,
        navigationType: l.action,
        navigator: i,
      })
    );
  }
  var lt = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i,
    st = r.forwardRef(function (e, t) {
      let n,
        {
          onClick: o,
          discover: a = "render",
          prefetch: l = "none",
          relative: s,
          reloadDocument: c,
          replace: u,
          state: f,
          target: p,
          to: m,
          preventScrollReset: y,
          viewTransition: v,
        } = e,
        g = i(e, h),
        { basename: S } = r.useContext(oe),
        k = "string" === typeof m && lt.test(m),
        E = !1;
      if ("string" === typeof m && k && ((n = m), at))
        try {
          let e = new URL(window.location.href),
            t = m.startsWith("//") ? new URL(e.protocol + m) : new URL(m),
            n = W(t.pathname, S);
          t.origin === e.origin && null != n
            ? (m = n + t.search + t.hash)
            : (E = !0);
        } catch (ga) {
          w(
            !1,
            '<Link to="'.concat(
              m,
              '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.'
            )
          );
        }
      let C = (function (e) {
          let { relative: t } =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          b(
            se(),
            "useHref() may be used only in the context of a <Router> component."
          );
          let { basename: n, navigator: o } = r.useContext(oe),
            { hash: a, pathname: i, search: l } = pe(e, { relative: t }),
            s = i;
          return (
            "/" !== n && (s = "/" === i ? n : q([n, i])),
            o.createHref({ pathname: s, search: l, hash: a })
          );
        })(m, { relative: s }),
        [N, T, P] = (function (e, t) {
          let n = r.useContext(Ke),
            [o, a] = r.useState(!1),
            [i, l] = r.useState(!1),
            {
              onFocus: s,
              onBlur: c,
              onMouseEnter: u,
              onMouseLeave: d,
              onTouchStart: f,
            } = t,
            p = r.useRef(null);
          r.useEffect(() => {
            if (("render" === e && l(!0), "viewport" === e)) {
              let e = new IntersectionObserver(
                (e) => {
                  e.forEach((e) => {
                    l(e.isIntersecting);
                  });
                },
                { threshold: 0.5 }
              );
              return (
                p.current && e.observe(p.current),
                () => {
                  e.disconnect();
                }
              );
            }
          }, [e]),
            r.useEffect(() => {
              if (o) {
                let e = setTimeout(() => {
                  l(!0);
                }, 100);
                return () => {
                  clearTimeout(e);
                };
              }
            }, [o]);
          let h = () => {
              a(!0);
            },
            m = () => {
              a(!1), l(!1);
            };
          return n
            ? "intent" !== e
              ? [i, p, {}]
              : [
                  i,
                  p,
                  {
                    onFocus: Xe(s, h),
                    onBlur: Xe(c, m),
                    onMouseEnter: Xe(u, h),
                    onMouseLeave: Xe(d, m),
                    onTouchStart: Xe(f, h),
                  },
                ]
            : [!1, p, {}];
        })(l, g),
        O = (function (e) {
          let {
              target: t,
              replace: n,
              state: o,
              preventScrollReset: a,
              relative: i,
              viewTransition: l,
            } = arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : {},
            s = fe(),
            c = ce(),
            u = pe(e, { relative: i });
          return r.useCallback(
            (r) => {
              if (
                (function (e, t) {
                  return (
                    0 === e.button &&
                    (!t || "_self" === t) &&
                    !(function (e) {
                      return !!(
                        e.metaKey ||
                        e.altKey ||
                        e.ctrlKey ||
                        e.shiftKey
                      );
                    })(e)
                  );
                })(r, t)
              ) {
                r.preventDefault();
                let t = void 0 !== n ? n : x(c) === x(u);
                s(e, {
                  replace: t,
                  state: o,
                  preventScrollReset: a,
                  relative: i,
                  viewTransition: l,
                });
              }
            },
            [c, s, u, n, o, t, e, a, i, l]
          );
        })(m, {
          replace: u,
          state: f,
          target: p,
          preventScrollReset: y,
          relative: s,
          viewTransition: v,
        });
      let j = r.createElement(
        "a",
        d(
          d(d({}, g), P),
          {},
          {
            href: n || C,
            onClick:
              E || c
                ? o
                : function (e) {
                    o && o(e), e.defaultPrevented || O(e);
                  },
            ref: ot(t, T),
            target: p,
            "data-discover": k || "render" !== a ? void 0 : "true",
          }
        )
      );
      return N && !k
        ? r.createElement(r.Fragment, null, j, r.createElement(Ze, { page: C }))
        : j;
    });
  (st.displayName = "Link"),
    (r.forwardRef(function (e, t) {
      let {
          "aria-current": n = "page",
          caseSensitive: o = !1,
          className: a = "",
          end: l = !1,
          style: s,
          to: c,
          viewTransition: u,
          children: f,
        } = e,
        p = i(e, m),
        h = pe(c, { relative: p.relative }),
        y = ce(),
        v = r.useContext(ee),
        { navigator: g, basename: w } = r.useContext(oe),
        S =
          null != v &&
          (function (e) {
            let t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {},
              n = r.useContext(te);
            b(
              null != n,
              "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?"
            );
            let { basename: o } = dt("useViewTransitionState"),
              a = pe(e, { relative: t.relative });
            if (!n.isTransitioning) return !1;
            let i =
                W(n.currentLocation.pathname, o) || n.currentLocation.pathname,
              l = W(n.nextLocation.pathname, o) || n.nextLocation.pathname;
            return null != D(a.pathname, l) || null != D(a.pathname, i);
          })(h) &&
          !0 === u,
        k = g.encodeLocation ? g.encodeLocation(h).pathname : h.pathname,
        x = y.pathname,
        E =
          v && v.navigation && v.navigation.location
            ? v.navigation.location.pathname
            : null;
      o ||
        ((x = x.toLowerCase()),
        (E = E ? E.toLowerCase() : null),
        (k = k.toLowerCase())),
        E && w && (E = W(E, w) || E);
      const C = "/" !== k && k.endsWith("/") ? k.length - 1 : k.length;
      let N,
        T = x === k || (!l && x.startsWith(k) && "/" === x.charAt(C)),
        P =
          null != E &&
          (E === k || (!l && E.startsWith(k) && "/" === E.charAt(k.length))),
        O = { isActive: T, isPending: P, isTransitioning: S },
        j = T ? n : void 0;
      N =
        "function" === typeof a
          ? a(O)
          : [
              a,
              T ? "active" : null,
              P ? "pending" : null,
              S ? "transitioning" : null,
            ]
              .filter(Boolean)
              .join(" ");
      let R = "function" === typeof s ? s(O) : s;
      return r.createElement(
        st,
        d(
          d({}, p),
          {},
          {
            "aria-current": j,
            className: N,
            ref: t,
            style: R,
            to: c,
            viewTransition: u,
          }
        ),
        "function" === typeof f ? f(O) : f
      );
    }).displayName = "NavLink");
  var ct = r.forwardRef((e, t) => {
    let {
        discover: n = "render",
        fetcherKey: o,
        navigate: a,
        reloadDocument: l,
        replace: s,
        state: c,
        method: u = Pe,
        action: f,
        onSubmit: p,
        relative: h,
        preventScrollReset: m,
        viewTransition: v,
      } = e,
      g = i(e, y),
      w = ht(),
      S = (function (e) {
        let { relative: t } =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          { basename: n } = r.useContext(oe),
          o = r.useContext(ie);
        b(o, "useFormAction must be used inside a RouteContext");
        let [a] = o.matches.slice(-1),
          i = d({}, pe(e || ".", { relative: t })),
          l = ce();
        if (null == e) {
          i.search = l.search;
          let e = new URLSearchParams(i.search),
            t = e.getAll("index");
          if (t.some((e) => "" === e)) {
            e.delete("index"),
              t.filter((e) => e).forEach((t) => e.append("index", t));
            let n = e.toString();
            i.search = n ? "?".concat(n) : "";
          }
        }
        (e && "." !== e) ||
          !a.route.index ||
          (i.search = i.search ? i.search.replace(/^\?/, "?index&") : "?index");
        "/" !== n && (i.pathname = "/" === i.pathname ? n : q([n, i.pathname]));
        return x(i);
      })(f, { relative: h }),
      k = "get" === u.toLowerCase() ? "get" : "post",
      E = "string" === typeof f && lt.test(f);
    return r.createElement(
      "form",
      d(
        d(
          {
            ref: t,
            method: k,
            action: S,
            onSubmit: l
              ? p
              : (e) => {
                  if ((p && p(e), e.defaultPrevented)) return;
                  e.preventDefault();
                  let t = e.nativeEvent.submitter,
                    n =
                      (null === t || void 0 === t
                        ? void 0
                        : t.getAttribute("formmethod")) || u;
                  w(t || e.currentTarget, {
                    fetcherKey: o,
                    method: n,
                    navigate: a,
                    replace: s,
                    state: c,
                    relative: h,
                    preventScrollReset: m,
                    viewTransition: v,
                  });
                },
          },
          g
        ),
        {},
        { "data-discover": E || "render" !== n ? void 0 : "true" }
      )
    );
  });
  function ut(e) {
    return "".concat(
      e,
      " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router."
    );
  }
  function dt(e) {
    let t = r.useContext(Z);
    return b(t, ut(e)), t;
  }
  ct.displayName = "Form";
  var ft = 0,
    pt = () => "__".concat(String(++ft), "__");
  function ht() {
    let { router: e } = dt("useSubmit"),
      { basename: t } = r.useContext(oe),
      n = xe("useRouteId");
    return r.useCallback(
      async function (r) {
        let o =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          { action: a, method: i, encType: l, formData: s, body: c } = ze(r, t);
        if (!1 === o.navigate) {
          let t = o.fetcherKey || pt();
          await e.fetch(t, n, o.action || a, {
            preventScrollReset: o.preventScrollReset,
            formData: s,
            body: c,
            formMethod: o.method || i,
            formEncType: o.encType || l,
            flushSync: o.flushSync,
          });
        } else
          await e.navigate(o.action || a, {
            preventScrollReset: o.preventScrollReset,
            formData: s,
            body: c,
            formMethod: o.method || i,
            formEncType: o.encType || l,
            replace: o.replace,
            state: o.state,
            fromRouteId: n,
            flushSync: o.flushSync,
            viewTransition: o.viewTransition,
          });
      },
      [e, t, n]
    );
  }
  new TextEncoder();
  var mt = n(579);
  const yt = () =>
      (0, mt.jsx)("div", {
        children: (0, mt.jsxs)("div", {
          className: "container service-page-styling",
          children: [
            (0, mt.jsx)("h1", { children: "Privacy Statement" }),
            (0, mt.jsx)("h2", {
              children: "SECTION 1 - WHAT DO WE DO WITH YOUR INFORMATION?",
            }),
            (0, mt.jsx)("p", {
              children:
                "When you purchase something from our store, as part of the buying and selling process, we collect the personal information you provide us, such as your name, address, and email address. When you browse our store, we also automatically receive your computer\u2019s Internet Protocol (IP) address to help us learn about your browser and operating system.",
            }),
            (0, mt.jsxs)("p", {
              children: [
                (0, mt.jsx)("strong", {
                  children: "Email Marketing (if applicable):",
                }),
                " With your permission, we may send you emails about our store, new products, and other updates.",
              ],
            }),
            (0, mt.jsx)("h2", { children: "SECTION 2 - CONSENT" }),
            (0, mt.jsxs)("p", {
              children: [
                (0, mt.jsx)("strong", {
                  children: "How do you get my consent?",
                }),
                "When you provide us with personal information to complete a transaction, verify your credit card, place an order, arrange for a delivery, or return a purchase, we imply that you consent to our collecting it and using it for that specific reason only. If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent or provide you with an opportunity to decline.",
              ],
            }),
            (0, mt.jsx)("strong", {
              children: "How do I withdraw my consent?",
            }),
            "If, after you opt in, you change your mind, you may withdraw your consent for us to contact you, for the continued collection, use, or disclosure of your information at any time by contacting us at",
            " ",
            (0, mt.jsx)("a", {
              href: "mailto:samtheofanopoulos@hotmail.com",
              children: "samtheofanopoulos@hotmail.com",
            }),
            "or mailing us at: OEM Used Auto Parts, 6875 Speedway Blvd, U104, Las Vegas, NV 89115.",
            (0, mt.jsx)("h2", {
              className: "mt-2",
              children: "SECTION 3 - DISCLOSURE",
            }),
            (0, mt.jsx)("p", {
              children:
                "We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.",
            }),
            (0, mt.jsx)("h2", { children: "SECTION 4 - SHOPIFY" }),
            (0, mt.jsx)("p", {
              children:
                "Our store is hosted on Shopify Inc. They provide us with the online e-commerce platform that allows us to sell our products and services to you. Your data is stored through Shopify\u2019s data storage, databases, and the general Shopify application. They store your data on a secure server behind a firewall.",
            }),
            (0, mt.jsxs)("p", {
              children: [
                (0, mt.jsx)("strong", { children: "Payment:" }),
                " If you choose a direct payment gateway to complete your purchase, then Shopify stores your credit card data. It is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS). Your purchase transaction data is stored only as long as necessary to complete your purchase transaction. After that is complete, your purchase transaction information is deleted.",
              ],
            }),
            (0, mt.jsxs)("p", {
              children: [
                "All direct payment gateways adhere to the standards set by PCI-DSS, which is managed by the PCI Security Standards Council, a joint effort of brands like Visa, MasterCard, American Express, and Discover. PCI-DSS requirements help ensure the secure handling of credit card information by our store and its service providers. For more insight, you may also want to read Shopify\u2019s",
                (0, mt.jsx)("a", {
                  href: "https://www.shopify.com/legal/terms",
                  children: "Terms of Service",
                }),
                " or",
                " ",
                (0, mt.jsx)("a", {
                  href: "https://www.shopify.com/legal/privacy",
                  children: "Privacy Statement",
                }),
                ".",
              ],
            }),
            (0, mt.jsx)("h2", { children: "SECTION 5 - THIRD-PARTY SERVICES" }),
            (0, mt.jsx)("p", {
              children:
                "In general, the third-party providers used by us will only collect, use, and disclose your information to the extent necessary to allow them to perform the services they provide to us. However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies regarding the information we are required to provide to them for your purchase-related transactions.",
            }),
            (0, mt.jsx)("p", {
              children:
                "For these providers, we recommend that you read their privacy policies so you can understand how your personal information will be handled. Remember that certain providers may be located in or have facilities in a different jurisdiction than either you or us. So if you elect to proceed with a transaction involving the services of a third-party service provider, your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located.",
            }),
            (0, mt.jsx)("p", {
              children:
                "As an example, if you are located in Canada and your transaction is processed by a payment gateway located in the United States, your personal information used in completing that transaction may be subject to disclosure under United States legislation, including the Patriot Act. Once you leave our store\u2019s website or are redirected to a third-party website or application, you are no longer governed by this Privacy Policy or our website\u2019s Terms of Service.",
            }),
            (0, mt.jsxs)("p", {
              children: [
                (0, mt.jsx)("strong", { children: "Links:" }),
                " When you click on links on our store, they may direct you away from our site. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements.",
              ],
            }),
            (0, mt.jsx)("h2", { children: "SECTION 6 - SECURITY" }),
            (0, mt.jsx)("p", {
              children:
                "If you provide us with your credit card information, the information is encrypted using secure socket layer technology (SSL) and stored with AES-256 encryption. Although no method of transmission over the Internet or electronic storage is 100% secure, we follow all PCI-DSS requirements and implement additional generally accepted industry standards.",
            }),
            (0, mt.jsx)("h2", { children: "SECTION 7 - COOKIES" }),
            (0, mt.jsx)("p", {
              children:
                "Here is a list of cookies that we use. We\u2019ve listed them here so you can choose if you want to opt-out of cookies or not:",
            }),
            (0, mt.jsxs)("ul", {
              children: [
                (0, mt.jsxs)("li", {
                  children: [
                    (0, mt.jsx)("strong", { children: "_session_id:" }),
                    " unique token, sessional, Allows Shopify to store information about your session (referrer, landing page, etc).",
                  ],
                }),
                (0, mt.jsxs)("li", {
                  children: [
                    (0, mt.jsx)("strong", { children: "_shopify_visit:" }),
                    " no data held, Persistent for 30 minutes from the last visit, Used by our website provider\u2019s internal stats tracker to record the number of visits.",
                  ],
                }),
                (0, mt.jsxs)("li", {
                  children: [
                    (0, mt.jsx)("strong", { children: "_shopify_uniq:" }),
                    " no data held, expires midnight (relative to the visitor) of the next day, Counts the number of visits to a store by a single customer.",
                  ],
                }),
                (0, mt.jsxs)("li", {
                  children: [
                    (0, mt.jsx)("strong", { children: "cart:" }),
                    " unique token, persistent for 2 weeks, Stores information about the contents of your cart.",
                  ],
                }),
                (0, mt.jsxs)("li", {
                  children: [
                    (0, mt.jsx)("strong", { children: "_secure_session_id:" }),
                    " unique token, sessional.",
                  ],
                }),
                (0, mt.jsxs)("li", {
                  children: [
                    (0, mt.jsx)("strong", { children: "storefront_digest:" }),
                    " unique token, indefinite, If the shop has a password, this is used to determine if the current visitor has access.",
                  ],
                }),
              ],
            }),
            (0, mt.jsx)("h2", {
              className: "mt-1",
              children: "SECTION 8 - AGE OF CONSENT",
            }),
            (0, mt.jsx)("p", {
              children:
                "By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.",
            }),
            (0, mt.jsx)("h2", {
              children: "SECTION 9 - CHANGES TO THIS PRIVACY POLICY",
            }),
            (0, mt.jsx)("p", {
              children:
                "We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it.",
            }),
            (0, mt.jsx)("p", {
              children:
                "If our store is acquired or merged with another company, your information may be transferred to the new owners so that we may continue to sell products to you.",
            }),
            (0, mt.jsx)("h2", {
              children: "QUESTIONS AND CONTACT INFORMATION",
            }),
            (0, mt.jsxs)("p", {
              children: [
                "If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance Officer at",
                " ",
                (0, mt.jsx)("a", {
                  href: "mailto:samtheofanopoulos@hotmail.com",
                  children: "samtheofanopoulos@hotmail.com",
                }),
                " ",
                "or by mail at:",
              ],
            }),
            "OEM Used Auto Parts [Re: Privacy Compliance Officer] 6963 Speedway Blvd Suite 107 Las Vegas NV 89115",
            (0, mt.jsx)("h2", {
              className: "mt-4 mb-2",
              children: "TERMS OF SERVICE",
            }),
            (0, mt.jsx)("h2", { children: "OVERVIEW" }),
            (0, mt.jsx)("p", {
              children:
                "This website is operated by OEM Used Auto Parts. Throughout the site, the terms \u201cwe\u201d, \u201cus\u201d and \u201cour\u201d refer to OEM Used Auto Parts. OEM Used Auto Parts offers this website, including all information, tools and services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here.",
            }),
            (0, mt.jsx)("p", {
              children:
                "By visiting our site and/or purchasing something from us, you engage in our \u201cService\u201d and agree to be bound by the following terms and conditions (\u201cTerms of Service\u201d, \u201cTerms\u201d), including those additional terms and conditions and policies referenced herein and/or available by hyperlink. These Terms of Service apply to all users of the site, including without limitation users who are browsers, vendors, customers, merchants, and/or contributors of content.",
            }),
            (0, mt.jsx)("p", {
              children:
                "Please read these Terms of Service carefully before accessing or using our website. By accessing or using any part of the site, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions of this agreement, then you may not access the website or use any services. If these Terms of Service are considered an offer, acceptance is expressly limited to these Terms of Service.",
            }),
            (0, mt.jsx)("p", {
              children:
                "Any new features or tools which are added to the current store shall also be subject to the Terms of Service. You can review the most current version of the Terms of Service at any time on this page. We reserve the right to update, change or replace any part of these Terms of Service by posting updates and/or changes to our website. It is your responsibility to check this page periodically for changes. Your continued use of or access to the website following the posting of any changes constitutes acceptance of those changes.",
            }),
            (0, mt.jsx)("p", {
              children:
                "Our store is hosted on Shopify Inc. They provide us with the online e-commerce platform that allows us to sell our products and services to you.",
            }),
            (0, mt.jsx)("h2", { children: "SECTION 1 - ONLINE STORE TERMS" }),
            (0, mt.jsx)("p", {
              children:
                "By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.",
            }),
            (0, mt.jsx)("p", {
              children:
                "You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws).",
            }),
            (0, mt.jsx)("p", {
              children:
                "You must not transmit any worms or viruses or any code of a destructive nature.",
            }),
            (0, mt.jsx)("p", {
              children:
                "A breach or violation of any of the Terms will result in an immediate termination of your Services.",
            }),
            (0, mt.jsx)("h2", { children: "SECTION 2 - GENERAL CONDITIONS" }),
            (0, mt.jsx)("p", {
              children:
                "We reserve the right to refuse service to anyone for any reason at any time.",
            }),
            (0, mt.jsx)("p", {
              children:
                "You understand that your content (not including credit card information), may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks.",
            }),
            (0, mt.jsx)("p", {
              children:
                "You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the service is provided, without express written permission by us.",
            }),
            (0, mt.jsx)("p", {
              children:
                "The headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms.",
            }),
            (0, mt.jsx)("h2", {
              children:
                "SECTION 3 - ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION",
            }),
            (0, mt.jsx)("p", {
              children:
                "We are not responsible if information made available on this site is not accurate, complete or current. The material on this site is provided for general information only and should not be relied upon or used as the sole basis for making decisions without consulting primary, more accurate, more complete or more timely sources of information. Any reliance on the material on this site is at your own risk.",
            }),
            (0, mt.jsx)("p", {
              children:
                "This site may contain certain historical information. Historical information, necessarily, is not current and is provided for your reference only. We reserve the right to modify the contents of this site at any time, but we have no obligation to update any information on our site. You agree that it is your responsibility to monitor changes to our site.",
            }),
            (0, mt.jsx)("h2", {
              children: "SECTION 4 - MODIFICATIONS TO THE SERVICE AND PRICES",
            }),
            (0, mt.jsx)("p", {
              children:
                "Prices for our products are subject to change without notice.",
            }),
            (0, mt.jsx)("p", {
              children:
                "We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time.",
            }),
            (0, mt.jsx)("p", {
              children:
                "We shall not be liable to you or to any third-party for any modification, price change, suspension or discontinuance of the Service.",
            }),
            (0, mt.jsx)("h2", {
              children: "SECTION 5 - PRODUCTS OR SERVICES (if applicable)",
            }),
            (0, mt.jsx)("p", {
              children:
                "Certain products or services may be available exclusively online through the website. These products or services may have limited quantities and are subject to return or exchange only according to our Return Policy.",
            }),
            (0, mt.jsx)("p", {
              children:
                "We have made every effort to display as accurately as possible the colors and images of our products that appear at the store. We cannot guarantee that your computer monitor's display of any color will be accurate.",
            }),
            (0, mt.jsx)("p", {
              children:
                "We reserve the right, but are not obligated, to limit the sales of our products or Services to any person, geographic region or jurisdiction. We may exercise this right on a case-by-case basis. We reserve the right to limit the quantities of any products or services that we offer. All descriptions of products or product pricing are subject to change at any time without notice, at the sole discretion of us. We reserve the right to discontinue any product at any time. Any offer for any product or service made on this site is void where prohibited.",
            }),
            (0, mt.jsx)("p", {
              children:
                "We do not warrant that the quality of any products, services, information, or other material purchased or obtained by you will meet your expectations, or that any errors in the Service will be corrected.",
            }),
            (0, mt.jsx)("h2", {
              children:
                "SECTION 6 - ACCURACY OF BILLING AND ACCOUNT INFORMATION",
            }),
            (0, mt.jsx)("p", {
              children:
                "We reserve the right to refuse any order you place with us. We may, in our sole discretion, limit or cancel quantities purchased per person, per household or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address. In the event that we make a change to or cancel an order, we may attempt to notify you by contacting the e-mail and/or billing address/phone number provided at the time the order was made. We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers or distributors.",
            }),
            (0, mt.jsx)("p", {
              children:
                "You agree to provide current, complete and accurate purchase and account information for all purchases made at our store. You agree to promptly update your account and other information, including your email address and credit card numbers and expiration dates, so that we can complete your transactions and contact you as needed.",
            }),
            (0, mt.jsx)("p", {
              children: "For more detail, please review our Returns Policy.",
            }),
            (0, mt.jsx)("h2", { children: "SECTION 7 - OPTIONAL TOOLS" }),
            (0, mt.jsx)("p", {
              children:
                "We may provide you with access to third-party tools over which we neither monitor nor have any control nor input.",
            }),
            (0, mt.jsx)("p", {
              children:
                "You acknowledge and agree that we provide access to such tools \u201cas is\u201d and \u201cas available\u201d without any warranties, representations or conditions of any kind and without any endorsement. We shall have no liability whatsoever arising from or relating to your use of optional third-party tools.",
            }),
            (0, mt.jsx)("p", {
              children:
                "Any use by you of optional tools offered through the site is entirely at your own risk and discretion and you should ensure that you are familiar with and approve of the terms on which tools are provided by the relevant third-party provider(s).",
            }),
            (0, mt.jsx)("p", {
              children:
                "We may also, in the future, offer new services and/or features through the website (including the release of new tools and resources). Such new features and/or services shall also be subject to these Terms of Service.",
            }),
            (0, mt.jsx)("h2", { children: "SECTION 8 - THIRD-PARTY LINKS" }),
            (0, mt.jsx)("p", {
              children:
                "Certain content, products and services available via our Service may include materials from third-parties.",
            }),
            (0, mt.jsx)("p", {
              children:
                "Third-party links on this site may direct you to third-party websites that are not affiliated with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites, or for any other materials, products, or services of third-parties.",
            }),
            (0, mt.jsx)("p", {
              children:
                "We are not liable for any harm or damages related to the purchase or use of goods, services, resources, content, or any other transactions made in connection with any third-party websites. Please review carefully the third-party's policies and practices and make sure you understand them before you engage in any transaction. Complaints, claims, concerns, or questions regarding third-party products should be directed to the third-party.",
            }),
            (0, mt.jsx)("h2", {
              children:
                "SECTION 9 - USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS",
            }),
            (0, mt.jsx)("p", {
              children:
                "If, at our request, you send certain specific submissions (for example contest entries) or without a request from us you send creative ideas, suggestions, proposals, plans, or other materials, whether online, by email, by postal mail, or otherwise (collectively, 'comments'), you agree that we may, at any time, without restriction, edit, copy, publish, distribute, translate and otherwise use in any medium any comments that you forward to us. We are and shall be under no obligation (1) to maintain any comments in confidence; (2) to pay compensation for any comments; or (3) to respond to any comments.",
            }),
            (0, mt.jsx)("p", {
              children:
                "We may, but have no obligation to, monitor, edit or remove content that we determine in our sole discretion are unlawful, offensive, threatening, libelous, defamatory, pornographic, obscene or otherwise objectionable or violates any party\u2019s intellectual property or these Terms of Service.",
            }),
            (0, mt.jsx)("p", {
              children:
                "You agree that your comments will not violate any right of any third-party, including copyright, trademark, privacy, personality or other personal or proprietary right. You further agree that your comments will not contain libelous or otherwise unlawful, abusive or obscene material, or contain any computer virus or other malware that could in any way affect the operation of the Service or any related website. You may not use a false e-mail address, pretend to be someone other than yourself, or otherwise mislead us or third-parties as to the origin of any comments. You are solely responsible for any comments you make and their accuracy. We take no responsibility and assume no liability for any comments posted by you or any third-party.",
            }),
            (0, mt.jsx)("h2", {
              children: "SECTION 10 - PERSONAL INFORMATION",
            }),
            (0, mt.jsx)("p", {
              children:
                "Your submission of personal information through the store is governed by our Privacy Policy. To view our Privacy Policy.",
            }),
            (0, mt.jsx)("h2", {
              children: "SECTION 11 - ERRORS, INACCURACIES AND OMISSIONS",
            }),
            (0, mt.jsx)("p", {
              children:
                "Occasionally there may be information on our site or in the Service that contains typographical errors, inaccuracies or omissions that may relate to product descriptions, pricing, promotions, offers, product shipping charges, transit times and availability. We reserve the right to correct any errors, inaccuracies or omissions, and to change or update information or cancel orders if any information in the Service or on any related website is inaccurate at any time without prior notice (including after you have submitted your order).",
            }),
            (0, mt.jsx)("p", {
              children:
                "We undertake no obligation to update, amend or clarify information in the Service or on any related website, including without limitation, pricing information, except as required by law. No specified update or refresh date applied in the Service or on any related website should be taken to indicate that all information in the Service or on any related website has been modified or updated.",
            }),
            (0, mt.jsx)("h2", { children: "SECTION 12 - PROHIBITED USES" }),
            (0, mt.jsx)("p", {
              children:
                "In addition to other prohibitions as set forth in the Terms of Service, you are prohibited from using the site or its content: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c) to violate any international, federal, provincial or state regulations, rules, laws, or local ordinances; (d) to infringe upon or violate our intellectual property rights or the intellectual property rights of others; (e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability; (f) to submit false or misleading information; (g) to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of the Service or of any related website, other websites, or the Internet; (h) to collect or track the personal information of others; (i) to spam, phish, pharm, pretext, spider, crawl, or scrape; (j) for any obscene or immoral purpose; or (k) to interfere with or circumvent the security features of the Service or any related website, other websites, or the Internet. We reserve the right to terminate your use of the Service or any related website for violating any of the prohibited uses.",
            }),
            (0, mt.jsx)("h2", {
              children:
                "SECTION 13 - DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY",
            }),
            (0, mt.jsx)("p", {
              children:
                "We do not guarantee, represent or warrant that your use of our service will be uninterrupted, timely, secure or error-free.",
            }),
            (0, mt.jsx)("p", {
              children:
                "We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable.",
            }),
            (0, mt.jsx)("p", {
              children:
                "You agree that from time to time we may remove the service for indefinite periods of time or cancel the service at any time, without notice to you.",
            }),
            (0, mt.jsx)("p", {
              children:
                "You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all products and services delivered to you through the service are (except as expressly stated by us) provided 'as is' and 'as available' for your use, without any representation, warranties or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement.",
            }),
            (0, mt.jsx)("p", {
              children:
                "In no case shall OEM Used Auto Parts, our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the service or any products procured using the service, or for any other claim related in any way to your use of the service or any product, including, but not limited to, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of the service or any content (or product) posted, transmitted, or otherwise made available via the service, even if advised of their possibility. Because some states or jurisdictions do not allow the exclusion or the limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law.",
            }),
            (0, mt.jsx)("h2", { children: "SECTION 14 - INDEMNIFICATION" }),
            (0, mt.jsx)("p", {
              children:
                "You agree to indemnify, defend and hold harmless OEM Used Auto Parts and our parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers, interns and employees, harmless from any claim or demand, including reasonable attorneys\u2019 fees, made by any third-party due to or arising out of your breach of these Terms of Service or the documents they incorporate by reference, or your violation of any law or the rights of a third-party.",
            }),
            (0, mt.jsx)("h2", { children: "SECTION 15 - SEVERABILITY" }),
            (0, mt.jsx)("p", {
              children:
                "In the event that any provision of these Terms of Service is determined to be unlawful, void or unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed to be severed from these Terms of Service, such determination shall not affect the validity and enforceability of any other remaining provisions.",
            }),
            (0, mt.jsx)("h2", { children: "SECTION 16 - TERMINATION" }),
            (0, mt.jsx)("p", {
              children:
                "The obligations and liabilities of the parties incurred prior to the termination date shall survive the termination of this agreement for all purposes.",
            }),
            (0, mt.jsx)("p", {
              children:
                "These Terms of Service are effective unless and until terminated by either you or us. You may terminate these Terms of Service at any time by notifying us that you no longer wish to use our Services, or when you cease using our site.",
            }),
            (0, mt.jsx)("p", {
              children:
                "If in our sole judgment you fail, or we suspect that you have failed, to comply with any term or provision of these Terms of Service, we also may terminate this agreement at any time without notice and you will remain liable for all amounts due up to and including the date of termination; and/or accordingly may deny you access to our Services (or any part thereof).",
            }),
            (0, mt.jsx)("h2", { children: "SECTION 17 - ENTIRE AGREEMENT" }),
            (0, mt.jsx)("p", {
              children:
                "The failure of us to exercise or enforce any right or provision of these Terms of Service shall not constitute a waiver of such right or provision.",
            }),
            (0, mt.jsx)("p", {
              children:
                "These Terms of Service and any policies or operating rules posted by us on this site or in respect to The Service constitutes the entire agreement and understanding between you and us and govern your use of the Service, superseding any prior or contemporaneous agreements, communications and proposals, whether oral or written, between you and us (including, but not limited to, any prior versions of the Terms of Service).",
            }),
            (0, mt.jsx)("p", {
              children:
                "Any ambiguities in the interpretation of these Terms of Service shall not be construed against the drafting party.",
            }),
            (0, mt.jsx)("h2", { children: "SECTION 18 - GOVERNING LAW" }),
            (0, mt.jsx)("p", {
              children:
                "These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of 6963 Speedway Blvd Suite 107 Las Vegas NV 89115.",
            }),
            (0, mt.jsx)("h2", {
              children: "SECTION 19 - CHANGES TO TERMS OF SERVICE",
            }),
            (0, mt.jsx)("p", {
              children:
                "You can review the most current version of the Terms of Service at any time at this page.",
            }),
            (0, mt.jsx)("p", {
              children:
                "We reserve the right, at our sole discretion, to update, change or replace any part of these Terms of Service by posting updates and changes to our website. It is your responsibility to check our website periodically for changes. Your continued use of or access to our website or the Service following the posting of any changes to these Terms of Service constitutes acceptance of those changes.",
            }),
            (0, mt.jsx)("h2", { children: "SECTION 20 - CONTACT INFORMATION" }),
            (0, mt.jsxs)("p", {
              children: [
                "Questions about the Terms of Service should be sent to us at",
                " ",
                (0, mt.jsx)("a", {
                  href: "mailto:SUPPORT@OEMUAP.COM",
                  children: "SUPPORT@OEMUAP.COM",
                }),
              ],
            }),
          ],
        }),
      }),
    vt = () => {
      const e = ce();
      return (0, mt.jsx)("div", {
        children: (0, mt.jsxs)("div", {
          className: "header-component",
          children: [
            (0, mt.jsx)("div", {
              className: "top-header",
              children: (0, mt.jsxs)("div", {
                className: "top-header-links",
                children: [
                  (0, mt.jsxs)("button", {
                    className: "call-us-btn",
                    children: [
                      (0, mt.jsx)("div", {
                        className: "icon",
                        children: (0, mt.jsx)("img", {
                          src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/telephone-icon.svg",
                          alt: "icon",
                        }),
                      }),
                      (0, mt.jsx)("p", {
                        children: (0, mt.jsx)("span", {
                          children: (0, mt.jsx)("a", {
                            href: "tel:+1 260-493-1553",
                            children: "Call Us",
                          }),
                        }),
                      }),
                    ],
                  }),
                  (0, mt.jsxs)("button", {
                    className: "email-us-btn",
                    children: [
                      (0, mt.jsx)("div", {
                        className: "icon",
                        children: (0, mt.jsx)("img", {
                          src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/email-icon.svg",
                          alt: "icon",
                        }),
                      }),
                      (0, mt.jsx)("p", {
                        children: (0, mt.jsx)("a", {
                          href: "mailto:support@oemuap.com",
                          children: "Email Us",
                        }),
                      }),
                    ],
                  }),
                ],
              }),
            }),
            (0, mt.jsxs)("div", {
              className: "navigation",
              children: [
                (0, mt.jsx)("div", {
                  className: "nav-logo",
                  children: (0, mt.jsx)("a", {
                    href: "/pages/yard",
                    children: (0, mt.jsx)("img", {
                      className: "image cursor",
                      src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/logo.svg",
                      height: 100,
                      alt: "logo",
                    }),
                  }),
                }),
                (0, mt.jsxs)("div", {
                  className: "navigation-links",
                  children: [
                    (0, mt.jsx)("li", {
                      className: "/pages/yard" === e.pathname ? "active" : "",
                      children: (0, mt.jsx)("a", {
                        href: "/pages/yard",
                        children: "Home",
                      }),
                    }),
                    (0, mt.jsx)("li", {
                      children: (0, mt.jsx)("a", {
                        href: "http://search3371.used-auto-parts.biz/inventory/retail.htm",
                        children: "Search Inventory",
                      }),
                    }),
                    (0, mt.jsx)("a", {
                      href: "/pages/sell-my-car",
                      children: (0, mt.jsx)("button", {
                        className: "junk-my-car",
                        children: "Sell My Car",
                      }),
                    }),
                  ],
                }),
              ],
            }),
          ],
        }),
      });
    };
  function gt(e) {
    return "auto" === e || "dark" === e || "light" === e;
  }
  function bt() {
    let e,
      { key: t = "mantine-color-scheme-value" } =
        arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return {
      get: (e) => {
        if ("undefined" === typeof window) return e;
        try {
          const n = window.localStorage.getItem(t);
          return gt(n) ? n : e;
        } catch (n) {
          return e;
        }
      },
      set: (e) => {
        try {
          window.localStorage.setItem(t, e);
        } catch (n) {
          console.warn(
            "[@mantine/core] Local storage color scheme manager was unable to save color scheme.",
            n
          );
        }
      },
      subscribe: (n) => {
        (e = (e) => {
          e.storageArea === window.localStorage &&
            e.key === t &&
            gt(e.newValue) &&
            n(e.newValue);
        }),
          window.addEventListener("storage", e);
      },
      unsubscribe: () => {
        window.removeEventListener("storage", e);
      },
      clear: () => {
        window.localStorage.removeItem(t);
      },
    };
  }
  const wt = (0, r.createContext)(null);
  function St() {
    const e = (0, r.useContext)(wt);
    if (!e)
      throw new Error("[@mantine/core] MantineProvider was not found in tree");
    return e;
  }
  function kt() {
    return St().getStyleNonce;
  }
  function xt(e) {
    return Object.keys(e);
  }
  function Et(e) {
    return "0rem" === e
      ? "0rem"
      : "calc(".concat(e, " * var(--mantine-scale))");
  }
  function Ct(e) {
    let { shouldScale: t = !1 } =
      arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return function n(r) {
      if (0 === r || "0" === r) return "0".concat(e);
      if ("number" === typeof r) {
        const n = "".concat(r / 16).concat(e);
        return t ? Et(n) : n;
      }
      if ("string" === typeof r) {
        if ("" === r) return r;
        if (
          r.startsWith("calc(") ||
          r.startsWith("clamp(") ||
          r.includes("rgba(")
        )
          return r;
        if (r.includes(","))
          return r
            .split(",")
            .map((e) => n(e))
            .join(",");
        if (r.includes(" "))
          return r
            .split(" ")
            .map((e) => n(e))
            .join(" ");
        if (r.includes(e)) return t ? Et(r) : r;
        const o = r.replace("px", "");
        if (!Number.isNaN(Number(o))) {
          const n = "".concat(Number(o) / 16).concat(e);
          return t ? Et(n) : n;
        }
      }
      return r;
    };
  }
  const Nt = Ct("rem", { shouldScale: !0 }),
    Tt = Ct("em");
  function Pt(e) {
    return (function (e) {
      return /^#?([0-9A-F]{3}){1,2}([0-9A-F]{2})?$/i.test(e);
    })(e)
      ? (function (e) {
          let t = e.replace("#", "");
          if (3 === t.length) {
            const e = t.split("");
            t = [e[0], e[0], e[1], e[1], e[2], e[2]].join("");
          }
          if (8 === t.length) {
            const e = parseInt(t.slice(6, 8), 16) / 255;
            return {
              r: parseInt(t.slice(0, 2), 16),
              g: parseInt(t.slice(2, 4), 16),
              b: parseInt(t.slice(4, 6), 16),
              a: e,
            };
          }
          const n = parseInt(t, 16);
          return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: 255 & n, a: 1 };
        })(e)
      : e.startsWith("rgb")
      ? (function (e) {
          const [t, n, r, o] = e
            .replace(/[^0-9,./]/g, "")
            .split(/[/,]/)
            .map(Number);
          return { r: t, g: n, b: r, a: o || 1 };
        })(e)
      : e.startsWith("hsl")
      ? (function (e) {
          const t = e.match(
            /^hsla?\(\s*(\d+)\s*,\s*(\d+%)\s*,\s*(\d+%)\s*(,\s*(0?\.\d+|\d+(\.\d+)?))?\s*\)$/i
          );
          if (!t) return { r: 0, g: 0, b: 0, a: 1 };
          const n = parseInt(t[1], 10),
            r = parseInt(t[2], 10) / 100,
            o = parseInt(t[3], 10) / 100,
            a = t[5] ? parseFloat(t[5]) : void 0,
            i = (1 - Math.abs(2 * o - 1)) * r,
            l = n / 60,
            s = i * (1 - Math.abs((l % 2) - 1)),
            c = o - i / 2;
          let u, d, f;
          return (
            l >= 0 && l < 1
              ? ((u = i), (d = s), (f = 0))
              : l >= 1 && l < 2
              ? ((u = s), (d = i), (f = 0))
              : l >= 2 && l < 3
              ? ((u = 0), (d = i), (f = s))
              : l >= 3 && l < 4
              ? ((u = 0), (d = s), (f = i))
              : l >= 4 && l < 5
              ? ((u = s), (d = 0), (f = i))
              : ((u = i), (d = 0), (f = s)),
            {
              r: Math.round(255 * (u + c)),
              g: Math.round(255 * (d + c)),
              b: Math.round(255 * (f + c)),
              a: a || 1,
            }
          );
        })(e)
      : { r: 0, g: 0, b: 0, a: 1 };
  }
  function Ot(e, t) {
    if (e.startsWith("var("))
      return "color-mix(in srgb, ".concat(e, ", black ").concat(100 * t, "%)");
    const { r: n, g: r, b: o, a: a } = Pt(e),
      i = 1 - t,
      l = (e) => Math.round(e * i);
    return "rgba("
      .concat(l(n), ", ")
      .concat(l(r), ", ")
      .concat(l(o), ", ")
      .concat(a, ")");
  }
  function jt(e, t) {
    return "number" === typeof e.primaryShade
      ? e.primaryShade
      : "dark" === t
      ? e.primaryShade.dark
      : e.primaryShade.light;
  }
  function Rt(e) {
    return e <= 0.03928 ? e / 12.92 : ((e + 0.055) / 1.055) ** 2.4;
  }
  function _t(e) {
    if (e.startsWith("oklch("))
      return (
        ((function (e) {
          const t = e.match(/oklch\((.*?)%\s/);
          return t ? parseFloat(t[1]) : null;
        })(e) || 0) / 100
      );
    const { r: t, g: n, b: r } = Pt(e),
      o = n / 255,
      a = r / 255;
    return 0.2126 * Rt(t / 255) + 0.7152 * Rt(o) + 0.0722 * Rt(a);
  }
  function Lt(e) {
    let t =
      arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0.179;
    return !e.startsWith("var(") && _t(e) > t;
  }
  function zt(e) {
    let { color: t, theme: n, colorScheme: r } = e;
    if ("string" !== typeof t)
      throw new Error(
        "[@mantine/core] Failed to parse color. Expected color to be a string, instead got ".concat(
          typeof t
        )
      );
    if ("bright" === t)
      return {
        color: t,
        value: "dark" === r ? n.white : n.black,
        shade: void 0,
        isThemeColor: !1,
        isLight: Lt("dark" === r ? n.white : n.black, n.luminanceThreshold),
        variable: "--mantine-color-bright",
      };
    if ("dimmed" === t)
      return {
        color: t,
        value: "dark" === r ? n.colors.dark[2] : n.colors.gray[7],
        shade: void 0,
        isThemeColor: !1,
        isLight: Lt(
          "dark" === r ? n.colors.dark[2] : n.colors.gray[6],
          n.luminanceThreshold
        ),
        variable: "--mantine-color-dimmed",
      };
    if ("white" === t || "black" === t)
      return {
        color: t,
        value: "white" === t ? n.white : n.black,
        shade: void 0,
        isThemeColor: !1,
        isLight: Lt("white" === t ? n.white : n.black, n.luminanceThreshold),
        variable: "--mantine-color-".concat(t),
      };
    const [o, a] = t.split("."),
      i = a ? Number(a) : void 0,
      l = o in n.colors;
    if (l) {
      const e =
        void 0 !== i ? n.colors[o][i] : n.colors[o][jt(n, r || "light")];
      return {
        color: o,
        value: e,
        shade: i,
        isThemeColor: l,
        isLight: Lt(e, n.luminanceThreshold),
        variable: a
          ? "--mantine-color-".concat(o, "-").concat(i)
          : "--mantine-color-".concat(o, "-filled"),
      };
    }
    return {
      color: t,
      value: t,
      isThemeColor: l,
      isLight: Lt(t, n.luminanceThreshold),
      shade: i,
      variable: void 0,
    };
  }
  function At(e, t) {
    const n = zt({ color: e || t.primaryColor, theme: t });
    return n.variable ? "var(".concat(n.variable, ")") : e;
  }
  function It(e, t) {
    const n = {
        from:
          (null === e || void 0 === e ? void 0 : e.from) ||
          t.defaultGradient.from,
        to:
          (null === e || void 0 === e ? void 0 : e.to) || t.defaultGradient.to,
        deg:
          (null === e || void 0 === e ? void 0 : e.deg) ||
          t.defaultGradient.deg ||
          0,
      },
      r = At(n.from, t),
      o = At(n.to, t);
    return "linear-gradient("
      .concat(n.deg, "deg, ")
      .concat(r, " 0%, ")
      .concat(o, " 100%)");
  }
  function Mt(e, t) {
    if ("string" !== typeof e || t > 1 || t < 0) return "rgba(0, 0, 0, 1)";
    if (e.startsWith("var(")) {
      const n = 100 * (1 - t);
      return "color-mix(in srgb, ".concat(e, ", transparent ").concat(n, "%)");
    }
    if (e.startsWith("oklch"))
      return e.includes("/")
        ? e.replace(/\/\s*[\d.]+\s*\)/, "/ ".concat(t, ")"))
        : e.replace(")", " / ".concat(t, ")"));
    const { r: n, g: r, b: o } = Pt(e);
    return "rgba("
      .concat(n, ", ")
      .concat(r, ", ")
      .concat(o, ", ")
      .concat(t, ")");
  }
  const Ft = Mt,
    Dt =
      "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
    Ut = {
      scale: 1,
      fontSmoothing: !0,
      focusRing: "auto",
      white: "#fff",
      black: "#000",
      colors: {
        dark: [
          "#C9C9C9",
          "#b8b8b8",
          "#828282",
          "#696969",
          "#424242",
          "#3b3b3b",
          "#2e2e2e",
          "#242424",
          "#1f1f1f",
          "#141414",
        ],
        gray: [
          "#f8f9fa",
          "#f1f3f5",
          "#e9ecef",
          "#dee2e6",
          "#ced4da",
          "#adb5bd",
          "#868e96",
          "#495057",
          "#343a40",
          "#212529",
        ],
        red: [
          "#fff5f5",
          "#ffe3e3",
          "#ffc9c9",
          "#ffa8a8",
          "#ff8787",
          "#ff6b6b",
          "#fa5252",
          "#f03e3e",
          "#e03131",
          "#c92a2a",
        ],
        pink: [
          "#fff0f6",
          "#ffdeeb",
          "#fcc2d7",
          "#faa2c1",
          "#f783ac",
          "#f06595",
          "#e64980",
          "#d6336c",
          "#c2255c",
          "#a61e4d",
        ],
        grape: [
          "#f8f0fc",
          "#f3d9fa",
          "#eebefa",
          "#e599f7",
          "#da77f2",
          "#cc5de8",
          "#be4bdb",
          "#ae3ec9",
          "#9c36b5",
          "#862e9c",
        ],
        violet: [
          "#f3f0ff",
          "#e5dbff",
          "#d0bfff",
          "#b197fc",
          "#9775fa",
          "#845ef7",
          "#7950f2",
          "#7048e8",
          "#6741d9",
          "#5f3dc4",
        ],
        indigo: [
          "#edf2ff",
          "#dbe4ff",
          "#bac8ff",
          "#91a7ff",
          "#748ffc",
          "#5c7cfa",
          "#4c6ef5",
          "#4263eb",
          "#3b5bdb",
          "#364fc7",
        ],
        blue: [
          "#e7f5ff",
          "#d0ebff",
          "#a5d8ff",
          "#74c0fc",
          "#4dabf7",
          "#339af0",
          "#228be6",
          "#1c7ed6",
          "#1971c2",
          "#1864ab",
        ],
        cyan: [
          "#e3fafc",
          "#c5f6fa",
          "#99e9f2",
          "#66d9e8",
          "#3bc9db",
          "#22b8cf",
          "#15aabf",
          "#1098ad",
          "#0c8599",
          "#0b7285",
        ],
        teal: [
          "#e6fcf5",
          "#c3fae8",
          "#96f2d7",
          "#63e6be",
          "#38d9a9",
          "#20c997",
          "#12b886",
          "#0ca678",
          "#099268",
          "#087f5b",
        ],
        green: [
          "#ebfbee",
          "#d3f9d8",
          "#b2f2bb",
          "#8ce99a",
          "#69db7c",
          "#51cf66",
          "#40c057",
          "#37b24d",
          "#2f9e44",
          "#2b8a3e",
        ],
        lime: [
          "#f4fce3",
          "#e9fac8",
          "#d8f5a2",
          "#c0eb75",
          "#a9e34b",
          "#94d82d",
          "#82c91e",
          "#74b816",
          "#66a80f",
          "#5c940d",
        ],
        yellow: [
          "#fff9db",
          "#fff3bf",
          "#ffec99",
          "#ffe066",
          "#ffd43b",
          "#fcc419",
          "#fab005",
          "#f59f00",
          "#f08c00",
          "#e67700",
        ],
        orange: [
          "#fff4e6",
          "#ffe8cc",
          "#ffd8a8",
          "#ffc078",
          "#ffa94d",
          "#ff922b",
          "#fd7e14",
          "#f76707",
          "#e8590c",
          "#d9480f",
        ],
      },
      primaryShade: { light: 6, dark: 8 },
      primaryColor: "blue",
      variantColorResolver: (e) => {
        let {
          color: t,
          theme: n,
          variant: r,
          gradient: o,
          autoContrast: a,
        } = e;
        const i = zt({ color: t, theme: n }),
          l = "boolean" === typeof a ? a : n.autoContrast;
        if ("filled" === r) {
          const e =
            l && i.isLight
              ? "var(--mantine-color-black)"
              : "var(--mantine-color-white)";
          return i.isThemeColor
            ? void 0 === i.shade
              ? {
                  background: "var(--mantine-color-".concat(t, "-filled)"),
                  hover: "var(--mantine-color-".concat(t, "-filled-hover)"),
                  color: e,
                  border: "".concat(Nt(1), " solid transparent"),
                }
              : {
                  background: "var(--mantine-color-"
                    .concat(i.color, "-")
                    .concat(i.shade, ")"),
                  hover: "var(--mantine-color-"
                    .concat(i.color, "-")
                    .concat(9 === i.shade ? 8 : i.shade + 1, ")"),
                  color: e,
                  border: "".concat(Nt(1), " solid transparent"),
                }
            : {
                background: t,
                hover: Ot(t, 0.1),
                color: e,
                border: "".concat(Nt(1), " solid transparent"),
              };
        }
        if ("light" === r) {
          if (i.isThemeColor) {
            if (void 0 === i.shade)
              return {
                background: "var(--mantine-color-".concat(t, "-light)"),
                hover: "var(--mantine-color-".concat(t, "-light-hover)"),
                color: "var(--mantine-color-".concat(t, "-light-color)"),
                border: "".concat(Nt(1), " solid transparent"),
              };
            const e = n.colors[i.color][i.shade];
            return {
              background: Mt(e, 0.1),
              hover: Mt(e, 0.12),
              color: "var(--mantine-color-"
                .concat(i.color, "-")
                .concat(Math.min(i.shade, 6), ")"),
              border: "".concat(Nt(1), " solid transparent"),
            };
          }
          return {
            background: Mt(t, 0.1),
            hover: Mt(t, 0.12),
            color: t,
            border: "".concat(Nt(1), " solid transparent"),
          };
        }
        if ("outline" === r)
          return i.isThemeColor
            ? void 0 === i.shade
              ? {
                  background: "transparent",
                  hover: "var(--mantine-color-".concat(t, "-outline-hover)"),
                  color: "var(--mantine-color-".concat(t, "-outline)"),
                  border: ""
                    .concat(Nt(1), " solid var(--mantine-color-")
                    .concat(t, "-outline)"),
                }
              : {
                  background: "transparent",
                  hover: Mt(n.colors[i.color][i.shade], 0.05),
                  color: "var(--mantine-color-"
                    .concat(i.color, "-")
                    .concat(i.shade, ")"),
                  border: ""
                    .concat(Nt(1), " solid var(--mantine-color-")
                    .concat(i.color, "-")
                    .concat(i.shade, ")"),
                }
            : {
                background: "transparent",
                hover: Mt(t, 0.05),
                color: t,
                border: "".concat(Nt(1), " solid ").concat(t),
              };
        if ("subtle" === r) {
          if (i.isThemeColor) {
            if (void 0 === i.shade)
              return {
                background: "transparent",
                hover: "var(--mantine-color-".concat(t, "-light-hover)"),
                color: "var(--mantine-color-".concat(t, "-light-color)"),
                border: "".concat(Nt(1), " solid transparent"),
              };
            return {
              background: "transparent",
              hover: Mt(n.colors[i.color][i.shade], 0.12),
              color: "var(--mantine-color-"
                .concat(i.color, "-")
                .concat(Math.min(i.shade, 6), ")"),
              border: "".concat(Nt(1), " solid transparent"),
            };
          }
          return {
            background: "transparent",
            hover: Mt(t, 0.12),
            color: t,
            border: "".concat(Nt(1), " solid transparent"),
          };
        }
        return "transparent" === r
          ? i.isThemeColor
            ? void 0 === i.shade
              ? {
                  background: "transparent",
                  hover: "transparent",
                  color: "var(--mantine-color-".concat(t, "-light-color)"),
                  border: "".concat(Nt(1), " solid transparent"),
                }
              : {
                  background: "transparent",
                  hover: "transparent",
                  color: "var(--mantine-color-"
                    .concat(i.color, "-")
                    .concat(Math.min(i.shade, 6), ")"),
                  border: "".concat(Nt(1), " solid transparent"),
                }
            : {
                background: "transparent",
                hover: "transparent",
                color: t,
                border: "".concat(Nt(1), " solid transparent"),
              }
          : "white" === r
          ? i.isThemeColor
            ? void 0 === i.shade
              ? {
                  background: "var(--mantine-color-white)",
                  hover: Ot(n.white, 0.01),
                  color: "var(--mantine-color-".concat(t, "-filled)"),
                  border: "".concat(Nt(1), " solid transparent"),
                }
              : {
                  background: "var(--mantine-color-white)",
                  hover: Ot(n.white, 0.01),
                  color: "var(--mantine-color-"
                    .concat(i.color, "-")
                    .concat(i.shade, ")"),
                  border: "".concat(Nt(1), " solid transparent"),
                }
            : {
                background: "var(--mantine-color-white)",
                hover: Ot(n.white, 0.01),
                color: t,
                border: "".concat(Nt(1), " solid transparent"),
              }
          : "gradient" === r
          ? {
              background: It(o, n),
              hover: It(o, n),
              color: "var(--mantine-color-white)",
              border: "none",
            }
          : "default" === r
          ? {
              background: "var(--mantine-color-default)",
              hover: "var(--mantine-color-default-hover)",
              color: "var(--mantine-color-default-color)",
              border: "".concat(
                Nt(1),
                " solid var(--mantine-color-default-border)"
              ),
            }
          : {};
      },
      autoContrast: !1,
      luminanceThreshold: 0.3,
      fontFamily: Dt,
      fontFamilyMonospace:
        "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
      respectReducedMotion: !1,
      cursorType: "default",
      defaultGradient: { from: "blue", to: "cyan", deg: 45 },
      defaultRadius: "sm",
      activeClassName: "mantine-active",
      focusClassName: "",
      headings: {
        fontFamily: Dt,
        fontWeight: "700",
        textWrap: "wrap",
        sizes: {
          h1: { fontSize: Nt(34), lineHeight: "1.3" },
          h2: { fontSize: Nt(26), lineHeight: "1.35" },
          h3: { fontSize: Nt(22), lineHeight: "1.4" },
          h4: { fontSize: Nt(18), lineHeight: "1.45" },
          h5: { fontSize: Nt(16), lineHeight: "1.5" },
          h6: { fontSize: Nt(14), lineHeight: "1.5" },
        },
      },
      fontSizes: { xs: Nt(12), sm: Nt(14), md: Nt(16), lg: Nt(18), xl: Nt(20) },
      lineHeights: { xs: "1.4", sm: "1.45", md: "1.55", lg: "1.6", xl: "1.65" },
      radius: { xs: Nt(2), sm: Nt(4), md: Nt(8), lg: Nt(16), xl: Nt(32) },
      spacing: { xs: Nt(10), sm: Nt(12), md: Nt(16), lg: Nt(20), xl: Nt(32) },
      breakpoints: {
        xs: "36em",
        sm: "48em",
        md: "62em",
        lg: "75em",
        xl: "88em",
      },
      shadows: {
        xs: "0 "
          .concat(Nt(1), " ")
          .concat(Nt(3), " rgba(0, 0, 0, 0.05), 0 ")
          .concat(Nt(1), " ")
          .concat(Nt(2), " rgba(0, 0, 0, 0.1)"),
        sm: "0 "
          .concat(Nt(1), " ")
          .concat(Nt(3), " rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ")
          .concat(Nt(10), " ")
          .concat(Nt(15), " ")
          .concat(Nt(-5), ", rgba(0, 0, 0, 0.04) 0 ")
          .concat(Nt(7), " ")
          .concat(Nt(7), " ")
          .concat(Nt(-5)),
        md: "0 "
          .concat(Nt(1), " ")
          .concat(Nt(3), " rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ")
          .concat(Nt(20), " ")
          .concat(Nt(25), " ")
          .concat(Nt(-5), ", rgba(0, 0, 0, 0.04) 0 ")
          .concat(Nt(10), " ")
          .concat(Nt(10), " ")
          .concat(Nt(-5)),
        lg: "0 "
          .concat(Nt(1), " ")
          .concat(Nt(3), " rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ")
          .concat(Nt(28), " ")
          .concat(Nt(23), " ")
          .concat(Nt(-7), ", rgba(0, 0, 0, 0.04) 0 ")
          .concat(Nt(12), " ")
          .concat(Nt(12), " ")
          .concat(Nt(-7)),
        xl: "0 "
          .concat(Nt(1), " ")
          .concat(Nt(3), " rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ")
          .concat(Nt(36), " ")
          .concat(Nt(28), " ")
          .concat(Nt(-7), ", rgba(0, 0, 0, 0.04) 0 ")
          .concat(Nt(17), " ")
          .concat(Nt(17), " ")
          .concat(Nt(-7)),
      },
      other: {},
      components: {},
    };
  function Wt(e) {
    return e && "object" === typeof e && !Array.isArray(e);
  }
  function Ht(e, t) {
    const n = d({}, e),
      r = t;
    return (
      Wt(e) &&
        Wt(t) &&
        Object.keys(t).forEach((t) => {
          Wt(r[t]) ? (n[t] = t in e ? Ht(n[t], r[t]) : r[t]) : (n[t] = r[t]);
        }),
      n
    );
  }
  const Bt =
    "[@mantine/core] MantineProvider: Invalid theme.primaryShade, it accepts only 0-9 integers or an object { light: 0-9, dark: 0-9 }";
  function Vt(e) {
    return !(e < 0 || e > 9) && parseInt(e.toString(), 10) === e;
  }
  function $t(e) {
    if (!(e.primaryColor in e.colors))
      throw new Error(
        "[@mantine/core] MantineProvider: Invalid theme.primaryColor, it accepts only key of theme.colors, learn more \u2013 https://mantine.dev/theming/colors/#primary-color"
      );
    if (
      "object" === typeof e.primaryShade &&
      (!Vt(e.primaryShade.dark) || !Vt(e.primaryShade.light))
    )
      throw new Error(Bt);
    if ("number" === typeof e.primaryShade && !Vt(e.primaryShade))
      throw new Error(Bt);
  }
  const qt = (0, r.createContext)(null);
  function Yt() {
    const e = (0, r.useContext)(qt);
    if (!e)
      throw new Error(
        "@mantine/core: MantineProvider was not found in component tree, make sure you have it in your app"
      );
    return e;
  }
  function Qt(e) {
    let { theme: t, children: n, inherit: o = !0 } = e;
    const a = (0, r.useContext)(qt) || Ut,
      i = (0, r.useMemo)(
        () =>
          (function (e, t) {
            var n;
            if (!t) return $t(e), e;
            const r = Ht(e, t);
            return (
              !t.fontFamily ||
                (null !== (n = t.headings) && void 0 !== n && n.fontFamily) ||
                (r.headings.fontFamily = t.fontFamily),
              $t(r),
              r
            );
          })(o ? a : Ut, t),
        [t, a, o]
      );
    return (0, mt.jsx)(qt.Provider, { value: i, children: n });
  }
  function Kt() {
    const e = Yt(),
      t = kt(),
      n = xt(e.breakpoints).reduce((t, n) => {
        const r = e.breakpoints[n].includes("px"),
          o = (function (e) {
            const t = (function (e) {
              var t;
              return "string" === typeof e && e.includes("var(--mantine-scale)")
                ? null === (t = e.match(/^calc\((.*?)\)$/)) || void 0 === t
                  ? void 0
                  : t[1].split("*")[0].trim()
                : e;
            })(e);
            return "number" === typeof t
              ? t
              : "string" === typeof t
              ? t.includes("calc") || t.includes("var")
                ? t
                : t.includes("px")
                ? Number(t.replace("px", ""))
                : t.includes("rem")
                ? 16 * Number(t.replace("rem", ""))
                : t.includes("em")
                ? 16 * Number(t.replace("em", ""))
                : Number(t)
              : NaN;
          })(e.breakpoints[n]),
          a = r ? "".concat(o - 0.1, "px") : Tt(o - 0.1),
          i = r ? "".concat(o, "px") : Tt(o);
        return ""
          .concat(t, "@media (max-width: ")
          .concat(a, ") {.mantine-visible-from-")
          .concat(n, " {display: none !important;}}@media (min-width: ")
          .concat(i, ") {.mantine-hidden-from-")
          .concat(n, " {display: none !important;}}");
      }, "");
    return (0, mt.jsx)("style", {
      "data-mantine-styles": "classes",
      nonce: null === t || void 0 === t ? void 0 : t(),
      dangerouslySetInnerHTML: { __html: n },
    });
  }
  function Gt(e) {
    return Object.entries(e)
      .map((e) => {
        let [t, n] = e;
        return "".concat(t, ": ").concat(n, ";");
      })
      .join("");
  }
  function Xt(e, t) {
    return (Array.isArray(e) ? e : [e]).reduce(
      (e, t) => "".concat(t, "{").concat(e, "}"),
      t
    );
  }
  function Jt(e, t) {
    return (function (e) {
      let { color: t, theme: n, autoContrast: r } = e;
      return ("boolean" === typeof r ? r : n.autoContrast) &&
        zt({ color: t || n.primaryColor, theme: n }).isLight
        ? "var(--mantine-color-black)"
        : "var(--mantine-color-white)";
    })({
      color: e.colors[e.primaryColor][jt(e, t)],
      theme: e,
      autoContrast: null,
    });
  }
  function Zt(e) {
    let {
      theme: t,
      color: n,
      colorScheme: r,
      name: o = n,
      withColorValues: a = !0,
    } = e;
    if (!t.colors[n]) return {};
    if ("light" === r) {
      const e = jt(t, "light"),
        r = {
          ["--mantine-color-".concat(o, "-text")]:
            "var(--mantine-color-".concat(o, "-filled)"),
          ["--mantine-color-".concat(o, "-filled")]: "var(--mantine-color-"
            .concat(o, "-")
            .concat(e, ")"),
          ["--mantine-color-".concat(o, "-filled-hover")]:
            "var(--mantine-color-"
              .concat(o, "-")
              .concat(9 === e ? 8 : e + 1, ")"),
          ["--mantine-color-".concat(o, "-light")]: Ft(t.colors[n][e], 0.1),
          ["--mantine-color-".concat(o, "-light-hover")]: Ft(
            t.colors[n][e],
            0.12
          ),
          ["--mantine-color-".concat(o, "-light-color")]: "var(--mantine-color-"
            .concat(o, "-")
            .concat(e, ")"),
          ["--mantine-color-".concat(o, "-outline")]: "var(--mantine-color-"
            .concat(o, "-")
            .concat(e, ")"),
          ["--mantine-color-".concat(o, "-outline-hover")]: Ft(
            t.colors[n][e],
            0.05
          ),
        };
      return a
        ? d(
            {
              ["--mantine-color-".concat(o, "-0")]: t.colors[n][0],
              ["--mantine-color-".concat(o, "-1")]: t.colors[n][1],
              ["--mantine-color-".concat(o, "-2")]: t.colors[n][2],
              ["--mantine-color-".concat(o, "-3")]: t.colors[n][3],
              ["--mantine-color-".concat(o, "-4")]: t.colors[n][4],
              ["--mantine-color-".concat(o, "-5")]: t.colors[n][5],
              ["--mantine-color-".concat(o, "-6")]: t.colors[n][6],
              ["--mantine-color-".concat(o, "-7")]: t.colors[n][7],
              ["--mantine-color-".concat(o, "-8")]: t.colors[n][8],
              ["--mantine-color-".concat(o, "-9")]: t.colors[n][9],
            },
            r
          )
        : r;
    }
    const i = jt(t, "dark"),
      l = {
        ["--mantine-color-".concat(o, "-text")]: "var(--mantine-color-".concat(
          o,
          "-4)"
        ),
        ["--mantine-color-".concat(o, "-filled")]: "var(--mantine-color-"
          .concat(o, "-")
          .concat(i, ")"),
        ["--mantine-color-".concat(o, "-filled-hover")]: "var(--mantine-color-"
          .concat(o, "-")
          .concat(9 === i ? 8 : i + 1, ")"),
        ["--mantine-color-".concat(o, "-light")]: Ft(
          t.colors[n][Math.max(0, i - 2)],
          0.15
        ),
        ["--mantine-color-".concat(o, "-light-hover")]: Ft(
          t.colors[n][Math.max(0, i - 2)],
          0.2
        ),
        ["--mantine-color-".concat(o, "-light-color")]: "var(--mantine-color-"
          .concat(o, "-")
          .concat(Math.max(i - 5, 0), ")"),
        ["--mantine-color-".concat(o, "-outline")]: "var(--mantine-color-"
          .concat(o, "-")
          .concat(Math.max(i - 4, 0), ")"),
        ["--mantine-color-".concat(o, "-outline-hover")]: Ft(
          t.colors[n][Math.max(i - 4, 0)],
          0.05
        ),
      };
    return a
      ? d(
          {
            ["--mantine-color-".concat(o, "-0")]: t.colors[n][0],
            ["--mantine-color-".concat(o, "-1")]: t.colors[n][1],
            ["--mantine-color-".concat(o, "-2")]: t.colors[n][2],
            ["--mantine-color-".concat(o, "-3")]: t.colors[n][3],
            ["--mantine-color-".concat(o, "-4")]: t.colors[n][4],
            ["--mantine-color-".concat(o, "-5")]: t.colors[n][5],
            ["--mantine-color-".concat(o, "-6")]: t.colors[n][6],
            ["--mantine-color-".concat(o, "-7")]: t.colors[n][7],
            ["--mantine-color-".concat(o, "-8")]: t.colors[n][8],
            ["--mantine-color-".concat(o, "-9")]: t.colors[n][9],
          },
          l
        )
      : l;
  }
  function en(e, t, n) {
    xt(t).forEach((r) =>
      Object.assign(e, { ["--mantine-".concat(n, "-").concat(r)]: t[r] })
    );
  }
  Qt.displayName = "@mantine/core/MantineThemeProvider";
  const tn = (e) => {
    const t = jt(e, "light"),
      n =
        e.defaultRadius in e.radius
          ? e.radius[e.defaultRadius]
          : Nt(e.defaultRadius),
      r = {
        variables: {
          "--mantine-scale": e.scale.toString(),
          "--mantine-cursor-type": e.cursorType,
          "--mantine-color-scheme": "light dark",
          "--mantine-webkit-font-smoothing": e.fontSmoothing
            ? "antialiased"
            : "unset",
          "--mantine-moz-font-smoothing": e.fontSmoothing
            ? "grayscale"
            : "unset",
          "--mantine-color-white": e.white,
          "--mantine-color-black": e.black,
          "--mantine-line-height": e.lineHeights.md,
          "--mantine-font-family": e.fontFamily,
          "--mantine-font-family-monospace": e.fontFamilyMonospace,
          "--mantine-font-family-headings": e.headings.fontFamily,
          "--mantine-heading-font-weight": e.headings.fontWeight,
          "--mantine-heading-text-wrap": e.headings.textWrap,
          "--mantine-radius-default": n,
          "--mantine-primary-color-filled": "var(--mantine-color-".concat(
            e.primaryColor,
            "-filled)"
          ),
          "--mantine-primary-color-filled-hover": "var(--mantine-color-".concat(
            e.primaryColor,
            "-filled-hover)"
          ),
          "--mantine-primary-color-light": "var(--mantine-color-".concat(
            e.primaryColor,
            "-light)"
          ),
          "--mantine-primary-color-light-hover": "var(--mantine-color-".concat(
            e.primaryColor,
            "-light-hover)"
          ),
          "--mantine-primary-color-light-color": "var(--mantine-color-".concat(
            e.primaryColor,
            "-light-color)"
          ),
        },
        light: {
          "--mantine-primary-color-contrast": Jt(e, "light"),
          "--mantine-color-bright": "var(--mantine-color-black)",
          "--mantine-color-text": e.black,
          "--mantine-color-body": e.white,
          "--mantine-color-error": "var(--mantine-color-red-6)",
          "--mantine-color-placeholder": "var(--mantine-color-gray-5)",
          "--mantine-color-anchor": "var(--mantine-color-"
            .concat(e.primaryColor, "-")
            .concat(t, ")"),
          "--mantine-color-default": "var(--mantine-color-white)",
          "--mantine-color-default-hover": "var(--mantine-color-gray-0)",
          "--mantine-color-default-color": "var(--mantine-color-black)",
          "--mantine-color-default-border": "var(--mantine-color-gray-4)",
          "--mantine-color-dimmed": "var(--mantine-color-gray-6)",
        },
        dark: {
          "--mantine-primary-color-contrast": Jt(e, "dark"),
          "--mantine-color-bright": "var(--mantine-color-white)",
          "--mantine-color-text": "var(--mantine-color-dark-0)",
          "--mantine-color-body": "var(--mantine-color-dark-7)",
          "--mantine-color-error": "var(--mantine-color-red-8)",
          "--mantine-color-placeholder": "var(--mantine-color-dark-3)",
          "--mantine-color-anchor": "var(--mantine-color-".concat(
            e.primaryColor,
            "-4)"
          ),
          "--mantine-color-default": "var(--mantine-color-dark-6)",
          "--mantine-color-default-hover": "var(--mantine-color-dark-5)",
          "--mantine-color-default-color": "var(--mantine-color-white)",
          "--mantine-color-default-border": "var(--mantine-color-dark-4)",
          "--mantine-color-dimmed": "var(--mantine-color-dark-2)",
        },
      };
    en(r.variables, e.breakpoints, "breakpoint"),
      en(r.variables, e.spacing, "spacing"),
      en(r.variables, e.fontSizes, "font-size"),
      en(r.variables, e.lineHeights, "line-height"),
      en(r.variables, e.shadows, "shadow"),
      en(r.variables, e.radius, "radius"),
      e.colors[e.primaryColor].forEach((t, n) => {
        r.variables["--mantine-primary-color-".concat(n)] =
          "var(--mantine-color-".concat(e.primaryColor, "-").concat(n, ")");
      }),
      xt(e.colors).forEach((t) => {
        const n = e.colors[t];
        if (
          (function (e) {
            return !!e && "object" === typeof e && "mantine-virtual-color" in e;
          })(n)
        )
          return (
            Object.assign(
              r.light,
              Zt({
                theme: e,
                name: n.name,
                color: n.light,
                colorScheme: "light",
                withColorValues: !0,
              })
            ),
            void Object.assign(
              r.dark,
              Zt({
                theme: e,
                name: n.name,
                color: n.dark,
                colorScheme: "dark",
                withColorValues: !0,
              })
            )
          );
        n.forEach((e, n) => {
          r.variables["--mantine-color-".concat(t, "-").concat(n)] = e;
        }),
          Object.assign(
            r.light,
            Zt({
              theme: e,
              color: t,
              colorScheme: "light",
              withColorValues: !1,
            })
          ),
          Object.assign(
            r.dark,
            Zt({ theme: e, color: t, colorScheme: "dark", withColorValues: !1 })
          );
      });
    const o = e.headings.sizes;
    return (
      xt(o).forEach((t) => {
        (r.variables["--mantine-".concat(t, "-font-size")] = o[t].fontSize),
          (r.variables["--mantine-".concat(t, "-line-height")] =
            o[t].lineHeight),
          (r.variables["--mantine-".concat(t, "-font-weight")] =
            o[t].fontWeight || e.headings.fontWeight);
      }),
      r
    );
  };
  const nn = tn(Ut);
  function rn(e) {
    let { cssVariablesSelector: t, deduplicateCssVariables: n } = e;
    const r = Yt(),
      o = kt(),
      a = (function (e) {
        let { theme: t, generator: n } = e;
        const r = tn(t),
          o = null === n || void 0 === n ? void 0 : n(t);
        return o ? Ht(r, o) : r;
      })({ theme: r, generator: St().cssVariablesResolver }),
      i = ":root" === t && n,
      l = (function (e, t) {
        const n = Gt(e.variables),
          r = n ? Xt(t, n) : "",
          o = Gt(e.dark),
          a = Gt(e.light),
          i = o
            ? Xt(
                "".concat(
                  t,
                  ":host" === t
                    ? '([data-mantine-color-scheme="dark"])'
                    : '[data-mantine-color-scheme="dark"]'
                ),
                o
              )
            : "",
          l = a
            ? Xt(
                "".concat(
                  t,
                  ":host" === t
                    ? '([data-mantine-color-scheme="light"])'
                    : '[data-mantine-color-scheme="light"]'
                ),
                a
              )
            : "";
        return "".concat(r).concat(i).concat(l);
      })(
        i
          ? (function (e) {
              const t = { variables: {}, light: {}, dark: {} };
              return (
                xt(e.variables).forEach((n) => {
                  nn.variables[n] !== e.variables[n] &&
                    (t.variables[n] = e.variables[n]);
                }),
                xt(e.light).forEach((n) => {
                  nn.light[n] !== e.light[n] && (t.light[n] = e.light[n]);
                }),
                xt(e.dark).forEach((n) => {
                  nn.dark[n] !== e.dark[n] && (t.dark[n] = e.dark[n]);
                }),
                t
              );
            })(a)
          : a,
        t
      );
    return l
      ? (0, mt.jsx)("style", {
          "data-mantine-styles": !0,
          nonce: null === o || void 0 === o ? void 0 : o(),
          dangerouslySetInnerHTML: {
            __html: ""
              .concat(l)
              .concat(
                i
                  ? ""
                  : ((s = t),
                    "\n  "
                      .concat(
                        s,
                        '[data-mantine-color-scheme="dark"] { --mantine-color-scheme: dark; }\n  '
                      )
                      .concat(
                        s,
                        '[data-mantine-color-scheme="light"] { --mantine-color-scheme: light; }\n'
                      ))
              ),
          },
        })
      : null;
    var s;
  }
  rn.displayName = "@mantine/CssVariables";
  const on = "undefined" !== typeof document ? r.useLayoutEffect : r.useEffect;
  function an(e, t) {
    var n;
    const r =
        "undefined" !== typeof window &&
        "matchMedia" in window &&
        window.matchMedia("(prefers-color-scheme: dark)").matches,
      o = "auto" !== e ? e : r ? "dark" : "light";
    null === (n = t()) ||
      void 0 === n ||
      n.setAttribute("data-mantine-color-scheme", o);
  }
  function ln(e) {
    let {
      theme: t,
      children: n,
      getStyleNonce: o,
      withStaticClasses: a = !0,
      withGlobalClasses: i = !0,
      deduplicateCssVariables: l = !0,
      withCssVariables: s = !0,
      cssVariablesSelector: c = ":root",
      classNamesPrefix: u = "mantine",
      colorSchemeManager: d = bt(),
      defaultColorScheme: f = "light",
      getRootElement: p = () => document.documentElement,
      cssVariablesResolver: h,
      forceColorScheme: m,
      stylesTransform: y,
    } = e;
    const {
      colorScheme: v,
      setColorScheme: g,
      clearColorScheme: b,
    } = (function (e) {
      let {
        manager: t,
        defaultColorScheme: n,
        getRootElement: o,
        forceColorScheme: a,
      } = e;
      const i = (0, r.useRef)(null),
        [l, s] = (0, r.useState)(() => t.get(n)),
        c = a || l,
        u = (0, r.useCallback)(
          (e) => {
            a || (an(e, o), s(e), t.set(e));
          },
          [t.set, c, a]
        ),
        d = (0, r.useCallback)(() => {
          s(n), an(n, o), t.clear();
        }, [t.clear, n]);
      return (
        (0, r.useEffect)(
          () => (t.subscribe(u), t.unsubscribe),
          [t.subscribe, t.unsubscribe]
        ),
        on(() => {
          an(t.get(n), o);
        }, []),
        (0, r.useEffect)(() => {
          var e;
          if (a) return an(a, o), () => {};
          void 0 === a && an(l, o),
            "undefined" !== typeof window &&
              "matchMedia" in window &&
              (i.current = window.matchMedia("(prefers-color-scheme: dark)"));
          const t = (e) => {
            "auto" === l && an(e.matches ? "dark" : "light", o);
          };
          return (
            null === (e = i.current) ||
              void 0 === e ||
              e.addEventListener("change", t),
            () => {
              var e;
              return null === (e = i.current) || void 0 === e
                ? void 0
                : e.removeEventListener("change", t);
            }
          );
        }, [l, a]),
        { colorScheme: c, setColorScheme: u, clearColorScheme: d }
      );
    })({
      defaultColorScheme: f,
      forceColorScheme: m,
      manager: d,
      getRootElement: p,
    });
    return (
      (function (e) {
        let { respectReducedMotion: t, getRootElement: n } = e;
        on(() => {
          var e;
          t &&
            (null === (e = n()) ||
              void 0 === e ||
              e.setAttribute("data-respect-reduced-motion", "true"));
        }, [t]);
      })({
        respectReducedMotion:
          (null === t || void 0 === t ? void 0 : t.respectReducedMotion) || !1,
        getRootElement: p,
      }),
      (0, mt.jsx)(wt.Provider, {
        value: {
          colorScheme: v,
          setColorScheme: g,
          clearColorScheme: b,
          getRootElement: p,
          classNamesPrefix: u,
          getStyleNonce: o,
          cssVariablesResolver: h,
          cssVariablesSelector: c,
          withStaticClasses: a,
          stylesTransform: y,
        },
        children: (0, mt.jsxs)(Qt, {
          theme: t,
          children: [
            s &&
              (0, mt.jsx)(rn, {
                cssVariablesSelector: c,
                deduplicateCssVariables: l,
              }),
            i && (0, mt.jsx)(Kt, {}),
            n,
          ],
        }),
      })
    );
  }
  function sn(e, t) {
    return (
      (sn = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function (e, t) {
            return (e.__proto__ = t), e;
          }),
      sn(e, t)
    );
  }
  function cn(e, t) {
    (e.prototype = Object.create(t.prototype)),
      (e.prototype.constructor = e),
      sn(e, t);
  }
  !(function () {
    const e = console.error;
    console.error = function () {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      (n.length > 1 &&
        "string" === typeof n[0] &&
        n[0].toLowerCase().includes("extra attributes from the server") &&
        "string" === typeof n[1] &&
        n[1].toLowerCase().includes("data-mantine-color-scheme")) ||
        e(...n);
    };
  })(),
    (ln.displayName = "@mantine/core/MantineProvider");
  var un = n(950);
  const dn = !1,
    fn = r.createContext(null);
  var pn = "unmounted",
    hn = "exited",
    mn = "entering",
    yn = "entered",
    vn = "exiting",
    gn = (function (e) {
      function t(t, n) {
        var r;
        r = e.call(this, t, n) || this;
        var o,
          a = n && !n.isMounting ? t.enter : t.appear;
        return (
          (r.appearStatus = null),
          t.in
            ? a
              ? ((o = hn), (r.appearStatus = mn))
              : (o = yn)
            : (o = t.unmountOnExit || t.mountOnEnter ? pn : hn),
          (r.state = { status: o }),
          (r.nextCallback = null),
          r
        );
      }
      cn(t, e),
        (t.getDerivedStateFromProps = function (e, t) {
          return e.in && t.status === pn ? { status: hn } : null;
        });
      var n = t.prototype;
      return (
        (n.componentDidMount = function () {
          this.updateStatus(!0, this.appearStatus);
        }),
        (n.componentDidUpdate = function (e) {
          var t = null;
          if (e !== this.props) {
            var n = this.state.status;
            this.props.in
              ? n !== mn && n !== yn && (t = mn)
              : (n !== mn && n !== yn) || (t = vn);
          }
          this.updateStatus(!1, t);
        }),
        (n.componentWillUnmount = function () {
          this.cancelNextCallback();
        }),
        (n.getTimeouts = function () {
          var e,
            t,
            n,
            r = this.props.timeout;
          return (
            (e = t = n = r),
            null != r &&
              "number" !== typeof r &&
              ((e = r.exit),
              (t = r.enter),
              (n = void 0 !== r.appear ? r.appear : t)),
            { exit: e, enter: t, appear: n }
          );
        }),
        (n.updateStatus = function (e, t) {
          if ((void 0 === e && (e = !1), null !== t))
            if ((this.cancelNextCallback(), t === mn)) {
              if (this.props.unmountOnExit || this.props.mountOnEnter) {
                var n = this.props.nodeRef
                  ? this.props.nodeRef.current
                  : un.findDOMNode(this);
                n &&
                  (function (e) {
                    e.scrollTop;
                  })(n);
              }
              this.performEnter(e);
            } else this.performExit();
          else
            this.props.unmountOnExit &&
              this.state.status === hn &&
              this.setState({ status: pn });
        }),
        (n.performEnter = function (e) {
          var t = this,
            n = this.props.enter,
            r = this.context ? this.context.isMounting : e,
            o = this.props.nodeRef ? [r] : [un.findDOMNode(this), r],
            a = o[0],
            i = o[1],
            l = this.getTimeouts(),
            s = r ? l.appear : l.enter;
          (!e && !n) || dn
            ? this.safeSetState({ status: yn }, function () {
                t.props.onEntered(a);
              })
            : (this.props.onEnter(a, i),
              this.safeSetState({ status: mn }, function () {
                t.props.onEntering(a, i),
                  t.onTransitionEnd(s, function () {
                    t.safeSetState({ status: yn }, function () {
                      t.props.onEntered(a, i);
                    });
                  });
              }));
        }),
        (n.performExit = function () {
          var e = this,
            t = this.props.exit,
            n = this.getTimeouts(),
            r = this.props.nodeRef ? void 0 : un.findDOMNode(this);
          t && !dn
            ? (this.props.onExit(r),
              this.safeSetState({ status: vn }, function () {
                e.props.onExiting(r),
                  e.onTransitionEnd(n.exit, function () {
                    e.safeSetState({ status: hn }, function () {
                      e.props.onExited(r);
                    });
                  });
              }))
            : this.safeSetState({ status: hn }, function () {
                e.props.onExited(r);
              });
        }),
        (n.cancelNextCallback = function () {
          null !== this.nextCallback &&
            (this.nextCallback.cancel(), (this.nextCallback = null));
        }),
        (n.safeSetState = function (e, t) {
          (t = this.setNextCallback(t)), this.setState(e, t);
        }),
        (n.setNextCallback = function (e) {
          var t = this,
            n = !0;
          return (
            (this.nextCallback = function (r) {
              n && ((n = !1), (t.nextCallback = null), e(r));
            }),
            (this.nextCallback.cancel = function () {
              n = !1;
            }),
            this.nextCallback
          );
        }),
        (n.onTransitionEnd = function (e, t) {
          this.setNextCallback(t);
          var n = this.props.nodeRef
              ? this.props.nodeRef.current
              : un.findDOMNode(this),
            r = null == e && !this.props.addEndListener;
          if (n && !r) {
            if (this.props.addEndListener) {
              var o = this.props.nodeRef
                  ? [this.nextCallback]
                  : [n, this.nextCallback],
                a = o[0],
                i = o[1];
              this.props.addEndListener(a, i);
            }
            null != e && setTimeout(this.nextCallback, e);
          } else setTimeout(this.nextCallback, 0);
        }),
        (n.render = function () {
          var e = this.state.status;
          if (e === pn) return null;
          var t = this.props,
            n = t.children,
            o =
              (t.in,
              t.mountOnEnter,
              t.unmountOnExit,
              t.appear,
              t.enter,
              t.exit,
              t.timeout,
              t.addEndListener,
              t.onEnter,
              t.onEntering,
              t.onEntered,
              t.onExit,
              t.onExiting,
              t.onExited,
              t.nodeRef,
              a(t, [
                "children",
                "in",
                "mountOnEnter",
                "unmountOnExit",
                "appear",
                "enter",
                "exit",
                "timeout",
                "addEndListener",
                "onEnter",
                "onEntering",
                "onEntered",
                "onExit",
                "onExiting",
                "onExited",
                "nodeRef",
              ]));
          return r.createElement(
            fn.Provider,
            { value: null },
            "function" === typeof n
              ? n(e, o)
              : r.cloneElement(r.Children.only(n), o)
          );
        }),
        t
      );
    })(r.Component);
  function bn() {}
  (gn.contextType = fn),
    (gn.propTypes = {}),
    (gn.defaultProps = {
      in: !1,
      mountOnEnter: !1,
      unmountOnExit: !1,
      appear: !1,
      enter: !0,
      exit: !0,
      onEnter: bn,
      onEntering: bn,
      onEntered: bn,
      onExit: bn,
      onExiting: bn,
      onExited: bn,
    }),
    (gn.UNMOUNTED = pn),
    (gn.EXITED = hn),
    (gn.ENTERING = mn),
    (gn.ENTERED = yn),
    (gn.EXITING = vn);
  const wn = gn;
  function Sn() {
    return (
      (Sn = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      Sn.apply(null, arguments)
    );
  }
  function kn(e, t) {
    var n = Object.create(null);
    return (
      e &&
        r.Children.map(e, function (e) {
          return e;
        }).forEach(function (e) {
          n[e.key] = (function (e) {
            return t && (0, r.isValidElement)(e) ? t(e) : e;
          })(e);
        }),
      n
    );
  }
  function xn(e, t, n) {
    return null != n[t] ? n[t] : e.props[t];
  }
  function En(e, t, n) {
    var o = kn(e.children),
      a = (function (e, t) {
        function n(n) {
          return n in t ? t[n] : e[n];
        }
        (e = e || {}), (t = t || {});
        var r,
          o = Object.create(null),
          a = [];
        for (var i in e)
          i in t ? a.length && ((o[i] = a), (a = [])) : a.push(i);
        var l = {};
        for (var s in t) {
          if (o[s])
            for (r = 0; r < o[s].length; r++) {
              var c = o[s][r];
              l[o[s][r]] = n(c);
            }
          l[s] = n(s);
        }
        for (r = 0; r < a.length; r++) l[a[r]] = n(a[r]);
        return l;
      })(t, o);
    return (
      Object.keys(a).forEach(function (i) {
        var l = a[i];
        if ((0, r.isValidElement)(l)) {
          var s = i in t,
            c = i in o,
            u = t[i],
            d = (0, r.isValidElement)(u) && !u.props.in;
          !c || (s && !d)
            ? c || !s || d
              ? c &&
                s &&
                (0, r.isValidElement)(u) &&
                (a[i] = (0, r.cloneElement)(l, {
                  onExited: n.bind(null, l),
                  in: u.props.in,
                  exit: xn(l, "exit", e),
                  enter: xn(l, "enter", e),
                }))
              : (a[i] = (0, r.cloneElement)(l, { in: !1 }))
            : (a[i] = (0, r.cloneElement)(l, {
                onExited: n.bind(null, l),
                in: !0,
                exit: xn(l, "exit", e),
                enter: xn(l, "enter", e),
              }));
        }
      }),
      a
    );
  }
  var Cn =
      Object.values ||
      function (e) {
        return Object.keys(e).map(function (t) {
          return e[t];
        });
      },
    Nn = (function (e) {
      function t(t, n) {
        var r,
          o = (r = e.call(this, t, n) || this).handleExited.bind(
            (function (e) {
              if (void 0 === e)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called"
                );
              return e;
            })(r)
          );
        return (
          (r.state = {
            contextValue: { isMounting: !0 },
            handleExited: o,
            firstRender: !0,
          }),
          r
        );
      }
      cn(t, e);
      var n = t.prototype;
      return (
        (n.componentDidMount = function () {
          (this.mounted = !0),
            this.setState({ contextValue: { isMounting: !1 } });
        }),
        (n.componentWillUnmount = function () {
          this.mounted = !1;
        }),
        (t.getDerivedStateFromProps = function (e, t) {
          var n,
            o,
            a = t.children,
            i = t.handleExited;
          return {
            children: t.firstRender
              ? ((n = e),
                (o = i),
                kn(n.children, function (e) {
                  return (0,
                  r.cloneElement)(e, { onExited: o.bind(null, e), in: !0, appear: xn(e, "appear", n), enter: xn(e, "enter", n), exit: xn(e, "exit", n) });
                }))
              : En(e, a, i),
            firstRender: !1,
          };
        }),
        (n.handleExited = function (e, t) {
          var n = kn(this.props.children);
          e.key in n ||
            (e.props.onExited && e.props.onExited(t),
            this.mounted &&
              this.setState(function (t) {
                var n = Sn({}, t.children);
                return delete n[e.key], { children: n };
              }));
        }),
        (n.render = function () {
          var e = this.props,
            t = e.component,
            n = e.childFactory,
            o = a(e, ["component", "childFactory"]),
            i = this.state.contextValue,
            l = Cn(this.state.children).map(n);
          return (
            delete o.appear,
            delete o.enter,
            delete o.exit,
            null === t
              ? r.createElement(fn.Provider, { value: i }, l)
              : r.createElement(
                  fn.Provider,
                  { value: i },
                  r.createElement(t, o, l)
                )
          );
        }),
        t
      );
    })(r.Component);
  (Nn.propTypes = {}),
    (Nn.defaultProps = {
      component: "div",
      childFactory: function (e) {
        return e;
      },
    });
  const Tn = Nn,
    Pn = { app: 100, modal: 200, popover: 300, overlay: 400, max: 9999 };
  function On(e) {
    return e;
  }
  function jn(e) {
    const t = (0, r.forwardRef)(e);
    return (
      (t.extend = On),
      (t.withProps = (e) => {
        const n = (0, r.forwardRef)((n, r) =>
          (0, mt.jsx)(t, d(d(d({}, e), n), {}, { ref: r }))
        );
        return (
          (n.extend = t.extend),
          (n.displayName = "WithProps(".concat(t.displayName, ")")),
          n
        );
      }),
      t
    );
  }
  function Rn(e) {
    return Object.keys(e).reduce(
      (t, n) => (void 0 !== e[n] && (t[n] = e[n]), t),
      {}
    );
  }
  function _n(e, t, n) {
    var r;
    const o = Yt(),
      a =
        null === (r = o.components[e]) || void 0 === r
          ? void 0
          : r.defaultProps,
      i = "function" === typeof a ? a(o) : a;
    return d(d(d({}, t), i), Rn(n));
  }
  function Ln(e) {
    var t,
      n,
      r = "";
    if ("string" == typeof e || "number" == typeof e) r += e;
    else if ("object" == typeof e)
      if (Array.isArray(e)) {
        var o = e.length;
        for (t = 0; t < o; t++)
          e[t] && (n = Ln(e[t])) && (r && (r += " "), (r += n));
      } else for (n in e) e[n] && (r && (r += " "), (r += n));
    return r;
  }
  const zn = function () {
      for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
        (e = arguments[n]) && (t = Ln(e)) && (r && (r += " "), (r += t));
      return r;
    },
    An = {
      always: "mantine-focus-always",
      auto: "mantine-focus-auto",
      never: "mantine-focus-never",
    };
  const In = {};
  function Mn(e) {
    let { theme: t, classNames: n, props: r, stylesCtx: o } = e;
    return (function (e) {
      const t = {};
      return (
        e.forEach((e) => {
          Object.entries(e).forEach((e) => {
            let [n, r] = e;
            t[n] ? (t[n] = zn(t[n], r)) : (t[n] = r);
          });
        }),
        t
      );
    })(
      (Array.isArray(n) ? n : [n]).map((e) =>
        "function" === typeof e ? e(t, r, o) : e || In
      )
    );
  }
  function Fn(e) {
    let { selector: t, stylesCtx: n, theme: r, classNames: o, props: a } = e;
    return Mn({ theme: r, classNames: o, props: a, stylesCtx: n })[t];
  }
  function Dn(e) {
    let {
      theme: t,
      options: n,
      themeName: r,
      selector: o,
      classNamesPrefix: a,
      classNames: i,
      classes: l,
      unstyled: s,
      className: c,
      rootSelector: u,
      props: d,
      stylesCtx: f,
      withStaticClasses: p,
      headless: h,
      transformedStyles: m,
    } = e;
    return zn(
      (function (e) {
        let { theme: t, options: n, unstyled: r } = e;
        return zn(
          (null === n || void 0 === n ? void 0 : n.focusable) &&
            !r &&
            (t.focusClassName || An[t.focusRing]),
          (null === n || void 0 === n ? void 0 : n.active) &&
            !r &&
            t.activeClassName
        );
      })({ theme: t, options: n, unstyled: s || h }),
      (function (e) {
        let { themeName: t, theme: n, selector: r, props: o, stylesCtx: a } = e;
        return t.map((e) => {
          var t, i;
          return null ===
            (t = Mn({
              theme: n,
              classNames:
                null === (i = n.components[e]) || void 0 === i
                  ? void 0
                  : i.classNames,
              props: o,
              stylesCtx: a,
            })) || void 0 === t
            ? void 0
            : t[r];
        });
      })({ theme: t, themeName: r, selector: o, props: d, stylesCtx: f }),
      (function (e) {
        let { options: t, classes: n, selector: r, unstyled: o } = e;
        return null !== t && void 0 !== t && t.variant && !o
          ? n["".concat(r, "--").concat(t.variant)]
          : void 0;
      })({ options: n, classes: l, selector: o, unstyled: s }),
      Fn({ selector: o, stylesCtx: f, theme: t, classNames: i, props: d }),
      Fn({ selector: o, stylesCtx: f, theme: t, classNames: m, props: d }),
      (function (e) {
        let { selector: t, stylesCtx: n, options: r, props: o, theme: a } = e;
        return Mn({
          theme: a,
          classNames: null === r || void 0 === r ? void 0 : r.classNames,
          props: (null === r || void 0 === r ? void 0 : r.props) || o,
          stylesCtx: n,
        })[t];
      })({ selector: o, stylesCtx: f, options: n, props: d, theme: t }),
      (function (e) {
        let { rootSelector: t, selector: n, className: r } = e;
        return t === n ? r : void 0;
      })({ rootSelector: u, selector: o, className: c }),
      (function (e) {
        let { selector: t, classes: n, unstyled: r } = e;
        return r ? void 0 : n[t];
      })({ selector: o, classes: l, unstyled: s || h }),
      p &&
        !h &&
        (function (e) {
          let {
            themeName: t,
            classNamesPrefix: n,
            selector: r,
            withStaticClass: o,
          } = e;
          return !1 === o
            ? []
            : t.map((e) => "".concat(n, "-").concat(e, "-").concat(r));
        })({
          themeName: r,
          classNamesPrefix: a,
          selector: o,
          withStaticClass:
            null === n || void 0 === n ? void 0 : n.withStaticClass,
        }),
      null === n || void 0 === n ? void 0 : n.className
    );
  }
  function Un(e) {
    let { theme: t, styles: n, props: r, stylesCtx: o } = e;
    return (Array.isArray(n) ? n : [n]).reduce(
      (e, n) => d(d({}, e), "function" === typeof n ? n(t, r, o) : n),
      {}
    );
  }
  function Wn(e) {
    let { style: t, theme: n } = e;
    return Array.isArray(t)
      ? [...t].reduce((e, t) => d(d({}, e), Wn({ style: t, theme: n })), {})
      : "function" === typeof t
      ? t(n)
      : null == t
      ? {}
      : t;
  }
  function Hn(e) {
    var t;
    let {
      vars: n,
      varsResolver: r,
      theme: o,
      props: a,
      stylesCtx: i,
      selector: l,
      themeName: s,
      headless: c,
    } = e;
    return null ===
      (t = (function (e) {
        return e.reduce(
          (e, t) => (
            t &&
              Object.keys(t).forEach((n) => {
                e[n] = d(d({}, e[n]), Rn(t[n]));
              }),
            e
          ),
          {}
        );
      })([
        c ? {} : null === r || void 0 === r ? void 0 : r(o, a, i),
        ...s.map((e) => {
          var t, n;
          return null === (t = o.components) ||
            void 0 === t ||
            null === (t = t[e]) ||
            void 0 === t ||
            null === (n = t.vars) ||
            void 0 === n
            ? void 0
            : n.call(t, o, a, i);
        }),
        null === n || void 0 === n ? void 0 : n(o, a, i),
      ])) || void 0 === t
      ? void 0
      : t[l];
  }
  function Bn(e) {
    let {
      theme: t,
      themeName: n,
      selector: r,
      options: o,
      props: a,
      stylesCtx: i,
      rootSelector: l,
      styles: s,
      style: c,
      vars: u,
      varsResolver: f,
      headless: p,
      withStylesTransform: h,
    } = e;
    return d(
      d(
        d(
          d(
            d(
              d(
                {},
                !h &&
                  (function (e) {
                    let {
                      theme: t,
                      themeName: n,
                      props: r,
                      stylesCtx: o,
                      selector: a,
                    } = e;
                    return n
                      .map((e) => {
                        var n;
                        return Un({
                          theme: t,
                          styles:
                            null === (n = t.components[e]) || void 0 === n
                              ? void 0
                              : n.styles,
                          props: r,
                          stylesCtx: o,
                        })[a];
                      })
                      .reduce((e, t) => d(d({}, e), t), {});
                  })({
                    theme: t,
                    themeName: n,
                    props: a,
                    stylesCtx: i,
                    selector: r,
                  })
              ),
              !h && Un({ theme: t, styles: s, props: a, stylesCtx: i })[r]
            ),
            !h &&
              Un({
                theme: t,
                styles: null === o || void 0 === o ? void 0 : o.styles,
                props: (null === o || void 0 === o ? void 0 : o.props) || a,
                stylesCtx: i,
              })[r]
          ),
          Hn({
            theme: t,
            props: a,
            stylesCtx: i,
            vars: u,
            varsResolver: f,
            selector: r,
            themeName: n,
            headless: p,
          })
        ),
        l === r ? Wn({ style: c, theme: t }) : null
      ),
      Wn({ style: null === o || void 0 === o ? void 0 : o.style, theme: t })
    );
  }
  function Vn(e) {
    var t;
    let { props: n, stylesCtx: r, themeName: o } = e;
    const a = Yt(),
      i =
        null ===
          (t = (function () {
            var e;
            return null === (e = St().stylesTransform) || void 0 === e
              ? void 0
              : e.styles;
          })()) || void 0 === t
          ? void 0
          : t();
    return {
      getTransformedStyles: (e) => {
        if (!i) return [];
        return [
          ...e.map((e) => i(e, { props: n, theme: a, ctx: r })),
          ...o.map((e) => {
            var t;
            return i(
              null === (t = a.components[e]) || void 0 === t
                ? void 0
                : t.styles,
              { props: n, theme: a, ctx: r }
            );
          }),
        ].filter(Boolean);
      },
      withStylesTransform: !!i,
    };
  }
  function $n(e) {
    let {
      name: t,
      classes: n,
      props: r,
      stylesCtx: o,
      className: a,
      style: i,
      rootSelector: l = "root",
      unstyled: s,
      classNames: c,
      styles: u,
      vars: d,
      varsResolver: f,
    } = e;
    const p = Yt(),
      h = St().classNamesPrefix,
      m = St().withStaticClasses,
      y = St().headless,
      v = (Array.isArray(t) ? t : [t]).filter((e) => e),
      { withStylesTransform: g, getTransformedStyles: b } = Vn({
        props: r,
        stylesCtx: o,
        themeName: v,
      });
    return (e, t) => ({
      className: Dn({
        theme: p,
        options: t,
        themeName: v,
        selector: e,
        classNamesPrefix: h,
        classNames: c,
        classes: n,
        unstyled: s,
        className: a,
        rootSelector: l,
        props: r,
        stylesCtx: o,
        withStaticClasses: m,
        headless: y,
        transformedStyles: b([
          null === t || void 0 === t ? void 0 : t.styles,
          u,
        ]),
      }),
      style: Bn({
        theme: p,
        themeName: v,
        selector: e,
        options: t,
        props: r,
        stylesCtx: o,
        rootSelector: l,
        styles: u,
        style: i,
        vars: d,
        varsResolver: f,
        headless: y,
        withStylesTransform: g,
      }),
    });
  }
  function qn(e, t) {
    "function" === typeof e
      ? e(t)
      : "object" === typeof e &&
        null !== e &&
        "current" in e &&
        (e.current = t);
  }
  const Yn = ["children", "target"];
  const Qn = {},
    Kn = (0, r.forwardRef)((e, t) => {
      const n = _n("Portal", Qn, e),
        { children: o, target: a } = n,
        l = i(n, Yn),
        [s, c] = (0, r.useState)(!1),
        u = (0, r.useRef)(null);
      return (
        on(
          () => (
            c(!0),
            (u.current = a
              ? "string" === typeof a
                ? document.querySelector(a)
                : a
              : (function (e) {
                  const t = document.createElement("div");
                  return (
                    t.setAttribute("data-portal", "true"),
                    "string" === typeof e.className &&
                      t.classList.add(
                        ...e.className.split(" ").filter(Boolean)
                      ),
                    "object" === typeof e.style &&
                      Object.assign(t.style, e.style),
                    "string" === typeof e.id && t.setAttribute("id", e.id),
                    t
                  );
                })(l)),
            qn(t, u.current),
            !a && u.current && document.body.appendChild(u.current),
            () => {
              !a && u.current && document.body.removeChild(u.current);
            }
          ),
          [a]
        ),
        s && u.current
          ? (0, un.createPortal)(
              (0, mt.jsx)(mt.Fragment, { children: o }),
              u.current
            )
          : null
      );
    });
  Kn.displayName = "@mantine/core/Portal";
  const Gn = ["withinPortal", "children"];
  function Xn(e) {
    let { withinPortal: t = !0, children: n } = e,
      r = i(e, Gn);
    return t
      ? (0, mt.jsx)(Kn, d(d({}, r), {}, { children: n }))
      : (0, mt.jsx)(mt.Fragment, { children: n });
  }
  function Jn(e) {
    return xt(e)
      .reduce((t, n) => {
        return void 0 !== e[n]
          ? ""
              .concat(t)
              .concat(
                ((r = n),
                r.replace(/[A-Z]/g, (e) => "-".concat(e.toLowerCase()))),
                ":"
              )
              .concat(e[n], ";")
          : t;
        var r;
      }, "")
      .trim();
  }
  function Zn(e) {
    let { selector: t, styles: n, media: r, container: o } = e;
    const a = n ? Jn(n) : "",
      i = Array.isArray(r)
        ? r.map((e) =>
            "@media"
              .concat(e.query, "{")
              .concat(t, "{")
              .concat(Jn(e.styles), "}}")
          )
        : [],
      l = Array.isArray(o)
        ? o.map((e) =>
            "@container "
              .concat(e.query, "{")
              .concat(t, "{")
              .concat(Jn(e.styles), "}}")
          )
        : [];
    return ""
      .concat(a ? "".concat(t, "{").concat(a, "}") : "")
      .concat(i.join(""))
      .concat(l.join(""))
      .trim();
  }
  function er(e) {
    const t = kt();
    return (0, mt.jsx)("style", {
      "data-mantine-styles": "inline",
      nonce: null === t || void 0 === t ? void 0 : t(),
      dangerouslySetInnerHTML: { __html: Zn(e) },
    });
  }
  function tr(e) {
    if ("number" === typeof e) return !0;
    if ("string" === typeof e) {
      if (
        e.startsWith("calc(") ||
        e.startsWith("var(") ||
        (e.includes(" ") && "" !== e.trim())
      )
        return !0;
      const t =
        /^[+-]?[0-9]+(\.[0-9]+)?(px|em|rem|ex|ch|lh|rlh|vw|vh|vmin|vmax|vb|vi|svw|svh|lvw|lvh|dvw|dvh|cm|mm|in|pt|pc|q|cqw|cqh|cqi|cqb|cqmin|cqmax|%)?$/;
      return e
        .trim()
        .split(/\s+/)
        .every((e) => t.test(e));
    }
    return !1;
  }
  function nr(e) {
    return e.startsWith("data-") ? e : "data-".concat(e);
  }
  function rr(e) {
    return e
      ? "string" === typeof e
        ? { [nr(e)]: !0 }
        : Array.isArray(e)
        ? [...e].reduce((e, t) => d(d({}, e), rr(t)), {})
        : ((t = e),
          Object.keys(t).reduce((e, n) => {
            const r = t[n];
            return (
              void 0 === r ||
                "" === r ||
                !1 === r ||
                null === r ||
                (e[nr(n)] = t[n]),
              e
            );
          }, {}))
      : null;
    var t;
  }
  function or(e, t) {
    return Array.isArray(e)
      ? [...e].reduce((e, n) => d(d({}, e), or(n, t)), {})
      : "function" === typeof e
      ? e(t)
      : null == e
      ? {}
      : e;
  }
  function ar(e) {
    let { theme: t, style: n, vars: r, styleProps: o } = e;
    const a = or(n, t),
      i = or(r, t);
    return d(d(d({}, a), i), o);
  }
  Xn.displayName = "@mantine/core/OptionalPortal";
  const ir = [
    "m",
    "mx",
    "my",
    "mt",
    "mb",
    "ml",
    "mr",
    "me",
    "ms",
    "p",
    "px",
    "py",
    "pt",
    "pb",
    "pl",
    "pr",
    "pe",
    "ps",
    "bd",
    "bg",
    "c",
    "opacity",
    "ff",
    "fz",
    "fw",
    "lts",
    "ta",
    "lh",
    "fs",
    "tt",
    "td",
    "w",
    "miw",
    "maw",
    "h",
    "mih",
    "mah",
    "bgsz",
    "bgp",
    "bgr",
    "bga",
    "pos",
    "top",
    "left",
    "bottom",
    "right",
    "inset",
    "display",
    "flex",
    "hiddenFrom",
    "visibleFrom",
    "lightHidden",
    "darkHidden",
    "sx",
  ];
  const lr = {
    m: { type: "spacing", property: "margin" },
    mt: { type: "spacing", property: "marginTop" },
    mb: { type: "spacing", property: "marginBottom" },
    ml: { type: "spacing", property: "marginLeft" },
    mr: { type: "spacing", property: "marginRight" },
    ms: { type: "spacing", property: "marginInlineStart" },
    me: { type: "spacing", property: "marginInlineEnd" },
    mx: { type: "spacing", property: "marginInline" },
    my: { type: "spacing", property: "marginBlock" },
    p: { type: "spacing", property: "padding" },
    pt: { type: "spacing", property: "paddingTop" },
    pb: { type: "spacing", property: "paddingBottom" },
    pl: { type: "spacing", property: "paddingLeft" },
    pr: { type: "spacing", property: "paddingRight" },
    ps: { type: "spacing", property: "paddingInlineStart" },
    pe: { type: "spacing", property: "paddingInlineEnd" },
    px: { type: "spacing", property: "paddingInline" },
    py: { type: "spacing", property: "paddingBlock" },
    bd: { type: "border", property: "border" },
    bg: { type: "color", property: "background" },
    c: { type: "textColor", property: "color" },
    opacity: { type: "identity", property: "opacity" },
    ff: { type: "fontFamily", property: "fontFamily" },
    fz: { type: "fontSize", property: "fontSize" },
    fw: { type: "identity", property: "fontWeight" },
    lts: { type: "size", property: "letterSpacing" },
    ta: { type: "identity", property: "textAlign" },
    lh: { type: "lineHeight", property: "lineHeight" },
    fs: { type: "identity", property: "fontStyle" },
    tt: { type: "identity", property: "textTransform" },
    td: { type: "identity", property: "textDecoration" },
    w: { type: "spacing", property: "width" },
    miw: { type: "spacing", property: "minWidth" },
    maw: { type: "spacing", property: "maxWidth" },
    h: { type: "spacing", property: "height" },
    mih: { type: "spacing", property: "minHeight" },
    mah: { type: "spacing", property: "maxHeight" },
    bgsz: { type: "size", property: "backgroundSize" },
    bgp: { type: "identity", property: "backgroundPosition" },
    bgr: { type: "identity", property: "backgroundRepeat" },
    bga: { type: "identity", property: "backgroundAttachment" },
    pos: { type: "identity", property: "position" },
    top: { type: "size", property: "top" },
    left: { type: "size", property: "left" },
    bottom: { type: "size", property: "bottom" },
    right: { type: "size", property: "right" },
    inset: { type: "size", property: "inset" },
    display: { type: "identity", property: "display" },
    flex: { type: "identity", property: "flex" },
  };
  function sr(e, t) {
    const n = zt({ color: e, theme: t });
    return "dimmed" === n.color
      ? "var(--mantine-color-dimmed)"
      : "bright" === n.color
      ? "var(--mantine-color-bright)"
      : n.variable
      ? "var(".concat(n.variable, ")")
      : n.color;
  }
  const cr = {
    text: "var(--mantine-font-family)",
    mono: "var(--mantine-font-family-monospace)",
    monospace: "var(--mantine-font-family-monospace)",
    heading: "var(--mantine-font-family-headings)",
    headings: "var(--mantine-font-family-headings)",
  };
  const ur = ["h1", "h2", "h3", "h4", "h5", "h6"];
  const dr = ["h1", "h2", "h3", "h4", "h5", "h6"];
  const fr = {
      color: sr,
      textColor: function (e, t) {
        const n = zt({ color: e, theme: t });
        return n.isThemeColor && void 0 === n.shade
          ? "var(--mantine-color-".concat(n.color, "-text)")
          : sr(e, t);
      },
      fontSize: function (e, t) {
        return "string" === typeof e && e in t.fontSizes
          ? "var(--mantine-font-size-".concat(e, ")")
          : "string" === typeof e && ur.includes(e)
          ? "var(--mantine-".concat(e, "-font-size)")
          : "number" === typeof e || "string" === typeof e
          ? Nt(e)
          : e;
      },
      spacing: function (e, t) {
        if ("number" === typeof e) return Nt(e);
        if ("string" === typeof e) {
          const n = e.replace("-", "");
          if (!(n in t.spacing)) return Nt(e);
          const r = "--mantine-spacing-".concat(n);
          return e.startsWith("-")
            ? "calc(var(".concat(r, ") * -1)")
            : "var(".concat(r, ")");
        }
        return e;
      },
      identity: function (e) {
        return e;
      },
      size: function (e) {
        return "number" === typeof e ? Nt(e) : e;
      },
      lineHeight: function (e, t) {
        return "string" === typeof e && e in t.lineHeights
          ? "var(--mantine-line-height-".concat(e, ")")
          : "string" === typeof e && dr.includes(e)
          ? "var(--mantine-".concat(e, "-line-height)")
          : e;
      },
      fontFamily: function (e) {
        return "string" === typeof e && e in cr ? cr[e] : e;
      },
      border: function (e, t) {
        if ("number" === typeof e) return Nt(e);
        if ("string" === typeof e) {
          const [n, r, ...o] = e.split(" ").filter((e) => "" !== e.trim());
          let a = "".concat(Nt(n));
          return (
            r && (a += " ".concat(r)),
            o.length > 0 && (a += " ".concat(sr(o.join(" "), t))),
            a.trim()
          );
        }
        return e;
      },
    },
    pr = ["media"];
  function hr(e) {
    return e.replace("(min-width: ", "").replace("em)", "");
  }
  function mr(e, t) {
    return "object" === typeof e && null !== e && t in e ? e[t] : e;
  }
  function yr(e) {
    let { styleProps: t, data: n, theme: r } = e;
    return (function (e) {
      let { media: t } = e,
        n = i(e, pr);
      const r = Object.keys(t)
        .sort((e, t) => Number(hr(e)) - Number(hr(t)))
        .map((e) => ({ query: e, styles: t[e] }));
      return d(d({}, n), {}, { media: r });
    })(
      xt(t).reduce(
        (e, o) => {
          if ("hiddenFrom" === o || "visibleFrom" === o || "sx" === o) return e;
          const a = n[o],
            i = Array.isArray(a.property) ? a.property : [a.property],
            l =
              "object" === typeof (s = t[o]) && null !== s
                ? "base" in s
                  ? s.base
                  : void 0
                : s;
          var s;
          if (
            !(function (e) {
              if ("object" !== typeof e || null === e) return !1;
              const t = Object.keys(e);
              return 1 !== t.length || "base" !== t[0];
            })(t[o])
          )
            return (
              i.forEach((t) => {
                e.inlineStyles[t] = fr[a.type](l, r);
              }),
              e
            );
          e.hasResponsiveStyles = !0;
          const c = (function (e) {
            return "object" === typeof e && null !== e
              ? xt(e).filter((e) => "base" !== e)
              : [];
          })(t[o]);
          return (
            i.forEach((n) => {
              l && (e.styles[n] = fr[a.type](l, r)),
                c.forEach((i) => {
                  const l = "(min-width: ".concat(r.breakpoints[i], ")");
                  e.media[l] = d(
                    d({}, e.media[l]),
                    {},
                    { [n]: fr[a.type](mr(t[o], i), r) }
                  );
                });
            }),
            e
          );
        },
        { hasResponsiveStyles: !1, styles: {}, inlineStyles: {}, media: {} }
      )
    );
  }
  const vr = [
      "component",
      "style",
      "__vars",
      "className",
      "variant",
      "mod",
      "size",
      "hiddenFrom",
      "visibleFrom",
      "lightHidden",
      "darkHidden",
      "renderRoot",
      "__size",
    ],
    gr = (0, r.forwardRef)((e, t) => {
      var n;
      let {
          component: o,
          style: a,
          __vars: l,
          className: s,
          variant: c,
          mod: u,
          size: f,
          hiddenFrom: p,
          visibleFrom: h,
          lightHidden: m,
          darkHidden: y,
          renderRoot: v,
          __size: g,
        } = e,
        b = i(e, vr);
      const w = Yt(),
        S = o || "div",
        { styleProps: k, rest: x } = (function (e) {
          const {
              m: t,
              mx: n,
              my: r,
              mt: o,
              mb: a,
              ml: l,
              mr: s,
              me: c,
              ms: u,
              p: d,
              px: f,
              py: p,
              pt: h,
              pb: m,
              pl: y,
              pr: v,
              pe: g,
              ps: b,
              bd: w,
              bg: S,
              c: k,
              opacity: x,
              ff: E,
              fz: C,
              fw: N,
              lts: T,
              ta: P,
              lh: O,
              fs: j,
              tt: R,
              td: _,
              w: L,
              miw: z,
              maw: A,
              h: I,
              mih: M,
              mah: F,
              bgsz: D,
              bgp: U,
              bgr: W,
              bga: H,
              pos: B,
              top: V,
              left: $,
              bottom: q,
              right: Y,
              inset: Q,
              display: K,
              flex: G,
              hiddenFrom: X,
              visibleFrom: J,
              lightHidden: Z,
              darkHidden: ee,
              sx: te,
            } = e,
            ne = i(e, ir);
          return {
            styleProps: Rn({
              m: t,
              mx: n,
              my: r,
              mt: o,
              mb: a,
              ml: l,
              mr: s,
              me: c,
              ms: u,
              p: d,
              px: f,
              py: p,
              pt: h,
              pb: m,
              pl: y,
              pr: v,
              pe: g,
              ps: b,
              bd: w,
              bg: S,
              c: k,
              opacity: x,
              ff: E,
              fz: C,
              fw: N,
              lts: T,
              ta: P,
              lh: O,
              fs: j,
              tt: R,
              td: _,
              w: L,
              miw: z,
              maw: A,
              h: I,
              mih: M,
              mah: F,
              bgsz: D,
              bgp: U,
              bgr: W,
              bga: H,
              pos: B,
              top: V,
              left: $,
              bottom: q,
              right: Y,
              inset: Q,
              display: K,
              flex: G,
              hiddenFrom: X,
              visibleFrom: J,
              lightHidden: Z,
              darkHidden: ee,
              sx: te,
            }),
            rest: ne,
          };
        })(b),
        E = (function () {
          var e;
          return null === (e = St().stylesTransform) || void 0 === e
            ? void 0
            : e.sx;
        })(),
        C =
          null === E || void 0 === E || null === (n = E()) || void 0 === n
            ? void 0
            : n(k.sx),
        N = (function () {
          const e = (0, r.useId)().replace(/:/g, "");
          return "__m__-".concat(e);
        })(),
        T = yr({ styleProps: k, theme: w, data: lr }),
        P = d(
          d(
            {
              ref: t,
              style: ar({
                theme: w,
                style: a,
                vars: l,
                styleProps: T.inlineStyles,
              }),
              className: zn(s, C, {
                [N]: T.hasResponsiveStyles,
                "mantine-light-hidden": m,
                "mantine-dark-hidden": y,
                ["mantine-hidden-from-".concat(p)]: p,
                ["mantine-visible-from-".concat(h)]: h,
              }),
              "data-variant": c,
              "data-size": tr(f) ? void 0 : f || void 0,
              size: g,
            },
            rr(u)
          ),
          x
        );
      return (0, mt.jsxs)(mt.Fragment, {
        children: [
          T.hasResponsiveStyles &&
            (0, mt.jsx)(er, {
              selector: ".".concat(N),
              styles: T.styles,
              media: T.media,
            }),
          "function" === typeof v ? v(P) : (0, mt.jsx)(S, d({}, P)),
        ],
      });
    });
  gr.displayName = "@mantine/core/Box";
  const br = gr;
  var wr = function () {
    return (
      (wr =
        Object.assign ||
        function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++)
            for (var o in (t = arguments[n]))
              Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }),
      wr.apply(this, arguments)
    );
  };
  function Sr(e, t) {
    var n = {};
    for (var r in e)
      Object.prototype.hasOwnProperty.call(e, r) &&
        t.indexOf(r) < 0 &&
        (n[r] = e[r]);
    if (null != e && "function" === typeof Object.getOwnPropertySymbols) {
      var o = 0;
      for (r = Object.getOwnPropertySymbols(e); o < r.length; o++)
        t.indexOf(r[o]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(e, r[o]) &&
          (n[r[o]] = e[r[o]]);
    }
    return n;
  }
  Object.create;
  function kr(e, t, n) {
    if (n || 2 === arguments.length)
      for (var r, o = 0, a = t.length; o < a; o++)
        (!r && o in t) ||
          (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
    return e.concat(r || Array.prototype.slice.call(t));
  }
  Object.create;
  "function" === typeof SuppressedError && SuppressedError;
  var xr = "right-scroll-bar-position",
    Er = "width-before-scroll-bar";
  function Cr(e, t) {
    return "function" === typeof e ? e(t) : e && (e.current = t), e;
  }
  var Nr = "undefined" !== typeof window ? r.useLayoutEffect : r.useEffect,
    Tr = new WeakMap();
  function Pr(e, t) {
    var n = (function (e, t) {
      var n = (0, r.useState)(function () {
        return {
          value: e,
          callback: t,
          facade: {
            get current() {
              return n.value;
            },
            set current(e) {
              var t = n.value;
              t !== e && ((n.value = e), n.callback(e, t));
            },
          },
        };
      })[0];
      return (n.callback = t), n.facade;
    })(t || null, function (t) {
      return e.forEach(function (e) {
        return Cr(e, t);
      });
    });
    return (
      Nr(
        function () {
          var t = Tr.get(n);
          if (t) {
            var r = new Set(t),
              o = new Set(e),
              a = n.current;
            r.forEach(function (e) {
              o.has(e) || Cr(e, null);
            }),
              o.forEach(function (e) {
                r.has(e) || Cr(e, a);
              });
          }
          Tr.set(n, e);
        },
        [e]
      ),
      n
    );
  }
  function Or(e) {
    return e;
  }
  function jr(e, t) {
    void 0 === t && (t = Or);
    var n = [],
      r = !1,
      o = {
        read: function () {
          if (r)
            throw new Error(
              "Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`."
            );
          return n.length ? n[n.length - 1] : e;
        },
        useMedium: function (e) {
          var o = t(e, r);
          return (
            n.push(o),
            function () {
              n = n.filter(function (e) {
                return e !== o;
              });
            }
          );
        },
        assignSyncMedium: function (e) {
          for (r = !0; n.length; ) {
            var t = n;
            (n = []), t.forEach(e);
          }
          n = {
            push: function (t) {
              return e(t);
            },
            filter: function () {
              return n;
            },
          };
        },
        assignMedium: function (e) {
          r = !0;
          var t = [];
          if (n.length) {
            var o = n;
            (n = []), o.forEach(e), (t = n);
          }
          var a = function () {
              var n = t;
              (t = []), n.forEach(e);
            },
            i = function () {
              return Promise.resolve().then(a);
            };
          i(),
            (n = {
              push: function (e) {
                t.push(e), i();
              },
              filter: function (e) {
                return (t = t.filter(e)), n;
              },
            });
        },
      };
    return o;
  }
  var Rr = (function (e) {
      void 0 === e && (e = {});
      var t = jr(null);
      return (t.options = wr({ async: !0, ssr: !1 }, e)), t;
    })(),
    _r = function () {},
    Lr = r.forwardRef(function (e, t) {
      var n = r.useRef(null),
        o = r.useState({
          onScrollCapture: _r,
          onWheelCapture: _r,
          onTouchMoveCapture: _r,
        }),
        a = o[0],
        i = o[1],
        l = e.forwardProps,
        s = e.children,
        c = e.className,
        u = e.removeScrollBar,
        d = e.enabled,
        f = e.shards,
        p = e.sideCar,
        h = e.noIsolation,
        m = e.inert,
        y = e.allowPinchZoom,
        v = e.as,
        g = void 0 === v ? "div" : v,
        b = e.gapMode,
        w = Sr(e, [
          "forwardProps",
          "children",
          "className",
          "removeScrollBar",
          "enabled",
          "shards",
          "sideCar",
          "noIsolation",
          "inert",
          "allowPinchZoom",
          "as",
          "gapMode",
        ]),
        S = p,
        k = Pr([n, t]),
        x = wr(wr({}, w), a);
      return r.createElement(
        r.Fragment,
        null,
        d &&
          r.createElement(S, {
            sideCar: Rr,
            removeScrollBar: u,
            shards: f,
            noIsolation: h,
            inert: m,
            setCallbacks: i,
            allowPinchZoom: !!y,
            lockRef: n,
            gapMode: b,
          }),
        l
          ? r.cloneElement(r.Children.only(s), wr(wr({}, x), { ref: k }))
          : r.createElement(g, wr({}, x, { className: c, ref: k }), s)
      );
    });
  (Lr.defaultProps = { enabled: !0, removeScrollBar: !0, inert: !1 }),
    (Lr.classNames = { fullWidth: Er, zeroRight: xr });
  var zr,
    Ar = function (e) {
      var t = e.sideCar,
        n = Sr(e, ["sideCar"]);
      if (!t)
        throw new Error(
          "Sidecar: please provide `sideCar` property to import the right car"
        );
      var o = t.read();
      if (!o) throw new Error("Sidecar medium not found");
      return r.createElement(o, wr({}, n));
    };
  Ar.isSideCarExport = !0;
  function Ir() {
    if (!document) return null;
    var e = document.createElement("style");
    e.type = "text/css";
    var t = zr || n.nc;
    return t && e.setAttribute("nonce", t), e;
  }
  var Mr = function () {
      var e = 0,
        t = null;
      return {
        add: function (n) {
          var r, o;
          0 == e &&
            (t = Ir()) &&
            ((o = n),
            (r = t).styleSheet
              ? (r.styleSheet.cssText = o)
              : r.appendChild(document.createTextNode(o)),
            (function (e) {
              (
                document.head || document.getElementsByTagName("head")[0]
              ).appendChild(e);
            })(t)),
            e++;
        },
        remove: function () {
          !--e &&
            t &&
            (t.parentNode && t.parentNode.removeChild(t), (t = null));
        },
      };
    },
    Fr = function () {
      var e = (function () {
        var e = Mr();
        return function (t, n) {
          r.useEffect(
            function () {
              return (
                e.add(t),
                function () {
                  e.remove();
                }
              );
            },
            [t && n]
          );
        };
      })();
      return function (t) {
        var n = t.styles,
          r = t.dynamic;
        return e(n, r), null;
      };
    },
    Dr = { left: 0, top: 0, right: 0, gap: 0 },
    Ur = function (e) {
      return parseInt(e || "", 10) || 0;
    },
    Wr = function (e) {
      if ((void 0 === e && (e = "margin"), "undefined" === typeof window))
        return Dr;
      var t = (function (e) {
          var t = window.getComputedStyle(document.body),
            n = t["padding" === e ? "paddingLeft" : "marginLeft"],
            r = t["padding" === e ? "paddingTop" : "marginTop"],
            o = t["padding" === e ? "paddingRight" : "marginRight"];
          return [Ur(n), Ur(r), Ur(o)];
        })(e),
        n = document.documentElement.clientWidth,
        r = window.innerWidth;
      return {
        left: t[0],
        top: t[1],
        right: t[2],
        gap: Math.max(0, r - n + t[2] - t[0]),
      };
    },
    Hr = Fr(),
    Br = "data-scroll-locked",
    Vr = function (e, t, n, r) {
      var o = e.left,
        a = e.top,
        i = e.right,
        l = e.gap;
      return (
        void 0 === n && (n = "margin"),
        "\n  ."
          .concat("with-scroll-bars-hidden", " {\n   overflow: hidden ")
          .concat(r, ";\n   padding-right: ")
          .concat(l, "px ")
          .concat(r, ";\n  }\n  body[")
          .concat(Br, "] {\n    overflow: hidden ")
          .concat(r, ";\n    overscroll-behavior: contain;\n    ")
          .concat(
            [
              t && "position: relative ".concat(r, ";"),
              "margin" === n &&
                "\n    padding-left: "
                  .concat(o, "px;\n    padding-top: ")
                  .concat(a, "px;\n    padding-right: ")
                  .concat(
                    i,
                    "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: "
                  )
                  .concat(l, "px ")
                  .concat(r, ";\n    "),
              "padding" === n &&
                "padding-right: ".concat(l, "px ").concat(r, ";"),
            ]
              .filter(Boolean)
              .join(""),
            "\n  }\n  \n  ."
          )
          .concat(xr, " {\n    right: ")
          .concat(l, "px ")
          .concat(r, ";\n  }\n  \n  .")
          .concat(Er, " {\n    margin-right: ")
          .concat(l, "px ")
          .concat(r, ";\n  }\n  \n  .")
          .concat(xr, " .")
          .concat(xr, " {\n    right: 0 ")
          .concat(r, ";\n  }\n  \n  .")
          .concat(Er, " .")
          .concat(Er, " {\n    margin-right: 0 ")
          .concat(r, ";\n  }\n  \n  body[")
          .concat(Br, "] {\n    ")
          .concat("--removed-body-scroll-bar-size", ": ")
          .concat(l, "px;\n  }\n")
      );
    },
    $r = function () {
      var e = parseInt(document.body.getAttribute(Br) || "0", 10);
      return isFinite(e) ? e : 0;
    },
    qr = function (e) {
      var t = e.noRelative,
        n = e.noImportant,
        o = e.gapMode,
        a = void 0 === o ? "margin" : o;
      r.useEffect(function () {
        return (
          document.body.setAttribute(Br, ($r() + 1).toString()),
          function () {
            var e = $r() - 1;
            e <= 0
              ? document.body.removeAttribute(Br)
              : document.body.setAttribute(Br, e.toString());
          }
        );
      }, []);
      var i = r.useMemo(
        function () {
          return Wr(a);
        },
        [a]
      );
      return r.createElement(Hr, {
        styles: Vr(i, !t, a, n ? "" : "!important"),
      });
    },
    Yr = !1;
  if ("undefined" !== typeof window)
    try {
      var Qr = Object.defineProperty({}, "passive", {
        get: function () {
          return (Yr = !0), !0;
        },
      });
      window.addEventListener("test", Qr, Qr),
        window.removeEventListener("test", Qr, Qr);
    } catch (ba) {
      Yr = !1;
    }
  var Kr = !!Yr && { passive: !1 },
    Gr = function (e, t) {
      if (!(e instanceof Element)) return !1;
      var n = window.getComputedStyle(e);
      return (
        "hidden" !== n[t] &&
        !(
          n.overflowY === n.overflowX &&
          !(function (e) {
            return "TEXTAREA" === e.tagName;
          })(e) &&
          "visible" === n[t]
        )
      );
    },
    Xr = function (e, t) {
      var n = t.ownerDocument,
        r = t;
      do {
        if (
          ("undefined" !== typeof ShadowRoot &&
            r instanceof ShadowRoot &&
            (r = r.host),
          Jr(e, r))
        ) {
          var o = Zr(e, r);
          if (o[1] > o[2]) return !0;
        }
        r = r.parentNode;
      } while (r && r !== n.body);
      return !1;
    },
    Jr = function (e, t) {
      return "v" === e
        ? (function (e) {
            return Gr(e, "overflowY");
          })(t)
        : (function (e) {
            return Gr(e, "overflowX");
          })(t);
    },
    Zr = function (e, t) {
      return "v" === e
        ? [(n = t).scrollTop, n.scrollHeight, n.clientHeight]
        : (function (e) {
            return [e.scrollLeft, e.scrollWidth, e.clientWidth];
          })(t);
      var n;
    },
    eo = function (e) {
      return "changedTouches" in e
        ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY]
        : [0, 0];
    },
    to = function (e) {
      return [e.deltaX, e.deltaY];
    },
    no = function (e) {
      return e && "current" in e ? e.current : e;
    },
    ro = function (e) {
      return "\n  .block-interactivity-"
        .concat(e, " {pointer-events: none;}\n  .allow-interactivity-")
        .concat(e, " {pointer-events: all;}\n");
    },
    oo = 0,
    ao = [];
  function io(e) {
    for (var t = null; null !== e; )
      e instanceof ShadowRoot && ((t = e.host), (e = e.host)),
        (e = e.parentNode);
    return t;
  }
  const lo =
    ((so = function (e) {
      var t = r.useRef([]),
        n = r.useRef([0, 0]),
        o = r.useRef(),
        a = r.useState(oo++)[0],
        i = r.useState(Fr)[0],
        l = r.useRef(e);
      r.useEffect(
        function () {
          l.current = e;
        },
        [e]
      ),
        r.useEffect(
          function () {
            if (e.inert) {
              document.body.classList.add("block-interactivity-".concat(a));
              var t = kr(
                [e.lockRef.current],
                (e.shards || []).map(no),
                !0
              ).filter(Boolean);
              return (
                t.forEach(function (e) {
                  return e.classList.add("allow-interactivity-".concat(a));
                }),
                function () {
                  document.body.classList.remove(
                    "block-interactivity-".concat(a)
                  ),
                    t.forEach(function (e) {
                      return e.classList.remove(
                        "allow-interactivity-".concat(a)
                      );
                    });
                }
              );
            }
          },
          [e.inert, e.lockRef.current, e.shards]
        );
      var s = r.useCallback(function (e, t) {
          if (
            ("touches" in e && 2 === e.touches.length) ||
            ("wheel" === e.type && e.ctrlKey)
          )
            return !l.current.allowPinchZoom;
          var r,
            a = eo(e),
            i = n.current,
            s = "deltaX" in e ? e.deltaX : i[0] - a[0],
            c = "deltaY" in e ? e.deltaY : i[1] - a[1],
            u = e.target,
            d = Math.abs(s) > Math.abs(c) ? "h" : "v";
          if ("touches" in e && "h" === d && "range" === u.type) return !1;
          var f = Xr(d, u);
          if (!f) return !0;
          if ((f ? (r = d) : ((r = "v" === d ? "h" : "v"), (f = Xr(d, u))), !f))
            return !1;
          if (
            (!o.current && "changedTouches" in e && (s || c) && (o.current = r),
            !r)
          )
            return !0;
          var p = o.current || r;
          return (function (e, t, n, r, o) {
            var a = (function (e, t) {
                return "h" === e && "rtl" === t ? -1 : 1;
              })(e, window.getComputedStyle(t).direction),
              i = a * r,
              l = n.target,
              s = t.contains(l),
              c = !1,
              u = i > 0,
              d = 0,
              f = 0;
            do {
              var p = Zr(e, l),
                h = p[0],
                m = p[1] - p[2] - a * h;
              (h || m) && Jr(e, l) && ((d += m), (f += h)),
                (l = l instanceof ShadowRoot ? l.host : l.parentNode);
            } while ((!s && l !== document.body) || (s && (t.contains(l) || t === l)));
            return (
              ((u && ((o && Math.abs(d) < 1) || (!o && i > d))) ||
                (!u && ((o && Math.abs(f) < 1) || (!o && -i > f)))) &&
                (c = !0),
              c
            );
          })(p, t, e, "h" === p ? s : c, !0);
        }, []),
        c = r.useCallback(function (e) {
          var n = e;
          if (ao.length && ao[ao.length - 1] === i) {
            var r = "deltaY" in n ? to(n) : eo(n),
              o = t.current.filter(function (e) {
                return (
                  e.name === n.type &&
                  (e.target === n.target || n.target === e.shadowParent) &&
                  ((t = e.delta), (o = r), t[0] === o[0] && t[1] === o[1])
                );
                var t, o;
              })[0];
            if (o && o.should) n.cancelable && n.preventDefault();
            else if (!o) {
              var a = (l.current.shards || [])
                .map(no)
                .filter(Boolean)
                .filter(function (e) {
                  return e.contains(n.target);
                });
              (a.length > 0 ? s(n, a[0]) : !l.current.noIsolation) &&
                n.cancelable &&
                n.preventDefault();
            }
          }
        }, []),
        u = r.useCallback(function (e, n, r, o) {
          var a = {
            name: e,
            delta: n,
            target: r,
            should: o,
            shadowParent: io(r),
          };
          t.current.push(a),
            setTimeout(function () {
              t.current = t.current.filter(function (e) {
                return e !== a;
              });
            }, 1);
        }, []),
        d = r.useCallback(function (e) {
          (n.current = eo(e)), (o.current = void 0);
        }, []),
        f = r.useCallback(function (t) {
          u(t.type, to(t), t.target, s(t, e.lockRef.current));
        }, []),
        p = r.useCallback(function (t) {
          u(t.type, eo(t), t.target, s(t, e.lockRef.current));
        }, []);
      r.useEffect(function () {
        return (
          ao.push(i),
          e.setCallbacks({
            onScrollCapture: f,
            onWheelCapture: f,
            onTouchMoveCapture: p,
          }),
          document.addEventListener("wheel", c, Kr),
          document.addEventListener("touchmove", c, Kr),
          document.addEventListener("touchstart", d, Kr),
          function () {
            (ao = ao.filter(function (e) {
              return e !== i;
            })),
              document.removeEventListener("wheel", c, Kr),
              document.removeEventListener("touchmove", c, Kr),
              document.removeEventListener("touchstart", d, Kr);
          }
        );
      }, []);
      var h = e.removeScrollBar,
        m = e.inert;
      return r.createElement(
        r.Fragment,
        null,
        m ? r.createElement(i, { styles: ro(a) }) : null,
        h ? r.createElement(qr, { gapMode: e.gapMode }) : null
      );
    }),
    Rr.useMedium(so),
    Ar);
  var so,
    co = r.forwardRef(function (e, t) {
      return r.createElement(Lr, wr({}, e, { ref: t, sideCar: lo }));
    });
  co.classNames = Lr.classNames;
  const uo = co,
    fo = (e) => (e + 1) % 1e6;
  function po(e, t) {
    let { getInitialValueInEffect: n } =
      arguments.length > 2 && void 0 !== arguments[2]
        ? arguments[2]
        : { getInitialValueInEffect: !0 };
    const [o, a] = (0, r.useState)(
        n
          ? t
          : (function (e) {
              return (
                "undefined" !== typeof window &&
                "matchMedia" in window &&
                window.matchMedia(e).matches
              );
            })(e)
      ),
      i = (0, r.useRef)(null);
    return (
      (0, r.useEffect)(() => {
        if ("matchMedia" in window)
          return (
            (i.current = window.matchMedia(e)),
            a(i.current.matches),
            (function (e, t) {
              try {
                return (
                  e.addEventListener("change", t),
                  () => e.removeEventListener("change", t)
                );
              } catch (ga) {
                return e.addListener(t), () => e.removeListener(t);
              }
            })(i.current, (e) => a(e.matches))
          );
      }, [e]),
      o
    );
  }
  const ho = [
    "bottom-center",
    "bottom-left",
    "bottom-right",
    "top-center",
    "top-left",
    "top-right",
  ];
  const mo = {
      left: "translateX(-100%)",
      right: "translateX(100%)",
      "top-center": "translateY(-100%)",
      "bottom-center": "translateY(100%)",
    },
    yo = {
      left: "translateX(0)",
      right: "translateX(0)",
      "top-center": "translateY(0)",
      "bottom-center": "translateY(0)",
    };
  function vo(e) {
    let { state: t, maxHeight: n, position: r, transitionDuration: o } = e;
    const [a, i] = r.split("-"),
      l = "center" === i ? "".concat(a, "-center") : i,
      s = {
        opacity: 0,
        maxHeight: n,
        transform: mo[l],
        transitionDuration: ""
          .concat(o, "ms, ")
          .concat(o, "ms, ")
          .concat(o, "ms"),
        transitionTimingFunction:
          "cubic-bezier(.51,.3,0,1.21), cubic-bezier(.51,.3,0,1.21), linear",
        transitionProperty: "opacity, transform, max-height",
      },
      c = { opacity: 1, transform: yo[l] },
      u = { opacity: 0, maxHeight: 0, transform: mo[l] },
      f = { entering: c, entered: c, exiting: u, exited: u };
    return d(d({}, s), f[t]);
  }
  function go(e) {
    let t =
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "size",
      n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
    if (void 0 !== e)
      return tr(e) ? (n ? Nt(e) : e) : "var(--".concat(t, "-").concat(e, ")");
  }
  function bo(e) {
    return void 0 === e
      ? "var(--mantine-radius-default)"
      : go(e, "mantine-radius");
  }
  function wo(e) {
    const t = (0, r.forwardRef)(e);
    return (
      (t.withProps = (e) => {
        const n = (0, r.forwardRef)((n, r) =>
          (0, mt.jsx)(t, d(d(d({}, e), n), {}, { ref: r }))
        );
        return (
          (n.extend = t.extend),
          (n.displayName = "WithProps(".concat(t.displayName, ")")),
          n
        );
      }),
      (t.extend = On),
      t
    );
  }
  var So = { root: "m_87cf2631" };
  const ko = [
      "className",
      "component",
      "__staticSelector",
      "unstyled",
      "classNames",
      "styles",
      "style",
    ],
    xo = { __staticSelector: "UnstyledButton" },
    Eo = wo((e, t) => {
      const n = _n("UnstyledButton", xo, e),
        {
          className: r,
          component: o = "button",
          __staticSelector: a,
          unstyled: l,
          classNames: s,
          styles: c,
          style: u,
        } = n,
        f = i(n, ko),
        p = $n({
          name: a,
          props: n,
          classes: So,
          className: r,
          style: u,
          classNames: s,
          styles: c,
          unstyled: l,
        });
      return (0, mt.jsx)(
        br,
        d(
          d({}, p("root", { focusable: !0 })),
          {},
          { component: o, ref: t, type: "button" === o ? "button" : void 0 },
          f
        )
      );
    });
  (Eo.classes = So), (Eo.displayName = "@mantine/core/UnstyledButton");
  const Co = ["size", "style"],
    No = (0, r.forwardRef)((e, t) => {
      let { size: n = "var(--cb-icon-size, 70%)", style: r } = e,
        o = i(e, Co);
      return (0, mt.jsx)(
        "svg",
        d(
          d(
            {
              viewBox: "0 0 15 15",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              style: d(d({}, r), {}, { width: n, height: n }),
              ref: t,
            },
            o
          ),
          {},
          {
            children: (0, mt.jsx)("path", {
              d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
              fill: "currentColor",
              fillRule: "evenodd",
              clipRule: "evenodd",
            }),
          }
        )
      );
    });
  No.displayName = "@mantine/core/CloseIcon";
  var To = { root: "m_86a44da5", "root--subtle": "m_220c80f2" };
  const Po = [
      "iconSize",
      "children",
      "vars",
      "radius",
      "className",
      "classNames",
      "style",
      "styles",
      "unstyled",
      "data-disabled",
      "disabled",
      "variant",
      "icon",
      "mod",
    ],
    Oo = { variant: "subtle" },
    jo = (e, t) => {
      let { size: n, radius: r, iconSize: o } = t;
      return {
        root: {
          "--cb-size": go(n, "cb-size"),
          "--cb-radius": void 0 === r ? void 0 : bo(r),
          "--cb-icon-size": Nt(o),
        },
      };
    },
    Ro = wo((e, t) => {
      const n = _n("CloseButton", Oo, e),
        {
          iconSize: r,
          children: o,
          vars: a,
          radius: l,
          className: s,
          classNames: c,
          style: u,
          styles: f,
          unstyled: p,
          "data-disabled": h,
          disabled: m,
          variant: y,
          icon: v,
          mod: g,
        } = n,
        b = i(n, Po),
        w = $n({
          name: "CloseButton",
          props: n,
          className: s,
          style: u,
          classes: To,
          classNames: c,
          styles: f,
          unstyled: p,
          vars: a,
          varsResolver: jo,
        });
      return (0, mt.jsxs)(
        Eo,
        d(
          d(
            d({ ref: t }, b),
            {},
            {
              unstyled: p,
              variant: y,
              disabled: m,
              mod: [{ disabled: m || h }, g],
            },
            w("root", { variant: y, active: !m && !h })
          ),
          {},
          { children: [v || (0, mt.jsx)(No, {}), o] }
        )
      );
    });
  (Ro.classes = To), (Ro.displayName = "@mantine/core/CloseButton");
  var _o = {
    root: "m_5ae2e3c",
    barsLoader: "m_7a2bd4cd",
    bar: "m_870bb79",
    "bars-loader-animation": "m_5d2b3b9d",
    dotsLoader: "m_4e3f22d7",
    dot: "m_870c4af",
    "loader-dots-animation": "m_aac34a1",
    ovalLoader: "m_b34414df",
    "oval-loader-animation": "m_f8e89c4b",
  };
  const Lo = ["className"],
    zo = (0, r.forwardRef)((e, t) => {
      let { className: n } = e,
        r = i(e, Lo);
      return (0, mt.jsxs)(
        br,
        d(
          d({ component: "span", className: zn(_o.barsLoader, n) }, r),
          {},
          {
            ref: t,
            children: [
              (0, mt.jsx)("span", { className: _o.bar }),
              (0, mt.jsx)("span", { className: _o.bar }),
              (0, mt.jsx)("span", { className: _o.bar }),
            ],
          }
        )
      );
    });
  zo.displayName = "@mantine/core/Bars";
  const Ao = ["className"],
    Io = (0, r.forwardRef)((e, t) => {
      let { className: n } = e,
        r = i(e, Ao);
      return (0, mt.jsxs)(
        br,
        d(
          d({ component: "span", className: zn(_o.dotsLoader, n) }, r),
          {},
          {
            ref: t,
            children: [
              (0, mt.jsx)("span", { className: _o.dot }),
              (0, mt.jsx)("span", { className: _o.dot }),
              (0, mt.jsx)("span", { className: _o.dot }),
            ],
          }
        )
      );
    });
  Io.displayName = "@mantine/core/Dots";
  const Mo = ["className"],
    Fo = (0, r.forwardRef)((e, t) => {
      let { className: n } = e,
        r = i(e, Mo);
      return (0, mt.jsx)(
        br,
        d(
          d({ component: "span", className: zn(_o.ovalLoader, n) }, r),
          {},
          { ref: t }
        )
      );
    });
  Fo.displayName = "@mantine/core/Oval";
  const Do = [
      "size",
      "color",
      "type",
      "vars",
      "className",
      "style",
      "classNames",
      "styles",
      "unstyled",
      "loaders",
      "variant",
      "children",
    ],
    Uo = { bars: zo, oval: Fo, dots: Io },
    Wo = { loaders: Uo, type: "oval" },
    Ho = (e, t) => {
      let { size: n, color: r } = t;
      return {
        root: {
          "--loader-size": go(n, "loader-size"),
          "--loader-color": r ? At(r, e) : void 0,
        },
      };
    },
    Bo = jn((e, t) => {
      const n = _n("Loader", Wo, e),
        {
          size: r,
          color: o,
          type: a,
          vars: l,
          className: s,
          style: c,
          classNames: u,
          styles: f,
          unstyled: p,
          loaders: h,
          variant: m,
          children: y,
        } = n,
        v = i(n, Do),
        g = $n({
          name: "Loader",
          props: n,
          classes: _o,
          className: s,
          style: c,
          classNames: u,
          styles: f,
          unstyled: p,
          vars: l,
          varsResolver: Ho,
        });
      return y
        ? (0, mt.jsx)(
            br,
            d(d(d({}, g("root")), {}, { ref: t }, v), {}, { children: y })
          )
        : (0, mt.jsx)(
            br,
            d(
              d({}, g("root")),
              {},
              { ref: t, component: h[a], variant: m, size: r },
              v
            )
          );
    });
  (Bo.defaultLoaders = Uo),
    (Bo.classes = _o),
    (Bo.displayName = "@mantine/core/Loader");
  var Vo = {
    root: "m_a513464",
    icon: "m_a4ceffb",
    loader: "m_b0920b15",
    body: "m_a49ed24",
    title: "m_3feedf16",
    description: "m_3d733a3a",
    closeButton: "m_919a4d88",
  };
  const $o = [
      "className",
      "color",
      "radius",
      "loading",
      "withCloseButton",
      "withBorder",
      "title",
      "icon",
      "children",
      "onClose",
      "closeButtonProps",
      "classNames",
      "style",
      "styles",
      "unstyled",
      "variant",
      "vars",
      "mod",
    ],
    qo = { withCloseButton: !0 },
    Yo = (e, t) => {
      let { radius: n, color: r } = t;
      return {
        root: {
          "--notification-radius": void 0 === n ? void 0 : bo(n),
          "--notification-color": r ? At(r, e) : void 0,
        },
      };
    },
    Qo = jn((e, t) => {
      const n = _n("Notification", qo, e),
        {
          className: r,
          color: o,
          radius: a,
          loading: l,
          withCloseButton: s,
          withBorder: c,
          title: u,
          icon: f,
          children: p,
          onClose: h,
          closeButtonProps: m,
          classNames: y,
          style: v,
          styles: g,
          unstyled: b,
          variant: w,
          vars: S,
          mod: k,
        } = n,
        x = i(n, $o),
        E = $n({
          name: "Notification",
          classes: Vo,
          props: n,
          className: r,
          style: v,
          classNames: y,
          styles: g,
          unstyled: b,
          vars: S,
          varsResolver: Yo,
        });
      return (0, mt.jsxs)(
        br,
        d(
          d(
            d({}, E("root")),
            {},
            {
              mod: [{ "data-with-icon": !!f || l, "data-with-border": c }, k],
              ref: t,
              variant: w,
            },
            x
          ),
          {},
          {
            role: "alert",
            children: [
              f &&
                !l &&
                (0, mt.jsx)("div", d(d({}, E("icon")), {}, { children: f })),
              l && (0, mt.jsx)(Bo, d({ size: 28, color: o }, E("loader"))),
              (0, mt.jsxs)(
                "div",
                d(
                  d({}, E("body")),
                  {},
                  {
                    children: [
                      u &&
                        (0, mt.jsx)(
                          "div",
                          d(d({}, E("title")), {}, { children: u })
                        ),
                      (0, mt.jsx)(
                        br,
                        d(
                          d({}, E("description")),
                          {},
                          { mod: { "data-with-title": !!u }, children: p }
                        )
                      ),
                    ],
                  }
                )
              ),
              s &&
                (0, mt.jsx)(
                  Ro,
                  d(
                    d({ iconSize: 16, color: "gray" }, m),
                    {},
                    { unstyled: b, onClick: h },
                    E("closeButton")
                  )
                ),
            ],
          }
        )
      );
    });
  (Qo.classes = Vo), (Qo.displayName = "@mantine/core/Notification");
  const Ko = ["data", "onHide", "autoClose"],
    Go = ["autoClose", "message"],
    Xo = (0, r.forwardRef)((e, t) => {
      let { data: n, onHide: o, autoClose: a } = e,
        l = i(e, Ko);
      const { autoClose: s, message: c } = n,
        u = i(n, Go),
        f = (function (e, t) {
          return "number" === typeof t ? t : !1 !== t && !1 !== e && e;
        })(a, n.autoClose),
        p = (0, r.useRef)(-1),
        h = () => window.clearTimeout(p.current),
        m = () => {
          o(n.id), h();
        },
        y = () => {
          "number" === typeof f && (p.current = window.setTimeout(m, f));
        };
      return (
        (0, r.useEffect)(() => {
          var e;
          null === (e = n.onOpen) || void 0 === e || e.call(n, n);
        }, []),
        (0, r.useEffect)(() => (y(), h), [f]),
        (0, mt.jsx)(
          Qo,
          d(
            d(d({}, l), u),
            {},
            {
              onClose: m,
              ref: t,
              onMouseEnter: h,
              onMouseLeave: y,
              children: c,
            }
          )
        )
      );
    });
  Xo.displayName = "@mantine/notifications/NotificationContainer";
  const Jo = (function (e) {
      let t = e,
        n = !1;
      const r = new Set();
      return {
        getState: () => t,
        updateState(e) {
          t = "function" === typeof e ? e(t) : e;
        },
        setState(e) {
          this.updateState(e), r.forEach((e) => e(t));
        },
        initialize(e) {
          n || ((t = e), (n = !0));
        },
        subscribe: (e) => (r.add(e), () => r.delete(e)),
      };
    })({
      notifications: [],
      queue: [],
      defaultPosition: "bottom-right",
      limit: 5,
    }),
    Zo = function () {
      return (function (e) {
        return (0, r.useSyncExternalStore)(
          e.subscribe,
          () => e.getState(),
          () => e.getState()
        );
      })(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Jo);
    };
  function ea(e, t) {
    const n = e.getState(),
      r = (function (e, t, n) {
        const r = [],
          o = [],
          a = {};
        for (const i of e) {
          const e = i.position || t;
          (a[e] = a[e] || 0), (a[e] += 1), a[e] <= n ? o.push(i) : r.push(i);
        }
        return { notifications: o, queue: r };
      })(t([...n.notifications, ...n.queue]), n.defaultPosition, n.limit);
    e.setState({
      notifications: r.notifications,
      queue: r.queue,
      limit: n.limit,
      defaultPosition: n.defaultPosition,
    });
  }
  function ta(e) {
    return (
      ea(
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Jo,
        (t) =>
          t.filter((t) => {
            var n;
            return (
              t.id !== e ||
              (null === (n = t.onClose) || void 0 === n || n.call(t, t), !1)
            );
          })
      ),
      e
    );
  }
  const na = function (e) {
      let t =
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Jo;
      const n =
        e.id ||
        (function () {
          return ""
            .concat(
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : "mantine-"
            )
            .concat(Math.random().toString(36).slice(2, 11));
        })();
      return (
        ea(t, (t) =>
          e.id && t.some((t) => t.id === e.id)
            ? t
            : [...t, d(d({}, e), {}, { id: n })]
        ),
        n
      );
    },
    ra = ta,
    oa = function (e) {
      return (
        ea(
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Jo,
          (t) => t.map((t) => (t.id === e.id ? d(d({}, t), e) : t))
        ),
        e.id
      );
    },
    aa = function () {
      ea(
        arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Jo,
        () => []
      );
    },
    ia = function () {
      let e =
        arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Jo;
      ea(e, (t) => t.slice(0, e.getState().limit));
    },
    la = ea;
  var sa = { root: "m_b37d9ac7", notification: "m_5ed0edd0" };
  const ca = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "vars",
      "position",
      "autoClose",
      "transitionDuration",
      "containerWidth",
      "notificationMaxHeight",
      "limit",
      "zIndex",
      "store",
      "portalProps",
      "withinPortal",
    ],
    ua = ["style"],
    da = wn,
    fa = {
      position: "bottom-right",
      autoClose: 4e3,
      transitionDuration: 250,
      containerWidth: 440,
      notificationMaxHeight: 200,
      limit: 5,
      zIndex: ((pa = "overlay"), Pn[pa]),
      store: Jo,
      withinPortal: !0,
    };
  var pa;
  const ha = (e, t) => {
      let { zIndex: n, containerWidth: r } = t;
      return {
        root: {
          "--notifications-z-index":
            null === n || void 0 === n ? void 0 : n.toString(),
          "--notifications-container-width": Nt(r),
        },
      };
    },
    ma = jn((e, t) => {
      const n = _n("Notifications", fa, e),
        {
          classNames: o,
          className: a,
          style: l,
          styles: s,
          unstyled: c,
          vars: u,
          position: f,
          autoClose: p,
          transitionDuration: h,
          containerWidth: m,
          notificationMaxHeight: y,
          limit: v,
          zIndex: g,
          store: b,
          portalProps: w,
          withinPortal: S,
        } = n,
        k = i(n, ca),
        x = Yt(),
        E = Zo(b),
        C = (function () {
          const [, e] = (0, r.useReducer)(fo, 0);
          return e;
        })(),
        N = (function (e, t) {
          return po("(prefers-reduced-motion: reduce)", e, t);
        })(),
        T = (0, r.useRef)({}),
        P = (0, r.useRef)(0),
        O = !!x.respectReducedMotion && N ? 1 : h,
        j = $n({
          name: "Notifications",
          classes: sa,
          props: n,
          className: a,
          style: l,
          classNames: o,
          styles: s,
          unstyled: c,
          vars: u,
          varsResolver: ha,
        });
      (0, r.useEffect)(() => {
        null === b ||
          void 0 === b ||
          b.updateState((e) =>
            d(d({}, e), {}, { limit: v || 5, defaultPosition: f })
          );
      }, [v, f]),
        (function (e, t) {
          const n = (0, r.useRef)(!1);
          (0, r.useEffect)(
            () => () => {
              n.current = !1;
            },
            []
          ),
            (0, r.useEffect)(() => {
              if (n.current) return e();
              n.current = !0;
            }, t);
        })(() => {
          E.notifications.length > P.current && setTimeout(() => C(), 0),
            (P.current = E.notifications.length);
        }, [E.notifications]);
      const R = (function (e, t) {
          return e.reduce(
            (e, n) => (e[n.position || t].push(n), e),
            ho.reduce((e, t) => ((e[t] = []), e), {})
          );
        })(E.notifications, f),
        _ = ho.reduce(
          (e, t) => (
            (e[t] = R[t].map((e) => {
              let { style: n } = e,
                r = i(e, ua);
              return (0, mt.jsx)(
                da,
                {
                  timeout: O,
                  onEnter: () => T.current[r.id].offsetHeight,
                  nodeRef: { current: T.current[r.id] },
                  children: (e) =>
                    (0, mt.jsx)(
                      Xo,
                      d(
                        {
                          ref: (e) => {
                            T.current[r.id] = e;
                          },
                          data: r,
                          onHide: (e) => ta(e, b),
                          autoClose: p,
                        },
                        j("notification", {
                          style: d(
                            d(
                              {},
                              vo({
                                state: e,
                                position: t,
                                transitionDuration: O,
                                maxHeight: y,
                              })
                            ),
                            n
                          ),
                        })
                      )
                    ),
                },
                r.id
              );
            })),
            e
          ),
          {}
        );
      return (0, mt.jsxs)(
        Xn,
        d(
          d({ withinPortal: S }, w),
          {},
          {
            children: [
              (0, mt.jsx)(
                br,
                d(
                  d(
                    d({}, j("root")),
                    {},
                    { "data-position": "top-center", ref: t },
                    k
                  ),
                  {},
                  { children: (0, mt.jsx)(Tn, { children: _["top-center"] }) }
                )
              ),
              (0, mt.jsx)(
                br,
                d(
                  d(d({}, j("root")), {}, { "data-position": "top-left" }, k),
                  {},
                  { children: (0, mt.jsx)(Tn, { children: _["top-left"] }) }
                )
              ),
              (0, mt.jsx)(
                br,
                d(
                  d(
                    d({}, j("root", { className: uo.classNames.fullWidth })),
                    {},
                    { "data-position": "top-right" },
                    k
                  ),
                  {},
                  { children: (0, mt.jsx)(Tn, { children: _["top-right"] }) }
                )
              ),
              (0, mt.jsx)(
                br,
                d(
                  d(
                    d({}, j("root", { className: uo.classNames.fullWidth })),
                    {},
                    { "data-position": "bottom-right" },
                    k
                  ),
                  {},
                  { children: (0, mt.jsx)(Tn, { children: _["bottom-right"] }) }
                )
              ),
              (0, mt.jsx)(
                br,
                d(
                  d(
                    d({}, j("root")),
                    {},
                    { "data-position": "bottom-left" },
                    k
                  ),
                  {},
                  { children: (0, mt.jsx)(Tn, { children: _["bottom-left"] }) }
                )
              ),
              (0, mt.jsx)(
                br,
                d(
                  d(
                    d({}, j("root")),
                    {},
                    { "data-position": "bottom-center" },
                    k
                  ),
                  {},
                  {
                    children: (0, mt.jsx)(Tn, { children: _["bottom-center"] }),
                  }
                )
              ),
            ],
          }
        )
      );
    });
  (ma.classes = sa),
    (ma.displayName = "@mantine/notifications/Notifications"),
    (ma.show = na),
    (ma.hide = ra),
    (ma.update = oa),
    (ma.clean = aa),
    (ma.cleanQueue = ia),
    (ma.updateState = la);
  const ya = () =>
    (0, mt.jsx)("div", {
      children: (0, mt.jsxs)("div", {
        className: "footer-section",
        children: [
          (0, mt.jsxs)("div", {
            className: "left-section",
            children: [
              (0, mt.jsx)("div", {
                className: "logo",
                children: (0, mt.jsx)("img", {
                  className: "main-logo",
                  src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/footer-logo.svg",
                  width: 111,
                  height: 47,
                  alt: "logo",
                }),
              }),
              (0, mt.jsx)("p", {
                className: "copy-right-para",
                children: "\xa9 2024 All rights reserved",
              }),
            ],
          }),
          (0, mt.jsxs)("div", {
            className: "right-section",
            children: [
              (0, mt.jsx)("div", {
                className: "links",
                children: (0, mt.jsx)("li", {
                  className: "terms-of-service mr-2",
                  children: (0, mt.jsx)("a", {
                    href: "/pages/terms-of-service",
                    children: "Terms of service & Privacy Policy",
                  }),
                }),
              }),
              (0, mt.jsxs)("div", {
                className: "follow-us",
                children: [
                  (0, mt.jsx)("h4", { children: "Follow Us:" }),
                  (0, mt.jsxs)("div", {
                    className: "section",
                    children: [
                      (0, mt.jsx)("li", {
                        children: (0, mt.jsx)("a", {
                          target: "_blank",
                          href: "https://www.instagram.com/oemuap/?hl=en",
                          rel: "noopener noreferrer",
                          children: (0, mt.jsx)("img", {
                            src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/instagram.svg",
                            alt: "Instagram",
                          }),
                        }),
                      }),
                      (0, mt.jsx)("li", {
                        children: (0, mt.jsx)("a", {
                          target: "_blank",
                          href: "https://www.facebook.com/people/OEM-Used-Auto-Parts-Fort-Wayne-Indiana/61560464334137/",
                          rel: "noopener noreferrer",
                          children: (0, mt.jsx)("img", {
                            src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/facebook.svg",
                            alt: "Facebook",
                          }),
                        }),
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
        ],
      }),
    });
  function va(e) {
    let { children: t } = e;
    return (0, mt.jsxs)("div", {
      children: [
        (0, mt.jsx)(vt, {}),
        (0, mt.jsxs)(ln, {
          children: [(0, mt.jsx)(ma, {}), t, (0, mt.jsx)(ya, {})],
        }),
      ],
    });
  }
  o.createRoot(document.getElementById("terms-of-service")).render(
    (0, mt.jsx)(r.StrictMode, {
      children: (0, mt.jsx)(it, {
        children: (0, mt.jsx)(va, { children: (0, mt.jsx)(yt, {}) }),
      }),
    })
  );
})();
//# sourceMappingURL=termsOfService.9d131d8ecd0c2b1da40c.js.map
